import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: any;
  JSON: any;
  Upload: any;
};

/** Account currency */
export enum AccountCurrency {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD',
}

export type AccountSchema = {
  __typename?: 'AccountSchema';
  /** Date of creating account */
  createdAt: Scalars['DateTime'];
  /** Account currency */
  currency?: Maybe<AccountCurrency>;
  /** Account ID */
  id: Scalars['BigInt'];
  /** Account name */
  name: Scalars['String'];
  /** Rate Card for Account */
  rateCard?: Maybe<RateCardData>;
  salesforceId?: Maybe<Scalars['String']>;
  /** Account status */
  status: AccountStatus;
  /** Date of updating account */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Account Status */
export enum AccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type AccountsSchema = {
  __typename?: 'AccountsSchema';
  /** Get all Accounts */
  nodes: Array<AccountSchema>;
};

export type ActorSchema = {
  __typename?: 'ActorSchema';
  /** Actor id */
  actorId: Scalars['BigInt'];
  availableCustomers: Array<CustomerSchema>;
  /** Customer id */
  customerId: Scalars['BigInt'];
  emailAddress: Scalars['String'];
};

export type AdaptCtvTemplatePropsSchema = {
  __typename?: 'AdaptCtvTemplatePropsSchema';
  /** CTA text */
  cta: Scalars['String'];
  /** CTA category id */
  ctaCategoryId: Scalars['String'];
  /** Remotion template name */
  template: Scalars['String'];
};

export type AdaptCtvTemplateSchema = {
  __typename?: 'AdaptCtvTemplateSchema';
  /** Adapt CTV record creation date */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Adapt CTV template id */
  id: Scalars['BigInt'];
  /** Adapt CTV template name */
  name: Scalars['String'];
  /** Template props */
  props: AdaptCtvTemplatePropsSchema;
  /** Adapt CTV template record status */
  status: ERecordEntityStatus;
  /** Adapt CTV record update date */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AddAdaptCtvTemplateSchema = {
  __typename?: 'AddAdaptCtvTemplateSchema';
  /** template id */
  id: Scalars['BigInt'];
};

export type AddOrReplaceCtvVideoVariantsDto = {
  /** Indicator to replace all old video variants */
  replace?: InputMaybe<Scalars['Boolean']>;
  /** CTV video variants array */
  variants: Array<VideoVariantItem>;
};

export type AddOrUpdateAdaptCtvTemplateDto = {
  /** template name */
  name: Scalars['String'];
  /** template props */
  props: AddOrUpdateAdaptCtvTemplateProps;
};

export type AddOrUpdateAdaptCtvTemplateProps = {
  /** CTA text */
  cta: Scalars['String'];
  /** CTA category id */
  ctaCategoryId: Scalars['String'];
  /** Remotion template name */
  template: Scalars['String'];
};

export type AdvertiserSchema = {
  __typename?: 'AdvertiserSchema';
  /** Advertiser account id */
  accountId: Scalars['BigInt'];
  /** Advertiser agency id */
  agencyId: Scalars['BigInt'];
  /** Advertiser code */
  code: Scalars['String'];
  /** Date of the Advertiser creation */
  createdAt: Scalars['DateTime'];
  /** Advertiser global id */
  globalAdvertiserId: Scalars['BigInt'];
  /** Advertiser id */
  id: Scalars['BigInt'];
  /** Advertiser Line Item Currencies */
  lineItemCurrencies: Array<Scalars['String']>;
  /** Advertiser name */
  name: Scalars['String'];
  /** Advertiser sales force id */
  salesforceId: Scalars['String'];
  /** Advertiser status */
  status: Scalars['String'];
  /** Date of last update of the Advertiser */
  updatedAt: Scalars['DateTime'];
};

export type AgencySchema = {
  __typename?: 'AgencySchema';
  /** Agency Account id */
  accountId: Scalars['BigInt'];
  /** Date of creating agency */
  createdAt: Scalars['DateTime'];
  /** Agency id */
  id: Scalars['BigInt'];
  /** Agency name */
  name: Scalars['String'];
  /** Agency status */
  status: ResourceStatus;
  /** Date of updating agency */
  updatedAt: Scalars['DateTime'];
};

export type App = {
  /** Create object */
  create: Array<CreateAppTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type AppCategorySchema = {
  __typename?: 'AppCategorySchema';
  categoryName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
};

export type AppCategoryTargetingBatchUpdateInput = {
  data: UpdateAppCategoryTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type AppCategoryTargetingPaginationSchema = {
  __typename?: 'AppCategoryTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AppCategoryTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type AppCategoryTargetingSchema = {
  __typename?: 'AppCategoryTargetingSchema';
  appCategory: AppCategorySchema;
  categoryId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type AppSchema = {
  __typename?: 'AppSchema';
  bundleId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id: Scalars['BigInt'];
  status: ResourceStatus;
};

export type AppTargetingBatchUpdateInput = {
  data: UpdateAppTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type AppTargetingPaginationSchema = {
  __typename?: 'AppTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AppTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type AppTargetingSchema = {
  __typename?: 'AppTargetingSchema';
  bundleId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  switcherRecord?: Maybe<Scalars['Boolean']>;
};

/** Auction type */
export enum AuctionType {
  First = 'FIRST',
  Fixed = 'FIXED',
  Second = 'SECOND',
}

export type AudienceCategorySchema = {
  __typename?: 'AudienceCategorySchema';
  /** Category id */
  id: Scalars['BigInt'];
  /** Category name */
  name: Scalars['String'];
  /** Sub-Category parent id */
  parentId?: Maybe<Scalars['BigInt']>;
};

export type AudienceDataProviderSchema = {
  __typename?: 'AudienceDataProviderSchema';
  /** Data provider name */
  dataProvider: Scalars['String'];
};

export type AudienceRateCard = {
  __typename?: 'AudienceRateCard';
  /** Rate card processing margin data */
  processingMargin?: Maybe<ProcessingMarginData>;
  /** cpm tier for audience rate */
  tierCpm?: Maybe<TierCpm>;
};

export type AudienceSchema = {
  __typename?: 'AudienceSchema';
  /** Audience account id */
  accountId?: Maybe<Scalars['BigInt']>;
  /** Audience size */
  approxSize?: Maybe<Scalars['Int']>;
  /** Audience billing type */
  billing?: Maybe<EAudienceBilling>;
  /** Audience category id */
  categoryId?: Maybe<Scalars['BigInt']>;
  /** list of child audience making combined audience */
  children?: Maybe<Array<CombinedAudienceSchema>>;
  /** and/or clause for combined child audience */
  childrenClause?: Maybe<EAudienceCombineClause>;
  country?: Maybe<CountrySchema>;
  /** Audience country code id */
  countryCode?: Maybe<Scalars['String']>;
  /** audience cpm */
  cpm?: Maybe<Scalars['Float']>;
  /** Date of creating audience */
  createdAt: Scalars['DateTime'];
  /** Audience data provider type */
  dataProvider: Scalars['String'];
  /** Audience description */
  description?: Maybe<Scalars['String']>;
  /** Audience environment type */
  envs?: Maybe<EAudienceEnvironment>;
  /** Audience id */
  id: Scalars['BigInt'];
  /** Audience name */
  name: Scalars['String'];
  /** Audience provider type */
  provider: EAudienceProvider;
  /** raw list of child audiences */
  rawChildren?: Maybe<Array<AudienceSchema>>;
  /** Audience strategies count */
  strategiesCount?: Maybe<Scalars['Int']>;
  /** Audience strategy names */
  strategyNames?: Maybe<Array<Scalars['String']>>;
  /** Audience sub-category id */
  subCategoryId?: Maybe<Scalars['BigInt']>;
  /** Audience targeting method/type */
  targetingMethod?: Maybe<EAudienceType>;
  /** Audience strategy type id */
  type: Scalars['BigInt'];
  /** Date of updating audience */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AudienceTypeSchema = {
  __typename?: 'AudienceTypeSchema';
  /** Type id */
  id: Scalars['BigInt'];
  /** Type name */
  name: Scalars['String'];
};

export type Audiences = {
  /** Create object */
  create: Array<CreateTargetingAudiencesDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type AudiencesSort = {
  /** Audiences sort by id filter, default ASC */
  direction?: InputMaybe<SortingDirectionType>;
  /** Audiences sort by field */
  field: EAudienceSortField;
};

export type AudioAttributes = {
  __typename?: 'AudioAttributes';
  bitRate?: Maybe<Scalars['Float']>;
  clickThroughLink?: Maybe<Scalars['String']>;
  codec?: Maybe<Scalars['String']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  maxBitRate?: Maybe<Scalars['Float']>;
  media?: Maybe<AudioMedia>;
  minBitRate?: Maybe<Scalars['Float']>;
  thirdPartyPixelTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTag?: Maybe<Scalars['String']>;
  thirdPartyTagTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AudioAttributesInput = {
  bitRate?: InputMaybe<Scalars['Float']>;
  clickThroughLink?: InputMaybe<Scalars['String']>;
  codec?: InputMaybe<Scalars['String']>;
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  maxBitRate?: InputMaybe<Scalars['Float']>;
  media?: InputMaybe<AudioMediaInput>;
  minBitRate?: InputMaybe<Scalars['Float']>;
  thirdPartyPixelTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTag?: InputMaybe<Scalars['String']>;
  thirdPartyTagTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AudioCreativeSchema = {
  __typename?: 'AudioCreativeSchema';
  account: AccountSchema;
  advertiser: AdvertiserSchema;
  advertiserID: Scalars['BigInt'];
  attributes: AudioAttributes;
  createdAt: Scalars['DateTime'];
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: Maybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: Maybe<Scalars['String']>;
  thirdPartyPlacementName?: Maybe<Scalars['String']>;
  typeID: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type AudioMedia = {
  __typename?: 'AudioMedia';
  mimeType: Scalars['String'];
  url: Scalars['String'];
};

export type AudioMediaInput = {
  mimeType: Scalars['String'];
  url: Scalars['String'];
};

export type BannerAttributes = {
  __typename?: 'BannerAttributes';
  clickThroughLink?: Maybe<Scalars['String']>;
  media?: Maybe<BannerMedia>;
  mediaItems?: Maybe<Array<BannerMedia>>;
  thirdPartyPixelTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTag?: Maybe<Scalars['String']>;
  thirdPartyTagTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: Maybe<Scalars['String']>;
};

export type BannerAttributesInput = {
  clickThroughLink?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<BannerMediaInput>;
  mediaItems?: InputMaybe<Array<BannerMediaInput>>;
  thirdPartyPixelTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTag?: InputMaybe<Scalars['String']>;
  thirdPartyTagTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: InputMaybe<Scalars['String']>;
};

export type BannerCreativeSchema = {
  __typename?: 'BannerCreativeSchema';
  account: AccountSchema;
  advertiser: AdvertiserSchema;
  advertiserID: Scalars['BigInt'];
  attributes?: Maybe<BannerAttributes>;
  createdAt: Scalars['DateTime'];
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: Maybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: Maybe<Scalars['String']>;
  thirdPartyPlacementName?: Maybe<Scalars['String']>;
  typeID: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type BannerMedia = {
  __typename?: 'BannerMedia';
  height: Scalars['Float'];
  qr?: Maybe<QrOverlay>;
  url?: Maybe<Scalars['String']>;
  width: Scalars['Float'];
};

export type BannerMediaInput = {
  height: Scalars['Float'];
  qr?: InputMaybe<QrOverlayInput>;
  url?: InputMaybe<Scalars['String']>;
  width: Scalars['Float'];
};

export type BatchCreate = {
  exclude: Scalars['Boolean'];
  supplyId?: InputMaybe<Scalars['Int']>;
  supplySource: ESupplySource;
  verifiedSupplyOnly: Scalars['Boolean'];
};

export type BatchDelete = {
  execute: Scalars['Boolean'];
  ids: Array<Scalars['Int']>;
};

export type BatchReplace = {
  create: Array<BatchCreate>;
  delete: BatchDelete;
};

export type Browser = {
  /** Create object */
  create: Array<CreateBrowserTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type BrowserSchema = {
  __typename?: 'BrowserSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type BrowserTargetingBatchUpdateInput = {
  data: UpdateBrowserTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type BrowserTargetingPaginationSchema = {
  __typename?: 'BrowserTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<BrowserTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type BrowserTargetingSchema = {
  __typename?: 'BrowserTargetingSchema';
  browserId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type BulkUpdateDealsArgsDto = {
  auctionType: AuctionType;
  bidFloor: Scalars['Float'];
  /** List of dsps ids to assign */
  dspAssignments?: InputMaybe<Array<DspWithSeat>>;
  dspDealId?: InputMaybe<Scalars['String']>;
  dspIds?: InputMaybe<Array<Scalars['BigInt']>>;
  dspSeatId?: InputMaybe<Scalars['BigInt']>;
  /** List of dsps ids to unassign */
  dspUnassignments?: InputMaybe<Array<DspWithSeat>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Deal id */
  id?: InputMaybe<Scalars['BigInt']>;
  margin: Scalars['Float'];
  name: Scalars['String'];
  priority?: EPriority;
  salesforceId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: DealStatus;
  supplyDealIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BulkUpdateStrategyArgsDto = {
  /** Bid Price of the strategy */
  bidPrice: Scalars['Float'];
  /** Flag to clear creatives of strategy */
  clearCreativeAssignments?: InputMaybe<Scalars['Boolean']>;
  /** List of creatives ids to assign */
  creativeAssignmentIDS?: InputMaybe<Array<Scalars['Float']>>;
  /** Cap for daily spend */
  dailyCap?: InputMaybe<Scalars['Float']>;
  /** End date of the strategy */
  endDate: Scalars['DateTime'];
  /** Total strategy pacing performance */
  flightPacing: Scalars['Int'];
  id: Scalars['BigInt'];
  /** Kpi Goal of the strategy */
  kpiGoal: Scalars['Float'];
  /** Kpi Id of the strategy */
  kpiId: Scalars['Int'];
  /** Min bid Price of the strategy */
  minBidPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Pacing type of the strategy */
  pacing: EPacingType;
  /** Pacing goal of the strategy */
  pacingGoal: Scalars['Float'];
  /** Strategy salesforce id */
  salesforceId?: InputMaybe<Scalars['String']>;
  /** Start date of the strategy */
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ERecordEntityStatus>;
};

export type BulkUpdateTargetingArgsDto = {
  App?: InputMaybe<App>;
  Audiences?: InputMaybe<Audiences>;
  Browser?: InputMaybe<Browser>;
  Carrier?: InputMaybe<Carrier>;
  Category?: InputMaybe<Category>;
  Country?: InputMaybe<Country>;
  CreativeType?: InputMaybe<CreativeType>;
  DayPart?: InputMaybe<DayPart>;
  Deal?: InputMaybe<Deal>;
  DeviceModel?: InputMaybe<DeviceModel>;
  DeviceType?: InputMaybe<DeviceType>;
  Frequency?: InputMaybe<Frequency>;
  Geo?: InputMaybe<Geo>;
  Os?: InputMaybe<Os>;
  Poi?: InputMaybe<Poi>;
  Position?: InputMaybe<Position>;
  Segment?: InputMaybe<Segment>;
  Site?: InputMaybe<Site>;
  Supply?: InputMaybe<Supply>;
};

export type CampaignDateRangeFilter = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type CampaignSchema = {
  __typename?: 'CampaignSchema';
  /** Advanced campaign optimization */
  acop?: Maybe<Scalars['Float']>;
  /** Advertiser */
  advertiser: AdvertiserSchema;
  /** Advertiser id */
  advertiserId: Scalars['BigInt'];
  /** Amount of Ad Spend to date */
  amountSpent: Scalars['Float'];
  /** The amount that needs to be spent daily for the remainder of the campaign */
  amountToSpend: Scalars['Float'];
  /** Total bids of campaign */
  bids: Scalars['BigInt'];
  /** Total budget for the campaign */
  budget: Scalars['Float'];
  /** Remaining budget of the campaign */
  budgetRemaining: Scalars['Float'];
  /** Click Through Rate of campaign */
  clickThroughRate: Scalars['Float'];
  /** Total clicks of campaign */
  clicks: Scalars['BigInt'];
  /** CPC of campaign */
  cpc: Scalars['Float'];
  /** CPM of campaign */
  cpm: Scalars['Float'];
  /** Date of the campaign creation */
  createdAt: Scalars['DateTime'];
  /** CTR of campaign */
  ctr: Scalars['Float'];
  /** Currency type of campaign */
  currency?: Maybe<Scalars['String']>;
  /** Cap for daily spend */
  dailyCap?: Maybe<Scalars['Float']>;
  /** Daily campaign pacing performance */
  dailyPacing: Scalars['Int'];
  /** Number of days left from current date to end date for the campaign */
  daysLeft?: Maybe<Scalars['Int']>;
  /** End date of the campaign */
  endDate: Scalars['DateTime'];
  /** Total campaign pacing performance */
  flightPacing: Scalars['Int'];
  id: Scalars['BigInt'];
  /** Ideal daily pacing */
  idealDailyPacing: Scalars['Float'];
  /** Number of impressions */
  impressions?: Maybe<Scalars['Int']>;
  /** KPI Goal for campaign */
  kpiGoal?: Maybe<Scalars['Float']>;
  /** KPI Id for campaign */
  kpiId?: Maybe<Scalars['Int']>;
  /** Managed Service of the Campaign */
  managedService?: Maybe<Scalars['Boolean']>;
  /** Margin of the Campaign */
  margin?: Maybe<Scalars['Float']>;
  /** Total Media Spend of campaign */
  mediaSpend: Scalars['Float'];
  name: Scalars['String'];
  /** Type of pacing */
  pacing: EPacingType;
  /** Pacing goal for campaign */
  pacingGoal?: Maybe<Scalars['Float']>;
  /** pacing option */
  pacingOption?: Maybe<EPacingOption>;
  /** Pacing tracking type of the campaign */
  pacingTracking: EPacingTracking;
  /** Campaign rate amount */
  rateAmount?: Maybe<Scalars['Float']>;
  /** Rate type of the campaign */
  rateType?: Maybe<ERateType>;
  /** Spent Yesterday in currency of campaign */
  spentYesterdayCurrency: Scalars['Float'];
  /** Spent Yesterday in impression of campaign */
  spentYesterdayImpression: Scalars['Float'];
  /** Start date of the campaign */
  startDate: Scalars['DateTime'];
  status?: Maybe<ERecordEntityStatus>;
  strategies: Array<StrategySchema>;
  /** Type of the campaign */
  type: ECampaignType;
  /** Date of last update of the campaign */
  updatedAt: Scalars['DateTime'];
  /** VCR of campaign */
  vcr: Scalars['Float'];
  /** Viewability Provider of the Campaign */
  viewabilityProvider?: Maybe<EViabilityProvider>;
  /** Total wins of campaign */
  wins: Scalars['BigInt'];
};

export type CampaignSchemaStrategiesArgs = {
  range: CampaignDateRangeFilter;
  withCreativesCount?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignsSortInputDto = {
  amountToSpend?: InputMaybe<SortingDirectionType>;
  bids?: InputMaybe<SortingDirectionType>;
  budget?: InputMaybe<SortingDirectionType>;
  clicks?: InputMaybe<SortingDirectionType>;
  cpc?: InputMaybe<SortingDirectionType>;
  cpm?: InputMaybe<SortingDirectionType>;
  ctr?: InputMaybe<SortingDirectionType>;
  dailyPacing?: InputMaybe<SortingDirectionType>;
  dateCreated?: InputMaybe<SortingDirectionType>;
  dateUpdated?: InputMaybe<SortingDirectionType>;
  daysLeft?: InputMaybe<SortingDirectionType>;
  endDate?: InputMaybe<SortingDirectionType>;
  flightPacing?: InputMaybe<SortingDirectionType>;
  id?: InputMaybe<SortingDirectionType>;
  impressions?: InputMaybe<SortingDirectionType>;
  mediaSpend?: InputMaybe<SortingDirectionType>;
  name?: InputMaybe<SortingDirectionType>;
  spentYesterdayCurrency?: InputMaybe<SortingDirectionType>;
  spentYesterdayImpression?: InputMaybe<SortingDirectionType>;
  startDate?: InputMaybe<SortingDirectionType>;
  status?: InputMaybe<SortingDirectionType>;
  wins?: InputMaybe<SortingDirectionType>;
};

export type Carrier = {
  /** Create object */
  create: Array<CreateCarrierTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type CarrierSchema = {
  __typename?: 'CarrierSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CarrierTargetingBatchUpdateInput = {
  data: UpdateCarrierTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type CarrierTargetingPaginationSchema = {
  __typename?: 'CarrierTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CarrierTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type CarrierTargetingSchema = {
  __typename?: 'CarrierTargetingSchema';
  carrier: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type Category = {
  /** Create object */
  create: Array<CreateCategoryTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type CategorySchema = {
  __typename?: 'CategorySchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  iabCategory: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CategoryTargetingBatchUpdateInput = {
  data: UpdateCategoryTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type CategoryTargetingPaginationSchema = {
  __typename?: 'CategoryTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CategoryTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type CategoryTargetingSchema = {
  __typename?: 'CategoryTargetingSchema';
  category: CategorySchema;
  categoryId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type CitySchema = {
  __typename?: 'CitySchema';
  countryCode: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  stateCode: Scalars['String'];
};

export type CloneCampaignArgsDto = {
  /** End date of the campaign */
  endDate: Scalars['DateTime'];
  name: Scalars['String'];
  /** Start date of the campaign */
  startDate: Scalars['DateTime'];
};

export type CloneDealsArgsDto = {
  accountId: Scalars['BigInt'];
  creator: Scalars['BigInt'];
  dspDealId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CloneStrategyArgsDto = {
  /** End date of the strategy */
  endDate: Scalars['DateTime'];
  name: Scalars['String'];
  /** Start date of the strategy */
  startDate: Scalars['DateTime'];
};

export type CombinedAudienceArg = {
  /** combined audience children */
  children?: InputMaybe<Array<CombinedAudienceArg>>;
  /** combined audience children clause */
  childrenClause?: InputMaybe<EAudienceCombineClause>;
  /** include or exclude */
  exclude?: InputMaybe<Scalars['Boolean']>;
  /** Combined audience id */
  id?: InputMaybe<Scalars['Int']>;
};

export type CombinedAudienceSchema = {
  __typename?: 'CombinedAudienceSchema';
  /** combined audience children */
  children?: Maybe<Array<CombinedAudienceSchema>>;
  /** combined audience children clause */
  childrenClause?: Maybe<EAudienceCombineClause>;
  /** include or exclude */
  exclude?: Maybe<Scalars['Boolean']>;
  /** Combined audience id */
  id?: Maybe<Scalars['BigInt']>;
};

export type Country = {
  /** Create object */
  create: Array<CreateCountryTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type CountrySchema = {
  __typename?: 'CountrySchema';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CountryTargetingBatchUpdateInput = {
  data: UpdateCountryTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type CountryTargetingPaginationSchema = {
  __typename?: 'CountryTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CountryTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type CountryTargetingSchema = {
  __typename?: 'CountryTargetingSchema';
  country?: Maybe<CountrySchema>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type CreateAppArgsDto = {
  bundleId: Scalars['String'];
  domain: Scalars['String'];
  status: ResourceStatus;
};

export type CreateAppCategoryArgsDto = {
  categoryName: Scalars['String'];
};

export type CreateAppCategoryTargetingDto = {
  categoryId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAppTargetingDto = {
  bundleId?: InputMaybe<Scalars['String']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAudioDto = {
  advertiserID: Scalars['BigInt'];
  attributes: AudioAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type CreateBannerDto = {
  advertiserID: Scalars['BigInt'];
  attributes?: InputMaybe<BannerAttributesInput>;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type CreateBrowserTargetingDto = {
  browserId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCampaignArgsDto = {
  /** Advanced campaign optimization */
  acop?: InputMaybe<Scalars['Float']>;
  /** Advertiser ID */
  advertiserId: Scalars['BigInt'];
  /** Total Budget for the campaign */
  budget: Scalars['Float'];
  /** Currency type of the campaign */
  currency: Scalars['String'];
  /** Cap for daily spend */
  dailyCap?: InputMaybe<Scalars['Float']>;
  /** End date of the campaign */
  endDate: Scalars['DateTime'];
  /** KPI Goal for campaign */
  kpiGoal: Scalars['Float'];
  /** KPI Id for campaign */
  kpiId: Scalars['Int'];
  /** Managed Service of the Campaign */
  managedService?: InputMaybe<Scalars['Boolean']>;
  /** Margin of the Campaign */
  margin?: InputMaybe<Scalars['Float']>;
  /** Name of campaign */
  name: Scalars['String'];
  /** Type of pacing */
  pacing: EPacingType;
  /** Pacing Goal for campaign */
  pacingGoal: Scalars['Float'];
  /** pacing option */
  pacingOption?: InputMaybe<EPacingOption>;
  /** Pacing tracking type */
  pacingTracking: EPacingTracking;
  /** Campaign rate amount */
  rateAmount?: InputMaybe<Scalars['Float']>;
  /** campaign rate type */
  rateType?: InputMaybe<ERateType>;
  /** Start date of the campaign */
  startDate: Scalars['DateTime'];
  /** campaign status */
  status: ERecordEntityStatus;
  /** Type of the campaign */
  type: ECampaignType;
  /** Viewability Provider of the Campaign */
  viewabilityProvider?: InputMaybe<EViabilityProvider>;
};

export type CreateCarrierTargetingDto = {
  carrier: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCategoryArgsDto = {
  iabCategory?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateCategoryTargetingDto = {
  categoryId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCountryArgsDto = {
  code: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateCountryTargetingDto = {
  countryCode: Scalars['String'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCreativeTypeArgsDto = {
  name: Scalars['String'];
};

export type CreateCreativeTypeTargetingDto = {
  creativeAttribute: ECreativeTypeAttribute;
  creativeAttributeValue: Scalars['String'];
  creativeTypeId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDayPartTargetingDto = {
  endHour: Scalars['Int'];
  exclude?: InputMaybe<Scalars['Boolean']>;
  startHour: Scalars['Int'];
  weekday: Scalars['Int'];
};

export type CreateDealTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  inventoryDealId: Scalars['String'];
};

export type CreateDealsArgsDto = {
  accountId: Scalars['BigInt'];
  auctionType: AuctionType;
  bidFloor: Scalars['Float'];
  creator: Scalars['BigInt'];
  dspDealId?: InputMaybe<Scalars['String']>;
  dspIds?: InputMaybe<Array<Scalars['BigInt']>>;
  dspSeatId?: InputMaybe<Scalars['BigInt']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  margin: Scalars['Float'];
  name: Scalars['String'];
  priority?: EPriority;
  salesforceId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: DealStatus;
  supplyDealIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateDeviceModelTargetingDto = {
  deviceModelId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDeviceTypeTargetingDto = {
  deviceTypeId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDspSeatArgsDto = {
  dspId: Scalars['BigInt'];
  rateLimit?: InputMaybe<Scalars['Int']>;
  seatId: Scalars['String'];
  seatName?: InputMaybe<Scalars['String']>;
  status: ResourceStatus;
};

export type CreateDvAuthenticBrandSuitabilityTargetingDto = {
  dvSegmentCode: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDvBrandSafetySuitabilityTargetingDto = {
  /** ID of dv segment to be targeted */
  dvSegmentId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDvSegmentArgsDto = {
  creativeType: ECreativeType;
  dvSegmentCode: Scalars['String'];
  name: Scalars['String'];
  product: EProduct;
};

export type CreateDvViewabilityTargetingDto = {
  dvSegmentId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateFrequencyTargetingDto = {
  freqCapCount: Scalars['Int'];
  freqCapPeriod: EFrequencyPeriods;
};

export type CreateGenreArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateGenreTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  genreId: Scalars['BigInt'];
};

export type CreateGeoTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  geoId: Scalars['BigInt'];
  type: EGeoType;
};

export type CreateKpiArgsDto = {
  name: Scalars['String'];
};

export type CreateLanguageArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateLanguageTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['BigInt'];
};

export type CreateLiveTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  live: ELiveType;
};

export type CreateLocationGroupArgsDto = {
  /** Audience account id */
  accountId?: InputMaybe<Scalars['BigInt']>;
  /** Location Group name */
  name: Scalars['String'];
  /** POI ids to create LG with */
  poiIds?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type CreateNativeDto = {
  advertiserID: Scalars['BigInt'];
  attributes: NativeAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type CreateOsTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  osId: Scalars['BigInt'];
};

export type CreatePixelMappingsDto = {
  mappedName: Scalars['String'];
  pageUrl: Scalars['String'];
};

export type CreatePixelsArgsDto = {
  /** Account id */
  account_id: Scalars['Int'];
  /** Advertiser id */
  advertiser_id?: InputMaybe<Scalars['Int']>;
  /** Pixel name */
  name: Scalars['String'];
  /** Pixel status */
  status: EPixelsStatus;
};

export type CreatePoiInputDto = {
  customLat?: InputMaybe<Scalars['Float']>;
  customLong?: InputMaybe<Scalars['Float']>;
  groupId?: InputMaybe<Scalars['Int']>;
  maxRadius: Scalars['Float'];
  minRadius?: InputMaybe<Scalars['Float']>;
  type: EPoiType;
};

export type CreatePositionTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  position: EPositionType;
};

export type CreateProductionTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  production: EProductionType;
};

export type CreateRatingArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateRatingTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  ratingId: Scalars['BigInt'];
};

export type CreateReportInputDto = {
  /** Account Id associated with the Report */
  accountId: Scalars['BigInt'];
  /** Selected advertisers ids array */
  advertiserIds: Array<Scalars['BigInt']>;
  /** Creator Id associated with the Report */
  creator: Scalars['BigInt'];
  emails: Array<Scalars['String']>;
  endDate: Scalars['DateTime'];
  fields: Array<Scalars['String']>;
  frequency?: InputMaybe<ReportFrequency>;
  isSendingEmail: Scalars['Boolean'];
  /** Selected campaigns ids array */
  lineItemIds: Array<Scalars['BigInt']>;
  metrics?: InputMaybe<Array<Scalars['String']>>;
  reportName: Scalars['String'];
  startDate: Scalars['DateTime'];
  timezone: Scalars['String'];
};

export type CreateResourceArgsDto = {
  name: Scalars['String'];
  status: ResourceStatus;
};

export type CreateSegmentTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  segmentId: Scalars['BigInt'];
  type: ESegmentType;
};

export type CreateSiteArgsDto = {
  domain: Scalars['String'];
  status: ResourceStatus;
};

export type CreateSiteTargetingDto = {
  domain?: InputMaybe<Scalars['String']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateStrategyArgsDto = {
  /** Bid Price of the strategy */
  bidPrice: Scalars['Float'];
  /** Cap for daily spend */
  dailyCap?: InputMaybe<Scalars['Float']>;
  /** End date of the strategy */
  endDate: Scalars['DateTime'];
  /** Total strategy pacing performance */
  flightPacing: Scalars['Int'];
  /** Kpi Goal of the strategy */
  kpiGoal: Scalars['Float'];
  /** Kpi Id of the strategy */
  kpiId: Scalars['Int'];
  /** Min bid Price of the strategy */
  minBidPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Pacing type of the strategy */
  pacing: EPacingType;
  /** Pacing goal of the strategy */
  pacingGoal: Scalars['Float'];
  /** Strategy salesforce id */
  salesforceId?: InputMaybe<Scalars['String']>;
  /** Start date of the strategy */
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ERecordEntityStatus>;
};

export type CreateSupplyTargetingDto = {
  supplySource: ESupplySource;
  verifiedSupplyOnly: Scalars['Boolean'];
};

export type CreateTargetingAudiencesDto = {
  /** Audience id */
  audienceId: Scalars['Float'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type CreateVideoDto = {
  advertiserID: Scalars['BigInt'];
  attributes: VideoAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type CreatedIdSchema = {
  __typename?: 'CreatedIDSchema';
  id: Scalars['BigInt'];
};

export type CreativeColumnsSortInputDto = {
  accountId?: InputMaybe<SortingDirectionType>;
  advertiserName?: InputMaybe<SortingDirectionType>;
  createdAt?: InputMaybe<SortingDirectionType>;
  /** Sort items by id */
  id?: InputMaybe<SortingDirectionType>;
  name?: InputMaybe<SortingDirectionType>;
  typeId?: InputMaybe<SortingDirectionType>;
  updatedAt?: InputMaybe<SortingDirectionType>;
};

export type CreativeFormatSchema = {
  __typename?: 'CreativeFormatSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ERecordEntityStatus;
};

export type CreativeLegacySchema = {
  __typename?: 'CreativeLegacySchema';
  brandName?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  controls?: Maybe<Scalars['Boolean']>;
  ctaText: Scalars['String'];
  disclosure?: Maybe<Scalars['String']>;
  disclosureText?: Maybe<Scalars['String']>;
  effects?: Maybe<EffectSchema>;
  eventTrackers?: Maybe<Array<Scalars['JSON']>>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  link: Scalars['String'];
  linkUrl: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  loop?: Maybe<Scalars['String']>;
  theme?: Maybe<ThemeSchema>;
  vastTag?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type CreativeType = {
  /** Create object */
  create: Array<CreateCreativeTypeTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type CreativeTypeSchema = {
  __typename?: 'CreativeTypeSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
};

export type CreativeTypeTargetingBatchUpdateInput = {
  data: UpdateCreativeTypeTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type CreativeTypeTargetingPaginationSchema = {
  __typename?: 'CreativeTypeTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CreativeTypeTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type CreativeTypeTargetingSchema = {
  __typename?: 'CreativeTypeTargetingSchema';
  createdAt: Scalars['DateTime'];
  creativeAttribute: ECreativeTypeAttribute;
  creativeAttributeValue: Scalars['String'];
  creativeTypeId: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type CtvVideoTemplateSchema = {
  __typename?: 'CtvVideoTemplateSchema';
  config: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status?: Maybe<ERecordEntityStatus>;
};

export type CtvVideoVariantSchema = {
  __typename?: 'CtvVideoVariantSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Creative Id */
  creativeId: Scalars['BigInt'];
  /** Variant id */
  id: Scalars['BigInt'];
  /** Video props */
  props: Scalars['JSON'];
  /** Video variant status */
  status: ECreativeVideoVariantStatus;
  /** CTV video targeting data */
  targeting?: Maybe<VideoTargetingSchema>;
  /** Video template id */
  templateId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerSchema = {
  __typename?: 'CustomerSchema';
  code: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type DateRangeFilter = {
  /** Deals search by start date filter */
  from?: InputMaybe<Scalars['DateTime']>;
  /** Deals search by start date filter */
  to?: InputMaybe<Scalars['DateTime']>;
};

export type DayPart = {
  /** Create object */
  create: Array<CreateDayPartTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type DayPartTargetingBatchUpdateInput = {
  data: UpdateDayPartTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DayPartTargetingPaginationSchema = {
  __typename?: 'DayPartTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DayPartTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DayPartTargetingSchema = {
  __typename?: 'DayPartTargetingSchema';
  createdAt: Scalars['DateTime'];
  endHour: Scalars['Int'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  startHour: Scalars['Int'];
  weekday: Scalars['Int'];
};

export type Deal = {
  /** Create object */
  create: Array<CreateDealTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type DealSchema = {
  __typename?: 'DealSchema';
  account: AccountSchema;
  auctionType: AuctionType;
  bidFloor: Scalars['Float'];
  /** Bid Rate of Deal */
  bidRate?: Maybe<Scalars['Float']>;
  /** Bid Requests of Deal */
  bidRequests?: Maybe<Scalars['BigInt']>;
  /** Bids of Deal */
  bids?: Maybe<Scalars['BigInt']>;
  /** CPM of Deal */
  cpm?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creator: Scalars['BigInt'];
  dspDealId?: Maybe<Scalars['String']>;
  dspIds?: Maybe<Array<Scalars['BigInt']>>;
  dspSeatId?: Maybe<Scalars['BigInt']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  /** Impressions of Deal */
  impressions?: Maybe<Scalars['BigInt']>;
  margin: Scalars['Float'];
  name: Scalars['String'];
  priority: EPriority;
  /** Revenue of Deal */
  revenue?: Maybe<Scalars['Float']>;
  salesforceId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: DealStatus;
  supplyDealIds?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Win Rate of Deal */
  winRate?: Maybe<Scalars['Float']>;
};

export type DealSort = {
  /** Deals sort by id filter, default ASC */
  direction?: InputMaybe<SortingDirectionType>;
  /** Deals sort by id filter */
  field: DealSortField;
};

/** Deal sort field */
export enum DealSortField {
  DealSortAuctionType = 'DealSortAuctionType',
  DealSortBidFloor = 'DealSortBidFloor',
  DealSortCreatedAt = 'DealSortCreatedAt',
  DealSortEndDate = 'DealSortEndDate',
  DealSortId = 'DealSortID',
  DealSortMargin = 'DealSortMargin',
  DealSortName = 'DealSortName',
  DealSortSalesforceId = 'DealSortSalesforceID',
  DealSortStartDate = 'DealSortStartDate',
  DealSortStatus = 'DealSortStatus',
  DealSortUpdatedAt = 'DealSortUpdatedAt',
}

/** Deal status */
export enum DealStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
}

export type DealTargetingBatchUpdateInput = {
  data: UpdateDealTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DealTargetingPaginationSchema = {
  __typename?: 'DealTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DealTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DealTargetingSchema = {
  __typename?: 'DealTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  inventoryDealId: Scalars['String'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type DealsTargetingBulkDto = {
  /** Account Id */
  accountId: Scalars['BigInt'];
  ids: Array<Scalars['Int']>;
};

export type DealsTargetingBulkSchema = {
  __typename?: 'DealsTargetingBulkSchema';
  app: Array<AppTargetingSchema>;
  audience: Array<TargetingAudiencesSchema>;
  browser: Array<BrowserTargetingSchema>;
  carrier: Array<CarrierTargetingSchema>;
  category: Array<CategoryTargetingSchema>;
  country: Array<CountryTargetingSchema>;
  creativeType: Array<CreativeTypeTargetingSchema>;
  dayPart: Array<DayPartTargetingSchema>;
  deal: Array<DealTargetingSchema>;
  deviceModel: Array<DeviceModelTargetingSchema>;
  deviceType: Array<DeviceTypeTargetingSchema>;
  dvAuthenticBrand: Array<DvAuthenticBrandSuitabilityTargetingSchema>;
  dvBrandSafety: Array<DvBrandSafetySuitabilityTargetingSchema>;
  dvViewability: Array<DvViewabilityTargetingSchema>;
  frequency: Array<FrequencyTargetingSchema>;
  genre: Array<GenreTargetingSchema>;
  geo: Array<GeoTargetingSchema>;
  language: Array<LanguageTargetingSchema>;
  live: Array<LiveTargetingSchema>;
  os: Array<OsTargetingSchema>;
  poi: Array<PoiSchema>;
  position: Array<PositionTargetingSchema>;
  production: Array<ProductionTargetingSchema>;
  rating: Array<RatingTargetingSchema>;
  segment: Array<SegmentTargetingSchema>;
  site: Array<SiteTargetingSchema>;
  supply: Array<SupplyTargetingSchema>;
};

export type DeletePoiInputDto = {
  ids: Array<Scalars['BigInt']>;
};

export type DeleteTargeting = {
  /** Execute the delete */
  execute: Scalars['Boolean'];
  /** List of object ids to delete */
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type DeleteTargetingAudiencesDto = {
  ids: Array<Scalars['BigInt']>;
};

export type DeviceModel = {
  /** Create object */
  create: Array<CreateDeviceModelTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type DeviceModelSchema = {
  __typename?: 'DeviceModelSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type DeviceModelTargetingBatchUpdateInput = {
  data: UpdateDeviceModelTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DeviceModelTargetingPaginationSchema = {
  __typename?: 'DeviceModelTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DeviceModelTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DeviceModelTargetingSchema = {
  __typename?: 'DeviceModelTargetingSchema';
  createdAt: Scalars['DateTime'];
  deviceModelId: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type DeviceSchema = {
  __typename?: 'DeviceSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type DeviceType = {
  /** Create object */
  create: Array<CreateDeviceTypeTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type DeviceTypeTargetingBatchUpdateInput = {
  data: UpdateDeviceTypeTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DeviceTypeTargetingPaginationSchema = {
  __typename?: 'DeviceTypeTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DeviceTypeTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DeviceTypeTargetingSchema = {
  __typename?: 'DeviceTypeTargetingSchema';
  createdAt: Scalars['DateTime'];
  deviceTypeId: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

/** Download report file schema. */
export type DownloadReportFileSchema = {
  __typename?: 'DownloadReportFileSchema';
  /** Report file storage signed url. */
  fileUrl: Scalars['String'];
};

export type DspSeatSchema = {
  __typename?: 'DspSeatSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  dspId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  rateLimit?: Maybe<Scalars['Int']>;
  seatId?: Maybe<Scalars['String']>;
  seatName?: Maybe<Scalars['String']>;
  status: ResourceStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DspWithSeat = {
  /** Dsp id */
  dspId?: InputMaybe<Scalars['BigInt']>;
  /** Dsp seat id */
  dspSeatId?: InputMaybe<Scalars['BigInt']>;
};

export type DvAuthenticBrandSuitabilityTargetingBatchUpdateInput = {
  data: UpdateDvAuthenticBrandSuitabilityTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DvAuthenticBrandSuitabilityTargetingPaginationSchema = {
  __typename?: 'DvAuthenticBrandSuitabilityTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DvAuthenticBrandSuitabilityTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DvAuthenticBrandSuitabilityTargetingSchema = {
  __typename?: 'DvAuthenticBrandSuitabilityTargetingSchema';
  createdAt: Scalars['DateTime'];
  dvSegmentCode: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type DvBrandSafetySuitabilityTargetingBatchUpdateInput = {
  data: UpdateDvBrandSafetySuitabilityTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DvBrandSafetySuitabilityTargetingPaginationSchema = {
  __typename?: 'DvBrandSafetySuitabilityTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DvBrandSafetySuitabilityTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DvBrandSafetySuitabilityTargetingSchema = {
  __typename?: 'DvBrandSafetySuitabilityTargetingSchema';
  createdAt: Scalars['DateTime'];
  dvSegment: DvSegmentSchema;
  /** ID of targeted dv segment */
  dvSegmentId: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type DvSegmentSchema = {
  __typename?: 'DvSegmentSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  creativeType: ECreativeType;
  dvSegmentCode: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  product: EProduct;
};

export type DvViewabilityTargetingBatchUpdateInput = {
  data: UpdateDvViewabilityTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type DvViewabilityTargetingPaginationSchema = {
  __typename?: 'DvViewabilityTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DvViewabilityTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type DvViewabilityTargetingSchema = {
  __typename?: 'DvViewabilityTargetingSchema';
  createdAt: Scalars['DateTime'];
  dvSegment: DvSegmentSchema;
  dvSegmentId: Scalars['BigInt'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

/** Audience billing type */
export enum EAudienceBilling {
  Combined = 'Combined',
  Custom = 'Custom',
  Premium = 'Premium',
  Standard = 'Standard',
  ThirdParty = 'ThirdParty',
  Verified = 'Verified',
}

/** Audience combine clause */
export enum EAudienceCombineClause {
  And = 'And',
  Or = 'Or',
}

/** Audience environment type */
export enum EAudienceEnvironment {
  Ctv = 'CTV',
  InApp = 'IN_APP',
  Web = 'WEB',
}

/** Audience provider type */
export enum EAudienceProvider {
  Emodo = 'Emodo',
  LiveRamp = 'LiveRamp',
  Multi = 'Multi',
  Optable = 'Optable',
}

/** Audiences Sort Field  */
export enum EAudienceSortField {
  AudienceSortApproxSize = 'AudienceSortApproxSize',
  AudienceSortCreatedAt = 'AudienceSortCreatedAt',
  AudienceSortId = 'AudienceSortID',
  AudienceSortName = 'AudienceSortName',
  AudienceSortStrategiesCount = 'AudienceSortStrategiesCount',
  AudienceSortType = 'AudienceSortType',
  AudienceSortUpdatedAt = 'AudienceSortUpdatedAt',
}

/** Audience Type */
export enum EAudienceType {
  Combined = 'Combined',
  GeoContextualLatLong = 'GeoContextualLatLong',
  GeoContextualPostal = 'GeoContextualPostal',
  IdBased = 'IDBased',
  Pixel = 'Pixel',
  Predictive = 'Predictive',
}

/** Campaign type */
export enum ECampaignType {
  Exempt = 'EXEMPT',
  Free = 'FREE',
  Paid = 'PAID',
  Test = 'TEST',
}

/** Creative type dv segment */
export enum ECreativeType {
  All = 'ALL',
  Banner = 'BANNER',
  Video = 'VIDEO',
}

/** Creative type attribute */
export enum ECreativeTypeAttribute {
  AudioDurationMax = 'AudioDurationMax',
  AudioDurationMin = 'AudioDurationMin',
  BannerMraid = 'BannerMRAID',
  BannerSize = 'BannerSize',
  EmodoPauseAdLift = 'EmodoPauseAdLift',
  NativeType = 'NativeType',
  PauseAd = 'PauseAd',
  Squeezeback = 'Squeezeback',
  VideoDurationMax = 'VideoDurationMax',
  VideoDurationMin = 'VideoDurationMin',
  VideoOrientation = 'VideoOrientation',
  VideoSkippable = 'VideoSkippable',
  VideoType = 'VideoType',
  VideoVpaid = 'VideoVPAID',
}

/** Creative Video Variant status */
export enum ECreativeVideoVariantStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING',
}

/** Freq cap period */
export enum EFrequencyPeriods {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Lifetime = 'LIFETIME',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

/** Geo targeting type */
export enum EGeoType {
  City = 'CITY',
  Metro = 'METRO',
  Postal = 'POSTAL',
  State = 'STATE',
}

/** Live type */
export enum ELiveType {
  Live = 'LIVE',
  NotLive = 'NOT_LIVE',
}

/** Targeting object type */
export enum EObjectType {
  Deal = 'Deal',
  LineItem = 'LineItem',
  Strategy = 'Strategy',
}

/** Pacing option */
export enum EPacingOption {
  AdvancedCampaignOptimized = 'ADVANCED_CAMPAIGN_OPTIMIZED',
  Regular = 'REGULAR',
}

/** Pacing tracking */
export enum EPacingTracking {
  Budget = 'BUDGET',
  Impression = 'IMPRESSION',
}

/** Pacing type */
export enum EPacingType {
  Asap = 'ASAP',
  Even = 'EVEN',
}

/** Pixels mapped sort field */
export enum EPixelsMappedSortField {
  PixelMappingSortCreatedAt = 'PixelMappingSortCreatedAt',
  PixelMappingSortFieldId = 'PixelMappingSortFieldID',
  PixelMappingSortFieldName = 'PixelMappingSortFieldName',
  PixelMappingSortFieldPageUrl = 'PixelMappingSortFieldPageUrl',
  PixelMappingSortUpdatedAt = 'PixelMappingSortUpdatedAt',
}

/** Pixels sort field */
export enum EPixelsSortField {
  PixelSortCreatedAt = 'PixelSortCreatedAt',
  PixelSortFieldId = 'PixelSortFieldID',
  PixelSortFieldName = 'PixelSortFieldName',
  PixelSortFieldStatus = 'PixelSortFieldStatus',
  PixelSortUpdatedAt = 'PixelSortUpdatedAt',
}

/** Pixels status */
export enum EPixelsStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/** POI targeting type */
export enum EPoiType {
  CustomPoi = 'CUSTOM_POI',
  LocationGroup = 'LOCATION_GROUP',
}

/** Position targeting type */
export enum EPositionType {
  AboveFold = 'ABOVE_FOLD',
  BelowFold = 'BELOW_FOLD',
  Footer = 'FOOTER',
  Fullscreen = 'FULLSCREEN',
  Header = 'HEADER',
  Interstitial = 'INTERSTITIAL',
  InArticle = 'IN_ARTICLE',
  InBanner = 'IN_BANNER',
  InFeed = 'IN_FEED',
  InStream = 'IN_STREAM',
  Locked = 'LOCKED',
  Sidebar = 'SIDEBAR',
  Unknown = 'UNKNOWN',
}

/** Deal Priority */
export enum EPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

/** Product dv segment */
export enum EProduct {
  BrandSafetySuitability = 'BRAND_SAFETY_SUITABILITY',
  Ivt = 'IVT',
  Viewability = 'VIEWABILITY',
}

/** Production type */
export enum EProductionType {
  Professional = 'PROFESSIONAL',
  Prosumer = 'PROSUMER',
  Ugc = 'UGC',
}

/** Rate type */
export enum ERateType {
  Cpa = 'CPA',
  Cpc = 'CPC',
  Cpcv = 'CPCV',
  Cpm = 'CPM',
}

/** Entity status */
export enum ERecordEntityStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
}

/** Segment targeting type */
export enum ESegmentType {
  Profile = 'PROFILE',
}

export type ESupplySchema = {
  __typename?: 'ESupplySchema';
  createdAt: Scalars['DateTime'];
  externalSupplyId: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  supplySource: Scalars['String'];
};

/** Supply source */
export enum ESupplySource {
  All = 'ALL',
  Direct = 'DIRECT',
  Reseller = 'RESELLER',
}

/** Viability provider for campaign */
export enum EViabilityProvider {
  DoubleVerify = 'DoubleVerify',
}

/** Video format */
export enum EVideoFormat {
  CtvAddWithOverlay = 'CtvAddWithOverlay',
  CtvBigStageWithDco = 'CtvBigStageWithDco',
  CtvBigStageWithoutDco = 'CtvBigStageWithoutDco',
  CtvStandardWithDco = 'CtvStandardWithDco',
  CtvStandardWithoutDco = 'CtvStandardWithoutDco',
  SelfHosted = 'SelfHosted',
}

export type EffectSchema = {
  __typename?: 'EffectSchema';
  background?: Maybe<Array<Scalars['String']>>;
  caption?: Maybe<Array<Scalars['String']>>;
  cta?: Maybe<Array<Scalars['String']>>;
  headline?: Maybe<Array<Scalars['String']>>;
  logo?: Maybe<Array<Scalars['String']>>;
  media?: Maybe<Array<Scalars['String']>>;
};

/** Export type */
export enum ExportType {
  Csv = 'CSV',
}

export type FloatRangeFilter = {
  /** Deals search by bid floor filter */
  from?: InputMaybe<Scalars['Float']>;
  /** Deals search by bid floor filter */
  to?: InputMaybe<Scalars['Float']>;
};

export type Frequency = {
  /** Create object */
  create: Array<CreateFrequencyTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type FrequencyTargetingBatchUpdateInput = {
  data: UpdateFrequencyTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type FrequencyTargetingPaginationSchema = {
  __typename?: 'FrequencyTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<FrequencyTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type FrequencyTargetingSchema = {
  __typename?: 'FrequencyTargetingSchema';
  createdAt: Scalars['DateTime'];
  freqCapCount: Scalars['Int'];
  freqCapPeriod: EFrequencyPeriods;
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type GenreSchema = {
  __typename?: 'GenreSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type GenreTargetingBatchUpdateInput = {
  data: UpdateGenreTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type GenreTargetingPaginationSchema = {
  __typename?: 'GenreTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<GenreTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type GenreTargetingSchema = {
  __typename?: 'GenreTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  genere?: Maybe<GenreSchema>;
  genre: GenreSchema;
  genreId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type Geo = {
  /** Create object */
  create: Array<CreateGeoTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type GeoCampaignSchema = {
  __typename?: 'GeoCampaignSchema';
  advertiser: AdvertiserSchema;
  currency: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: StatusCodeType;
};

export type GeoTargetingBatchUpdateInput = {
  data: UpdateGeoTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type GeoTargetingPaginationSchema = {
  __typename?: 'GeoTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<GeoTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type GeoTargetingSchema = {
  __typename?: 'GeoTargetingSchema';
  city?: Maybe<CitySchema>;
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  geoId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  metro?: Maybe<MetroSchema>;
  postalCode?: Maybe<PostalCodeSchema>;
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  state?: Maybe<StateSchema>;
  type: EGeoType;
};

export type GetAudienceDataProvidersArgsDto = {
  /** Audiences search by account id */
  accountId: Scalars['BigInt'];
  /** Include all public audiences records */
  includePublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type KpiSchema = {
  __typename?: 'KpiSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
};

export type LanguageSchema = {
  __typename?: 'LanguageSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type LanguageTargetingBatchUpdateInput = {
  data: UpdateLanguageTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type LanguageTargetingPaginationSchema = {
  __typename?: 'LanguageTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<LanguageTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type LanguageTargetingSchema = {
  __typename?: 'LanguageTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  language: LanguageSchema;
  languageId: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type LiveTargetingBatchUpdateInput = {
  data: UpdateLiveTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type LiveTargetingPaginationSchema = {
  __typename?: 'LiveTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<LiveTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type LiveTargetingSchema = {
  __typename?: 'LiveTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  live: ELiveType;
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type LocationGroupSchema = {
  __typename?: 'LocationGroupSchema';
  /** Audience account id */
  accountId?: Maybe<Scalars['BigInt']>;
  /** Date of creating Location Group */
  createdAt: Scalars['DateTime'];
  /** Location Group id */
  id: Scalars['BigInt'];
  /** Location Group name */
  name: Scalars['String'];
  /** POI count */
  poiCount?: Maybe<Scalars['Int']>;
  /** Strategy count */
  strategyCount?: Maybe<Scalars['Int']>;
  /** Strategy names */
  strategyNames?: Maybe<Array<Scalars['String']>>;
  /** Date of updating Location Group */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** LocationGroup Sort Field  */
export enum LocationGroupSortField {
  LocationGroupSortCreatedAt = 'LocationGroupSortCreatedAt',
  LocationGroupSortId = 'LocationGroupSortId',
  LocationGroupSortName = 'LocationGroupSortName',
  LocationGroupSortPoiCount = 'LocationGroupSortPoiCount',
  LocationGroupSortStrategiesCount = 'LocationGroupSortStrategiesCount',
  LocationGroupSortUpdatedAt = 'LocationGroupSortUpdatedAt',
}

export type LocationGroupsSort = {
  /** Location Group sort by id filter, default ASC */
  direction?: InputMaybe<SortingDirectionType>;
  /** Location Group sort by field */
  field: LocationGroupSortField;
};

export type MetroSchema = {
  __typename?: 'MetroSchema';
  code: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create new Adapt CTV template */
  addAdaptCtvTemplate: AddAdaptCtvTemplateSchema;
  /** Add new audio creative. */
  addAudioCreative: CreatedIdSchema;
  /** Add new banner creative. */
  addBannerCreative: CreatedIdSchema;
  /** Add new native creative. */
  addNativeCreative: CreatedIdSchema;
  /** Add or replace video variants for CTV creative by id. */
  addOrReplaceCtvVideoVariants: Scalars['Boolean'];
  /** Add new pal creative. */
  addPalCreative: CreatedIdSchema;
  /** Add new video creative. */
  addVideoCreative: CreatedIdSchema;
  /** Assign creatives to deal */
  assignCreatives: Scalars['Boolean'];
  /** Assign creatives to strategy */
  assignCreativesToStrategy: Scalars['Boolean'];
  /** Get Audiences csv file */
  audiencesExport: Scalars['String'];
  batchCreateAppCategoryTargeting: Array<AppCategoryTargetingSchema>;
  batchCreateAppTargeting: Array<AppTargetingSchema>;
  batchCreateBrowserTargeting: Array<BrowserTargetingSchema>;
  batchCreateCarrierTargeting: Array<CarrierTargetingSchema>;
  batchCreateCategoryTargeting: Array<CategoryTargetingSchema>;
  batchCreateCountryTargeting: Array<CountryTargetingSchema>;
  batchCreateCreativeTypeTargeting: Array<CreativeTypeTargetingSchema>;
  batchCreateDayPartTargeting: Array<DayPartTargetingSchema>;
  batchCreateDealTargeting: Array<DealTargetingSchema>;
  batchCreateDeviceModelTargeting: Array<DeviceModelTargetingSchema>;
  batchCreateDeviceTypeTargeting: Array<DeviceTypeTargetingSchema>;
  batchCreateDvAuthenticBrandSuitabilityTargeting: Array<DvAuthenticBrandSuitabilityTargetingSchema>;
  batchCreateDvBrandSafetySuitabilityTargeting: Array<DvBrandSafetySuitabilityTargetingSchema>;
  batchCreateDvViewabilityTargeting: Array<DvViewabilityTargetingSchema>;
  batchCreateFrequencyTargeting: Array<FrequencyTargetingSchema>;
  batchCreateGenreTargeting: Array<GenreTargetingSchema>;
  batchCreateGeoTargeting: Array<GeoTargetingSchema>;
  batchCreateLanguageTargeting: Array<LanguageTargetingSchema>;
  batchCreateLiveTargeting: Array<LiveTargetingSchema>;
  batchCreateOsTargeting: Array<OsTargetingSchema>;
  batchCreatePositionTargeting: Array<PositionTargetingSchema>;
  batchCreateProductionTargeting: Array<ProductionTargetingSchema>;
  batchCreateRatingTargeting: Array<RatingTargetingSchema>;
  batchCreateSegmentTargeting: Array<SegmentTargetingSchema>;
  batchCreateSiteTargeting: Array<SiteTargetingSchema>;
  batchCreateSupplyTargeting: Array<SupplyTargetingSchema>;
  batchDeleteAppCategoryTargeting: Array<Scalars['Boolean']>;
  batchDeleteAppTargeting: Array<Scalars['Boolean']>;
  batchDeleteBrowserTargeting: Array<Scalars['Boolean']>;
  batchDeleteCarrierTargeting: Array<Scalars['Boolean']>;
  batchDeleteCategoryTargeting: Array<Scalars['Boolean']>;
  batchDeleteCountryTargeting: Array<Scalars['Boolean']>;
  batchDeleteCreativeTypeTargeting: Array<Scalars['Boolean']>;
  batchDeleteDayPartTargeting: Array<Scalars['Boolean']>;
  batchDeleteDealTargeting: Array<Scalars['Boolean']>;
  batchDeleteDeviceModelTargeting: Array<Scalars['Boolean']>;
  batchDeleteDeviceTypeTargeting: Array<Scalars['Boolean']>;
  batchDeleteDvAuthenticBrandSuitabilityTargeting: Array<Scalars['Boolean']>;
  batchDeleteDvBrandSafetySuitabilityTargeting: Array<Scalars['Boolean']>;
  batchDeleteDvViewabilityTargeting: Array<Scalars['Boolean']>;
  batchDeleteFrequencyTargeting: Array<Scalars['Boolean']>;
  batchDeleteGenreTargeting: Array<Scalars['Boolean']>;
  batchDeleteGeoTargeting: Array<Scalars['Boolean']>;
  batchDeleteLanguageTargeting: Array<Scalars['Boolean']>;
  batchDeleteLiveTargeting: Array<Scalars['Boolean']>;
  batchDeleteOsTargeting: Array<Scalars['Boolean']>;
  batchDeletePositionTargeting: Array<Scalars['Boolean']>;
  batchDeleteProductionTargeting: Array<Scalars['Boolean']>;
  batchDeleteRatingTargeting: Array<Scalars['Boolean']>;
  batchDeleteSegmentTargeting: Array<Scalars['Boolean']>;
  batchDeleteSiteTargeting: Array<Scalars['Boolean']>;
  batchDeleteSupplyTargeting: Array<Scalars['Boolean']>;
  /** Adding, updating, deleting Pixel mappings */
  batchReplacePixelMappings: Scalars['BigInt'];
  batchUpdateAppCategoryTargeting: Array<AppCategoryTargetingSchema>;
  batchUpdateAppTargeting: Array<AppTargetingSchema>;
  batchUpdateBrowserTargeting: Array<BrowserTargetingSchema>;
  batchUpdateCarrierTargeting: Array<CarrierTargetingSchema>;
  batchUpdateCategoryTargeting: Array<CategoryTargetingSchema>;
  batchUpdateCountryTargeting: Array<CountryTargetingSchema>;
  batchUpdateCreativeTypeTargeting: Array<CreativeTypeTargetingSchema>;
  batchUpdateDayPartTargeting: Array<DayPartTargetingSchema>;
  batchUpdateDealTargeting: Array<DealTargetingSchema>;
  batchUpdateDeviceModelTargeting: Array<DeviceModelTargetingSchema>;
  batchUpdateDeviceTypeTargeting: Array<DeviceTypeTargetingSchema>;
  batchUpdateDvAuthenticBrandSuitabilityTargeting: Array<DvAuthenticBrandSuitabilityTargetingSchema>;
  batchUpdateDvBrandSafetySuitabilityTargeting: Array<DvBrandSafetySuitabilityTargetingSchema>;
  batchUpdateDvViewabilityTargeting: Array<DvViewabilityTargetingSchema>;
  batchUpdateFrequencyTargeting: Array<FrequencyTargetingSchema>;
  batchUpdateGenreTargeting: Array<GenreTargetingSchema>;
  batchUpdateGeoTargeting: Array<GeoTargetingSchema>;
  batchUpdateLanguageTargeting: Array<LanguageTargetingSchema>;
  batchUpdateLiveTargeting: Array<LiveTargetingSchema>;
  batchUpdateOsTargeting: Array<OsTargetingSchema>;
  batchUpdatePositionTargeting: Array<PositionTargetingSchema>;
  batchUpdateProductionTargeting: Array<ProductionTargetingSchema>;
  batchUpdateRatingTargeting: Array<RatingTargetingSchema>;
  batchUpdateSegmentTargeting: Array<SegmentTargetingSchema>;
  batchUpdateSiteTargeting: Array<SiteTargetingSchema>;
  batchUpdateSupplyTargeting: Array<SupplyTargetingSchema>;
  /** Bulk Update campaign by Id */
  bulkUpdateCampaign: Scalars['Boolean'];
  /** Bulk update deals */
  bulkUpdateDeals: Scalars['Boolean'];
  /** Bulk Update strategies */
  bulkUpdateStrategies: Scalars['Boolean'];
  /** Bulk Update strategies placeholder, needed to prevent issues with codegen */
  bulkUpdateStrategiesPlaceholder: Scalars['Boolean'];
  /** Bulk Update targeting */
  bulkUpdateTargeting: Scalars['Boolean'];
  /** Clone Campaign by Id */
  cloneCampaign: Scalars['Boolean'];
  /** Clone deal by ID */
  cloneDeal: Scalars['Int'];
  /** Clone Strategy by Id */
  cloneStrategy: Scalars['Boolean'];
  createApp: AppSchema;
  createAppCategory: AppCategorySchema;
  createAppCategoryTargeting: AppCategoryTargetingSchema;
  createAppTargeting: AppTargetingSchema;
  createBrowser: BrowserSchema;
  createBrowserTargeting: BrowserTargetingSchema;
  /** Create new campaign */
  createCampaign: CampaignSchema;
  createCarrier: CarrierSchema;
  createCarrierTargeting: CarrierTargetingSchema;
  createCategory: CategorySchema;
  createCategoryTargeting: CategoryTargetingSchema;
  /** create combined audience */
  createCombinedAudience: AudienceSchema;
  createCountry: CountrySchema;
  createCountryTargeting: CountryTargetingSchema;
  createCreativeType: CreativeTypeSchema;
  createCreativeTypeTargeting: CreativeTypeTargetingSchema;
  createDayPartTargeting: DayPartTargetingSchema;
  /** Create new deal */
  createDeal: DealSchema;
  createDealTargeting: DealTargetingSchema;
  createDevice: DeviceSchema;
  createDeviceModel: DeviceModelSchema;
  createDeviceModelTargeting: DeviceModelTargetingSchema;
  createDeviceTypeTargeting: DeviceTypeTargetingSchema;
  createDsp: ResourceSchema;
  createDspSeat: DspSeatSchema;
  createDvAuthenticBrandSuitabilityTargeting: DvAuthenticBrandSuitabilityTargetingSchema;
  createDvBrandSafetySuitabilityTargeting: DvBrandSafetySuitabilityTargetingSchema;
  createDvSegment: DvSegmentSchema;
  createDvViewabilityTargeting: DvViewabilityTargetingSchema;
  createFrequencyTargeting: FrequencyTargetingSchema;
  createGenre: GenreSchema;
  createGenreTargeting: GenreTargetingSchema;
  createGeoTargeting: GeoTargetingSchema;
  createKpi: KpiSchema;
  createLanguage: LanguageSchema;
  createLanguageTargeting: LanguageTargetingSchema;
  createLiveTargeting: LiveTargetingSchema;
  /** Create new Location Group */
  createLocationGroup: LocationGroupSchema;
  createOs: OsSchema;
  createOsTargeting: OsTargetingSchema;
  /** Create a New Pixel */
  createPixel: NewPixelSchema;
  createPositionTargeting: PositionTargetingSchema;
  createProductionTargeting: ProductionTargetingSchema;
  createRating: RatingSchema;
  createRatingTargeting: RatingTargetingSchema;
  /** Create new report mutation */
  createReport: ReportSchema;
  createSegmentTargeting: SegmentTargetingSchema;
  createSite: SiteSchema;
  createSiteTargeting: SiteTargetingSchema;
  /** Create new Strategy */
  createStrategy: StrategySchema;
  createSupplyTargeting: SupplyTargetingSchema;
  deleteApp: Scalars['Boolean'];
  deleteAppCategory: Scalars['Boolean'];
  deleteAppCategoryTargeting: Scalars['Boolean'];
  deleteAppTargeting: Scalars['Boolean'];
  deleteBrowser: Scalars['Boolean'];
  deleteBrowserTargeting: Scalars['Boolean'];
  /** Delete campaign by Id */
  deleteCampaign: Scalars['Boolean'];
  deleteCarrier: Scalars['Boolean'];
  deleteCarrierTargeting: Scalars['Boolean'];
  deleteCategory: Scalars['Boolean'];
  deleteCategoryTargeting: Scalars['Boolean'];
  deleteCountry: Scalars['Boolean'];
  deleteCountryTargeting: Scalars['Boolean'];
  deleteCreativeType: Scalars['Boolean'];
  deleteCreativeTypeTargeting: Scalars['Boolean'];
  deleteDayPartTargeting: Scalars['Boolean'];
  /** Delete deal by Id */
  deleteDeal: Scalars['Boolean'];
  deleteDealTargeting: Scalars['Boolean'];
  deleteDevice: Scalars['Boolean'];
  deleteDeviceModel: Scalars['Boolean'];
  deleteDeviceModelTargeting: Scalars['Boolean'];
  deleteDeviceTypeTargeting: Scalars['Boolean'];
  deleteDsp: Scalars['Boolean'];
  deleteDspSeat: Scalars['Boolean'];
  deleteDvAuthenticBrandSuitabilityTargeting: Scalars['Boolean'];
  deleteDvBrandSafetySuitabilityTargeting: Scalars['Boolean'];
  deleteDvSegment: Scalars['Boolean'];
  deleteDvViewabilityTargeting: Scalars['Boolean'];
  deleteFrequencyTargeting: Scalars['Boolean'];
  deleteGenre: Scalars['Boolean'];
  deleteGenreTargeting: Scalars['Boolean'];
  deleteGeoTargeting: Scalars['Boolean'];
  deleteKpi: Scalars['Boolean'];
  deleteLanguage: Scalars['Boolean'];
  deleteLanguageTargeting: Scalars['Boolean'];
  deleteLiveTargeting: Scalars['Boolean'];
  /** Delete Location Groups by Ids */
  deleteLocationGroups: MutationResponse;
  deleteOs: Scalars['Boolean'];
  deleteOsTargeting: Scalars['Boolean'];
  deletePositionTargeting: Scalars['Boolean'];
  deleteProductionTargeting: Scalars['Boolean'];
  deleteRating: Scalars['Boolean'];
  deleteRatingTargeting: Scalars['Boolean'];
  /** Delete reports by Ids */
  deleteReports: Scalars['Boolean'];
  deleteSegmentTargeting: Scalars['Boolean'];
  deleteSite: Scalars['Boolean'];
  deleteSiteTargeting: Scalars['Boolean'];
  /** Delete Strategy by Id */
  deleteStrategy: Scalars['Boolean'];
  deleteSupplyTargeting: Scalars['Boolean'];
  /** Get Pixels csv file */
  exportPixels: Scalars['String'];
  /** Get Location Groups csv file */
  locationGroupExport: Scalars['String'];
  /** Replace batch coordinates for deal */
  replacePoiBatch: Scalars['Boolean'];
  replaceTargetingAudiencesBatch: Scalars['Boolean'];
  /** Run report by ID  */
  runReportById: MutationResponse;
  supplyBatchReplace: Scalars['Boolean'];
  /** Unassign creatives to deal */
  unassignCreatives: Scalars['Boolean'];
  /** Update Adapt CTV template by id */
  updateAdaptCtvTemplate: Scalars['Boolean'];
  updateApp: AppSchema;
  updateAppCategory: AppCategorySchema;
  updateAppCategoryTargeting: AppCategoryTargetingSchema;
  updateAppTargeting: AppTargetingSchema;
  /** Update audio creative by id. */
  updateAudioCreative: Scalars['Boolean'];
  /** Update banner creative by id. */
  updateBannerCreative: Scalars['Boolean'];
  updateBrowser: BrowserSchema;
  updateBrowserTargeting: BrowserTargetingSchema;
  /** Update campaign by Id */
  updateCampaign: CampaignSchema;
  updateCarrier: CarrierSchema;
  updateCarrierTargeting: CarrierTargetingSchema;
  updateCategory: CategorySchema;
  updateCategoryTargeting: CategoryTargetingSchema;
  /** edit an existing combined audience */
  updateCombinedAudience: AudienceSchema;
  updateCountry: CountrySchema;
  updateCountryTargeting: CountryTargetingSchema;
  updateCreativeType: CreativeTypeSchema;
  updateCreativeTypeTargeting: CreativeTypeTargetingSchema;
  updateDayPartTargeting: DayPartTargetingSchema;
  /** Update deal by Id */
  updateDeal: DealSchema;
  updateDealTargeting: DealTargetingSchema;
  updateDevice: DeviceSchema;
  updateDeviceModel: DeviceModelSchema;
  updateDeviceModelTargeting: DeviceModelTargetingSchema;
  updateDeviceTypeTargeting: DeviceTypeTargetingSchema;
  updateDsp: ResourceSchema;
  updateDspSeat: DspSeatSchema;
  updateDvAuthenticBrandSuitabilityTargeting: DvAuthenticBrandSuitabilityTargetingSchema;
  updateDvBrandSafetySuitabilityTargeting: DvBrandSafetySuitabilityTargetingSchema;
  updateDvSegment: DvSegmentSchema;
  updateDvViewabilityTargeting: DvViewabilityTargetingSchema;
  updateFrequencyTargeting: FrequencyTargetingSchema;
  updateGenre: GenreSchema;
  updateGenreTargeting: GenreTargetingSchema;
  updateGeoTargeting: GeoTargetingSchema;
  updateKpi: KpiSchema;
  updateLanguage: LanguageSchema;
  updateLanguageTargeting: LanguageTargetingSchema;
  updateLiveTargeting: LiveTargetingSchema;
  /** Update new Location Group */
  updateLocationGroup: Scalars['Boolean'];
  /** Update native creative by id. */
  updateNativeCreative: Scalars['Boolean'];
  updateOs: OsSchema;
  updateOsTargeting: OsTargetingSchema;
  /** Update pal creative by id. */
  updatePalCreative: Scalars['Boolean'];
  /** Pixel update by ID */
  updatePixel: Scalars['BigInt'];
  updatePositionTargeting: PositionTargetingSchema;
  updateProductionTargeting: ProductionTargetingSchema;
  updateRating: RatingSchema;
  updateRatingTargeting: RatingTargetingSchema;
  /** Update report by Id */
  updateReport: ReportSchema;
  updateSegmentTargeting: SegmentTargetingSchema;
  updateSite: SiteSchema;
  updateSiteTargeting: SiteTargetingSchema;
  /** Update Strategy by Id */
  updateStrategy: StrategySchema;
  updateSupplyTargeting: SupplyTargetingSchema;
  /** Update Video creative by id. */
  updateVideoCreative: Scalars['Boolean'];
  uploadImage: Scalars['String'];
  uploadVideo: Scalars['String'];
};

export type MutationAddAdaptCtvTemplateArgs = {
  data: AddOrUpdateAdaptCtvTemplateDto;
};

export type MutationAddAudioCreativeArgs = {
  data: CreateAudioDto;
};

export type MutationAddBannerCreativeArgs = {
  data: CreateBannerDto;
};

export type MutationAddNativeCreativeArgs = {
  data: CreateNativeDto;
};

export type MutationAddOrReplaceCtvVideoVariantsArgs = {
  creativeId: Scalars['BigInt'];
  data: AddOrReplaceCtvVideoVariantsDto;
};

export type MutationAddPalCreativeArgs = {
  data: CreateBannerDto;
};

export type MutationAddVideoCreativeArgs = {
  data: CreateVideoDto;
};

export type MutationAssignCreativesArgs = {
  creativeIds: Array<Scalars['BigInt']>;
  dealId: Scalars['BigInt'];
};

export type MutationAssignCreativesToStrategyArgs = {
  creativeIds: Array<Scalars['BigInt']>;
  strategyId: Scalars['BigInt'];
};

export type MutationAudiencesExportArgs = {
  accountId: Scalars['BigInt'];
  fields: Array<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  type: ExportType;
};

export type MutationBatchCreateAppCategoryTargetingArgs = {
  data: Array<CreateAppCategoryTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateAppTargetingArgs = {
  data: Array<CreateAppTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateBrowserTargetingArgs = {
  data: Array<CreateBrowserTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateCarrierTargetingArgs = {
  data: Array<CreateCarrierTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateCategoryTargetingArgs = {
  data: Array<CreateCategoryTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateCountryTargetingArgs = {
  data: Array<CreateCountryTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateCreativeTypeTargetingArgs = {
  data: Array<CreateCreativeTypeTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDayPartTargetingArgs = {
  data: Array<CreateDayPartTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDealTargetingArgs = {
  data: Array<CreateDealTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDeviceModelTargetingArgs = {
  data: Array<CreateDeviceModelTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDeviceTypeTargetingArgs = {
  data: Array<CreateDeviceTypeTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDvAuthenticBrandSuitabilityTargetingArgs = {
  data: Array<CreateDvAuthenticBrandSuitabilityTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDvBrandSafetySuitabilityTargetingArgs = {
  data: Array<CreateDvBrandSafetySuitabilityTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateDvViewabilityTargetingArgs = {
  data: Array<CreateDvViewabilityTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateFrequencyTargetingArgs = {
  data: Array<CreateFrequencyTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateGenreTargetingArgs = {
  data: Array<CreateGenreTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateGeoTargetingArgs = {
  data: Array<CreateGeoTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateLanguageTargetingArgs = {
  data: Array<CreateLanguageTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateLiveTargetingArgs = {
  data: Array<CreateLiveTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateOsTargetingArgs = {
  data: Array<CreateOsTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreatePositionTargetingArgs = {
  data: Array<CreatePositionTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateProductionTargetingArgs = {
  data: Array<CreateProductionTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateRatingTargetingArgs = {
  data: Array<CreateRatingTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateSegmentTargetingArgs = {
  data: Array<CreateSegmentTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateSiteTargetingArgs = {
  data: Array<CreateSiteTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchCreateSupplyTargetingArgs = {
  data: Array<CreateSupplyTargetingDto>;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationBatchDeleteAppCategoryTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteAppTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteBrowserTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteCarrierTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteCategoryTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteCountryTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteCreativeTypeTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDayPartTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDealTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDeviceModelTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDeviceTypeTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDvAuthenticBrandSuitabilityTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDvBrandSafetySuitabilityTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteDvViewabilityTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteFrequencyTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteGenreTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteGeoTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteLanguageTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteLiveTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteOsTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeletePositionTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteProductionTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteRatingTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteSegmentTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteSiteTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchDeleteSupplyTargetingArgs = {
  ids: Array<Scalars['BigInt']>;
  refId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<EObjectType>;
};

export type MutationBatchReplacePixelMappingsArgs = {
  data: PixelMappingNameArgsDto;
  pixelId: Scalars['BigInt'];
};

export type MutationBatchUpdateAppCategoryTargetingArgs = {
  data: Array<AppCategoryTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateAppTargetingArgs = {
  data: Array<AppTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateBrowserTargetingArgs = {
  data: Array<BrowserTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateCarrierTargetingArgs = {
  data: Array<CarrierTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateCategoryTargetingArgs = {
  data: Array<CategoryTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateCountryTargetingArgs = {
  data: Array<CountryTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateCreativeTypeTargetingArgs = {
  data: Array<CreativeTypeTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDayPartTargetingArgs = {
  data: Array<DayPartTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDealTargetingArgs = {
  data: Array<DealTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDeviceModelTargetingArgs = {
  data: Array<DeviceModelTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDeviceTypeTargetingArgs = {
  data: Array<DeviceTypeTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDvAuthenticBrandSuitabilityTargetingArgs = {
  data: Array<DvAuthenticBrandSuitabilityTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDvBrandSafetySuitabilityTargetingArgs = {
  data: Array<DvBrandSafetySuitabilityTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateDvViewabilityTargetingArgs = {
  data: Array<DvViewabilityTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateFrequencyTargetingArgs = {
  data: Array<FrequencyTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateGenreTargetingArgs = {
  data: Array<GenreTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateGeoTargetingArgs = {
  data: Array<GeoTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateLanguageTargetingArgs = {
  data: Array<LanguageTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateLiveTargetingArgs = {
  data: Array<LiveTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateOsTargetingArgs = {
  data: Array<OsTargetingBatchUpdateInput>;
};

export type MutationBatchUpdatePositionTargetingArgs = {
  data: Array<PositionTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateProductionTargetingArgs = {
  data: Array<ProductionTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateRatingTargetingArgs = {
  data: Array<RatingTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateSegmentTargetingArgs = {
  data: Array<SegmentTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateSiteTargetingArgs = {
  data: Array<SiteTargetingBatchUpdateInput>;
};

export type MutationBatchUpdateSupplyTargetingArgs = {
  data: Array<SupplyTargetingBatchUpdateInput>;
};

export type MutationBulkUpdateCampaignArgs = {
  data: Array<UpdateCampaignArgsDto>;
};

export type MutationBulkUpdateDealsArgs = {
  data: Array<BulkUpdateDealsArgsDto>;
};

export type MutationBulkUpdateStrategiesArgs = {
  data: Array<BulkUpdateStrategyArgsDto>;
};

export type MutationBulkUpdateStrategiesPlaceholderArgs = {
  data: Array<UpdateStrategyArgsDto>;
};

export type MutationBulkUpdateTargetingArgs = {
  data: BulkUpdateTargetingArgsDto;
};

export type MutationCloneCampaignArgs = {
  data: CloneCampaignArgsDto;
  id: Scalars['BigInt'];
};

export type MutationCloneDealArgs = {
  data: CloneDealsArgsDto;
  dealId: Scalars['BigInt'];
};

export type MutationCloneStrategyArgs = {
  data: CloneStrategyArgsDto;
  id: Scalars['BigInt'];
};

export type MutationCreateAppArgs = {
  data: CreateAppArgsDto;
};

export type MutationCreateAppCategoryArgs = {
  data: CreateAppCategoryArgsDto;
};

export type MutationCreateAppCategoryTargetingArgs = {
  data: CreateAppCategoryTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateAppTargetingArgs = {
  data: CreateAppTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateBrowserArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateBrowserTargetingArgs = {
  data: CreateBrowserTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateCampaignArgs = {
  data: CreateCampaignArgsDto;
};

export type MutationCreateCarrierArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateCarrierTargetingArgs = {
  data: CreateCarrierTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateCategoryArgs = {
  data: CreateCategoryArgsDto;
};

export type MutationCreateCategoryTargetingArgs = {
  data: CreateCategoryTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateCombinedAudienceArgs = {
  accountId: Scalars['Int'];
  children: Array<CombinedAudienceArg>;
  childrenClause?: InputMaybe<EAudienceCombineClause>;
  countryCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MutationCreateCountryArgs = {
  data: CreateCountryArgsDto;
};

export type MutationCreateCountryTargetingArgs = {
  data: CreateCountryTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateCreativeTypeArgs = {
  data: CreateCreativeTypeArgsDto;
};

export type MutationCreateCreativeTypeTargetingArgs = {
  data: CreateCreativeTypeTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDayPartTargetingArgs = {
  data: CreateDayPartTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDealArgs = {
  data: CreateDealsArgsDto;
};

export type MutationCreateDealTargetingArgs = {
  data: CreateDealTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDeviceArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateDeviceModelArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateDeviceModelTargetingArgs = {
  data: CreateDeviceModelTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDeviceTypeTargetingArgs = {
  data: CreateDeviceTypeTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDspArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateDspSeatArgs = {
  data: CreateDspSeatArgsDto;
};

export type MutationCreateDvAuthenticBrandSuitabilityTargetingArgs = {
  data: CreateDvAuthenticBrandSuitabilityTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDvBrandSafetySuitabilityTargetingArgs = {
  data: CreateDvBrandSafetySuitabilityTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateDvSegmentArgs = {
  data: CreateDvSegmentArgsDto;
};

export type MutationCreateDvViewabilityTargetingArgs = {
  data: CreateDvViewabilityTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateFrequencyTargetingArgs = {
  data: CreateFrequencyTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateGenreArgs = {
  data: CreateGenreArgsDto;
};

export type MutationCreateGenreTargetingArgs = {
  data: CreateGenreTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateGeoTargetingArgs = {
  data: CreateGeoTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateKpiArgs = {
  data: CreateKpiArgsDto;
};

export type MutationCreateLanguageArgs = {
  data: CreateLanguageArgsDto;
};

export type MutationCreateLanguageTargetingArgs = {
  data: CreateLanguageTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateLiveTargetingArgs = {
  data: CreateLiveTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateLocationGroupArgs = {
  data: CreateLocationGroupArgsDto;
};

export type MutationCreateOsArgs = {
  data: CreateResourceArgsDto;
};

export type MutationCreateOsTargetingArgs = {
  data: CreateOsTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreatePixelArgs = {
  data: CreatePixelsArgsDto;
};

export type MutationCreatePositionTargetingArgs = {
  data: CreatePositionTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateProductionTargetingArgs = {
  data: CreateProductionTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateRatingArgs = {
  data: CreateRatingArgsDto;
};

export type MutationCreateRatingTargetingArgs = {
  data: CreateRatingTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateReportArgs = {
  data: CreateReportInputDto;
};

export type MutationCreateSegmentTargetingArgs = {
  data: CreateSegmentTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateSiteArgs = {
  data: CreateSiteArgsDto;
};

export type MutationCreateSiteTargetingArgs = {
  data: CreateSiteTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationCreateStrategyArgs = {
  campaignId: Scalars['BigInt'];
  data: CreateStrategyArgsDto;
};

export type MutationCreateSupplyTargetingArgs = {
  data: CreateSupplyTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
};

export type MutationDeleteAppArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteAppCategoryArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteAppCategoryTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteAppTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteBrowserArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteBrowserTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCampaignArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCarrierArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCarrierTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCategoryArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCategoryTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCountryArgs = {
  id: Scalars['String'];
};

export type MutationDeleteCountryTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCreativeTypeArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteCreativeTypeTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDayPartTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDealArgs = {
  dealId: Scalars['BigInt'];
};

export type MutationDeleteDealTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDeviceArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDeviceModelArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDeviceModelTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDeviceTypeTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDspArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDspSeatArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDvAuthenticBrandSuitabilityTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDvBrandSafetySuitabilityTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDvSegmentArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteDvViewabilityTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteFrequencyTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteGenreArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteGenreTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteGeoTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteKpiArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteLanguageArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteLanguageTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteLiveTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteLocationGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type MutationDeleteOsArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteOsTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeletePositionTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteProductionTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteRatingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteRatingTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteReportsArgs = {
  ids: Array<Scalars['BigInt']>;
};

export type MutationDeleteSegmentTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteSiteArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteSiteTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteStrategyArgs = {
  id: Scalars['BigInt'];
};

export type MutationDeleteSupplyTargetingArgs = {
  id: Scalars['BigInt'];
};

export type MutationExportPixelsArgs = {
  fields: Array<Scalars['String']>;
  ids: Array<Scalars['BigInt']>;
  type: ExportType;
};

export type MutationLocationGroupExportArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  type: ExportType;
};

export type MutationReplacePoiBatchArgs = {
  data: ReplaceBatchPoiInputDto;
  referenceObjectID: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type MutationReplaceTargetingAudiencesBatchArgs = {
  data: ReplaceTargetingAudiencesBatchDto;
  id: Scalars['Float'];
  type: Scalars['String'];
};

export type MutationRunReportByIdArgs = {
  id: Scalars['Float'];
};

export type MutationSupplyBatchReplaceArgs = {
  objectId: Scalars['BigInt'];
  objectType: TargetingObjectTypeEnum;
  replace: BatchReplace;
};

export type MutationUnassignCreativesArgs = {
  creativeIds: Array<Scalars['BigInt']>;
  dealId: Scalars['BigInt'];
};

export type MutationUpdateAdaptCtvTemplateArgs = {
  data: AddOrUpdateAdaptCtvTemplateDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateAppArgs = {
  data: UpdateAppArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateAppCategoryArgs = {
  data: UpdateAppCategoryArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateAppCategoryTargetingArgs = {
  data: UpdateAppCategoryTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateAppTargetingArgs = {
  data: UpdateAppTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateAudioCreativeArgs = {
  creativeId: Scalars['BigInt'];
  data: UpdateAudioDto;
};

export type MutationUpdateBannerCreativeArgs = {
  creativeId: Scalars['BigInt'];
  data: UpdateBannerDto;
};

export type MutationUpdateBrowserArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateBrowserTargetingArgs = {
  data: UpdateBrowserTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCampaignArgs = {
  data: UpdateCampaignArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCarrierArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCarrierTargetingArgs = {
  data: UpdateCarrierTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCategoryArgs = {
  data: UpdateCategoryArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCategoryTargetingArgs = {
  data: UpdateCategoryTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCombinedAudienceArgs = {
  accountId: Scalars['Int'];
  children: Array<CombinedAudienceArg>;
  childrenClause?: InputMaybe<EAudienceCombineClause>;
  countryCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MutationUpdateCountryArgs = {
  data: UpdateCountryArgsDto;
  id: Scalars['String'];
};

export type MutationUpdateCountryTargetingArgs = {
  data: UpdateCountryTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCreativeTypeArgs = {
  data: UpdateCreativeTypeArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateCreativeTypeTargetingArgs = {
  data: UpdateCreativeTypeTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDayPartTargetingArgs = {
  data: UpdateDayPartTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDealArgs = {
  data: UpdateDealsArgsDto;
  dealId: Scalars['BigInt'];
};

export type MutationUpdateDealTargetingArgs = {
  data: UpdateDealTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDeviceArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDeviceModelArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDeviceModelTargetingArgs = {
  data: UpdateDeviceModelTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDeviceTypeTargetingArgs = {
  data: UpdateDeviceTypeTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDspArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDspSeatArgs = {
  data: UpdateDspSeatArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDvAuthenticBrandSuitabilityTargetingArgs = {
  data: UpdateDvAuthenticBrandSuitabilityTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDvBrandSafetySuitabilityTargetingArgs = {
  data: UpdateDvBrandSafetySuitabilityTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDvSegmentArgs = {
  data: UpdateDvSegmentArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateDvViewabilityTargetingArgs = {
  data: UpdateDvViewabilityTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateFrequencyTargetingArgs = {
  data: UpdateFrequencyTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateGenreArgs = {
  data: UpdateGenreArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateGenreTargetingArgs = {
  data: UpdateGenreTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateGeoTargetingArgs = {
  data: UpdateGeoTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateKpiArgs = {
  data: UpdateKpiArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateLanguageArgs = {
  data: UpdateLanguageArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateLanguageTargetingArgs = {
  data: UpdateLanguageTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateLiveTargetingArgs = {
  data: UpdateLiveTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateLocationGroupArgs = {
  data: UpdateLocationGroupArgsDto;
};

export type MutationUpdateNativeCreativeArgs = {
  creativeId: Scalars['BigInt'];
  data: UpdateNativeDto;
};

export type MutationUpdateOsArgs = {
  data: UpdateResourceArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateOsTargetingArgs = {
  data: UpdateOsTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdatePalCreativeArgs = {
  creativeId: Scalars['BigInt'];
  data: UpdateBannerDto;
};

export type MutationUpdatePixelArgs = {
  data: UpdatePixelsArgsDto;
  pixelId: Scalars['BigInt'];
};

export type MutationUpdatePositionTargetingArgs = {
  data: UpdatePositionTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateProductionTargetingArgs = {
  data: UpdateProductionTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateRatingArgs = {
  data: UpdateRatingArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateRatingTargetingArgs = {
  data: UpdateRatingTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateReportArgs = {
  data: UpdateReportArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateSegmentTargetingArgs = {
  data: UpdateSegmentTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateSiteArgs = {
  data: UpdateSiteArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateSiteTargetingArgs = {
  data: UpdateSiteTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateStrategyArgs = {
  data: UpdateStrategyArgsDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateSupplyTargetingArgs = {
  data: UpdateSupplyTargetingDto;
  id: Scalars['BigInt'];
};

export type MutationUpdateVideoCreativeArgs = {
  creativeId: Scalars['BigInt'];
  data: UpdateVideoDto;
};

export type MutationUploadImageArgs = {
  data: UploadImageDto;
};

export type MutationUploadVideoArgs = {
  data: UploadVideoDto;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type NativeAnimation = {
  __typename?: 'NativeAnimation';
  /** Attention animation */
  attention?: Maybe<Scalars['String']>;
  /** Intro animation */
  intro?: Maybe<Scalars['String']>;
  /** Polite Load animations */
  load?: Maybe<Scalars['String']>;
};

export type NativeAnimationInput = {
  /** Attention animation */
  attention?: InputMaybe<Scalars['String']>;
  /** Intro animation */
  intro?: InputMaybe<Scalars['String']>;
  /** Polite Load animations */
  load?: InputMaybe<Scalars['String']>;
};

export type NativeAttributes = {
  __typename?: 'NativeAttributes';
  animation?: Maybe<NativeAnimation>;
  animationName?: Maybe<Scalars['String']>;
  brandName: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  clickThroughLink?: Maybe<Scalars['String']>;
  ctaText: Scalars['String'];
  disclosure: Scalars['String'];
  effectCtaName?: Maybe<Scalars['String']>;
  effectLogoName?: Maybe<Scalars['String']>;
  effectMediaName?: Maybe<Scalars['String']>;
  /** Native event trackers attributes */
  event_trackers?: Maybe<Array<NativeEventTracker>>;
  headline: Scalars['String'];
  /** Creative multiple headline assets. */
  headlines?: Maybe<Array<Scalars['String']>>;
  height: Scalars['Int'];
  logo: NativeMedia;
  /** Creative image asset */
  main?: Maybe<NativeMedia>;
  /** Creative multiple image assets. */
  mains?: Maybe<Array<NativeMedia>>;
  platform: PlatformType;
  publisherId: Scalars['BigInt'];
  /** Native Slideshow items */
  slides?: Maybe<Array<NativeSlide>>;
  thirdPartyPixelTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTag?: Maybe<Scalars['String']>;
  thirdPartyTagTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: Maybe<Scalars['String']>;
  /** Native Video attributes */
  video?: Maybe<VideoAttributes>;
  width: Scalars['Int'];
};

export type NativeAttributesInput = {
  animation?: InputMaybe<NativeAnimationInput>;
  animationName?: InputMaybe<Scalars['String']>;
  brandName: Scalars['String'];
  caption?: InputMaybe<Scalars['String']>;
  clickThroughLink?: InputMaybe<Scalars['String']>;
  ctaText: Scalars['String'];
  disclosure: Scalars['String'];
  effectCtaName?: InputMaybe<Scalars['String']>;
  effectLogoName?: InputMaybe<Scalars['String']>;
  effectMediaName?: InputMaybe<Scalars['String']>;
  /** Native event trackers attributes */
  event_trackers?: InputMaybe<Array<NativeEventTrackerInput>>;
  headline: Scalars['String'];
  /** Creative multiple headline assets. */
  headlines?: InputMaybe<Array<Scalars['String']>>;
  height: Scalars['Int'];
  logo: NativeMediaInput;
  /** Creative image asset */
  main?: InputMaybe<NativeMediaInput>;
  /** Creative multiple image assets. */
  mains?: InputMaybe<Array<NativeMediaInput>>;
  platform: PlatformType;
  publisherId: Scalars['BigInt'];
  /** Native Slideshow items */
  slides?: InputMaybe<Array<NativeSlideInput>>;
  thirdPartyPixelTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTag?: InputMaybe<Scalars['String']>;
  thirdPartyTagTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: InputMaybe<Scalars['String']>;
  /** Native Video attributes */
  video?: InputMaybe<VideoAttributesInput>;
  width: Scalars['Int'];
};

export type NativeCreativeSchema = {
  __typename?: 'NativeCreativeSchema';
  account: AccountSchema;
  advertiser: AdvertiserSchema;
  advertiserID: Scalars['BigInt'];
  attributes: NativeAttributes;
  createdAt: Scalars['DateTime'];
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: Maybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: Maybe<Scalars['String']>;
  thirdPartyPlacementName?: Maybe<Scalars['String']>;
  typeID: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type NativeEventTracker = {
  __typename?: 'NativeEventTracker';
  event: Scalars['Int'];
  method: Scalars['Int'];
  url: Scalars['String'];
};

export type NativeEventTrackerInput = {
  event: Scalars['Int'];
  method: Scalars['Int'];
  url: Scalars['String'];
};

export type NativeMedia = {
  __typename?: 'NativeMedia';
  height: Scalars['Float'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type NativeMediaInput = {
  height: Scalars['Float'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type NativeSlide = {
  __typename?: 'NativeSlide';
  caption?: Maybe<Scalars['String']>;
  clickThroughLink?: Maybe<Scalars['String']>;
  ctaText: Scalars['String'];
  headline: Scalars['String'];
  main: NativeMedia;
};

export type NativeSlideInput = {
  caption?: InputMaybe<Scalars['String']>;
  clickThroughLink?: InputMaybe<Scalars['String']>;
  ctaText: Scalars['String'];
  headline: Scalars['String'];
  main: NativeMediaInput;
};

export type NewPixelSchema = {
  __typename?: 'NewPixelSchema';
  /** Pixel account id */
  accountId: Scalars['Int'];
  /** Pixel advertiser id */
  advertiserId: Scalars['Int'];
  /** Date of the pixel creation */
  createdAt: Scalars['DateTime'];
  /** Pixel id */
  id: Scalars['Int'];
  /** Pixel name */
  name: Scalars['String'];
  /** Pixel status */
  status: ERecordEntityStatus;
  /** Date of last update of the pixel */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Os = {
  /** Create object */
  create: Array<CreateOsTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type OsSchema = {
  __typename?: 'OsSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type OsTargetingBatchUpdateInput = {
  data: UpdateOsTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type OsTargetingPaginationSchema = {
  __typename?: 'OsTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<OsTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type OsTargetingSchema = {
  __typename?: 'OsTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  osId: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

/** POI Status Field */
export enum PoiStatus {
  PoiStatusActive = 'POIStatusActive',
  PoiStatusInActive = 'POIStatusInActive',
  PoiStatusObsolete = 'POIStatusObsolete',
}

export type PaginatedAdaptCtvTemplatesSchema = {
  __typename?: 'PaginatedAdaptCtvTemplatesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AdaptCtvTemplateSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAdvertisersSchema = {
  __typename?: 'PaginatedAdvertisersSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AdvertiserSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAgenciesSchema = {
  __typename?: 'PaginatedAgenciesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AgencySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAppCategorySchema = {
  __typename?: 'PaginatedAppCategorySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AppCategorySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAppSchema = {
  __typename?: 'PaginatedAppSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AppSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAudienceCategorySchema = {
  __typename?: 'PaginatedAudienceCategorySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AudienceCategorySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAudienceDataProviderSchema = {
  __typename?: 'PaginatedAudienceDataProviderSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AudienceDataProviderSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAudienceTypeSchema = {
  __typename?: 'PaginatedAudienceTypeSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AudienceTypeSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedAudiencesSchema = {
  __typename?: 'PaginatedAudiencesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<AudienceSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedBrowserSchema = {
  __typename?: 'PaginatedBrowserSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<BrowserSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCampaignSchema = {
  __typename?: 'PaginatedCampaignSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CampaignSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCarrierSchema = {
  __typename?: 'PaginatedCarrierSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CarrierSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCategorySchema = {
  __typename?: 'PaginatedCategorySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CategorySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCitySchema = {
  __typename?: 'PaginatedCitySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CitySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCountrySchema = {
  __typename?: 'PaginatedCountrySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CountrySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCreativeFormatsSchema = {
  __typename?: 'PaginatedCreativeFormatsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CreativeFormatSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCreativeTypeSchema = {
  __typename?: 'PaginatedCreativeTypeSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CreativeTypeSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCreativesSchema = {
  __typename?: 'PaginatedCreativesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<ResultUnion>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCtvVideoTemplatesSchema = {
  __typename?: 'PaginatedCtvVideoTemplatesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CtvVideoTemplateSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedCtvVideoVariantsSchema = {
  __typename?: 'PaginatedCtvVideoVariantsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<CtvVideoVariantSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDealsSchema = {
  __typename?: 'PaginatedDealsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DealSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDeviceModelSchema = {
  __typename?: 'PaginatedDeviceModelSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DeviceModelSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDeviceSchema = {
  __typename?: 'PaginatedDeviceSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DeviceSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDspSchema = {
  __typename?: 'PaginatedDspSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<ResourceSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDspSeatSchema = {
  __typename?: 'PaginatedDspSeatSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DspSeatSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedDvSegmentSchema = {
  __typename?: 'PaginatedDvSegmentSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<DvSegmentSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedGenreSchema = {
  __typename?: 'PaginatedGenreSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<GenreSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedGeoCampaignsSchema = {
  __typename?: 'PaginatedGeoCampaignsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<GeoCampaignSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedKpiSchema = {
  __typename?: 'PaginatedKpiSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<KpiSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedLanguageSchema = {
  __typename?: 'PaginatedLanguageSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<LanguageSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedLocationGroupsSchema = {
  __typename?: 'PaginatedLocationGroupsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<LocationGroupSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedMetroSchema = {
  __typename?: 'PaginatedMetroSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<MetroSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedOsSchema = {
  __typename?: 'PaginatedOsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<OsSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPixelMappingsSchema = {
  __typename?: 'PaginatedPixelMappingsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PixelMappingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPixelsSchema = {
  __typename?: 'PaginatedPixelsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PixelSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPoiSchema = {
  __typename?: 'PaginatedPoiSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PoiSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestBrandsSchema = {
  __typename?: 'PaginatedPointOfInterestBrandsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestBrandSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestCategoriesSchema = {
  __typename?: 'PaginatedPointOfInterestCategoriesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestCategorySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestCategoriesWithSubCategoriesSchema = {
  __typename?: 'PaginatedPointOfInterestCategoriesWithSubCategoriesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestCategoryWithSubCategoriesSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestSchema = {
  __typename?: 'PaginatedPointOfInterestSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestStatesSchema = {
  __typename?: 'PaginatedPointOfInterestStatesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestStateSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPointOfInterestSubCategoriesSchema = {
  __typename?: 'PaginatedPointOfInterestSubCategoriesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PointOfInterestSubCategorySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedPostalSchema = {
  __typename?: 'PaginatedPostalSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PostalCodeSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedRatingSchema = {
  __typename?: 'PaginatedRatingSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<RatingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedReportsSchema = {
  __typename?: 'PaginatedReportsSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<ReportSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedSiteSchema = {
  __typename?: 'PaginatedSiteSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<SiteSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedStateSchema = {
  __typename?: 'PaginatedStateSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<StateSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedStrategySchema = {
  __typename?: 'PaginatedStrategySchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<StrategySchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PaginatedTargetingAudiencesSchema = {
  __typename?: 'PaginatedTargetingAudiencesSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<TargetingAudiencesSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PixelMappedSort = {
  /** Pixels sort direction, default ASC */
  direction?: InputMaybe<SortingDirectionType>;
  /** Pixels sort field */
  field: EPixelsMappedSortField;
};

export type PixelMappingNameArgsDto = {
  /** Pixels for create */
  create?: InputMaybe<Array<CreatePixelMappingsDto>>;
  /** Pixels for delete */
  delete?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Pixels for update */
  update?: InputMaybe<Array<UpdatePixelMappingsDto>>;
};

export type PixelMappingSchema = {
  __typename?: 'PixelMappingSchema';
  /** Pixel Mapping account id */
  accountId: Scalars['BigInt'];
  /** Date of the pixel creation */
  createdAt: Scalars['DateTime'];
  /** Pixel Mapping Description */
  description: Scalars['String'];
  /** Pixel Mapping events */
  events?: Maybe<Scalars['BigInt']>;
  /** Pixel Mapping id */
  id: Scalars['BigInt'];
  /** Pixel Mapping Last fire */
  lastFire?: Maybe<Scalars['DateTime']>;
  /** Pixel Mapping Page URL */
  pageUrl: Scalars['String'];
  pixel: PixelSchema;
  /** Pixel Mapping Pixel id */
  pixelId: Scalars['BigInt'];
  /** Date of last update of the pixel */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PixelSchema = {
  __typename?: 'PixelSchema';
  /** Pixel account id */
  accountId: Scalars['BigInt'];
  /** Pixel advertiser id */
  advertiserId: Scalars['BigInt'];
  /** Date of the pixel creation */
  createdAt: Scalars['DateTime'];
  /** Pixel events */
  events?: Maybe<Scalars['BigInt']>;
  /** Pixel id */
  id: Scalars['BigInt'];
  /** Pixel Last fire */
  lastFire?: Maybe<Scalars['DateTime']>;
  /** Pixel mapped ids */
  mappedIds: Array<Scalars['BigInt']>;
  /** Pixel mapped names */
  mappedNames: Array<Scalars['String']>;
  /** Pixel mapped urls */
  mappedUrls: Array<Scalars['String']>;
  /** Pixel name */
  name: Scalars['String'];
  /** Pixel status */
  status: EPixelsStatus;
  /** Date of last update of the pixel */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PixelSort = {
  /** Pixels sort direction, default ASC */
  direction?: InputMaybe<SortingDirectionType>;
  /** Pixels sort field */
  field: EPixelsSortField;
};

/** Builder supported platform types */
export enum PlatformType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

export type Poi = {
  /** Create object */
  create: Array<CreatePoiInputDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type PoiSchema = {
  __typename?: 'PoiSchema';
  createdAt: Scalars['DateTime'];
  customLat?: Maybe<Scalars['Float']>;
  customLong?: Maybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  locationGroupId?: Maybe<Scalars['Int']>;
  maxRadius: Scalars['Float'];
  minRadius?: Maybe<Scalars['Float']>;
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  type: EPoiType;
};

export type PointOfInterestBrandSchema = {
  __typename?: 'PointOfInterestBrandSchema';
  /** POI brand name */
  name?: Maybe<Scalars['String']>;
};

export type PointOfInterestCategorySchema = {
  __typename?: 'PointOfInterestCategorySchema';
  /** POI category name */
  name?: Maybe<Scalars['String']>;
};

export type PointOfInterestCategoryWithSubCategoriesSchema = {
  __typename?: 'PointOfInterestCategoryWithSubCategoriesSchema';
  /** POI category name */
  categoryName?: Maybe<Scalars['String']>;
  /** POI sub category name */
  subCategoryNames?: Maybe<Array<Scalars['String']>>;
};

export type PointOfInterestSchema = {
  __typename?: 'PointOfInterestSchema';
  /** POI added to location group */
  added: Scalars['Boolean'];
  /** POI address */
  address?: Maybe<Scalars['String']>;
  /** POI brands */
  brands?: Maybe<Array<Scalars['String']>>;
  /** POI category */
  category?: Maybe<Scalars['String']>;
  /** POI city */
  city?: Maybe<Scalars['String']>;
  /** POI country code */
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** POI ID */
  id: Scalars['BigInt'];
  /** POI Latitude */
  lat: Scalars['Float'];
  /** POI Longitude */
  long: Scalars['Float'];
  /** POI name */
  name: Scalars['String'];
  /** POI state */
  state?: Maybe<Scalars['String']>;
  /** POI status */
  status: PoiStatus;
  /** POI sub-category */
  subcategory?: Maybe<Scalars['String']>;
  /** POI tags */
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type PointOfInterestSort = {
  /** POI sort by direction */
  direction?: InputMaybe<SortingDirectionType>;
  /** POI sort by field */
  field: PointOfInterestSortField;
};

/** PointOfInterest Sort Field */
export enum PointOfInterestSortField {
  PointOfInterestSortAdded = 'PointOfInterestSortAdded',
  PointOfInterestSortAddress = 'PointOfInterestSortAddress',
  PointOfInterestSortName = 'PointOfInterestSortName',
}

export type PointOfInterestStateSchema = {
  __typename?: 'PointOfInterestStateSchema';
  /** POI state name */
  name?: Maybe<Scalars['String']>;
};

export type PointOfInterestSubCategorySchema = {
  __typename?: 'PointOfInterestSubCategorySchema';
  /** POI subcatgory name */
  name?: Maybe<Scalars['String']>;
};

export type Position = {
  /** Create object */
  create: Array<CreatePositionTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type PositionTargetingBatchUpdateInput = {
  data: UpdatePositionTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type PositionTargetingPaginationSchema = {
  __typename?: 'PositionTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<PositionTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type PositionTargetingSchema = {
  __typename?: 'PositionTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  position: EPositionType;
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type PostalCodeSchema = {
  __typename?: 'PostalCodeSchema';
  cityName: Scalars['String'];
  code: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['BigInt'];
  stateCode: Scalars['String'];
};

export type ProcessingMarginData = {
  __typename?: 'ProcessingMarginData';
  /** Third party audience processing margin */
  thirdParty?: Maybe<Scalars['Float']>;
};

export type ProductionTargetingBatchUpdateInput = {
  data: UpdateProductionTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type ProductionTargetingPaginationSchema = {
  __typename?: 'ProductionTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<ProductionTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type ProductionTargetingSchema = {
  __typename?: 'ProductionTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  production: EProductionType;
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type PublisherSchema = {
  __typename?: 'PublisherSchema';
  id: Scalars['BigInt'];
  /** Publisher metadata generic type */
  metadata: Array<Scalars['JSON']>;
  /** Name of publisher */
  name: Scalars['String'];
  /** Supported platform */
  platform: PlatformType;
};

export type QrOverlay = {
  __typename?: 'QrOverlay';
  content?: Maybe<Scalars['String']>;
  h: Scalars['Float'];
  sha256?: Maybe<Scalars['String']>;
  w: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type QrOverlayInput = {
  content?: InputMaybe<Scalars['String']>;
  h: Scalars['Float'];
  sha256?: InputMaybe<Scalars['String']>;
  w: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  LanguageTargeting: LanguageTargetingPaginationSchema;
  LiveTargeting: LiveTargetingPaginationSchema;
  ProductionTargeting: ProductionTargetingPaginationSchema;
  RatingTargeting: RatingTargetingPaginationSchema;
  /** Get Account by id */
  account: AccountSchema;
  /** Get all Accounts */
  accounts: AccountsSchema;
  /** Get actor data */
  actor: ActorSchema;
  /** Search Adapt CTV templates */
  adaptCtvTemplates: PaginatedAdaptCtvTemplatesSchema;
  /** Get paginated advertisers data */
  advertisers: PaginatedAdvertisersSchema;
  /** Get paginated geo advertisers data */
  advertisersGeo: PaginatedAdvertisersSchema;
  /** Get paginated agencies data */
  agencies: PaginatedAgenciesSchema;
  app: PaginatedAppSchema;
  appCategory: PaginatedAppCategorySchema;
  appCategoryTargeting: AppCategoryTargetingPaginationSchema;
  appTargeting: AppTargetingPaginationSchema;
  /** Get paginated Audiences Categories Data */
  audienceCategories: PaginatedAudienceCategorySchema;
  /** Get paginated Audience Types Data */
  audienceTypes: PaginatedAudienceTypeSchema;
  /** Get paginated Audiences Data */
  audiences: PaginatedAudiencesSchema;
  browser: PaginatedBrowserSchema;
  browserTargeting: BrowserTargetingPaginationSchema;
  /** Get paginated campaign data */
  campaigns: PaginatedCampaignSchema;
  /** Get paginated geo campaigns data */
  campaignsGeo: PaginatedGeoCampaignsSchema;
  carrier: PaginatedCarrierSchema;
  carrierTargeting: CarrierTargetingPaginationSchema;
  category: PaginatedCategorySchema;
  categoryTargeting: CategoryTargetingPaginationSchema;
  cities: PaginatedCitySchema;
  country: PaginatedCountrySchema;
  countryTargeting: CountryTargetingPaginationSchema;
  /** Get paginated creative formats */
  creativeFormats: PaginatedCreativeFormatsSchema;
  /** Get legacy creative by id */
  creativeLegacy: CreativeLegacySchema;
  creativeType: PaginatedCreativeTypeSchema;
  creativeTypeTargeting: CreativeTypeTargetingPaginationSchema;
  /** Get creative ctv video variants */
  creativeVideoVariants: PaginatedCtvVideoVariantsSchema;
  /** Get creatives paginated data. */
  creatives: PaginatedCreativesSchema;
  /** Get legacy creatives list */
  creativesLegacy: Array<Maybe<CreativeLegacySchema>>;
  /** Get ctv video templates */
  ctvVideoTemplates: PaginatedCtvVideoTemplatesSchema;
  /** Custom Report field parent categories */
  customReportFields: Array<ReportCategorySchema>;
  dayPartTargeting: DayPartTargetingPaginationSchema;
  /** test */
  dealBulkTargeting: DealsTargetingBulkSchema;
  dealTargeting: DealTargetingPaginationSchema;
  /** Search deals data */
  deals: PaginatedDealsSchema;
  device: PaginatedDeviceSchema;
  deviceModel: PaginatedDeviceModelSchema;
  deviceModelTargeting: DeviceModelTargetingPaginationSchema;
  deviceTypeTargeting: DeviceTypeTargetingPaginationSchema;
  /** Get report file storage url  */
  downloadReportFile: DownloadReportFileSchema;
  dsp: PaginatedDspSchema;
  dspSeat: PaginatedDspSeatSchema;
  dvAuthenticBrandSuitabilityTargeting: DvAuthenticBrandSuitabilityTargetingPaginationSchema;
  dvBrandSafetySuitabilityTargeting: DvBrandSafetySuitabilityTargetingPaginationSchema;
  dvSegment: PaginatedDvSegmentSchema;
  dvViewabilityTargeting: DvViewabilityTargetingPaginationSchema;
  frequencyTargeting: FrequencyTargetingPaginationSchema;
  genre: PaginatedGenreSchema;
  genreTargeting: GenreTargetingPaginationSchema;
  geoTargeting: GeoTargetingPaginationSchema;
  /** get all data providers */
  getAudienceDataProviders: PaginatedAudienceDataProviderSchema;
  getESupply: Array<ESupplySchema>;
  kpi: PaginatedKpiSchema;
  language: PaginatedLanguageSchema;
  /** Get paginated Location Groups Data */
  locationGroups: PaginatedLocationGroupsSchema;
  metros: PaginatedMetroSchema;
  os: PaginatedOsSchema;
  osTargeting: OsTargetingPaginationSchema;
  /** Get paginated Pixel Mapping data */
  pixelMappings: PaginatedPixelMappingsSchema;
  /** Get paginated Pixels data */
  pixels: PaginatedPixelsSchema;
  /** Get Targeting POI paginated data */
  poi: PaginatedPoiSchema;
  /** Get paginated POI data  */
  pointsOfInterest: PaginatedPointOfInterestSchema;
  /** Get paginated POI brand data  */
  pointsOfInterestBrands: PaginatedPointOfInterestBrandsSchema;
  /** Get paginated POI category data  */
  pointsOfInterestCategories: PaginatedPointOfInterestCategoriesSchema;
  /** Get paginated POI category w/ subcategories data  */
  pointsOfInterestCategoriesWithSubCategories: PaginatedPointOfInterestCategoriesWithSubCategoriesSchema;
  /** Get paginated POI state data  */
  pointsOfInterestStates: PaginatedPointOfInterestStatesSchema;
  /** Get paginated POI subCategory data  */
  pointsOfInterestSubCategories: PaginatedPointOfInterestSubCategoriesSchema;
  positionTargeting: PositionTargetingPaginationSchema;
  postalCodes: PaginatedPostalSchema;
  /** Get publisher by id */
  publisher: PublisherSchema;
  /** Get publishers list */
  publishers: Array<Maybe<PublisherSchema>>;
  rating: PaginatedRatingSchema;
  /** Get report available fields list */
  reportFields: Array<ReportFieldSchema>;
  /** Get paginated reports data */
  reports: PaginatedReportsSchema;
  segmentTargeting: SegmentTargetingPaginationSchema;
  site: PaginatedSiteSchema;
  siteTargeting: SiteTargetingPaginationSchema;
  states: PaginatedStateSchema;
  /** Get paginated Strategy data */
  strategies: PaginatedStrategySchema;
  supplyTargeting: SupplyTargetingPaginationSchema;
  /** Get Targeting Audiences paginated data */
  targetingAudiences: PaginatedTargetingAudiencesSchema;
  /** Get User data by id */
  user: UserSchema;
};

export type QueryLanguageTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryLiveTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryProductionTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRatingTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAccountArgs = {
  id: Scalars['BigInt'];
};

export type QueryAdaptCtvTemplatesArgs = {
  search: SearchAdaptCtvTemplatesDto;
};

export type QueryAdvertisersArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type QueryAdvertisersGeoArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type QueryAgenciesArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  userIds?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type QueryAppArgs = {
  bundleIdPrefix?: InputMaybe<Scalars['String']>;
  bundle_ids?: InputMaybe<Array<Scalars['String']>>;
  domainPrefix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryAppCategoryArgs = {
  categoryNamePrefix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryAppCategoryTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAppTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAudienceCategoriesArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentIds?: InputMaybe<Array<Scalars['BigInt']>>;
  rootOnly?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAudienceTypesArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryAudiencesArgs = {
  accountId: Scalars['BigInt'];
  billing?: InputMaybe<EAudienceBilling>;
  categoryIds?: InputMaybe<Array<Scalars['BigInt']>>;
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  dataProviders?: InputMaybe<Array<Scalars['String']>>;
  envs?: InputMaybe<Array<EAudienceEnvironment>>;
  excludeParentForId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  providers?: InputMaybe<Array<EAudienceProvider>>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<AudiencesSort>>;
  subCategoryIds?: InputMaybe<Array<Scalars['BigInt']>>;
  targetingMethod?: InputMaybe<Array<EAudienceType>>;
  typeIds?: InputMaybe<Array<Scalars['BigInt']>>;
  userId?: InputMaybe<Scalars['BigInt']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  withEnvs?: InputMaybe<Scalars['Boolean']>;
  withStrategies?: InputMaybe<Scalars['Boolean']>;
};

export type QueryBrowserArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryBrowserTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCampaignsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  advertiserIds?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<CampaignDateRangeFilter>;
  searchAdvertiserName?: InputMaybe<Scalars['String']>;
  searchId?: InputMaybe<Scalars['Int']>;
  searchIds?: InputMaybe<Array<Scalars['Int']>>;
  searchName?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<CampaignsSortInputDto>;
};

export type QueryCampaignsGeoArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchAdvName?: InputMaybe<Scalars['String']>;
  searchCampName?: InputMaybe<Scalars['String']>;
};

export type QueryCarrierArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryCarrierTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryCategoryTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCitiesArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryCountryArgs = {
  code?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryCountryTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCreativeFormatsArgs = {
  search: SearchCreativeFormatsDto;
};

export type QueryCreativeLegacyArgs = {
  id: Scalars['String'];
};

export type QueryCreativeTypeArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryCreativeTypeTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCreativeVideoVariantsArgs = {
  search: SearchCtvVideoVariantsDto;
};

export type QueryCreativesArgs = {
  search: SearchCreativeDto;
};

export type QueryCtvVideoTemplatesArgs = {
  search: SearchVideoTemplatesDto;
};

export type QueryDayPartTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDealBulkTargetingArgs = {
  data: DealsTargetingBulkDto;
};

export type QueryDealTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  inventoryDealIds?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDealsArgs = {
  search: SearchDealsArgsDto;
};

export type QueryDeviceArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryDeviceModelArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryDeviceModelTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDeviceTypeTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDownloadReportFileArgs = {
  id: Scalars['Float'];
};

export type QueryDspArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryDspSeatArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryDvAuthenticBrandSuitabilityTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDvBrandSafetySuitabilityTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDvSegmentArgs = {
  creativeType?: InputMaybe<ECreativeType>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<EProduct>;
};

export type QueryDvViewabilityTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryFrequencyTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGenreArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryGenreTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGeoTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EGeoType>;
};

export type QueryGetAudienceDataProvidersArgs = {
  args: GetAudienceDataProvidersArgsDto;
};

export type QueryGetESupplyArgs = {
  search: SearchESupplyArgsDto;
};

export type QueryKpiArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryLanguageArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryLocationGroupsArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<LocationGroupsSort>>;
  withPoiCount?: InputMaybe<Scalars['Boolean']>;
  withStrategies?: InputMaybe<Scalars['Boolean']>;
};

export type QueryMetrosArgs = {
  codesOrNames?: InputMaybe<Array<Scalars['String']>>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryOsArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryOsTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPixelMappingsArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pixelIds?: InputMaybe<Array<Scalars['BigInt']>>;
  sort?: InputMaybe<Array<PixelMappedSort>>;
};

export type QueryPixelsArgs = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  mappedSort?: InputMaybe<Array<PixelMappedSort>>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PixelSort>>;
  status?: InputMaybe<EPixelsStatus>;
};

export type QueryPoiArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectID: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  type: EPoiType;
};

export type QueryPointsOfInterestArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  cityPrefix?: InputMaybe<Scalars['String']>;
  contextLocationGroupId?: InputMaybe<Scalars['BigInt']>;
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  locationGroupId?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PointOfInterestSort>>;
  states?: InputMaybe<Array<Scalars['String']>>;
  subcategories?: InputMaybe<Array<Scalars['String']>>;
  tagPrefix?: InputMaybe<Scalars['String']>;
};

export type QueryPointsOfInterestBrandsArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryPointsOfInterestCategoriesArgs = {
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPointsOfInterestCategoriesWithSubCategoriesArgs = {
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPointsOfInterestStatesArgs = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  subcategories?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPointsOfInterestSubCategoriesArgs = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  states?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPositionTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPostalCodesArgs = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryPublisherArgs = {
  id: Scalars['Float'];
};

export type QueryPublishersArgs = {
  type?: InputMaybe<PlatformType>;
};

export type QueryRatingArgs = {
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QueryReportsArgs = {
  accountId?: InputMaybe<Scalars['Float']>;
  creator?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchId?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ReportColumnsSortingInputDto>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type QuerySegmentTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySiteArgs = {
  domainPrefix?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type QuerySiteTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryStatesArgs = {
  codesOrNames?: InputMaybe<Array<Scalars['String']>>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryStrategiesArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  campaignIds?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  salesforceId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<StrategySortInputDto>;
  status?: InputMaybe<ERecordEntityStatus>;
  withCreativesCount?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySupplyTargetingArgs = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type QueryTargetingAudiencesArgs = {
  accountId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type QueryUserArgs = {
  id: Scalars['Float'];
};

export type RateCardData = {
  __typename?: 'RateCardData';
  /** Rate card audience data */
  audience?: Maybe<AudienceRateCard>;
};

export type RatingSchema = {
  __typename?: 'RatingSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type RatingTargetingBatchUpdateInput = {
  data: UpdateRatingTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type RatingTargetingPaginationSchema = {
  __typename?: 'RatingTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<RatingTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type RatingTargetingSchema = {
  __typename?: 'RatingTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  rating: RatingSchema;
  ratingId: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
};

export type ReplaceBatchPoiInputDto = {
  /** Batch create items. */
  create?: InputMaybe<Array<CreatePoiInputDto>>;
  /** Batch delete ids. */
  delete?: InputMaybe<DeletePoiInputDto>;
};

export type ReplaceTargetingAudiencesBatchDto = {
  /** Batch create items. */
  create?: InputMaybe<Array<CreateTargetingAudiencesDto>>;
  /** Batch delete ids. */
  delete?: InputMaybe<DeleteTargetingAudiencesDto>;
};

export type ReportCategorySchema = {
  __typename?: 'ReportCategorySchema';
  /** report field label */
  label: Scalars['String'];
  /** report field value */
  value: Scalars['String'];
};

export type ReportColumnsSortingInputDto = {
  endDate?: InputMaybe<SortingDirectionType>;
  reportLastUpdated?: InputMaybe<SortingDirectionType>;
  reportName?: InputMaybe<SortingDirectionType>;
  reportStatus?: InputMaybe<SortingDirectionType>;
  startDate?: InputMaybe<SortingDirectionType>;
  timezone?: InputMaybe<SortingDirectionType>;
};

export type ReportFieldSchema = {
  __typename?: 'ReportFieldSchema';
  /** Report field label */
  label: Scalars['String'];
  /** Report field value */
  value: Scalars['String'];
};

/** Report generation frequency */
export enum ReportFrequency {
  Daily = 'Daily',
  Once = 'Once',
  Weekly = 'Weekly',
}

export type ReportSchema = {
  __typename?: 'ReportSchema';
  accountId: Scalars['BigInt'];
  advertiserIds: Array<Scalars['BigInt']>;
  createdAt: Scalars['DateTime'];
  creator: Scalars['BigInt'];
  /** Download report filename identifier */
  downloadURL?: Maybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  endDate: Scalars['DateTime'];
  fields: Array<Scalars['String']>;
  frequency?: Maybe<ReportFrequency>;
  id: Scalars['BigInt'];
  isSendingEmail: Scalars['Boolean'];
  lineItemIds: Array<Scalars['BigInt']>;
  metrics?: Maybe<Array<Scalars['String']>>;
  reportLastUpdated?: Maybe<Scalars['DateTime']>;
  reportName: Scalars['String'];
  reportStatus: ReportStatus;
  startDate: Scalars['DateTime'];
  timezone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Report creation status */
export enum ReportStatus {
  Delayed = 'Delayed',
  InProgress = 'InProgress',
  Ready = 'Ready',
}

export type ResourceSchema = {
  __typename?: 'ResourceSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  name: Scalars['String'];
  status: ResourceStatus;
};

/** Resource status */
export enum ResourceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type ResultUnion = AudioCreativeSchema | BannerCreativeSchema | NativeCreativeSchema | VideoCreativeSchema;

export type SearchAdaptCtvTemplatesDto = {
  id?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<Scalars['Float']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type SearchCreativeDto = {
  account_id?: InputMaybe<Scalars['Float']>;
  advertiser_ids?: InputMaybe<Array<Scalars['Float']>>;
  creative_type_id?: InputMaybe<Scalars['Float']>;
  /** Filter creatives by deal assignment */
  dealIds?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter creatives by format */
  formatIds?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<Scalars['Float']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search_string?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<CreativeColumnsSortInputDto>;
  status?: InputMaybe<ResourceStatus>;
  strategy_ids?: InputMaybe<Array<Scalars['Float']>>;
};

export type SearchCreativeFormatsDto = {
  id?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<Scalars['Float']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type SearchCtvVideoVariantsDto = {
  accountId?: InputMaybe<Scalars['Float']>;
  creativeIds?: InputMaybe<Array<Scalars['Float']>>;
  id?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<Scalars['Float']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type SearchDealsArgsDto = {
  /** Deals search by account id filter */
  accountId?: InputMaybe<Scalars['BigInt']>;
  /** Deals search by auction type filter */
  auctionType?: InputMaybe<Scalars['String']>;
  /** Deals search by bid floor filter */
  bidFloor?: InputMaybe<FloatRangeFilter>;
  /** Deals search by creator filter */
  creator?: InputMaybe<Scalars['Int']>;
  /** Deals search by id filter */
  dealId?: InputMaybe<Scalars['BigInt']>;
  /** Deals search by dsp deal id filter */
  dspDealIdPrefix?: InputMaybe<Scalars['String']>;
  /** Deals search by dsp seat id filter */
  dspSeatId?: InputMaybe<Scalars['Int']>;
  /** Deals search by dsp ids */
  dsp_ids?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Deals search by end date filter */
  endDate?: InputMaybe<DateRangeFilter>;
  /** Deals search by ids filter */
  ids?: InputMaybe<Array<Scalars['BigInt']>>;
  limit?: InputMaybe<Scalars['Int']>;
  /** Deals search by name prefix filter */
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Deals search by salesforce id filter */
  salesforceId?: InputMaybe<Scalars['String']>;
  /** Deals search by search string filter */
  searchString?: InputMaybe<Scalars['String']>;
  /** Deals search by sort filter */
  sort?: InputMaybe<Array<DealSort>>;
  /** Deals search by start date filter */
  startDate?: InputMaybe<DateRangeFilter>;
  /** Deals search by status filter */
  status?: InputMaybe<DealStatus>;
};

export type SearchESupplyArgsDto = {
  limit?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
};

export type SearchVideoTemplatesDto = {
  id?: InputMaybe<Scalars['Float']>;
  ids?: InputMaybe<Array<Scalars['Float']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
};

export type Segment = {
  /** Create object */
  create: Array<CreateSegmentTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type SegmentTargetingBatchUpdateInput = {
  data: UpdateSegmentTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type SegmentTargetingPaginationSchema = {
  __typename?: 'SegmentTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<SegmentTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type SegmentTargetingSchema = {
  __typename?: 'SegmentTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  segmentId: Scalars['BigInt'];
  type: ESegmentType;
};

export type Site = {
  /** Create object */
  create: Array<CreateSiteTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type SiteSchema = {
  __typename?: 'SiteSchema';
  createdAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id: Scalars['BigInt'];
  status: ResourceStatus;
};

export type SiteTargetingBatchUpdateInput = {
  data: UpdateSiteTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type SiteTargetingPaginationSchema = {
  __typename?: 'SiteTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<SiteTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type SiteTargetingSchema = {
  __typename?: 'SiteTargetingSchema';
  createdAt: Scalars['DateTime'];
  domain?: Maybe<Scalars['String']>;
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  switcherRecord?: Maybe<Scalars['Boolean']>;
};

/** Columns sorting direction type */
export enum SortingDirectionType {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type StateSchema = {
  __typename?: 'StateSchema';
  countryCode: Scalars['String'];
  id: Scalars['BigInt'];
  name: Scalars['String'];
  stateCode: Scalars['String'];
};

/** Status code type */
export enum StatusCodeType {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Draft = 'Draft',
  Live = 'Live',
  LiveEdited = 'LiveEdited',
  Locked = 'Locked',
  Paused = 'Paused',
  PausedEdited = 'PausedEdited',
  Ready = 'Ready',
  ReadyEdited = 'ReadyEdited',
  Restored = 'Restored',
}

export type StrategySchema = {
  __typename?: 'StrategySchema';
  accountID: Scalars['BigInt'];
  /** Amount of Ad Spend to date */
  amountSpent: Scalars['Float'];
  /** The amount that needs to be spent daily for the remainder of the strategy */
  amountToSpend: Scalars['Int'];
  /** Bid Price of the strategy */
  bidPrice: Scalars['Float'];
  /** Total bids of strategy */
  bids: Scalars['BigInt'];
  /** Total budget for the strategy */
  budget: Scalars['Int'];
  /** Remaining budget of the strategy */
  budgetRemaining: Scalars['Int'];
  campaignId: Scalars['BigInt'];
  /** Total clicks of strategy */
  clicks: Scalars['BigInt'];
  /** CPC of strategy */
  cpc: Scalars['Float'];
  /** CPM of strategy */
  cpm: Scalars['Float'];
  /** Date of the strategy creation */
  createdAt: Scalars['DateTime'];
  /** # of creatives attached to Strategy */
  creativesCount?: Maybe<Scalars['Int']>;
  /** CTR of strategy */
  ctr: Scalars['Float'];
  /** Cap for daily spend */
  dailyCap?: Maybe<Scalars['Float']>;
  /** Daily strategy pacing performance */
  dailyPacing: Scalars['Int'];
  /** Number of days left for the strategy */
  daysLeft?: Maybe<Scalars['Int']>;
  /** End date of the strategy */
  endDate: Scalars['DateTime'];
  /** Total strategy pacing performance */
  flightPacing: Scalars['Int'];
  id: Scalars['BigInt'];
  /** Ideal daily pacing */
  idealDailyPacing: Scalars['Float'];
  /** Number of impressions */
  impressions?: Maybe<Scalars['Int']>;
  /** Kpi Goal of the strategy */
  kpiGoal: Scalars['Float'];
  /** Kpi Id of the strategy */
  kpiId: Scalars['Int'];
  /** Total Media Spend of strategy */
  mediaSpend: Scalars['Float'];
  /** Min bid Price of the strategy */
  minBidPrice?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Pacing type of the strategy */
  pacing: EPacingType;
  /** Pacing goal of the strategy */
  pacingGoal: Scalars['Float'];
  /** Strategy salesforce id */
  salesforceId?: Maybe<Scalars['String']>;
  /** Spent Yesterday in currency of campaign */
  spentYesterdayCurrency: Scalars['Float'];
  /** Spent Yesterday in impression of campaign */
  spentYesterdayImpression: Scalars['Float'];
  /** Start date of the strategy */
  startDate: Scalars['DateTime'];
  status?: Maybe<ERecordEntityStatus>;
  /** Date of last update of the strategy */
  updatedAt: Scalars['DateTime'];
  /** Total wins of strategy */
  wins: Scalars['BigInt'];
};

export type StrategySortInputDto = {
  createdAt?: InputMaybe<SortingDirectionType>;
  endDate?: InputMaybe<SortingDirectionType>;
  id?: InputMaybe<SortingDirectionType>;
  name?: InputMaybe<SortingDirectionType>;
  startDate?: InputMaybe<SortingDirectionType>;
  status?: InputMaybe<SortingDirectionType>;
  updatedAt?: InputMaybe<SortingDirectionType>;
};

export type Supply = {
  /** Create object */
  create: Array<CreateSupplyTargetingDto>;
  /** Delete object */
  delete: DeleteTargeting;
  /** List of object ids  */
  referenceObjectIDs: Array<Scalars['BigInt']>;
  /** Type of object */
  referenceObjectType: EObjectType;
};

export type SupplyTargetingBatchUpdateInput = {
  data: UpdateSupplyTargetingDto;
  targetingId: Scalars['BigInt'];
};

export type SupplyTargetingPaginationSchema = {
  __typename?: 'SupplyTargetingPaginationSchema';
  /** Maximum number of entries to return */
  limit: Scalars['Int'];
  /** Collection of items */
  nodes?: Maybe<Array<SupplyTargetingSchema>>;
  /** Number of first items to skip */
  offset: Scalars['Int'];
  /** Total count of items in collection */
  totalCount: Scalars['Int'];
};

export type SupplyTargetingSchema = {
  __typename?: 'SupplyTargetingSchema';
  createdAt: Scalars['DateTime'];
  exclude: Scalars['Boolean'];
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  supplyId?: Maybe<Scalars['Int']>;
  supplySource: ESupplySource;
  verifiedSupplyOnly: Scalars['Boolean'];
};

export type TargetingAudiencesSchema = {
  __typename?: 'TargetingAudiencesSchema';
  /** Account id */
  accountId: Scalars['BigInt'];
  audience?: Maybe<AudienceSchema>;
  audienceId: Scalars['BigInt'];
  createdAt: Scalars['DateTime'];
  exclude?: Maybe<Scalars['Boolean']>;
  id: Scalars['BigInt'];
  referenceObjectId: Scalars['BigInt'];
};

/** Targeting object type */
export enum TargetingObjectTypeEnum {
  Deal = 'DEAL',
  LineItem = 'LINE_ITEM',
  Strategy = 'STRATEGY',
}

export type ThemeSchema = {
  __typename?: 'ThemeSchema';
  brand?: Maybe<Scalars['JSON']>;
  brandName?: Maybe<Scalars['JSON']>;
  caption?: Maybe<Scalars['JSON']>;
  container?: Maybe<Scalars['JSON']>;
  content?: Maybe<Scalars['JSON']>;
  copy?: Maybe<Scalars['JSON']>;
  cta?: Maybe<Scalars['JSON']>;
  ctaIcon?: Maybe<Scalars['String']>;
  disclosure?: Maybe<Scalars['JSON']>;
  footer?: Maybe<Scalars['JSON']>;
  header?: Maybe<Scalars['JSON']>;
  headline?: Maybe<Scalars['JSON']>;
  logo?: Maybe<Scalars['JSON']>;
  logoStyle?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['JSON']>;
  mediaContainer?: Maybe<Scalars['JSON']>;
  parent?: Maybe<Scalars['JSON']>;
  postCss?: Maybe<Scalars['String']>;
  preCss?: Maybe<Scalars['String']>;
};

export type TierCpm = {
  __typename?: 'TierCpm';
  /** custom audience cpm rate */
  custom?: Maybe<Scalars['Float']>;
  /** premium audience cpm rate */
  premium?: Maybe<Scalars['Float']>;
  /** standard audience cpm rate */
  standard?: Maybe<Scalars['Float']>;
  /** verified audience cpm rate */
  verified?: Maybe<Scalars['Float']>;
};

export type UpdateAppArgsDto = {
  bundleId: Scalars['String'];
  domain: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateAppCategoryArgsDto = {
  categoryName: Scalars['String'];
};

export type UpdateAppCategoryTargetingDto = {
  categoryId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAppTargetingDto = {
  bundleId: Scalars['String'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAudioDto = {
  advertiserID: Scalars['BigInt'];
  attributes: AudioAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type UpdateBannerDto = {
  advertiserID: Scalars['BigInt'];
  attributes?: InputMaybe<BannerAttributesInput>;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type UpdateBrowserTargetingDto = {
  browserId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCampaignArgsDto = {
  /** Advanced campaign optimization */
  acop?: InputMaybe<Scalars['Float']>;
  /** Advertiser id */
  advertiserId: Scalars['BigInt'];
  /** Total budget for the campaign */
  budget: Scalars['Float'];
  /** Currency type of campaign */
  currency?: InputMaybe<Scalars['String']>;
  /** Cap for daily spend */
  dailyCap?: InputMaybe<Scalars['Float']>;
  /** End date of the campaign */
  endDate: Scalars['DateTime'];
  id: Scalars['BigInt'];
  /** KPI Goal for campaign */
  kpiGoal?: InputMaybe<Scalars['Float']>;
  /** KPI Id for campaign */
  kpiId?: InputMaybe<Scalars['Int']>;
  /** Managed Service of the Campaign */
  managedService?: InputMaybe<Scalars['Boolean']>;
  /** Margin of the Campaign */
  margin?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Type of pacing */
  pacing: EPacingType;
  /** Pacing goal for campaign */
  pacingGoal?: InputMaybe<Scalars['Float']>;
  /** pacing option */
  pacingOption?: InputMaybe<EPacingOption>;
  /** Pacing tracking type of the campaign */
  pacingTracking: EPacingTracking;
  /** Rate type of the campaign */
  rateType?: InputMaybe<ERateType>;
  /** Start date of the campaign */
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ERecordEntityStatus>;
  /** Type of the campaign */
  type: ECampaignType;
  /** Viewability Provider of the Campaign */
  viewabilityProvider?: InputMaybe<EViabilityProvider>;
};

export type UpdateCarrierTargetingDto = {
  carrier: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCategoryArgsDto = {
  iabCategory?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateCategoryTargetingDto = {
  categoryId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCountryArgsDto = {
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateCountryTargetingDto = {
  countryCode: Scalars['String'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCreativeTypeArgsDto = {
  name: Scalars['String'];
};

export type UpdateCreativeTypeTargetingDto = {
  creativeAttribute: ECreativeTypeAttribute;
  creativeAttributeValue: Scalars['String'];
  creativeTypeId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDayPartTargetingDto = {
  endHour: Scalars['Int'];
  exclude?: InputMaybe<Scalars['Boolean']>;
  startHour: Scalars['Int'];
  weekday: Scalars['Int'];
};

export type UpdateDealTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  inventoryDealId: Scalars['String'];
};

export type UpdateDealsArgsDto = {
  accountId: Scalars['BigInt'];
  auctionType: AuctionType;
  bidFloor: Scalars['Float'];
  creator: Scalars['BigInt'];
  dspDealId?: InputMaybe<Scalars['String']>;
  dspIds?: InputMaybe<Array<Scalars['BigInt']>>;
  dspSeatId?: InputMaybe<Scalars['BigInt']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  margin: Scalars['Float'];
  name: Scalars['String'];
  priority?: EPriority;
  salesforceId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: DealStatus;
  supplyDealIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDeviceModelTargetingDto = {
  deviceModelId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDeviceTypeTargetingDto = {
  deviceTypeId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDspSeatArgsDto = {
  rateLimit?: InputMaybe<Scalars['Int']>;
  seatId: Scalars['String'];
  seatName?: InputMaybe<Scalars['String']>;
  status: ResourceStatus;
};

export type UpdateDvAuthenticBrandSuitabilityTargetingDto = {
  dvSegmentCode: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDvBrandSafetySuitabilityTargetingDto = {
  /** ID of dv segment to be targeted */
  dvSegmentId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDvSegmentArgsDto = {
  creativeType: ECreativeType;
  dvSegmentCode: Scalars['String'];
  name: Scalars['String'];
  product: EProduct;
};

export type UpdateDvViewabilityTargetingDto = {
  dvSegmentId: Scalars['BigInt'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFrequencyTargetingDto = {
  freqCapCount: Scalars['Int'];
  freqCapPeriod: EFrequencyPeriods;
};

export type UpdateGenreArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateGenreTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  genreId: Scalars['BigInt'];
};

export type UpdateGeoTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  geoId: Scalars['BigInt'];
  type: EGeoType;
};

export type UpdateKpiArgsDto = {
  name: Scalars['String'];
};

export type UpdateLanguageArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateLanguageTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['BigInt'];
};

export type UpdateLiveTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  live: ELiveType;
};

export type UpdateLocationGroupArgsDto = {
  /** Location Group id */
  id: Scalars['BigInt'];
  /** Location Group name */
  name: Scalars['String'];
  /** POI ids to add to LG */
  poiAddIds?: InputMaybe<Array<Scalars['BigInt']>>;
  /** POI ids to remove from LG */
  poiRemoveIds?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type UpdateNativeDto = {
  advertiserID: Scalars['BigInt'];
  attributes: NativeAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type UpdateOsTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  osId: Scalars['BigInt'];
};

export type UpdatePixelMappingsDto = {
  id: Scalars['BigInt'];
  mappedName: Scalars['String'];
  pageUrl: Scalars['String'];
};

export type UpdatePixelsArgsDto = {
  /** Pixel name */
  name: Scalars['String'];
  /** Pixel status */
  status: EPixelsStatus;
};

export type UpdatePositionTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  position: EPositionType;
};

export type UpdateProductionTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  production: EProductionType;
};

export type UpdateRatingArgsDto = {
  matchValue: Scalars['String'];
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateRatingTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  ratingId: Scalars['BigInt'];
};

export type UpdateReportArgsDto = {
  accountId: Scalars['BigInt'];
  advertiserIds: Array<Scalars['BigInt']>;
  creator: Scalars['BigInt'];
  emails: Array<Scalars['String']>;
  endDate: Scalars['DateTime'];
  fields: Array<Scalars['String']>;
  frequency?: InputMaybe<ReportFrequency>;
  isSendingEmail: Scalars['Boolean'];
  lineItemIds: Array<Scalars['BigInt']>;
  metrics?: InputMaybe<Array<Scalars['String']>>;
  reportName: Scalars['String'];
  reportStatus: ReportStatus;
  startDate: Scalars['DateTime'];
  timezone: Scalars['String'];
};

export type UpdateResourceArgsDto = {
  name: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateSegmentTargetingDto = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  segmentId: Scalars['BigInt'];
  type: ESegmentType;
};

export type UpdateSiteArgsDto = {
  domain: Scalars['String'];
  status: ResourceStatus;
};

export type UpdateSiteTargetingDto = {
  domain: Scalars['String'];
  exclude?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateStrategyArgsDto = {
  /** Bid Price of the strategy */
  bidPrice: Scalars['Float'];
  /** Cap for daily spend */
  dailyCap?: InputMaybe<Scalars['Float']>;
  /** End date of the strategy */
  endDate: Scalars['DateTime'];
  /** Total strategy pacing performance */
  flightPacing: Scalars['Int'];
  id: Scalars['BigInt'];
  /** Kpi Goal of the strategy */
  kpiGoal: Scalars['Float'];
  /** Kpi Id of the strategy */
  kpiId: Scalars['Int'];
  /** Min bid Price of the strategy */
  minBidPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  /** Pacing type of the strategy */
  pacing: EPacingType;
  /** Pacing goal of the strategy */
  pacingGoal: Scalars['Float'];
  /** Strategy salesforce id */
  salesforceId?: InputMaybe<Scalars['String']>;
  /** Start date of the strategy */
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ERecordEntityStatus>;
};

export type UpdateSupplyTargetingDto = {
  supplySource: ESupplySource;
  verifiedSupplyOnly: Scalars['Boolean'];
};

export type UpdateVideoDto = {
  advertiserID: Scalars['BigInt'];
  attributes: VideoAttributesInput;
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: InputMaybe<Scalars['BigInt']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: InputMaybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: InputMaybe<Scalars['String']>;
  thirdPartyPlacementName?: InputMaybe<Scalars['String']>;
  typeID: Scalars['Float'];
};

export type UploadImageDto = {
  file: Scalars['Upload'];
};

export type UploadVideoDto = {
  file: Scalars['Upload'];
};

export type UserSchema = {
  __typename?: 'UserSchema';
  /** User account id */
  accountId: Scalars['BigInt'];
  /** User email */
  email: Scalars['String'];
  /** User first name */
  firstName: Scalars['String'];
  /** User id */
  id: Scalars['BigInt'];
  /** User last login */
  lastLogin: Scalars['String'];
  /** User last name */
  lastName: Scalars['String'];
  /** User role id */
  roleId: Scalars['BigInt'];
  /** User status */
  status: Scalars['String'];
};

export type VideoAttributes = {
  __typename?: 'VideoAttributes';
  bitRate?: Maybe<Scalars['Float']>;
  clickThroughLink?: Maybe<Scalars['String']>;
  codec?: Maybe<Scalars['String']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  /** Video format */
  format?: Maybe<EVideoFormat>;
  maintainAspectRatio?: Maybe<Scalars['Boolean']>;
  maxBitRate?: Maybe<Scalars['Float']>;
  media?: Maybe<VideoMedia>;
  minBitRate?: Maybe<Scalars['Float']>;
  scalable?: Maybe<Scalars['Boolean']>;
  /** Vast TAG url for third-party DSP. Generated by server */
  tagUrlForThirdPartyDSP?: Maybe<Scalars['String']>;
  thirdPartyPixelTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTag?: Maybe<Scalars['String']>;
  thirdPartyTagTracking?: Maybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Third-Party Impression Tracking URLs */
  variantThirdPartyImpTracking?: Maybe<Array<Scalars['String']>>;
};

export type VideoAttributesInput = {
  bitRate?: InputMaybe<Scalars['Float']>;
  clickThroughLink?: InputMaybe<Scalars['String']>;
  codec?: InputMaybe<Scalars['String']>;
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  /** Video format */
  format?: InputMaybe<EVideoFormat>;
  maintainAspectRatio?: InputMaybe<Scalars['Boolean']>;
  maxBitRate?: InputMaybe<Scalars['Float']>;
  media?: InputMaybe<VideoMediaInput>;
  minBitRate?: InputMaybe<Scalars['Float']>;
  scalable?: InputMaybe<Scalars['Boolean']>;
  /** Vast TAG url for third-party DSP. Generated by server */
  tagUrlForThirdPartyDSP?: InputMaybe<Scalars['String']>;
  thirdPartyPixelTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTag?: InputMaybe<Scalars['String']>;
  thirdPartyTagTracking?: InputMaybe<Array<Scalars['String']>>;
  thirdPartyTagUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** Third-Party Impression Tracking URLs */
  variantThirdPartyImpTracking?: InputMaybe<Array<Scalars['String']>>;
};

export type VideoCreativeSchema = {
  __typename?: 'VideoCreativeSchema';
  account: AccountSchema;
  advertiser: AdvertiserSchema;
  advertiserID: Scalars['BigInt'];
  attributes: VideoAttributes;
  createdAt: Scalars['DateTime'];
  /** Creative Format id. Used for Video creative, other nullable */
  formatId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  previewURL?: Maybe<Scalars['String']>;
  status: ERecordEntityStatus;
  thirdPartyPlacementID?: Maybe<Scalars['String']>;
  thirdPartyPlacementName?: Maybe<Scalars['String']>;
  typeID: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type VideoMedia = {
  __typename?: 'VideoMedia';
  height: Scalars['Float'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type VideoMediaInput = {
  height: Scalars['Float'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type VideoTargetingInput = {
  /** Location coordinated in form [lat, long] */
  location: Array<Scalars['Float']>;
};

export type VideoTargetingSchema = {
  __typename?: 'VideoTargetingSchema';
  /** Location coordinated in form [lat, long] */
  location: Array<Scalars['Float']>;
};

export type VideoVariantItem = {
  /** Video props */
  props: Scalars['JSON'];
  /** CTV video targeting data */
  targeting?: InputMaybe<VideoTargetingInput>;
  /** Video template id */
  templateId?: InputMaybe<Scalars['BigInt']>;
};

export type StrategyFieldsFragment = {
  __typename?: 'StrategySchema';
  id: any;
  name: string;
  startDate: any;
  endDate: any;
  daysLeft?: number | null;
  budget: number;
  createdAt: any;
  updatedAt: any;
  budgetRemaining: number;
  flightPacing: number;
  dailyPacing: number;
  amountToSpend: number;
  campaignId: any;
  accountID: any;
  clicks: any;
  bids: any;
  wins: any;
  mediaSpend: number;
  cpm: number;
  cpc: number;
  ctr: number;
  spentYesterdayCurrency: number;
  spentYesterdayImpression: number;
  impressions?: number | null;
  pacing: EPacingType;
  pacingGoal: number;
  dailyCap?: number | null;
  status?: ERecordEntityStatus | null;
  kpiId: number;
  kpiGoal: number;
  bidPrice: number;
  minBidPrice?: number | null;
  creativesCount?: number | null;
  idealDailyPacing: number;
};

export type CloneDealMutationVariables = Exact<{
  dealId: Scalars['BigInt'];
  data: CloneDealsArgsDto;
}>;

export type CloneDealMutation = { __typename?: 'Mutation'; cloneDeal: number };

export type CreatePixelMutationVariables = Exact<{
  data: CreatePixelsArgsDto;
}>;

export type CreatePixelMutation = {
  __typename?: 'Mutation';
  createPixel: { __typename?: 'NewPixelSchema'; id: number; name: string };
};

export type BatchReplacePixelMappingsMutationVariables = Exact<{
  pixelId: Scalars['BigInt'];
  data: PixelMappingNameArgsDto;
}>;

export type BatchReplacePixelMappingsMutation = { __typename?: 'Mutation'; batchReplacePixelMappings: any };

export type CreateReportMutationVariables = Exact<{
  data: CreateReportInputDto;
}>;

export type CreateReportMutation = {
  __typename?: 'Mutation';
  createReport: {
    __typename?: 'ReportSchema';
    id: any;
    reportName: string;
    startDate: any;
    endDate: any;
    timezone: string;
    reportLastUpdated?: any | null;
    reportStatus: ReportStatus;
    accountId: any;
    advertiserIds: Array<any>;
    lineItemIds: Array<any>;
    fields: Array<string>;
    isSendingEmail: boolean;
    emails: Array<string>;
    frequency?: ReportFrequency | null;
    creator: any;
    createdAt: any;
    updatedAt: any;
    downloadURL?: string | null;
  };
};

export type DeleteReportsMutationVariables = Exact<{
  reportIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type DeleteReportsMutation = { __typename?: 'Mutation'; deleteReports: boolean };

export type UpdatePixelMutationVariables = Exact<{
  pixelId: Scalars['BigInt'];
  data: UpdatePixelsArgsDto;
}>;

export type UpdatePixelMutation = { __typename?: 'Mutation'; updatePixel: any };

export type ExportPixelsMutationVariables = Exact<{
  type: ExportType;
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  fields: Array<Scalars['String']> | Scalars['String'];
}>;

export type ExportPixelsMutation = { __typename?: 'Mutation'; exportPixels: string };

export type UpdateReportMutationVariables = Exact<{
  reportId: Scalars['BigInt'];
  data: UpdateReportArgsDto;
}>;

export type UpdateReportMutation = {
  __typename?: 'Mutation';
  updateReport: {
    __typename?: 'ReportSchema';
    id: any;
    reportName: string;
    startDate: any;
    endDate: any;
    timezone: string;
    reportLastUpdated?: any | null;
    reportStatus: ReportStatus;
    accountId: any;
    advertiserIds: Array<any>;
    lineItemIds: Array<any>;
    fields: Array<string>;
    isSendingEmail: boolean;
    emails: Array<string>;
    frequency?: ReportFrequency | null;
    creator: any;
    createdAt: any;
    updatedAt: any;
    downloadURL?: string | null;
  };
};

export type UploadImageMutationVariables = Exact<{
  data: UploadImageDto;
}>;

export type UploadImageMutation = { __typename?: 'Mutation'; uploadImage: string };

export type UploadVideoMutationVariables = Exact<{
  data: UploadVideoDto;
}>;

export type UploadVideoMutation = { __typename?: 'Mutation'; uploadVideo: string };

export type CreateAdaptCtvTemplateMutationVariables = Exact<{
  data: AddOrUpdateAdaptCtvTemplateDto;
}>;

export type CreateAdaptCtvTemplateMutation = {
  __typename?: 'Mutation';
  addAdaptCtvTemplate: { __typename?: 'AddAdaptCtvTemplateSchema'; id: any };
};

export type UpdateAdaptCtvTemplateByIdMutationVariables = Exact<{
  id: Scalars['BigInt'];
  data: AddOrUpdateAdaptCtvTemplateDto;
}>;

export type UpdateAdaptCtvTemplateByIdMutation = { __typename?: 'Mutation'; updateAdaptCtvTemplate: boolean };

export type CreateCombinedAudienceMutationVariables = Exact<{
  accountId: Scalars['Int'];
  children: Array<CombinedAudienceArg> | CombinedAudienceArg;
  childrenClause?: InputMaybe<EAudienceCombineClause>;
  countryCode: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
}>;

export type CreateCombinedAudienceMutation = {
  __typename?: 'Mutation';
  createCombinedAudience: { __typename?: 'AudienceSchema'; id: any };
};

export type ExportAudiencesMutationVariables = Exact<{
  type: ExportType;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  fields: Array<Scalars['String']> | Scalars['String'];
  accountId: Scalars['BigInt'];
}>;

export type ExportAudiencesMutation = { __typename?: 'Mutation'; audiencesExport: string };

export type UpdateCombinedAudienceMutationVariables = Exact<{
  accountId: Scalars['Int'];
  children: Array<CombinedAudienceArg> | CombinedAudienceArg;
  childrenClause?: InputMaybe<EAudienceCombineClause>;
  countryCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  id: Scalars['Int'];
}>;

export type UpdateCombinedAudienceMutation = {
  __typename?: 'Mutation';
  updateCombinedAudience: { __typename?: 'AudienceSchema'; id: any };
};

export type BulkUpdateCampaignMutationVariables = Exact<{
  data: Array<UpdateCampaignArgsDto> | UpdateCampaignArgsDto;
}>;

export type BulkUpdateCampaignMutation = { __typename?: 'Mutation'; bulkUpdateCampaign: boolean };

export type CloneCampaignMutationVariables = Exact<{
  id: Scalars['BigInt'];
  data: CloneCampaignArgsDto;
}>;

export type CloneCampaignMutation = { __typename?: 'Mutation'; cloneCampaign: boolean };

export type CreateCampaignMutationVariables = Exact<{
  data: CreateCampaignArgsDto;
}>;

export type CreateCampaignMutation = {
  __typename?: 'Mutation';
  createCampaign: { __typename?: 'CampaignSchema'; id: any };
};

export type UpdateCampaignMutationVariables = Exact<{
  campaignId: Scalars['BigInt'];
  data: UpdateCampaignArgsDto;
}>;

export type UpdateCampaignMutation = {
  __typename?: 'Mutation';
  updateCampaign: { __typename?: 'CampaignSchema'; id: any };
};

export type AddAudioMutationVariables = Exact<{
  data: CreateAudioDto;
}>;

export type AddAudioMutation = {
  __typename?: 'Mutation';
  addAudioCreative: { __typename?: 'CreatedIDSchema'; id: any };
};

export type AddBannerMutationVariables = Exact<{
  data: CreateBannerDto;
}>;

export type AddBannerMutation = {
  __typename?: 'Mutation';
  addBannerCreative: { __typename?: 'CreatedIDSchema'; id: any };
};

export type AddOrReplaceCtvVideoVariantsMutationVariables = Exact<{
  creativeId: Scalars['BigInt'];
  data: AddOrReplaceCtvVideoVariantsDto;
}>;

export type AddOrReplaceCtvVideoVariantsMutation = { __typename?: 'Mutation'; addOrReplaceCtvVideoVariants: boolean };

export type AddNativeMutationVariables = Exact<{
  data: CreateNativeDto;
}>;

export type AddNativeMutation = {
  __typename?: 'Mutation';
  addNativeCreative: { __typename?: 'CreatedIDSchema'; id: any };
};

export type AddVideoMutationVariables = Exact<{
  data: CreateVideoDto;
}>;

export type AddVideoMutation = {
  __typename?: 'Mutation';
  addVideoCreative: { __typename?: 'CreatedIDSchema'; id: any };
};

export type UpdateAudioMutationVariables = Exact<{
  creativeId: Scalars['BigInt'];
  data: UpdateAudioDto;
}>;

export type UpdateAudioMutation = { __typename?: 'Mutation'; updateAudioCreative: boolean };

export type UpdateBannerMutationVariables = Exact<{
  creativeId: Scalars['BigInt'];
  data: UpdateBannerDto;
}>;

export type UpdateBannerMutation = { __typename?: 'Mutation'; updateBannerCreative: boolean };

export type UpdateNativeMutationVariables = Exact<{
  creativeId: Scalars['BigInt'];
  data: UpdateNativeDto;
}>;

export type UpdateNativeMutation = { __typename?: 'Mutation'; updateNativeCreative: boolean };

export type UpdateVideoMutationVariables = Exact<{
  creativeId: Scalars['BigInt'];
  data: UpdateVideoDto;
}>;

export type UpdateVideoMutation = { __typename?: 'Mutation'; updateVideoCreative: boolean };

export type AssignCreativesToDealMutationVariables = Exact<{
  dealId: Scalars['BigInt'];
  creativeIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type AssignCreativesToDealMutation = { __typename?: 'Mutation'; assignCreatives: boolean };

export type BulkUpdateDealMutationVariables = Exact<{
  data: Array<BulkUpdateDealsArgsDto> | BulkUpdateDealsArgsDto;
}>;

export type BulkUpdateDealMutation = { __typename?: 'Mutation'; bulkUpdateDeals: boolean };

export type CreateDealMutationVariables = Exact<{
  data: CreateDealsArgsDto;
}>;

export type CreateDealMutation = { __typename?: 'Mutation'; createDeal: { __typename?: 'DealSchema'; id: any } };

export type UnassignCreativesFromDealMutationVariables = Exact<{
  dealId: Scalars['BigInt'];
  creativeIds: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type UnassignCreativesFromDealMutation = { __typename?: 'Mutation'; unassignCreatives: boolean };

export type UpdateDealMutationVariables = Exact<{
  dealId: Scalars['BigInt'];
  data: UpdateDealsArgsDto;
}>;

export type UpdateDealMutation = { __typename?: 'Mutation'; updateDeal: { __typename?: 'DealSchema'; id: any } };

export type CreateLocatonGroupMutationVariables = Exact<{
  data: CreateLocationGroupArgsDto;
}>;

export type CreateLocatonGroupMutation = {
  __typename?: 'Mutation';
  createLocationGroup: { __typename?: 'LocationGroupSchema'; id: any };
};

export type DeleteLocationGroupsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type DeleteLocationGroupsMutation = {
  __typename?: 'Mutation';
  deleteLocationGroups: { __typename?: 'MutationResponse'; success: boolean; message: string };
};

export type ExportLocationGroupMutationVariables = Exact<{
  type: ExportType;
  id: Scalars['BigInt'];
}>;

export type ExportLocationGroupMutation = { __typename?: 'Mutation'; locationGroupExport: string };

export type UpdateLocatonGroupMutationVariables = Exact<{
  data: UpdateLocationGroupArgsDto;
}>;

export type UpdateLocatonGroupMutation = { __typename?: 'Mutation'; updateLocationGroup: boolean };

export type AssignCreativesToStrategyMutationVariables = Exact<{
  strategyId: Scalars['BigInt'];
  creativeIDs: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type AssignCreativesToStrategyMutation = { __typename?: 'Mutation'; assignCreativesToStrategy: boolean };

export type BulkUpdateStrategiesMutationVariables = Exact<{
  data: Array<BulkUpdateStrategyArgsDto> | BulkUpdateStrategyArgsDto;
}>;

export type BulkUpdateStrategiesMutation = { __typename?: 'Mutation'; bulkUpdateStrategies: boolean };

export type CloneStrategyMutationVariables = Exact<{
  id: Scalars['BigInt'];
  data: CloneStrategyArgsDto;
}>;

export type CloneStrategyMutation = { __typename?: 'Mutation'; cloneStrategy: boolean };

export type CreateStrategyMutationVariables = Exact<{
  campaignId: Scalars['BigInt'];
  data: CreateStrategyArgsDto;
}>;

export type CreateStrategyMutation = {
  __typename?: 'Mutation';
  createStrategy: { __typename?: 'StrategySchema'; id: any };
};

export type UpdateStrategyMutationVariables = Exact<{
  id: Scalars['BigInt'];
  data: UpdateStrategyArgsDto;
}>;

export type UpdateStrategyMutation = {
  __typename?: 'Mutation';
  updateStrategy: { __typename?: 'StrategySchema'; id: any };
};

export type BulkUpdateTargetingMutationVariables = Exact<{
  data: BulkUpdateTargetingArgsDto;
}>;

export type BulkUpdateTargetingMutation = { __typename?: 'Mutation'; bulkUpdateTargeting: boolean };

export type ReplaceTargetingAudiencesBatchMutationVariables = Exact<{
  id: Scalars['Float'];
  type: Scalars['String'];
  data: ReplaceTargetingAudiencesBatchDto;
}>;

export type ReplaceTargetingAudiencesBatchMutation = {
  __typename?: 'Mutation';
  replaceTargetingAudiencesBatch: boolean;
};

export type ReplaceTargetingPoiBatchMutationVariables = Exact<{
  referenceObjectID: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  data: ReplaceBatchPoiInputDto;
}>;

export type ReplaceTargetingPoiBatchMutation = { __typename?: 'Mutation'; replacePoiBatch: boolean };

export type CreateAbsTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateDvAuthenticBrandSuitabilityTargetingDto> | CreateDvAuthenticBrandSuitabilityTargetingDto;
}>;

export type CreateAbsTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDvAuthenticBrandSuitabilityTargeting: Array<{
    __typename?: 'DvAuthenticBrandSuitabilityTargetingSchema';
    id: any;
  }>;
};

export type DeleteAbsTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
}>;

export type DeleteAbsTargetingMutation = {
  __typename?: 'Mutation';
  deleteDvAuthenticBrandSuitabilityTargeting: boolean;
};

export type CreateAppCategoryTargetingMutationVariables = Exact<{
  data: Array<CreateAppCategoryTargetingDto> | CreateAppCategoryTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateAppCategoryTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateAppCategoryTargeting: Array<{ __typename?: 'AppCategoryTargetingSchema'; id: any }>;
};

export type CreateAppTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateAppTargetingDto> | CreateAppTargetingDto;
}>;

export type CreateAppTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateAppTargeting: Array<{ __typename?: 'AppTargetingSchema'; id: any }>;
};

export type DeleteAppTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  type?: InputMaybe<EObjectType>;
  refId?: InputMaybe<Scalars['BigInt']>;
}>;

export type DeleteAppTargetingMutation = { __typename?: 'Mutation'; batchDeleteAppTargeting: Array<boolean> };

export type UpdateAppTargetingMutationVariables = Exact<{
  data: Array<AppTargetingBatchUpdateInput> | AppTargetingBatchUpdateInput;
}>;

export type UpdateAppTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateAppTargeting: Array<{ __typename?: 'AppTargetingSchema'; id: any }>;
};

export type CreateBrowserTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateBrowserTargetingDto> | CreateBrowserTargetingDto;
}>;

export type CreateBrowserTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateBrowserTargeting: Array<{ __typename?: 'BrowserTargetingSchema'; id: any }>;
};

export type DeleteBrowserTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type DeleteBrowserTargetingMutation = { __typename?: 'Mutation'; batchDeleteBrowserTargeting: Array<boolean> };

export type UpdateBrowserTargetingMutationVariables = Exact<{
  data: Array<BrowserTargetingBatchUpdateInput> | BrowserTargetingBatchUpdateInput;
}>;

export type UpdateBrowserTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateBrowserTargeting: Array<{ __typename?: 'BrowserTargetingSchema'; id: any }>;
};

export type CreateBssTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateDvBrandSafetySuitabilityTargetingDto> | CreateDvBrandSafetySuitabilityTargetingDto;
}>;

export type CreateBssTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDvBrandSafetySuitabilityTargeting: Array<{
    __typename?: 'DvBrandSafetySuitabilityTargetingSchema';
    id: any;
  }>;
};

export type DeleteBssTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  type: EObjectType;
  refId: Scalars['BigInt'];
}>;

export type DeleteBssTargetingMutation = {
  __typename?: 'Mutation';
  batchDeleteDvBrandSafetySuitabilityTargeting: Array<boolean>;
};

export type CreateCarrierTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateCarrierTargetingDto> | CreateCarrierTargetingDto;
}>;

export type CreateCarrierTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateCarrierTargeting: Array<{ __typename?: 'CarrierTargetingSchema'; id: any }>;
};

export type DeleteCarrierTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type DeleteCarrierTargetingMutation = { __typename?: 'Mutation'; batchDeleteCarrierTargeting: Array<boolean> };

export type UpdateCarrierTargetingMutationVariables = Exact<{
  data: Array<CarrierTargetingBatchUpdateInput> | CarrierTargetingBatchUpdateInput;
}>;

export type UpdateCarrierTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateCarrierTargeting: Array<{ __typename?: 'CarrierTargetingSchema'; id: any }>;
};

export type CreateCreativeTypeTargetingMutationVariables = Exact<{
  data: Array<CreateCreativeTypeTargetingDto> | CreateCreativeTypeTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateCreativeTypeTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateCreativeTypeTargeting: Array<{ __typename?: 'CreativeTypeTargetingSchema'; id: any }>;
};

export type DeleteCreativeTypeTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type DeleteCreativeTypeTargetingMutation = {
  __typename?: 'Mutation';
  batchDeleteCreativeTypeTargeting: Array<boolean>;
};

export type UpdateCreativeTypeTargetingMutationVariables = Exact<{
  data: Array<CreativeTypeTargetingBatchUpdateInput> | CreativeTypeTargetingBatchUpdateInput;
}>;

export type UpdateCreativeTypeTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateCreativeTypeTargeting: Array<{ __typename?: 'CreativeTypeTargetingSchema'; id: any }>;
};

export type CreateDealTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateDealTargetingDto> | CreateDealTargetingDto;
}>;

export type CreateDealTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDealTargeting: Array<{ __typename?: 'DealTargetingSchema'; id: any }>;
};

export type DeleteDealTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  type?: InputMaybe<EObjectType>;
  refId?: InputMaybe<Scalars['BigInt']>;
}>;

export type DeleteDealTargetingMutation = { __typename?: 'Mutation'; batchDeleteDealTargeting: Array<boolean> };

export type UpdateDealTargetingMutationVariables = Exact<{
  data: Array<DealTargetingBatchUpdateInput> | DealTargetingBatchUpdateInput;
}>;

export type UpdateDealTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateDealTargeting: Array<{ __typename?: 'DealTargetingSchema'; id: any }>;
};

export type BatchDeleteDeviceTypesMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  type?: InputMaybe<EObjectType>;
  refid?: InputMaybe<Scalars['BigInt']>;
}>;

export type BatchDeleteDeviceTypesMutation = {
  __typename?: 'Mutation';
  batchDeleteDeviceTypeTargeting: Array<boolean>;
};

export type CreateDeviceTypeTargetingMutationVariables = Exact<{
  data: Array<CreateDeviceTypeTargetingDto> | CreateDeviceTypeTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateDeviceTypeTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDeviceTypeTargeting: Array<{ __typename?: 'DeviceTypeTargetingSchema'; id: any }>;
};

export type UpdateDeviceTypeTargetingMutationVariables = Exact<{
  data: Array<DeviceTypeTargetingBatchUpdateInput> | DeviceTypeTargetingBatchUpdateInput;
}>;

export type UpdateDeviceTypeTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateDeviceTypeTargeting: Array<{ __typename?: 'DeviceTypeTargetingSchema'; id: any }>;
};

export type CreateDvSegmentTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateDvViewabilityTargetingDto> | CreateDvViewabilityTargetingDto;
}>;

export type CreateDvSegmentTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDvViewabilityTargeting: Array<{ __typename?: 'DvViewabilityTargetingSchema'; id: any }>;
};

export type CreateFreqCapTargetingMutationVariables = Exact<{
  data: Array<CreateFrequencyTargetingDto> | CreateFrequencyTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateFreqCapTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateFrequencyTargeting: Array<{ __typename?: 'FrequencyTargetingSchema'; id: any }>;
};

export type CreateGenreTargetingMutationVariables = Exact<{
  data: Array<CreateGenreTargetingDto> | CreateGenreTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateGenreTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateGenreTargeting: Array<{ __typename?: 'GenreTargetingSchema'; id: any }>;
};

export type CreateCountryTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateCountryTargetingDto> | CreateCountryTargetingDto;
}>;

export type CreateCountryTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateCountryTargeting: Array<{ __typename?: 'CountryTargetingSchema'; id: any }>;
};

export type CreateGeoTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateGeoTargetingDto> | CreateGeoTargetingDto;
}>;

export type CreateGeoTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateGeoTargeting: Array<{ __typename?: 'GeoTargetingSchema'; id: any }>;
};

export type DeleteCountryTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  refId: Scalars['BigInt'];
  type: EObjectType;
}>;

export type DeleteCountryTargetingMutation = { __typename?: 'Mutation'; batchDeleteCountryTargeting: Array<boolean> };

export type DeleteGeoTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  refId: Scalars['BigInt'];
  type: EObjectType;
}>;

export type DeleteGeoTargetingMutation = { __typename?: 'Mutation'; batchDeleteGeoTargeting: Array<boolean> };

export type UpdateCountryTargetingMutationVariables = Exact<{
  data: Array<CountryTargetingBatchUpdateInput> | CountryTargetingBatchUpdateInput;
}>;

export type UpdateCountryTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateCountryTargeting: Array<{ __typename?: 'CountryTargetingSchema'; id: any }>;
};

export type UpdateGeoTargetingMutationVariables = Exact<{
  data: Array<GeoTargetingBatchUpdateInput> | GeoTargetingBatchUpdateInput;
}>;

export type UpdateGeoTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateGeoTargeting: Array<{ __typename?: 'GeoTargetingSchema'; id: any }>;
};

export type CreateIabCategoryTargetingMutationVariables = Exact<{
  data: Array<CreateCategoryTargetingDto> | CreateCategoryTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateIabCategoryTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateCategoryTargeting: Array<{
    __typename?: 'CategoryTargetingSchema';
    id: any;
    categoryId: any;
    exclude: boolean;
  }>;
};

export type CreateLanguageTargetingMutationVariables = Exact<{
  data: Array<CreateLanguageTargetingDto> | CreateLanguageTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateLanguageTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateLanguageTargeting: Array<{ __typename?: 'LanguageTargetingSchema'; id: any }>;
};

export type CreateLiveTargetingMutationVariables = Exact<{
  data: Array<CreateLiveTargetingDto> | CreateLiveTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateLiveTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateLiveTargeting: Array<{ __typename?: 'LiveTargetingSchema'; id: any }>;
};

export type CreateOsTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateOsTargetingDto> | CreateOsTargetingDto;
}>;

export type CreateOsTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateOsTargeting: Array<{ __typename?: 'OsTargetingSchema'; id: any }>;
};

export type DeleteOsTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type DeleteOsTargetingMutation = { __typename?: 'Mutation'; batchDeleteOsTargeting: Array<boolean> };

export type UpdateOsTargetingMutationVariables = Exact<{
  data: Array<OsTargetingBatchUpdateInput> | OsTargetingBatchUpdateInput;
}>;

export type UpdateOsTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateOsTargeting: Array<{ __typename?: 'OsTargetingSchema'; id: any }>;
};

export type BatchDeletePositionTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
}>;

export type BatchDeletePositionTargetingMutation = {
  __typename?: 'Mutation';
  batchDeletePositionTargeting: Array<boolean>;
};

export type CreatePlacementTargetingMutationVariables = Exact<{
  data: Array<CreatePositionTargetingDto> | CreatePositionTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreatePlacementTargetingMutation = {
  __typename?: 'Mutation';
  batchCreatePositionTargeting: Array<{ __typename?: 'PositionTargetingSchema'; id: any }>;
};

export type UpdatePlacementTargetingMutationVariables = Exact<{
  data: Array<PositionTargetingBatchUpdateInput> | PositionTargetingBatchUpdateInput;
}>;

export type UpdatePlacementTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdatePositionTargeting: Array<{ __typename?: 'PositionTargetingSchema'; id: any }>;
};

export type CreateProductionTargetingMutationVariables = Exact<{
  data: Array<CreateProductionTargetingDto> | CreateProductionTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateProductionTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateProductionTargeting: Array<{ __typename?: 'ProductionTargetingSchema'; id: any }>;
};

export type CreateRatingTargetingMutationVariables = Exact<{
  data: Array<CreateRatingTargetingDto> | CreateRatingTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateRatingTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateRatingTargeting: Array<{ __typename?: 'RatingTargetingSchema'; id: any }>;
};

export type CreateSiteTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
  type: EObjectType;
  data: Array<CreateSiteTargetingDto> | CreateSiteTargetingDto;
}>;

export type CreateSiteTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateSiteTargeting: Array<{ __typename?: 'SiteTargetingSchema'; id: any }>;
};

export type DeleteSiteTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  type?: InputMaybe<EObjectType>;
  refId?: InputMaybe<Scalars['BigInt']>;
}>;

export type DeleteSiteTargetingMutation = { __typename?: 'Mutation'; batchDeleteSiteTargeting: Array<boolean> };

export type UpdateSiteTargetingMutationVariables = Exact<{
  data: Array<SiteTargetingBatchUpdateInput> | SiteTargetingBatchUpdateInput;
}>;

export type UpdateSiteTargetingMutation = {
  __typename?: 'Mutation';
  batchUpdateSiteTargeting: Array<{ __typename?: 'SiteTargetingSchema'; id: any }>;
};

export type SupplyBatchReplaceMutationVariables = Exact<{
  objectType: TargetingObjectTypeEnum;
  objectId: Scalars['BigInt'];
  replace: BatchReplace;
}>;

export type SupplyBatchReplaceMutation = { __typename?: 'Mutation'; supplyBatchReplace: boolean };

export type CreateSupplySourceTargetingMutationVariables = Exact<{
  data: CreateSupplyTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateSupplySourceTargetingMutation = {
  __typename?: 'Mutation';
  createSupplyTargeting: { __typename?: 'SupplyTargetingSchema'; id: any };
};

export type DeleteSupplySourceTargetingMutationVariables = Exact<{
  id: Scalars['BigInt'];
}>;

export type DeleteSupplySourceTargetingMutation = { __typename?: 'Mutation'; deleteSupplyTargeting: boolean };

export type UpdateSupplySourceTargetingMutationVariables = Exact<{
  data: UpdateSupplyTargetingDto;
  id: Scalars['BigInt'];
}>;

export type UpdateSupplySourceTargetingMutation = {
  __typename?: 'Mutation';
  updateSupplyTargeting: { __typename?: 'SupplyTargetingSchema'; id: any };
};

export type CreateTimePartingTargetingMutationVariables = Exact<{
  data: Array<CreateDayPartTargetingDto> | CreateDayPartTargetingDto;
  id: Scalars['BigInt'];
  type: EObjectType;
}>;

export type CreateTimePartingTargetingMutation = {
  __typename?: 'Mutation';
  batchCreateDayPartTargeting: Array<{ __typename?: 'DayPartTargetingSchema'; id: any }>;
};

export type DeleteTimePartingTargetingMutationVariables = Exact<{
  ids: Array<Scalars['BigInt']> | Scalars['BigInt'];
  objectID: Scalars['BigInt'];
  type: EObjectType;
}>;

export type DeleteTimePartingTargetingMutation = {
  __typename?: 'Mutation';
  batchDeleteDayPartTargeting: Array<boolean>;
};

export type GetAccountQueryVariables = Exact<{
  id: Scalars['BigInt'];
}>;

export type GetAccountQuery = {
  __typename?: 'Query';
  account: {
    __typename?: 'AccountSchema';
    id: any;
    name: string;
    status: AccountStatus;
    salesforceId?: string | null;
    currency?: AccountCurrency | null;
    createdAt: any;
    updatedAt?: any | null;
    rateCard?: {
      __typename?: 'RateCardData';
      audience?: {
        __typename?: 'AudienceRateCard';
        tierCpm?: {
          __typename?: 'TierCpm';
          custom?: number | null;
          premium?: number | null;
          standard?: number | null;
          verified?: number | null;
        } | null;
      } | null;
    } | null;
  };
};

export type GetAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountsQuery = {
  __typename?: 'Query';
  accounts: {
    __typename?: 'AccountsSchema';
    nodes: Array<{
      __typename?: 'AccountSchema';
      id: any;
      name: string;
      status: AccountStatus;
      salesforceId?: string | null;
      currency?: AccountCurrency | null;
      createdAt: any;
      updatedAt?: any | null;
      rateCard?: {
        __typename?: 'RateCardData';
        audience?: {
          __typename?: 'AudienceRateCard';
          tierCpm?: {
            __typename?: 'TierCpm';
            custom?: number | null;
            premium?: number | null;
            verified?: number | null;
            standard?: number | null;
          } | null;
          processingMargin?: { __typename?: 'ProcessingMarginData'; thirdParty?: number | null } | null;
        } | null;
      } | null;
    }>;
  };
};

export type GetActorQueryVariables = Exact<{ [key: string]: never }>;

export type GetActorQuery = {
  __typename?: 'Query';
  actor: {
    __typename?: 'ActorSchema';
    actorId: any;
    customerId: any;
    emailAddress: string;
    availableCustomers: Array<{
      __typename?: 'CustomerSchema';
      id: any;
      name: string;
      code: string;
      selected: boolean;
    }>;
  };
};

export type GetAdvertisersQueryVariables = Exact<{
  searchName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetAdvertisersQuery = {
  __typename?: 'Query';
  advertisers: {
    __typename?: 'PaginatedAdvertisersSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AdvertiserSchema';
      id: any;
      name: string;
      code: string;
      agencyId: any;
      accountId: any;
      lineItemCurrencies: Array<string>;
    }> | null;
  };
};

export type GetAgenciesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  accountId?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResourceStatus>;
  userIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetAgenciesQuery = {
  __typename?: 'Query';
  agencies: {
    __typename?: 'PaginatedAgenciesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AgencySchema';
      id: any;
      name: string;
      accountId: any;
      status: ResourceStatus;
      createdAt: any;
      updatedAt: any;
    }> | null;
  };
};

export type GetAudienceCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  parentIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  rootOnly?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAudienceCategoriesQuery = {
  __typename?: 'Query';
  audienceCategories: {
    __typename?: 'PaginatedAudienceCategorySchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{ __typename?: 'AudienceCategorySchema'; id: any; name: string; parentId?: any | null }> | null;
  };
};

export type GetAudienceDataProvidersQueryVariables = Exact<{
  args: GetAudienceDataProvidersArgsDto;
}>;

export type GetAudienceDataProvidersQuery = {
  __typename?: 'Query';
  getAudienceDataProviders: {
    __typename?: 'PaginatedAudienceDataProviderSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'AudienceDataProviderSchema'; dataProvider: string }> | null;
  };
};

export type GetAudienceTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetAudienceTypesQuery = {
  __typename?: 'Query';
  audienceTypes: {
    __typename?: 'PaginatedAudienceTypeSchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{ __typename?: 'AudienceTypeSchema'; name: string; id: any }> | null;
  };
};

export type GetAudiencesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  accountId: Scalars['BigInt'];
  billing?: InputMaybe<EAudienceBilling>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  targetingMethod?: InputMaybe<Array<EAudienceType> | EAudienceType>;
  namePrefix?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  withStrategies?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<AudiencesSort> | AudiencesSort>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  envs?: InputMaybe<Array<EAudienceEnvironment> | EAudienceEnvironment>;
  excludeParentForId?: InputMaybe<Scalars['Int']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  typeIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  categoryIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  subCategoryIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  providers?: InputMaybe<Array<EAudienceProvider> | EAudienceProvider>;
  dataProviders?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  withEnvs?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAudiencesQuery = {
  __typename?: 'Query';
  audiences: {
    __typename?: 'PaginatedAudiencesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AudienceSchema';
      accountId?: any | null;
      approxSize?: number | null;
      billing?: EAudienceBilling | null;
      categoryId?: any | null;
      subCategoryId?: any | null;
      childrenClause?: EAudienceCombineClause | null;
      countryCode?: string | null;
      cpm?: number | null;
      provider: EAudienceProvider;
      dataProvider: string;
      id: any;
      description?: string | null;
      envs?: EAudienceEnvironment | null;
      name: string;
      strategiesCount?: number | null;
      strategyNames?: Array<string> | null;
      type: any;
      targetingMethod?: EAudienceType | null;
      createdAt: any;
      updatedAt?: any | null;
      children?: Array<{
        __typename?: 'CombinedAudienceSchema';
        id?: any | null;
        childrenClause?: EAudienceCombineClause | null;
        exclude?: boolean | null;
        children?: Array<{
          __typename?: 'CombinedAudienceSchema';
          id?: any | null;
          childrenClause?: EAudienceCombineClause | null;
          exclude?: boolean | null;
          children?: Array<{
            __typename?: 'CombinedAudienceSchema';
            id?: any | null;
            childrenClause?: EAudienceCombineClause | null;
            exclude?: boolean | null;
          }> | null;
        }> | null;
      }> | null;
      rawChildren?: Array<{
        __typename?: 'AudienceSchema';
        accountId?: any | null;
        approxSize?: number | null;
        billing?: EAudienceBilling | null;
        categoryId?: any | null;
        subCategoryId?: any | null;
        countryCode?: string | null;
        cpm?: number | null;
        provider: EAudienceProvider;
        dataProvider: string;
        id: any;
        description?: string | null;
        envs?: EAudienceEnvironment | null;
        name: string;
        strategiesCount?: number | null;
        strategyNames?: Array<string> | null;
        type: any;
        targetingMethod?: EAudienceType | null;
        createdAt: any;
        updatedAt?: any | null;
      }> | null;
      country?: { __typename?: 'CountrySchema'; name: string } | null;
    }> | null;
  };
};

export type GetCampaignsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
  searchId?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<CampaignDateRangeFilter>;
  sortBy?: InputMaybe<CampaignsSortInputDto>;
  advertiserIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  withCreativesCount?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCampaignsQuery = {
  __typename?: 'Query';
  campaigns: {
    __typename?: 'PaginatedCampaignSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'CampaignSchema';
      id: any;
      name: string;
      status?: ERecordEntityStatus | null;
      flightPacing: number;
      dailyPacing: number;
      impressions?: number | null;
      clickThroughRate: number;
      clicks: any;
      bids: any;
      wins: any;
      mediaSpend: number;
      cpm: number;
      cpc: number;
      ctr: number;
      vcr: number;
      spentYesterdayCurrency: number;
      spentYesterdayImpression: number;
      amountSpent: number;
      amountToSpend: number;
      budget: number;
      budgetRemaining: number;
      daysLeft?: number | null;
      advertiserId: any;
      currency?: string | null;
      dailyCap?: number | null;
      pacing: EPacingType;
      pacingOption?: EPacingOption | null;
      acop?: number | null;
      kpiId?: number | null;
      kpiGoal?: number | null;
      rateAmount?: number | null;
      rateType?: ERateType | null;
      pacingTracking: EPacingTracking;
      pacingGoal?: number | null;
      type: ECampaignType;
      startDate: any;
      endDate: any;
      createdAt: any;
      updatedAt: any;
      margin?: number | null;
      managedService?: boolean | null;
      viewabilityProvider?: EViabilityProvider | null;
      idealDailyPacing: number;
      strategies: Array<{
        __typename?: 'StrategySchema';
        id: any;
        name: string;
        startDate: any;
        endDate: any;
        daysLeft?: number | null;
        budget: number;
        createdAt: any;
        updatedAt: any;
        budgetRemaining: number;
        flightPacing: number;
        dailyPacing: number;
        amountToSpend: number;
        campaignId: any;
        accountID: any;
        clicks: any;
        bids: any;
        wins: any;
        mediaSpend: number;
        cpm: number;
        cpc: number;
        ctr: number;
        spentYesterdayCurrency: number;
        spentYesterdayImpression: number;
        impressions?: number | null;
        pacing: EPacingType;
        pacingGoal: number;
        dailyCap?: number | null;
        status?: ERecordEntityStatus | null;
        kpiId: number;
        kpiGoal: number;
        bidPrice: number;
        minBidPrice?: number | null;
        creativesCount?: number | null;
        idealDailyPacing: number;
      }>;
    }> | null;
  };
};

export type GetCampaignsForPerformanceReportsModalQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchName?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<CampaignsSortInputDto>;
  searchAdvertiserName?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type GetCampaignsForPerformanceReportsModalQuery = {
  __typename?: 'Query';
  campaigns: {
    __typename?: 'PaginatedCampaignSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'CampaignSchema';
      id: any;
      name: string;
      status?: ERecordEntityStatus | null;
      currency?: string | null;
      advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string; code: string };
    }> | null;
  };
};

export type GetCustomReportFieldCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomReportFieldCategoriesQuery = {
  __typename?: 'Query';
  customReportFields: Array<{ __typename?: 'ReportCategorySchema'; label: string; value: string }>;
};

export type GetDealForEditQueryVariables = Exact<{
  search: SearchDealsArgsDto;
}>;

export type GetDealForEditQuery = {
  __typename?: 'Query';
  deals: {
    __typename?: 'PaginatedDealsSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DealSchema';
      id: any;
      margin: number;
      endDate?: any | null;
      salesforceId?: string | null;
      bidFloor: number;
      dspDealId?: string | null;
      startDate: any;
      createdAt?: any | null;
      dspIds?: Array<any> | null;
      dspSeatId?: any | null;
      updatedAt?: any | null;
      status: DealStatus;
      creator: any;
      auctionType: AuctionType;
      name: string;
      bidRequests?: any | null;
      bidRate?: number | null;
      bids?: any | null;
      winRate?: number | null;
      impressions?: any | null;
      revenue?: number | null;
      cpm?: number | null;
      priority: EPriority;
      supplyDealIds?: Array<string> | null;
      account: { __typename?: 'AccountSchema'; id: any; name: string };
    }> | null;
  };
};

export type GetDealsSummaryQueryVariables = Exact<{
  search: SearchDealsArgsDto;
}>;

export type GetDealsSummaryQuery = {
  __typename?: 'Query';
  deals: {
    __typename?: 'PaginatedDealsSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DealSchema';
      id: any;
      margin: number;
      endDate?: any | null;
      salesforceId?: string | null;
      bidFloor: number;
      dspDealId?: string | null;
      startDate: any;
      createdAt?: any | null;
      dspIds?: Array<any> | null;
      dspSeatId?: any | null;
      updatedAt?: any | null;
      status: DealStatus;
      creator: any;
      auctionType: AuctionType;
      name: string;
      bidRequests?: any | null;
      bidRate?: number | null;
      bids?: any | null;
      winRate?: number | null;
      impressions?: any | null;
      revenue?: number | null;
      cpm?: number | null;
      priority: EPriority;
      account: { __typename?: 'AccountSchema'; id: any; name: string };
    }> | null;
  };
};

export type GetDsPsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetDsPsQuery = {
  __typename?: 'Query';
  dsp: {
    __typename?: 'PaginatedDspSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'ResourceSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetGeoAdvertisersQueryVariables = Exact<{
  searchName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetGeoAdvertisersQuery = {
  __typename?: 'Query';
  advertisersGeo: {
    __typename?: 'PaginatedAdvertisersSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AdvertiserSchema';
      id: any;
      name: string;
      code: string;
      lineItemCurrencies: Array<string>;
    }> | null;
  };
};

export type GetGeoCampaignsQueryVariables = Exact<{
  searchCampName?: InputMaybe<Scalars['String']>;
  searchAdvName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetGeoCampaignsQuery = {
  __typename?: 'Query';
  campaignsGeo: {
    __typename?: 'PaginatedGeoCampaignsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'GeoCampaignSchema';
      id: any;
      name: string;
      status: StatusCodeType;
      currency: string;
      advertiser: {
        __typename?: 'AdvertiserSchema';
        id: any;
        name: string;
        code: string;
        lineItemCurrencies: Array<string>;
      };
    }> | null;
  };
};

export type GetKpisQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetKpisQuery = {
  __typename?: 'Query';
  kpi: {
    __typename?: 'PaginatedKpiSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'KpiSchema'; id: any; name: string }> | null;
  };
};

export type GetLocationGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<LocationGroupsSort> | LocationGroupsSort>;
  withPoiCount?: InputMaybe<Scalars['Boolean']>;
  withStrategies?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetLocationGroupsQuery = {
  __typename?: 'Query';
  locationGroups: {
    __typename?: 'PaginatedLocationGroupsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'LocationGroupSchema';
      id: any;
      name: string;
      createdAt: any;
      updatedAt?: any | null;
      poiCount?: number | null;
      strategyCount?: number | null;
      strategyNames?: Array<string> | null;
    }> | null;
  };
};

export type GetPointsOfInterestQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  brands?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cityPrefix?: InputMaybe<Scalars['String']>;
  contextLocationGroupId?: InputMaybe<Scalars['BigInt']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  locationGroupId?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PointOfInterestSort> | PointOfInterestSort>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tagPrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetPointsOfInterestQuery = {
  __typename?: 'Query';
  pointsOfInterest: {
    __typename?: 'PaginatedPointOfInterestSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'PointOfInterestSchema';
      added: boolean;
      address?: string | null;
      brands?: Array<string> | null;
      category?: string | null;
      city?: string | null;
      countryCode?: string | null;
      createdAt: any;
      id: any;
      lat: number;
      long: number;
      name: string;
      state?: string | null;
      status: PoiStatus;
      subcategory?: string | null;
      tags?: Array<string> | null;
      updatedAt: any;
    }> | null;
  };
};

export type GetPointsOfInterestBrandsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetPointsOfInterestBrandsQuery = {
  __typename?: 'Query';
  pointsOfInterestBrands: {
    __typename?: 'PaginatedPointOfInterestBrandsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestBrandSchema'; name?: string | null }> | null;
  };
};

export type GetPointsOfInterestCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetPointsOfInterestCategoriesQuery = {
  __typename?: 'Query';
  pointsOfInterestCategories: {
    __typename?: 'PaginatedPointOfInterestCategoriesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestCategorySchema'; name?: string | null }> | null;
  };
};

export type GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetPointsOfInterestCategoriesWithSubCategoriesQuery = {
  __typename?: 'Query';
  pointsOfInterestCategoriesWithSubCategories: {
    __typename?: 'PaginatedPointOfInterestCategoriesWithSubCategoriesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'PointOfInterestCategoryWithSubCategoriesSchema';
      categoryName?: string | null;
      subCategoryNames?: Array<string> | null;
    }> | null;
  };
};

export type GetPointsOfInterestNameAndLatLongQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  brands?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cityPrefix?: InputMaybe<Scalars['String']>;
  contextLocationGroupId?: InputMaybe<Scalars['BigInt']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  locationGroupId?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PointOfInterestSort> | PointOfInterestSort>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tagPrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetPointsOfInterestNameAndLatLongQuery = {
  __typename?: 'Query';
  pointsOfInterest: {
    __typename?: 'PaginatedPointOfInterestSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestSchema'; name: string; lat: number; long: number }> | null;
  };
};

export type GetPointsOfInterestIDandNameQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  brands?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cityPrefix?: InputMaybe<Scalars['String']>;
  contextLocationGroupId?: InputMaybe<Scalars['BigInt']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  locationGroupId?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PointOfInterestSort> | PointOfInterestSort>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tagPrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetPointsOfInterestIDandNameQuery = {
  __typename?: 'Query';
  pointsOfInterest: {
    __typename?: 'PaginatedPointOfInterestSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestSchema'; id: any; name: string }> | null;
  };
};

export type GetPointsOfInterestStatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetPointsOfInterestStatesQuery = {
  __typename?: 'Query';
  pointsOfInterestStates: {
    __typename?: 'PaginatedPointOfInterestStatesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestStateSchema'; name?: string | null }> | null;
  };
};

export type GetPointsOfInterestSubCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetPointsOfInterestSubCategoriesQuery = {
  __typename?: 'Query';
  pointsOfInterestSubCategories: {
    __typename?: 'PaginatedPointOfInterestSubCategoriesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'PointOfInterestSubCategorySchema'; name?: string | null }> | null;
  };
};

export type GetPixelMappingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  pixelIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetPixelMappingsQuery = {
  __typename?: 'Query';
  pixelMappings: {
    __typename?: 'PaginatedPixelMappingsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'PixelMappingSchema';
      id: any;
      accountId: any;
      pixelId: any;
      pageUrl: string;
      description: string;
      createdAt: any;
      updatedAt?: any | null;
      events?: any | null;
      lastFire?: any | null;
      pixel: {
        __typename?: 'PixelSchema';
        id: any;
        name: string;
        advertiserId: any;
        status: EPixelsStatus;
        createdAt: any;
      };
    }> | null;
  };
};

export type GetPixelsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PixelSort> | PixelSort>;
  mappedSort?: InputMaybe<Array<PixelMappedSort> | PixelMappedSort>;
  status?: InputMaybe<EPixelsStatus>;
}>;

export type GetPixelsQuery = {
  __typename?: 'Query';
  pixels: {
    __typename?: 'PaginatedPixelsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'PixelSchema';
      id: any;
      name: string;
      advertiserId: any;
      status: EPixelsStatus;
      createdAt: any;
      mappedNames: Array<string>;
      mappedUrls: Array<string>;
      mappedIds: Array<any>;
    }> | null;
  };
};

export type GetPublisherQueryVariables = Exact<{
  id: Scalars['Float'];
}>;

export type GetPublisherQuery = {
  __typename?: 'Query';
  publisher: { __typename?: 'PublisherSchema'; id: any; name: string; platform: PlatformType; metadata: Array<any> };
};

export type GetPublishersQueryVariables = Exact<{
  type?: InputMaybe<PlatformType>;
}>;

export type GetPublishersQuery = {
  __typename?: 'Query';
  publishers: Array<{
    __typename?: 'PublisherSchema';
    id: any;
    name: string;
    platform: PlatformType;
    metadata: Array<any>;
  } | null>;
};

export type GetReportFileDownloadUrlQueryVariables = Exact<{
  id: Scalars['Float'];
}>;

export type GetReportFileDownloadUrlQuery = {
  __typename?: 'Query';
  downloadReportFile: { __typename?: 'DownloadReportFileSchema'; fileUrl: string };
};

export type GetReportFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type GetReportFieldsQuery = {
  __typename?: 'Query';
  reportFields: Array<{ __typename?: 'ReportFieldSchema'; label: string; value: string }>;
};

export type GetReportsQueryVariables = Exact<{
  searchName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<ReportColumnsSortingInputDto>;
  creator?: InputMaybe<Scalars['Float']>;
  searchId?: InputMaybe<Scalars['Int']>;
}>;

export type GetReportsQuery = {
  __typename?: 'Query';
  reports: {
    __typename?: 'PaginatedReportsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'ReportSchema';
      id: any;
      reportName: string;
      startDate: any;
      endDate: any;
      timezone: string;
      reportLastUpdated?: any | null;
      reportStatus: ReportStatus;
      accountId: any;
      advertiserIds: Array<any>;
      fields: Array<string>;
      lineItemIds: Array<any>;
      frequency?: ReportFrequency | null;
      isSendingEmail: boolean;
      emails: Array<string>;
      creator: any;
      metrics?: Array<string> | null;
    }> | null;
  };
};

export type GetStrategiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  campaignIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  accountId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  salesforceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ERecordEntityStatus>;
  sortBy?: InputMaybe<StrategySortInputDto>;
  withCreativesCount?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetStrategiesQuery = {
  __typename?: 'Query';
  strategies: {
    __typename?: 'PaginatedStrategySchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'StrategySchema';
      id: any;
      name: string;
      startDate: any;
      endDate: any;
      daysLeft?: number | null;
      budget: number;
      createdAt: any;
      updatedAt: any;
      budgetRemaining: number;
      flightPacing: number;
      dailyPacing: number;
      amountToSpend: number;
      campaignId: any;
      accountID: any;
      clicks: any;
      bids: any;
      wins: any;
      mediaSpend: number;
      cpm: number;
      cpc: number;
      ctr: number;
      spentYesterdayCurrency: number;
      spentYesterdayImpression: number;
      impressions?: number | null;
      pacing: EPacingType;
      pacingGoal: number;
      dailyCap?: number | null;
      status?: ERecordEntityStatus | null;
      kpiId: number;
      kpiGoal: number;
      bidPrice: number;
      minBidPrice?: number | null;
      creativesCount?: number | null;
      idealDailyPacing: number;
    }> | null;
  };
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['Float'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'UserSchema';
    id: any;
    accountId: any;
    email: string;
    firstName: string;
    lastName: string;
    roleId: any;
    status: string;
    lastLogin: string;
  };
};

export type GetAdaptCtvTemplatesQueryVariables = Exact<{
  search: SearchAdaptCtvTemplatesDto;
}>;

export type GetAdaptCtvTemplatesQuery = {
  __typename?: 'Query';
  adaptCtvTemplates: {
    __typename?: 'PaginatedAdaptCtvTemplatesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AdaptCtvTemplateSchema';
      id: any;
      name: string;
      props: { __typename?: 'AdaptCtvTemplatePropsSchema'; ctaCategoryId: string; cta: string; template: string };
    }> | null;
  };
};

export type GetAudiencesChildrenQueryVariables = Exact<{
  accountId: Scalars['BigInt'];
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  withChildren?: InputMaybe<Scalars['Boolean']>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAudiencesChildrenQuery = {
  __typename?: 'Query';
  audiences: {
    __typename?: 'PaginatedAudiencesSchema';
    nodes?: Array<{
      __typename?: 'AudienceSchema';
      id: any;
      name: string;
      children?: Array<{ __typename?: 'CombinedAudienceSchema'; exclude?: boolean | null; id?: any | null }> | null;
    }> | null;
  };
};

export type GetAudiencesChildrenDataQueryVariables = Exact<{
  accountId: Scalars['BigInt'];
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAudiencesChildrenDataQuery = {
  __typename?: 'Query';
  audiences: {
    __typename?: 'PaginatedAudiencesSchema';
    nodes?: Array<{
      __typename?: 'AudienceSchema';
      name: string;
      provider: EAudienceProvider;
      dataProvider: string;
      id: any;
    }> | null;
  };
};

export type GetCreativeFormatsQueryVariables = Exact<{
  search: SearchCreativeFormatsDto;
}>;

export type GetCreativeFormatsQuery = {
  __typename?: 'Query';
  creativeFormats: {
    __typename?: 'PaginatedCreativeFormatsSchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{ __typename?: 'CreativeFormatSchema'; id: any; name: string }> | null;
  };
};

export type GetCreativesQueryVariables = Exact<{
  search: SearchCreativeDto;
}>;

export type GetCreativesQuery = {
  __typename?: 'Query';
  creatives: {
    __typename?: 'PaginatedCreativesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<
      | {
          __typename: 'AudioCreativeSchema';
          formatId?: any | null;
          id: any;
          name: string;
          advertiserID: any;
          status: ERecordEntityStatus;
          mimeType: string;
          typeID: number;
          previewURL?: string | null;
          thirdPartyPlacementID?: string | null;
          thirdPartyPlacementName?: string | null;
          createdAt: any;
          updatedAt: any;
          audioAttributes: {
            __typename?: 'AudioAttributes';
            bitRate?: number | null;
            clickThroughLink?: string | null;
            codec?: string | null;
            durationInSeconds?: number | null;
            maxBitRate?: number | null;
            minBitRate?: number | null;
            thirdPartyTag?: string | null;
            thirdPartyTagUrl?: string | null;
            thirdPartyPixelTracking?: Array<string> | null;
            thirdPartyTagTracking?: Array<string> | null;
            title?: string | null;
            media?: { __typename?: 'AudioMedia'; url: string; mimeType: string } | null;
          };
          account: { __typename?: 'AccountSchema'; id: any; name: string };
          advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string };
        }
      | {
          __typename: 'BannerCreativeSchema';
          formatId?: any | null;
          id: any;
          name: string;
          advertiserID: any;
          status: ERecordEntityStatus;
          mimeType: string;
          typeID: number;
          previewURL?: string | null;
          thirdPartyPlacementID?: string | null;
          thirdPartyPlacementName?: string | null;
          createdAt: any;
          updatedAt: any;
          bannerAttributes?: {
            __typename?: 'BannerAttributes';
            clickThroughLink?: string | null;
            thirdPartyTag?: string | null;
            thirdPartyPixelTracking?: Array<string> | null;
            thirdPartyTagTracking?: Array<string> | null;
            media?: { __typename?: 'BannerMedia'; width: number; height: number; url?: string | null } | null;
          } | null;
          account: { __typename?: 'AccountSchema'; id: any; name: string };
          advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string };
        }
      | {
          __typename: 'NativeCreativeSchema';
          id: any;
          name: string;
          advertiserID: any;
          status: ERecordEntityStatus;
          mimeType: string;
          typeID: number;
          previewURL?: string | null;
          thirdPartyPlacementID?: string | null;
          thirdPartyPlacementName?: string | null;
          createdAt: any;
          updatedAt: any;
          formatId?: any | null;
          account: { __typename?: 'AccountSchema'; id: any; name: string };
          advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string };
          attributes: {
            __typename?: 'NativeAttributes';
            platform: PlatformType;
            brandName: string;
            headline: string;
            headlines?: Array<string> | null;
            caption?: string | null;
            clickThroughLink?: string | null;
            ctaText: string;
            disclosure: string;
            effectCtaName?: string | null;
            effectLogoName?: string | null;
            effectMediaName?: string | null;
            publisherId: any;
            animationName?: string | null;
            height: number;
            width: number;
            thirdPartyPixelTracking?: Array<string> | null;
            thirdPartyTagTracking?: Array<string> | null;
            main?: { __typename?: 'NativeMedia'; url: string; width: number; height: number } | null;
            mains?: Array<{ __typename?: 'NativeMedia'; url: string; width: number; height: number }> | null;
            logo: { __typename?: 'NativeMedia'; url: string; width: number; height: number };
            slides?: Array<{
              __typename?: 'NativeSlide';
              headline: string;
              caption?: string | null;
              clickThroughLink?: string | null;
              ctaText: string;
              main: { __typename?: 'NativeMedia'; url: string; width: number; height: number };
            }> | null;
            animation?: {
              __typename?: 'NativeAnimation';
              intro?: string | null;
              load?: string | null;
              attention?: string | null;
            } | null;
            event_trackers?: Array<{
              __typename?: 'NativeEventTracker';
              event: number;
              method: number;
              url: string;
            }> | null;
            video?: {
              __typename?: 'VideoAttributes';
              clickThroughLink?: string | null;
              thirdPartyTag?: string | null;
              thirdPartyTagUrl?: string | null;
              thirdPartyPixelTracking?: Array<string> | null;
              thirdPartyTagTracking?: Array<string> | null;
              title?: string | null;
              bitRate?: number | null;
              maxBitRate?: number | null;
              minBitRate?: number | null;
              codec?: string | null;
              maintainAspectRatio?: boolean | null;
              scalable?: boolean | null;
              durationInSeconds?: number | null;
              media?: {
                __typename?: 'VideoMedia';
                url: string;
                height: number;
                width: number;
                mimeType: string;
              } | null;
            } | null;
          };
        }
      | {
          __typename: 'VideoCreativeSchema';
          formatId?: any | null;
          id: any;
          name: string;
          advertiserID: any;
          status: ERecordEntityStatus;
          mimeType: string;
          typeID: number;
          previewURL?: string | null;
          thirdPartyPlacementID?: string | null;
          thirdPartyPlacementName?: string | null;
          createdAt: any;
          updatedAt: any;
          videoAttributes: {
            __typename?: 'VideoAttributes';
            bitRate?: number | null;
            clickThroughLink?: string | null;
            codec?: string | null;
            durationInSeconds?: number | null;
            maintainAspectRatio?: boolean | null;
            maxBitRate?: number | null;
            minBitRate?: number | null;
            scalable?: boolean | null;
            thirdPartyTag?: string | null;
            thirdPartyTagUrl?: string | null;
            thirdPartyPixelTracking?: Array<string> | null;
            thirdPartyTagTracking?: Array<string> | null;
            title?: string | null;
            format?: EVideoFormat | null;
            variantThirdPartyImpTracking?: Array<string> | null;
            tagUrlForThirdPartyDSP?: string | null;
            media?: { __typename?: 'VideoMedia'; url: string; width: number; height: number; mimeType: string } | null;
          };
          account: { __typename?: 'AccountSchema'; id: any; name: string };
          advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string };
        }
    > | null;
  };
};

export type GetCtvVideoTemplatesQueryVariables = Exact<{
  search: SearchVideoTemplatesDto;
}>;

export type GetCtvVideoTemplatesQuery = {
  __typename?: 'Query';
  ctvVideoTemplates: {
    __typename?: 'PaginatedCtvVideoTemplatesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{ __typename?: 'CtvVideoTemplateSchema'; id: any; name: string; createdAt?: any | null }> | null;
  };
};

export type GetCtvVideoVariantsQueryVariables = Exact<{
  search: SearchCtvVideoVariantsDto;
}>;

export type GetCtvVideoVariantsQuery = {
  __typename?: 'Query';
  creativeVideoVariants: {
    __typename?: 'PaginatedCtvVideoVariantsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'CtvVideoVariantSchema';
      id: any;
      creativeId: any;
      props: any;
      templateId?: any | null;
      status: ECreativeVideoVariantStatus;
    }> | null;
  };
};

export type GetDcoCreativesQueryVariables = Exact<{
  search: SearchCreativeDto;
}>;

export type GetDcoCreativesQuery = {
  __typename?: 'Query';
  creatives: {
    __typename?: 'PaginatedCreativesSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<
      | { __typename: 'AudioCreativeSchema' }
      | { __typename: 'BannerCreativeSchema' }
      | { __typename: 'NativeCreativeSchema' }
      | {
          __typename: 'VideoCreativeSchema';
          formatId?: any | null;
          id: any;
          name: string;
          advertiserID: any;
          status: ERecordEntityStatus;
          mimeType: string;
          typeID: number;
          previewURL?: string | null;
          thirdPartyPlacementID?: string | null;
          thirdPartyPlacementName?: string | null;
          createdAt: any;
          updatedAt: any;
          videoAttributes: {
            __typename?: 'VideoAttributes';
            bitRate?: number | null;
            clickThroughLink?: string | null;
            codec?: string | null;
            durationInSeconds?: number | null;
            maintainAspectRatio?: boolean | null;
            maxBitRate?: number | null;
            minBitRate?: number | null;
            scalable?: boolean | null;
            thirdPartyTag?: string | null;
            thirdPartyTagUrl?: string | null;
            thirdPartyPixelTracking?: Array<string> | null;
            thirdPartyTagTracking?: Array<string> | null;
            title?: string | null;
            format?: EVideoFormat | null;
            variantThirdPartyImpTracking?: Array<string> | null;
            tagUrlForThirdPartyDSP?: string | null;
            media?: { __typename?: 'VideoMedia'; url: string; width: number; height: number; mimeType: string } | null;
          };
          account: { __typename?: 'AccountSchema'; id: any; name: string };
          advertiser: { __typename?: 'AdvertiserSchema'; id: any; name: string };
        }
    > | null;
  };
};

export type GetFreqCapTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
}>;

export type GetFreqCapTargetingQuery = {
  __typename?: 'Query';
  frequencyTargeting: {
    __typename?: 'FrequencyTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'FrequencyTargetingSchema';
      id: any;
      createdAt: any;
      freqCapPeriod: EFrequencyPeriods;
      freqCapCount: number;
    }> | null;
  };
};

export type GetSupplySourceTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
}>;

export type GetSupplySourceTargetingQuery = {
  __typename?: 'Query';
  supplyTargeting: {
    __typename?: 'SupplyTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'SupplyTargetingSchema';
      verifiedSupplyOnly: boolean;
      supplySource: ESupplySource;
      supplyId?: number | null;
      exclude: boolean;
      id: any;
    }> | null;
  };
};

export type GetTargetingAudiencesQueryVariables = Exact<{
  id: Scalars['BigInt'];
  type: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['BigInt'];
}>;

export type GetTargetingAudiencesQuery = {
  __typename?: 'Query';
  targetingAudiences: {
    __typename?: 'PaginatedTargetingAudiencesSchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{
      __typename?: 'TargetingAudiencesSchema';
      id: any;
      audienceId: any;
      exclude?: boolean | null;
      referenceObjectId: any;
      audience?: { __typename?: 'AudienceSchema'; id: any; name: string } | null;
    }> | null;
  };
};

export type GetTargetingPoiQueryVariables = Exact<{
  referenceObjectID: Scalars['BigInt'];
  referenceObjectType: EObjectType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type: EPoiType;
}>;

export type GetTargetingPoiQuery = {
  __typename?: 'Query';
  poi: {
    __typename?: 'PaginatedPoiSchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{
      __typename?: 'PoiSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      customLat?: number | null;
      customLong?: number | null;
      minRadius?: number | null;
      maxRadius: number;
      locationGroupId?: number | null;
    }> | null;
  };
};

export type GetAbsTargetingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAbsTargetingQuery = {
  __typename?: 'Query';
  dvAuthenticBrandSuitabilityTargeting: {
    __typename?: 'DvAuthenticBrandSuitabilityTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'DvAuthenticBrandSuitabilityTargetingSchema';
      id: any;
      dvSegmentCode: any;
      exclude: boolean;
    }> | null;
  };
};

export type GetAppCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetAppCategoriesQuery = {
  __typename?: 'Query';
  appCategory: {
    __typename?: 'PaginatedAppCategorySchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'AppCategorySchema'; id: any; categoryName: string; createdAt?: any | null }> | null;
  };
};

export type GetAppCategoriesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAppCategoriesTargetingQuery = {
  __typename?: 'Query';
  appCategoryTargeting: {
    __typename?: 'AppCategoryTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'AppCategoryTargetingSchema';
      categoryId: any;
      exclude: boolean;
      id: any;
      appCategory: { __typename?: 'AppCategorySchema'; categoryName: string };
    }> | null;
  };
};

export type GetAppsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  status?: InputMaybe<ResourceStatus>;
  bundleIdPrefix?: InputMaybe<Scalars['String']>;
  bundle_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  domainPrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetAppsQuery = {
  __typename?: 'Query';
  app: {
    __typename?: 'PaginatedAppSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AppSchema';
      id: any;
      status: ResourceStatus;
      bundleId: string;
      domain: string;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetAppTargetingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAppTargetingQuery = {
  __typename?: 'Query';
  appTargeting: {
    __typename?: 'AppTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'AppTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      bundleId?: string | null;
      exclude: boolean;
      switcherRecord?: boolean | null;
    }> | null;
  };
};

export type GetBrowserTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetBrowserTargetingQuery = {
  __typename?: 'Query';
  browserTargeting: {
    __typename?: 'BrowserTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'BrowserTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      browserId: any;
      exclude: boolean;
    }> | null;
  };
};

export type GetBrowsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResourceStatus>;
}>;

export type GetBrowsersQuery = {
  __typename?: 'Query';
  browser: {
    __typename?: 'PaginatedBrowserSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'BrowserSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetBssTargetingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetBssTargetingQuery = {
  __typename?: 'Query';
  dvBrandSafetySuitabilityTargeting: {
    __typename?: 'DvBrandSafetySuitabilityTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'DvBrandSafetySuitabilityTargetingSchema';
      createdAt: any;
      id: any;
      exclude: boolean;
      dvSegmentId: any;
      dvSegment: { __typename?: 'DvSegmentSchema'; id: any; name: string; product: EProduct };
    }> | null;
  };
};

export type DealBulkTargetingQueryVariables = Exact<{
  data: DealsTargetingBulkDto;
}>;

export type DealBulkTargetingQuery = {
  __typename?: 'Query';
  dealBulkTargeting: {
    __typename?: 'DealsTargetingBulkSchema';
    app: Array<{
      __typename?: 'AppTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      bundleId?: string | null;
      switcherRecord?: boolean | null;
      createdAt: any;
    }>;
    audience: Array<{
      __typename?: 'TargetingAudiencesSchema';
      id: any;
      exclude?: boolean | null;
      referenceObjectId: any;
      audienceId: any;
      audience?: { __typename?: 'AudienceSchema'; id: any; name: string } | null;
    }>;
    browser: Array<{
      __typename?: 'BrowserTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      browserId: any;
    }>;
    carrier: Array<{
      __typename?: 'CarrierTargetingSchema';
      id: any;
      exclude: boolean;
      referenceObjectId: any;
      carrier: any;
      createdAt: any;
    }>;
    category: Array<{
      __typename?: 'CategoryTargetingSchema';
      id: any;
      categoryId: any;
      exclude: boolean;
      referenceObjectId: any;
      createdAt: any;
    }>;
    country: Array<{
      __typename?: 'CountryTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      countryCode: string;
      country?: {
        __typename?: 'CountrySchema';
        name: string;
        status: ResourceStatus;
        code: string;
        createdAt?: any | null;
      } | null;
    }>;
    dayPart: Array<{
      __typename?: 'DayPartTargetingSchema';
      id: any;
      exclude: boolean;
      referenceObjectId: any;
      startHour: number;
      endHour: number;
      createdAt: any;
    }>;
    deal: Array<{
      __typename?: 'DealTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      inventoryDealId: string;
      createdAt: any;
    }>;
    deviceModel: Array<{
      __typename?: 'DeviceModelTargetingSchema';
      id: any;
      deviceModelId: any;
      referenceObjectId: any;
      exclude: boolean;
      createdAt: any;
    }>;
    deviceType: Array<{
      __typename?: 'DeviceTypeTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      deviceTypeId: any;
      createdAt: any;
    }>;
    creativeType: Array<{
      __typename?: 'CreativeTypeTargetingSchema';
      referenceObjectId: any;
      creativeAttribute: ECreativeTypeAttribute;
      creativeAttributeValue: string;
      creativeTypeId: any;
      createdAt: any;
      exclude: boolean;
      id: any;
    }>;
    dvAuthenticBrand: Array<{
      __typename?: 'DvAuthenticBrandSuitabilityTargetingSchema';
      id: any;
      dvSegmentCode: any;
      referenceObjectId: any;
      exclude: boolean;
      createdAt: any;
    }>;
    dvBrandSafety: Array<{
      __typename?: 'DvBrandSafetySuitabilityTargetingSchema';
      id: any;
      dvSegmentId: any;
      referenceObjectId: any;
      exclude: boolean;
      createdAt: any;
      dvSegment: { __typename?: 'DvSegmentSchema'; id: any; name: string };
    }>;
    dvViewability: Array<{
      __typename?: 'DvViewabilityTargetingSchema';
      id: any;
      dvSegmentId: any;
      exclude: boolean;
      referenceObjectId: any;
      createdAt: any;
      dvSegment: { __typename?: 'DvSegmentSchema'; id: any; name: string };
    }>;
    frequency: Array<{
      __typename?: 'FrequencyTargetingSchema';
      id: any;
      freqCapCount: number;
      freqCapPeriod: EFrequencyPeriods;
      referenceObjectId: any;
      createdAt: any;
    }>;
    genre: Array<{
      __typename?: 'GenreTargetingSchema';
      id: any;
      genreId: any;
      exclude: boolean;
      referenceObjectId: any;
      createdAt: any;
      genere?: { __typename?: 'GenreSchema'; id: any; name: string; status: ResourceStatus } | null;
    }>;
    geo: Array<{
      __typename?: 'GeoTargetingSchema';
      id: any;
      referenceObjectId: any;
      geoId: any;
      type: EGeoType;
      exclude: boolean;
      createdAt: any;
      state?: { __typename?: 'StateSchema'; name: string; countryCode: string; stateCode: string } | null;
      city?: { __typename?: 'CitySchema'; name: string; stateCode: string; countryCode: string } | null;
      metro?: { __typename?: 'MetroSchema'; name: string; countryCode: string; code: string } | null;
      postalCode?: { __typename?: 'PostalCodeSchema'; code: string } | null;
    }>;
    language: Array<{
      __typename?: 'LanguageTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      languageId: any;
      language: { __typename?: 'LanguageSchema'; name: string };
    }>;
    live: Array<{
      __typename?: 'LiveTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      live: ELiveType;
    }>;
    os: Array<{ __typename?: 'OsTargetingSchema'; id: any; referenceObjectId: any; exclude: boolean; osId: any }>;
    poi: Array<{
      __typename?: 'PoiSchema';
      id: any;
      referenceObjectId: any;
      customLat?: number | null;
      customLong?: number | null;
      minRadius?: number | null;
      maxRadius: number;
      locationGroupId?: number | null;
    }>;
    position: Array<{
      __typename?: 'PositionTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      position: EPositionType;
    }>;
    production: Array<{
      __typename?: 'ProductionTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      production: EProductionType;
    }>;
    rating: Array<{
      __typename?: 'RatingTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      ratingId: any;
      rating: { __typename?: 'RatingSchema'; name: string };
    }>;
    segment: Array<{
      __typename?: 'SegmentTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      segmentId: any;
      type: ESegmentType;
    }>;
    site: Array<{
      __typename?: 'SiteTargetingSchema';
      id: any;
      referenceObjectId: any;
      exclude: boolean;
      domain?: string | null;
      switcherRecord?: boolean | null;
    }>;
    supply: Array<{
      __typename?: 'SupplyTargetingSchema';
      id: any;
      referenceObjectId: any;
      supplyId?: number | null;
      exclude: boolean;
      verifiedSupplyOnly: boolean;
      supplySource: ESupplySource;
    }>;
  };
};

export type GetCarriesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResourceStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetCarriesQuery = {
  __typename?: 'Query';
  carrier: {
    __typename?: 'PaginatedCarrierSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'CarrierSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetCarriersTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCarriersTargetingQuery = {
  __typename?: 'Query';
  carrierTargeting: {
    __typename?: 'CarrierTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'CarrierTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      carrier: any;
      exclude: boolean;
    }> | null;
  };
};

export type GetCreativeTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetCreativeTypesQuery = {
  __typename?: 'Query';
  creativeType: {
    __typename?: 'PaginatedCreativeTypeSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'CreativeTypeSchema'; id: any; name: string; createdAt?: any | null }> | null;
  };
};

export type GetCreativeTypesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCreativeTypesTargetingQuery = {
  __typename?: 'Query';
  creativeTypeTargeting: {
    __typename?: 'CreativeTypeTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'CreativeTypeTargetingSchema';
      creativeAttribute: ECreativeTypeAttribute;
      creativeAttributeValue: string;
      creativeTypeId: any;
      createdAt: any;
      exclude: boolean;
      id: any;
    }> | null;
  };
};

export type GetDealsTargetingQueryVariables = Exact<{
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  inventoryDealIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
}>;

export type GetDealsTargetingQuery = {
  __typename?: 'Query';
  dealTargeting: {
    __typename?: 'DealTargetingPaginationSchema';
    limit: number;
    offset: number;
    totalCount: number;
    nodes?: Array<{
      __typename?: 'DealTargetingSchema';
      id: any;
      inventoryDealId: string;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
    }> | null;
  };
};

export type GetInventoryDealsQueryVariables = Exact<{
  search: SearchDealsArgsDto;
}>;

export type GetInventoryDealsQuery = {
  __typename?: 'Query';
  deals: {
    __typename?: 'PaginatedDealsSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DealSchema';
      id: any;
      name: string;
      dspDealId?: string | null;
      auctionType: AuctionType;
      bidFloor: number;
    }> | null;
  };
};

export type GetDeviceTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
}>;

export type GetDeviceTypesQuery = {
  __typename?: 'Query';
  device: {
    __typename?: 'PaginatedDeviceSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DeviceSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetDeviceTypesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetDeviceTypesTargetingQuery = {
  __typename?: 'Query';
  deviceTypeTargeting: {
    __typename?: 'DeviceTypeTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'DeviceTypeTargetingSchema'; deviceTypeId: any; exclude: boolean; id: any }> | null;
  };
};

export type GetDvViewabilityTargetingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
}>;

export type GetDvViewabilityTargetingQuery = {
  __typename?: 'Query';
  dvViewabilityTargeting: {
    __typename?: 'DvViewabilityTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'DvViewabilityTargetingSchema';
      id: any;
      referenceObjectId: any;
      dvSegmentId: any;
      exclude: boolean;
      dvSegment: { __typename?: 'DvSegmentSchema'; name: string; creativeType: ECreativeType };
    }> | null;
  };
};

export type GetDvSegmentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  creativeType?: InputMaybe<ECreativeType>;
  product?: InputMaybe<EProduct>;
}>;

export type GetDvSegmentsQuery = {
  __typename?: 'Query';
  dvSegment: {
    __typename?: 'PaginatedDvSegmentSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DvSegmentSchema';
      id: any;
      name: string;
      dvSegmentCode: string;
      product: EProduct;
      creativeType: ECreativeType;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetGenresTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetGenresTargetingQuery = {
  __typename?: 'Query';
  genreTargeting: {
    __typename?: 'GenreTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'GenreTargetingSchema';
      genreId: any;
      exclude: boolean;
      id: any;
      genre: { __typename?: 'GenreSchema'; name: string };
    }> | null;
  };
};

export type GetGenresQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetGenresQuery = {
  __typename?: 'Query';
  genre: {
    __typename?: 'PaginatedGenreSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'GenreSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetCityQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetCityQuery = {
  __typename?: 'Query';
  cities: {
    __typename?: 'PaginatedCitySchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'CitySchema'; name: string; countryCode: string; stateCode: string; id: any }> | null;
  };
};

export type GetCountriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResourceStatus>;
  code?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetCountriesQuery = {
  __typename?: 'Query';
  country: {
    __typename?: 'PaginatedCountrySchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'CountrySchema';
      name: string;
      code: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetCountryTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetCountryTargetingQuery = {
  __typename?: 'Query';
  countryTargeting: {
    __typename?: 'CountryTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'CountryTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      countryCode: string;
      exclude: boolean;
      createdAt: any;
      country?: { __typename?: 'CountrySchema'; name: string } | null;
    }> | null;
  };
};

export type GetGeoTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EGeoType>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetGeoTargetingQuery = {
  __typename?: 'Query';
  geoTargeting: {
    __typename?: 'GeoTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'GeoTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      geoId: any;
      type: EGeoType;
      exclude: boolean;
      createdAt: any;
      state?: { __typename?: 'StateSchema'; name: string; countryCode: string; stateCode: string } | null;
      city?: { __typename?: 'CitySchema'; name: string; stateCode: string; countryCode: string } | null;
      metro?: { __typename?: 'MetroSchema'; name: string; countryCode: string; code: string } | null;
      postalCode?: { __typename?: 'PostalCodeSchema'; code: string } | null;
    }> | null;
  };
};

export type GetMetroQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetMetroQuery = {
  __typename?: 'Query';
  metros: {
    __typename?: 'PaginatedMetroSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'MetroSchema'; name: string; code: string; countryCode: string; id: any }> | null;
  };
};

export type GetPostalCodesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  countryCode?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetPostalCodesQuery = {
  __typename?: 'Query';
  postalCodes: {
    __typename?: 'PaginatedPostalSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'PostalCodeSchema'; id: any; code: string }> | null;
  };
};

export type GetStateQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetStateQuery = {
  __typename?: 'Query';
  states: {
    __typename?: 'PaginatedStateSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'StateSchema'; name: string; countryCode: string; stateCode: string; id: any }> | null;
  };
};

export type GetIabCategoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetIabCategoriesQuery = {
  __typename?: 'Query';
  category: {
    __typename?: 'PaginatedCategorySchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'CategorySchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
      iabCategory: string;
    }> | null;
  };
};

export type GetIabCategoriesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetIabCategoriesTargetingQuery = {
  __typename?: 'Query';
  categoryTargeting: {
    __typename?: 'CategoryTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'CategoryTargetingSchema';
      id: any;
      exclude: boolean;
      categoryId: any;
      category: { __typename?: 'CategorySchema'; id: any; name: string; iabCategory: string };
    }> | null;
  };
};

export type GetLanguagesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetLanguagesTargetingQuery = {
  __typename?: 'Query';
  LanguageTargeting: {
    __typename?: 'LanguageTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'LanguageTargetingSchema';
      languageId: any;
      exclude: boolean;
      id: any;
      language: { __typename?: 'LanguageSchema'; name: string };
    }> | null;
  };
};

export type GetLanguagesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetLanguagesQuery = {
  __typename?: 'Query';
  language: {
    __typename?: 'PaginatedLanguageSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'LanguageSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetLivesTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetLivesTargetingQuery = {
  __typename?: 'Query';
  LiveTargeting: {
    __typename?: 'LiveTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{ __typename?: 'LiveTargetingSchema'; live: ELiveType; exclude: boolean; id: any }> | null;
  };
};

export type GetOsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResourceStatus>;
}>;

export type GetOsQuery = {
  __typename?: 'Query';
  os: {
    __typename?: 'PaginatedOsSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'OsSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetOsTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetOsTargetingQuery = {
  __typename?: 'Query';
  osTargeting: {
    __typename?: 'OsTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'OsTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      exclude: boolean;
      osId: any;
      createdAt: any;
    }> | null;
  };
};

export type GetPlacementTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetPlacementTargetingQuery = {
  __typename?: 'Query';
  positionTargeting: {
    __typename?: 'PositionTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'PositionTargetingSchema';
      position: EPositionType;
      exclude: boolean;
      id: any;
    }> | null;
  };
};

export type GetProductionsTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetProductionsTargetingQuery = {
  __typename?: 'Query';
  ProductionTargeting: {
    __typename?: 'ProductionTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'ProductionTargetingSchema';
      production: EProductionType;
      exclude: boolean;
      id: any;
    }> | null;
  };
};

export type GetRatingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ResourceStatus>;
  namePrefix?: InputMaybe<Scalars['String']>;
}>;

export type GetRatingsQuery = {
  __typename?: 'Query';
  rating: {
    __typename?: 'PaginatedRatingSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'RatingSchema';
      id: any;
      name: string;
      status: ResourceStatus;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetRatingsTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetRatingsTargetingQuery = {
  __typename?: 'Query';
  RatingTargeting: {
    __typename?: 'RatingTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'RatingTargetingSchema';
      ratingId: any;
      exclude: boolean;
      id: any;
      rating: { __typename?: 'RatingSchema'; name: string };
    }> | null;
  };
};

export type GetSitesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<ResourceStatus>;
  domainPrefix?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
}>;

export type GetSitesQuery = {
  __typename?: 'Query';
  site: {
    __typename?: 'PaginatedSiteSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'SiteSchema';
      id: any;
      status: ResourceStatus;
      domain: string;
      createdAt?: any | null;
    }> | null;
  };
};

export type GetSiteTargetingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  switcherRecord?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetSiteTargetingQuery = {
  __typename?: 'Query';
  siteTargeting: {
    __typename?: 'SiteTargetingPaginationSchema';
    totalCount: number;
    limit: number;
    offset: number;
    nodes?: Array<{
      __typename?: 'SiteTargetingSchema';
      id: any;
      referenceObjectId: any;
      referenceObjectType: EObjectType;
      domain?: string | null;
      exclude: boolean;
      switcherRecord?: boolean | null;
    }> | null;
  };
};

export type GetESupplyQueryVariables = Exact<{
  search: SearchESupplyArgsDto;
}>;

export type GetESupplyQuery = {
  __typename?: 'Query';
  getESupply: Array<{
    __typename?: 'ESupplySchema';
    id: number;
    name: string;
    supplySource: string;
    externalSupplyId: string;
    createdAt: any;
  }>;
};

export type GetTimePartingTargetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  referenceObjectId?: InputMaybe<Scalars['BigInt']>;
  referenceObjectType?: InputMaybe<EObjectType>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetTimePartingTargetingQuery = {
  __typename?: 'Query';
  dayPartTargeting: {
    __typename?: 'DayPartTargetingPaginationSchema';
    totalCount: number;
    offset: number;
    limit: number;
    nodes?: Array<{
      __typename?: 'DayPartTargetingSchema';
      startHour: number;
      endHour: number;
      weekday: number;
      exclude: boolean;
      id: any;
    }> | null;
  };
};

export const StrategyFieldsFragmentDoc = gql`
  fragment StrategyFields on StrategySchema {
    id
    name
    startDate
    endDate
    daysLeft
    budget
    createdAt
    updatedAt
    budgetRemaining
    flightPacing
    dailyPacing
    amountToSpend
    campaignId
    accountID
    clicks
    bids
    wins
    mediaSpend
    cpm
    cpc
    ctr
    spentYesterdayCurrency
    spentYesterdayImpression
    impressions
    pacing
    pacingGoal
    dailyCap
    status
    kpiId
    kpiGoal
    bidPrice
    minBidPrice
    creativesCount
    idealDailyPacing
  }
`;
export const CloneDealDocument = gql`
  mutation CloneDeal($dealId: BigInt!, $data: CloneDealsArgsDto!) {
    cloneDeal(dealId: $dealId, data: $data)
  }
`;
export type CloneDealMutationFn = Apollo.MutationFunction<CloneDealMutation, CloneDealMutationVariables>;

/**
 * __useCloneDealMutation__
 *
 * To run a mutation, you first call `useCloneDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneDealMutation, { data, loading, error }] = useCloneDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneDealMutation(
  baseOptions?: Apollo.MutationHookOptions<CloneDealMutation, CloneDealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneDealMutation, CloneDealMutationVariables>(CloneDealDocument, options);
}
export type CloneDealMutationHookResult = ReturnType<typeof useCloneDealMutation>;
export type CloneDealMutationResult = Apollo.MutationResult<CloneDealMutation>;
export type CloneDealMutationOptions = Apollo.BaseMutationOptions<CloneDealMutation, CloneDealMutationVariables>;
export const CreatePixelDocument = gql`
  mutation CreatePixel($data: CreatePixelsArgsDto!) {
    createPixel(data: $data) {
      id
      name
    }
  }
`;
export type CreatePixelMutationFn = Apollo.MutationFunction<CreatePixelMutation, CreatePixelMutationVariables>;

/**
 * __useCreatePixelMutation__
 *
 * To run a mutation, you first call `useCreatePixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPixelMutation, { data, loading, error }] = useCreatePixelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePixelMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePixelMutation, CreatePixelMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePixelMutation, CreatePixelMutationVariables>(CreatePixelDocument, options);
}
export type CreatePixelMutationHookResult = ReturnType<typeof useCreatePixelMutation>;
export type CreatePixelMutationResult = Apollo.MutationResult<CreatePixelMutation>;
export type CreatePixelMutationOptions = Apollo.BaseMutationOptions<CreatePixelMutation, CreatePixelMutationVariables>;
export const BatchReplacePixelMappingsDocument = gql`
  mutation BatchReplacePixelMappings($pixelId: BigInt!, $data: PixelMappingNameArgsDto!) {
    batchReplacePixelMappings(pixelId: $pixelId, data: $data)
  }
`;
export type BatchReplacePixelMappingsMutationFn = Apollo.MutationFunction<
  BatchReplacePixelMappingsMutation,
  BatchReplacePixelMappingsMutationVariables
>;

/**
 * __useBatchReplacePixelMappingsMutation__
 *
 * To run a mutation, you first call `useBatchReplacePixelMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchReplacePixelMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchReplacePixelMappingsMutation, { data, loading, error }] = useBatchReplacePixelMappingsMutation({
 *   variables: {
 *      pixelId: // value for 'pixelId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchReplacePixelMappingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchReplacePixelMappingsMutation,
    BatchReplacePixelMappingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchReplacePixelMappingsMutation, BatchReplacePixelMappingsMutationVariables>(
    BatchReplacePixelMappingsDocument,
    options
  );
}
export type BatchReplacePixelMappingsMutationHookResult = ReturnType<typeof useBatchReplacePixelMappingsMutation>;
export type BatchReplacePixelMappingsMutationResult = Apollo.MutationResult<BatchReplacePixelMappingsMutation>;
export type BatchReplacePixelMappingsMutationOptions = Apollo.BaseMutationOptions<
  BatchReplacePixelMappingsMutation,
  BatchReplacePixelMappingsMutationVariables
>;
export const CreateReportDocument = gql`
  mutation CreateReport($data: CreateReportInputDto!) {
    createReport(data: $data) {
      id
      reportName
      startDate
      endDate
      timezone
      reportLastUpdated
      reportStatus
      accountId
      advertiserIds
      lineItemIds
      fields
      isSendingEmail
      emails
      frequency
      creator
      createdAt
      updatedAt
      downloadURL
    }
  }
`;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
}
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<
  CreateReportMutation,
  CreateReportMutationVariables
>;
export const DeleteReportsDocument = gql`
  mutation DeleteReports($reportIds: [BigInt!]!) {
    deleteReports(ids: $reportIds)
  }
`;
export type DeleteReportsMutationFn = Apollo.MutationFunction<DeleteReportsMutation, DeleteReportsMutationVariables>;

/**
 * __useDeleteReportsMutation__
 *
 * To run a mutation, you first call `useDeleteReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportsMutation, { data, loading, error }] = useDeleteReportsMutation({
 *   variables: {
 *      reportIds: // value for 'reportIds'
 *   },
 * });
 */
export function useDeleteReportsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteReportsMutation, DeleteReportsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteReportsMutation, DeleteReportsMutationVariables>(DeleteReportsDocument, options);
}
export type DeleteReportsMutationHookResult = ReturnType<typeof useDeleteReportsMutation>;
export type DeleteReportsMutationResult = Apollo.MutationResult<DeleteReportsMutation>;
export type DeleteReportsMutationOptions = Apollo.BaseMutationOptions<
  DeleteReportsMutation,
  DeleteReportsMutationVariables
>;
export const UpdatePixelDocument = gql`
  mutation UpdatePixel($pixelId: BigInt!, $data: UpdatePixelsArgsDto!) {
    updatePixel(pixelId: $pixelId, data: $data)
  }
`;
export type UpdatePixelMutationFn = Apollo.MutationFunction<UpdatePixelMutation, UpdatePixelMutationVariables>;

/**
 * __useUpdatePixelMutation__
 *
 * To run a mutation, you first call `useUpdatePixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePixelMutation, { data, loading, error }] = useUpdatePixelMutation({
 *   variables: {
 *      pixelId: // value for 'pixelId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePixelMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePixelMutation, UpdatePixelMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePixelMutation, UpdatePixelMutationVariables>(UpdatePixelDocument, options);
}
export type UpdatePixelMutationHookResult = ReturnType<typeof useUpdatePixelMutation>;
export type UpdatePixelMutationResult = Apollo.MutationResult<UpdatePixelMutation>;
export type UpdatePixelMutationOptions = Apollo.BaseMutationOptions<UpdatePixelMutation, UpdatePixelMutationVariables>;
export const ExportPixelsDocument = gql`
  mutation ExportPixels($type: ExportType!, $ids: [BigInt!]!, $fields: [String!]!) {
    exportPixels(type: $type, ids: $ids, fields: $fields)
  }
`;
export type ExportPixelsMutationFn = Apollo.MutationFunction<ExportPixelsMutation, ExportPixelsMutationVariables>;

/**
 * __useExportPixelsMutation__
 *
 * To run a mutation, you first call `useExportPixelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPixelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPixelsMutation, { data, loading, error }] = useExportPixelsMutation({
 *   variables: {
 *      type: // value for 'type'
 *      ids: // value for 'ids'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExportPixelsMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportPixelsMutation, ExportPixelsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportPixelsMutation, ExportPixelsMutationVariables>(ExportPixelsDocument, options);
}
export type ExportPixelsMutationHookResult = ReturnType<typeof useExportPixelsMutation>;
export type ExportPixelsMutationResult = Apollo.MutationResult<ExportPixelsMutation>;
export type ExportPixelsMutationOptions = Apollo.BaseMutationOptions<
  ExportPixelsMutation,
  ExportPixelsMutationVariables
>;
export const UpdateReportDocument = gql`
  mutation UpdateReport($reportId: BigInt!, $data: UpdateReportArgsDto!) {
    updateReport(id: $reportId, data: $data) {
      id
      reportName
      startDate
      endDate
      timezone
      reportLastUpdated
      reportStatus
      accountId
      advertiserIds
      lineItemIds
      fields
      isSendingEmail
      emails
      frequency
      creator
      createdAt
      updatedAt
      downloadURL
    }
  }
`;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
}
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<
  UpdateReportMutation,
  UpdateReportMutationVariables
>;
export const UploadImageDocument = gql`
  mutation UploadImage($data: UploadImageDto!) {
    uploadImage(data: $data)
  }
`;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadImageMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
}
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const UploadVideoDocument = gql`
  mutation UploadVideo($data: UploadVideoDto!) {
    uploadVideo(data: $data)
  }
`;
export type UploadVideoMutationFn = Apollo.MutationFunction<UploadVideoMutation, UploadVideoMutationVariables>;

/**
 * __useUploadVideoMutation__
 *
 * To run a mutation, you first call `useUploadVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVideoMutation, { data, loading, error }] = useUploadVideoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadVideoMutation, UploadVideoMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadVideoMutation, UploadVideoMutationVariables>(UploadVideoDocument, options);
}
export type UploadVideoMutationHookResult = ReturnType<typeof useUploadVideoMutation>;
export type UploadVideoMutationResult = Apollo.MutationResult<UploadVideoMutation>;
export type UploadVideoMutationOptions = Apollo.BaseMutationOptions<UploadVideoMutation, UploadVideoMutationVariables>;
export const CreateAdaptCtvTemplateDocument = gql`
  mutation CreateAdaptCtvTemplate($data: AddOrUpdateAdaptCtvTemplateDto!) {
    addAdaptCtvTemplate(data: $data) {
      id
    }
  }
`;
export type CreateAdaptCtvTemplateMutationFn = Apollo.MutationFunction<
  CreateAdaptCtvTemplateMutation,
  CreateAdaptCtvTemplateMutationVariables
>;

/**
 * __useCreateAdaptCtvTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAdaptCtvTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdaptCtvTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdaptCtvTemplateMutation, { data, loading, error }] = useCreateAdaptCtvTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAdaptCtvTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAdaptCtvTemplateMutation, CreateAdaptCtvTemplateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAdaptCtvTemplateMutation, CreateAdaptCtvTemplateMutationVariables>(
    CreateAdaptCtvTemplateDocument,
    options
  );
}
export type CreateAdaptCtvTemplateMutationHookResult = ReturnType<typeof useCreateAdaptCtvTemplateMutation>;
export type CreateAdaptCtvTemplateMutationResult = Apollo.MutationResult<CreateAdaptCtvTemplateMutation>;
export type CreateAdaptCtvTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateAdaptCtvTemplateMutation,
  CreateAdaptCtvTemplateMutationVariables
>;
export const UpdateAdaptCtvTemplateByIdDocument = gql`
  mutation UpdateAdaptCtvTemplateById($id: BigInt!, $data: AddOrUpdateAdaptCtvTemplateDto!) {
    updateAdaptCtvTemplate(id: $id, data: $data)
  }
`;
export type UpdateAdaptCtvTemplateByIdMutationFn = Apollo.MutationFunction<
  UpdateAdaptCtvTemplateByIdMutation,
  UpdateAdaptCtvTemplateByIdMutationVariables
>;

/**
 * __useUpdateAdaptCtvTemplateByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAdaptCtvTemplateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdaptCtvTemplateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdaptCtvTemplateByIdMutation, { data, loading, error }] = useUpdateAdaptCtvTemplateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAdaptCtvTemplateByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdaptCtvTemplateByIdMutation,
    UpdateAdaptCtvTemplateByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAdaptCtvTemplateByIdMutation, UpdateAdaptCtvTemplateByIdMutationVariables>(
    UpdateAdaptCtvTemplateByIdDocument,
    options
  );
}
export type UpdateAdaptCtvTemplateByIdMutationHookResult = ReturnType<typeof useUpdateAdaptCtvTemplateByIdMutation>;
export type UpdateAdaptCtvTemplateByIdMutationResult = Apollo.MutationResult<UpdateAdaptCtvTemplateByIdMutation>;
export type UpdateAdaptCtvTemplateByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdaptCtvTemplateByIdMutation,
  UpdateAdaptCtvTemplateByIdMutationVariables
>;
export const CreateCombinedAudienceDocument = gql`
  mutation CreateCombinedAudience(
    $accountId: Int!
    $children: [CombinedAudienceArg!]!
    $childrenClause: EAudienceCombineClause
    $countryCode: String!
    $description: String!
    $name: String!
  ) {
    createCombinedAudience(
      accountId: $accountId
      children: $children
      childrenClause: $childrenClause
      countryCode: $countryCode
      description: $description
      name: $name
    ) {
      id
    }
  }
`;
export type CreateCombinedAudienceMutationFn = Apollo.MutationFunction<
  CreateCombinedAudienceMutation,
  CreateCombinedAudienceMutationVariables
>;

/**
 * __useCreateCombinedAudienceMutation__
 *
 * To run a mutation, you first call `useCreateCombinedAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCombinedAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCombinedAudienceMutation, { data, loading, error }] = useCreateCombinedAudienceMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      children: // value for 'children'
 *      childrenClause: // value for 'childrenClause'
 *      countryCode: // value for 'countryCode'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCombinedAudienceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCombinedAudienceMutation, CreateCombinedAudienceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCombinedAudienceMutation, CreateCombinedAudienceMutationVariables>(
    CreateCombinedAudienceDocument,
    options
  );
}
export type CreateCombinedAudienceMutationHookResult = ReturnType<typeof useCreateCombinedAudienceMutation>;
export type CreateCombinedAudienceMutationResult = Apollo.MutationResult<CreateCombinedAudienceMutation>;
export type CreateCombinedAudienceMutationOptions = Apollo.BaseMutationOptions<
  CreateCombinedAudienceMutation,
  CreateCombinedAudienceMutationVariables
>;
export const ExportAudiencesDocument = gql`
  mutation ExportAudiences($type: ExportType!, $ids: [BigInt!], $fields: [String!]!, $accountId: BigInt!) {
    audiencesExport(type: $type, ids: $ids, fields: $fields, accountId: $accountId)
  }
`;
export type ExportAudiencesMutationFn = Apollo.MutationFunction<
  ExportAudiencesMutation,
  ExportAudiencesMutationVariables
>;

/**
 * __useExportAudiencesMutation__
 *
 * To run a mutation, you first call `useExportAudiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAudiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAudiencesMutation, { data, loading, error }] = useExportAudiencesMutation({
 *   variables: {
 *      type: // value for 'type'
 *      ids: // value for 'ids'
 *      fields: // value for 'fields'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useExportAudiencesMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportAudiencesMutation, ExportAudiencesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportAudiencesMutation, ExportAudiencesMutationVariables>(
    ExportAudiencesDocument,
    options
  );
}
export type ExportAudiencesMutationHookResult = ReturnType<typeof useExportAudiencesMutation>;
export type ExportAudiencesMutationResult = Apollo.MutationResult<ExportAudiencesMutation>;
export type ExportAudiencesMutationOptions = Apollo.BaseMutationOptions<
  ExportAudiencesMutation,
  ExportAudiencesMutationVariables
>;
export const UpdateCombinedAudienceDocument = gql`
  mutation UpdateCombinedAudience(
    $accountId: Int!
    $children: [CombinedAudienceArg!]!
    $childrenClause: EAudienceCombineClause
    $countryCode: String!
    $description: String
    $name: String!
    $id: Int!
  ) {
    updateCombinedAudience(
      accountId: $accountId
      children: $children
      childrenClause: $childrenClause
      countryCode: $countryCode
      description: $description
      name: $name
      id: $id
    ) {
      id
    }
  }
`;
export type UpdateCombinedAudienceMutationFn = Apollo.MutationFunction<
  UpdateCombinedAudienceMutation,
  UpdateCombinedAudienceMutationVariables
>;

/**
 * __useUpdateCombinedAudienceMutation__
 *
 * To run a mutation, you first call `useUpdateCombinedAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCombinedAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCombinedAudienceMutation, { data, loading, error }] = useUpdateCombinedAudienceMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      children: // value for 'children'
 *      childrenClause: // value for 'childrenClause'
 *      countryCode: // value for 'countryCode'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCombinedAudienceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCombinedAudienceMutation, UpdateCombinedAudienceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCombinedAudienceMutation, UpdateCombinedAudienceMutationVariables>(
    UpdateCombinedAudienceDocument,
    options
  );
}
export type UpdateCombinedAudienceMutationHookResult = ReturnType<typeof useUpdateCombinedAudienceMutation>;
export type UpdateCombinedAudienceMutationResult = Apollo.MutationResult<UpdateCombinedAudienceMutation>;
export type UpdateCombinedAudienceMutationOptions = Apollo.BaseMutationOptions<
  UpdateCombinedAudienceMutation,
  UpdateCombinedAudienceMutationVariables
>;
export const BulkUpdateCampaignDocument = gql`
  mutation BulkUpdateCampaign($data: [UpdateCampaignArgsDto!]!) {
    bulkUpdateCampaign(data: $data)
  }
`;
export type BulkUpdateCampaignMutationFn = Apollo.MutationFunction<
  BulkUpdateCampaignMutation,
  BulkUpdateCampaignMutationVariables
>;

/**
 * __useBulkUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCampaignMutation, { data, loading, error }] = useBulkUpdateCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkUpdateCampaignMutation, BulkUpdateCampaignMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkUpdateCampaignMutation, BulkUpdateCampaignMutationVariables>(
    BulkUpdateCampaignDocument,
    options
  );
}
export type BulkUpdateCampaignMutationHookResult = ReturnType<typeof useBulkUpdateCampaignMutation>;
export type BulkUpdateCampaignMutationResult = Apollo.MutationResult<BulkUpdateCampaignMutation>;
export type BulkUpdateCampaignMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateCampaignMutation,
  BulkUpdateCampaignMutationVariables
>;
export const CloneCampaignDocument = gql`
  mutation CloneCampaign($id: BigInt!, $data: CloneCampaignArgsDto!) {
    cloneCampaign(id: $id, data: $data)
  }
`;
export type CloneCampaignMutationFn = Apollo.MutationFunction<CloneCampaignMutation, CloneCampaignMutationVariables>;

/**
 * __useCloneCampaignMutation__
 *
 * To run a mutation, you first call `useCloneCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCampaignMutation, { data, loading, error }] = useCloneCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<CloneCampaignMutation, CloneCampaignMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneCampaignMutation, CloneCampaignMutationVariables>(CloneCampaignDocument, options);
}
export type CloneCampaignMutationHookResult = ReturnType<typeof useCloneCampaignMutation>;
export type CloneCampaignMutationResult = Apollo.MutationResult<CloneCampaignMutation>;
export type CloneCampaignMutationOptions = Apollo.BaseMutationOptions<
  CloneCampaignMutation,
  CloneCampaignMutationVariables
>;
export const CreateCampaignDocument = gql`
  mutation CreateCampaign($data: CreateCampaignArgsDto!) {
    createCampaign(data: $data) {
      id
    }
  }
`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
}
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<
  CreateCampaignMutation,
  CreateCampaignMutationVariables
>;
export const UpdateCampaignDocument = gql`
  mutation UpdateCampaign($campaignId: BigInt!, $data: UpdateCampaignArgsDto!) {
    updateCampaign(id: $campaignId, data: $data) {
      id
    }
  }
`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
}
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<
  UpdateCampaignMutation,
  UpdateCampaignMutationVariables
>;
export const AddAudioDocument = gql`
  mutation AddAudio($data: CreateAudioDto!) {
    addAudioCreative(data: $data) {
      id
    }
  }
`;
export type AddAudioMutationFn = Apollo.MutationFunction<AddAudioMutation, AddAudioMutationVariables>;

/**
 * __useAddAudioMutation__
 *
 * To run a mutation, you first call `useAddAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAudioMutation, { data, loading, error }] = useAddAudioMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddAudioMutation(
  baseOptions?: Apollo.MutationHookOptions<AddAudioMutation, AddAudioMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddAudioMutation, AddAudioMutationVariables>(AddAudioDocument, options);
}
export type AddAudioMutationHookResult = ReturnType<typeof useAddAudioMutation>;
export type AddAudioMutationResult = Apollo.MutationResult<AddAudioMutation>;
export type AddAudioMutationOptions = Apollo.BaseMutationOptions<AddAudioMutation, AddAudioMutationVariables>;
export const AddBannerDocument = gql`
  mutation AddBanner($data: CreateBannerDto!) {
    addBannerCreative(data: $data) {
      id
    }
  }
`;
export type AddBannerMutationFn = Apollo.MutationFunction<AddBannerMutation, AddBannerMutationVariables>;

/**
 * __useAddBannerMutation__
 *
 * To run a mutation, you first call `useAddBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBannerMutation, { data, loading, error }] = useAddBannerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<AddBannerMutation, AddBannerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddBannerMutation, AddBannerMutationVariables>(AddBannerDocument, options);
}
export type AddBannerMutationHookResult = ReturnType<typeof useAddBannerMutation>;
export type AddBannerMutationResult = Apollo.MutationResult<AddBannerMutation>;
export type AddBannerMutationOptions = Apollo.BaseMutationOptions<AddBannerMutation, AddBannerMutationVariables>;
export const AddOrReplaceCtvVideoVariantsDocument = gql`
  mutation AddOrReplaceCtvVideoVariants($creativeId: BigInt!, $data: AddOrReplaceCtvVideoVariantsDto!) {
    addOrReplaceCtvVideoVariants(creativeId: $creativeId, data: $data)
  }
`;
export type AddOrReplaceCtvVideoVariantsMutationFn = Apollo.MutationFunction<
  AddOrReplaceCtvVideoVariantsMutation,
  AddOrReplaceCtvVideoVariantsMutationVariables
>;

/**
 * __useAddOrReplaceCtvVideoVariantsMutation__
 *
 * To run a mutation, you first call `useAddOrReplaceCtvVideoVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrReplaceCtvVideoVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrReplaceCtvVideoVariantsMutation, { data, loading, error }] = useAddOrReplaceCtvVideoVariantsMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddOrReplaceCtvVideoVariantsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddOrReplaceCtvVideoVariantsMutation,
    AddOrReplaceCtvVideoVariantsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddOrReplaceCtvVideoVariantsMutation, AddOrReplaceCtvVideoVariantsMutationVariables>(
    AddOrReplaceCtvVideoVariantsDocument,
    options
  );
}
export type AddOrReplaceCtvVideoVariantsMutationHookResult = ReturnType<typeof useAddOrReplaceCtvVideoVariantsMutation>;
export type AddOrReplaceCtvVideoVariantsMutationResult = Apollo.MutationResult<AddOrReplaceCtvVideoVariantsMutation>;
export type AddOrReplaceCtvVideoVariantsMutationOptions = Apollo.BaseMutationOptions<
  AddOrReplaceCtvVideoVariantsMutation,
  AddOrReplaceCtvVideoVariantsMutationVariables
>;
export const AddNativeDocument = gql`
  mutation AddNative($data: CreateNativeDto!) {
    addNativeCreative(data: $data) {
      id
    }
  }
`;
export type AddNativeMutationFn = Apollo.MutationFunction<AddNativeMutation, AddNativeMutationVariables>;

/**
 * __useAddNativeMutation__
 *
 * To run a mutation, you first call `useAddNativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNativeMutation, { data, loading, error }] = useAddNativeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddNativeMutation(
  baseOptions?: Apollo.MutationHookOptions<AddNativeMutation, AddNativeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddNativeMutation, AddNativeMutationVariables>(AddNativeDocument, options);
}
export type AddNativeMutationHookResult = ReturnType<typeof useAddNativeMutation>;
export type AddNativeMutationResult = Apollo.MutationResult<AddNativeMutation>;
export type AddNativeMutationOptions = Apollo.BaseMutationOptions<AddNativeMutation, AddNativeMutationVariables>;
export const AddVideoDocument = gql`
  mutation AddVideo($data: CreateVideoDto!) {
    addVideoCreative(data: $data) {
      id
    }
  }
`;
export type AddVideoMutationFn = Apollo.MutationFunction<AddVideoMutation, AddVideoMutationVariables>;

/**
 * __useAddVideoMutation__
 *
 * To run a mutation, you first call `useAddVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVideoMutation, { data, loading, error }] = useAddVideoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<AddVideoMutation, AddVideoMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddVideoMutation, AddVideoMutationVariables>(AddVideoDocument, options);
}
export type AddVideoMutationHookResult = ReturnType<typeof useAddVideoMutation>;
export type AddVideoMutationResult = Apollo.MutationResult<AddVideoMutation>;
export type AddVideoMutationOptions = Apollo.BaseMutationOptions<AddVideoMutation, AddVideoMutationVariables>;
export const UpdateAudioDocument = gql`
  mutation UpdateAudio($creativeId: BigInt!, $data: UpdateAudioDto!) {
    updateAudioCreative(creativeId: $creativeId, data: $data)
  }
`;
export type UpdateAudioMutationFn = Apollo.MutationFunction<UpdateAudioMutation, UpdateAudioMutationVariables>;

/**
 * __useUpdateAudioMutation__
 *
 * To run a mutation, you first call `useUpdateAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudioMutation, { data, loading, error }] = useUpdateAudioMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAudioMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAudioMutation, UpdateAudioMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAudioMutation, UpdateAudioMutationVariables>(UpdateAudioDocument, options);
}
export type UpdateAudioMutationHookResult = ReturnType<typeof useUpdateAudioMutation>;
export type UpdateAudioMutationResult = Apollo.MutationResult<UpdateAudioMutation>;
export type UpdateAudioMutationOptions = Apollo.BaseMutationOptions<UpdateAudioMutation, UpdateAudioMutationVariables>;
export const UpdateBannerDocument = gql`
  mutation UpdateBanner($creativeId: BigInt!, $data: UpdateBannerDto!) {
    updateBannerCreative(creativeId: $creativeId, data: $data)
  }
`;
export type UpdateBannerMutationFn = Apollo.MutationFunction<UpdateBannerMutation, UpdateBannerMutationVariables>;

/**
 * __useUpdateBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerMutation, { data, loading, error }] = useUpdateBannerMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateBannerMutation, UpdateBannerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBannerMutation, UpdateBannerMutationVariables>(UpdateBannerDocument, options);
}
export type UpdateBannerMutationHookResult = ReturnType<typeof useUpdateBannerMutation>;
export type UpdateBannerMutationResult = Apollo.MutationResult<UpdateBannerMutation>;
export type UpdateBannerMutationOptions = Apollo.BaseMutationOptions<
  UpdateBannerMutation,
  UpdateBannerMutationVariables
>;
export const UpdateNativeDocument = gql`
  mutation UpdateNative($creativeId: BigInt!, $data: UpdateNativeDto!) {
    updateNativeCreative(creativeId: $creativeId, data: $data)
  }
`;
export type UpdateNativeMutationFn = Apollo.MutationFunction<UpdateNativeMutation, UpdateNativeMutationVariables>;

/**
 * __useUpdateNativeMutation__
 *
 * To run a mutation, you first call `useUpdateNativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNativeMutation, { data, loading, error }] = useUpdateNativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNativeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateNativeMutation, UpdateNativeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateNativeMutation, UpdateNativeMutationVariables>(UpdateNativeDocument, options);
}
export type UpdateNativeMutationHookResult = ReturnType<typeof useUpdateNativeMutation>;
export type UpdateNativeMutationResult = Apollo.MutationResult<UpdateNativeMutation>;
export type UpdateNativeMutationOptions = Apollo.BaseMutationOptions<
  UpdateNativeMutation,
  UpdateNativeMutationVariables
>;
export const UpdateVideoDocument = gql`
  mutation UpdateVideo($creativeId: BigInt!, $data: UpdateVideoDto!) {
    updateVideoCreative(creativeId: $creativeId, data: $data)
  }
`;
export type UpdateVideoMutationFn = Apollo.MutationFunction<UpdateVideoMutation, UpdateVideoMutationVariables>;

/**
 * __useUpdateVideoMutation__
 *
 * To run a mutation, you first call `useUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoMutation, { data, loading, error }] = useUpdateVideoMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateVideoMutation, UpdateVideoMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateVideoMutation, UpdateVideoMutationVariables>(UpdateVideoDocument, options);
}
export type UpdateVideoMutationHookResult = ReturnType<typeof useUpdateVideoMutation>;
export type UpdateVideoMutationResult = Apollo.MutationResult<UpdateVideoMutation>;
export type UpdateVideoMutationOptions = Apollo.BaseMutationOptions<UpdateVideoMutation, UpdateVideoMutationVariables>;
export const AssignCreativesToDealDocument = gql`
  mutation AssignCreativesToDeal($dealId: BigInt!, $creativeIds: [BigInt!]!) {
    assignCreatives(dealId: $dealId, creativeIds: $creativeIds)
  }
`;
export type AssignCreativesToDealMutationFn = Apollo.MutationFunction<
  AssignCreativesToDealMutation,
  AssignCreativesToDealMutationVariables
>;

/**
 * __useAssignCreativesToDealMutation__
 *
 * To run a mutation, you first call `useAssignCreativesToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCreativesToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCreativesToDealMutation, { data, loading, error }] = useAssignCreativesToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      creativeIds: // value for 'creativeIds'
 *   },
 * });
 */
export function useAssignCreativesToDealMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignCreativesToDealMutation, AssignCreativesToDealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignCreativesToDealMutation, AssignCreativesToDealMutationVariables>(
    AssignCreativesToDealDocument,
    options
  );
}
export type AssignCreativesToDealMutationHookResult = ReturnType<typeof useAssignCreativesToDealMutation>;
export type AssignCreativesToDealMutationResult = Apollo.MutationResult<AssignCreativesToDealMutation>;
export type AssignCreativesToDealMutationOptions = Apollo.BaseMutationOptions<
  AssignCreativesToDealMutation,
  AssignCreativesToDealMutationVariables
>;
export const BulkUpdateDealDocument = gql`
  mutation BulkUpdateDeal($data: [BulkUpdateDealsArgsDto!]!) {
    bulkUpdateDeals(data: $data)
  }
`;
export type BulkUpdateDealMutationFn = Apollo.MutationFunction<BulkUpdateDealMutation, BulkUpdateDealMutationVariables>;

/**
 * __useBulkUpdateDealMutation__
 *
 * To run a mutation, you first call `useBulkUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateDealMutation, { data, loading, error }] = useBulkUpdateDealMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkUpdateDealMutation, BulkUpdateDealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkUpdateDealMutation, BulkUpdateDealMutationVariables>(BulkUpdateDealDocument, options);
}
export type BulkUpdateDealMutationHookResult = ReturnType<typeof useBulkUpdateDealMutation>;
export type BulkUpdateDealMutationResult = Apollo.MutationResult<BulkUpdateDealMutation>;
export type BulkUpdateDealMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateDealMutation,
  BulkUpdateDealMutationVariables
>;
export const CreateDealDocument = gql`
  mutation CreateDeal($data: CreateDealsArgsDto!) {
    createDeal(data: $data) {
      id
    }
  }
`;
export type CreateDealMutationFn = Apollo.MutationFunction<CreateDealMutation, CreateDealMutationVariables>;

/**
 * __useCreateDealMutation__
 *
 * To run a mutation, you first call `useCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealMutation, { data, loading, error }] = useCreateDealMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDealMutation, CreateDealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDealMutation, CreateDealMutationVariables>(CreateDealDocument, options);
}
export type CreateDealMutationHookResult = ReturnType<typeof useCreateDealMutation>;
export type CreateDealMutationResult = Apollo.MutationResult<CreateDealMutation>;
export type CreateDealMutationOptions = Apollo.BaseMutationOptions<CreateDealMutation, CreateDealMutationVariables>;
export const UnassignCreativesFromDealDocument = gql`
  mutation UnassignCreativesFromDeal($dealId: BigInt!, $creativeIds: [BigInt!]!) {
    unassignCreatives(dealId: $dealId, creativeIds: $creativeIds)
  }
`;
export type UnassignCreativesFromDealMutationFn = Apollo.MutationFunction<
  UnassignCreativesFromDealMutation,
  UnassignCreativesFromDealMutationVariables
>;

/**
 * __useUnassignCreativesFromDealMutation__
 *
 * To run a mutation, you first call `useUnassignCreativesFromDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignCreativesFromDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignCreativesFromDealMutation, { data, loading, error }] = useUnassignCreativesFromDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      creativeIds: // value for 'creativeIds'
 *   },
 * });
 */
export function useUnassignCreativesFromDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnassignCreativesFromDealMutation,
    UnassignCreativesFromDealMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnassignCreativesFromDealMutation, UnassignCreativesFromDealMutationVariables>(
    UnassignCreativesFromDealDocument,
    options
  );
}
export type UnassignCreativesFromDealMutationHookResult = ReturnType<typeof useUnassignCreativesFromDealMutation>;
export type UnassignCreativesFromDealMutationResult = Apollo.MutationResult<UnassignCreativesFromDealMutation>;
export type UnassignCreativesFromDealMutationOptions = Apollo.BaseMutationOptions<
  UnassignCreativesFromDealMutation,
  UnassignCreativesFromDealMutationVariables
>;
export const UpdateDealDocument = gql`
  mutation UpdateDeal($dealId: BigInt!, $data: UpdateDealsArgsDto!) {
    updateDeal(dealId: $dealId, data: $data) {
      id
    }
  }
`;
export type UpdateDealMutationFn = Apollo.MutationFunction<UpdateDealMutation, UpdateDealMutationVariables>;

/**
 * __useUpdateDealMutation__
 *
 * To run a mutation, you first call `useUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealMutation, { data, loading, error }] = useUpdateDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDealMutation, UpdateDealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDealMutation, UpdateDealMutationVariables>(UpdateDealDocument, options);
}
export type UpdateDealMutationHookResult = ReturnType<typeof useUpdateDealMutation>;
export type UpdateDealMutationResult = Apollo.MutationResult<UpdateDealMutation>;
export type UpdateDealMutationOptions = Apollo.BaseMutationOptions<UpdateDealMutation, UpdateDealMutationVariables>;
export const CreateLocatonGroupDocument = gql`
  mutation CreateLocatonGroup($data: CreateLocationGroupArgsDto!) {
    createLocationGroup(data: $data) {
      id
    }
  }
`;
export type CreateLocatonGroupMutationFn = Apollo.MutationFunction<
  CreateLocatonGroupMutation,
  CreateLocatonGroupMutationVariables
>;

/**
 * __useCreateLocatonGroupMutation__
 *
 * To run a mutation, you first call `useCreateLocatonGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocatonGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocatonGroupMutation, { data, loading, error }] = useCreateLocatonGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocatonGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateLocatonGroupMutation, CreateLocatonGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLocatonGroupMutation, CreateLocatonGroupMutationVariables>(
    CreateLocatonGroupDocument,
    options
  );
}
export type CreateLocatonGroupMutationHookResult = ReturnType<typeof useCreateLocatonGroupMutation>;
export type CreateLocatonGroupMutationResult = Apollo.MutationResult<CreateLocatonGroupMutation>;
export type CreateLocatonGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateLocatonGroupMutation,
  CreateLocatonGroupMutationVariables
>;
export const DeleteLocationGroupsDocument = gql`
  mutation DeleteLocationGroups($ids: [BigInt!]) {
    deleteLocationGroups(ids: $ids) {
      success
      message
    }
  }
`;
export type DeleteLocationGroupsMutationFn = Apollo.MutationFunction<
  DeleteLocationGroupsMutation,
  DeleteLocationGroupsMutationVariables
>;

/**
 * __useDeleteLocationGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteLocationGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationGroupsMutation, { data, loading, error }] = useDeleteLocationGroupsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLocationGroupsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteLocationGroupsMutation, DeleteLocationGroupsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteLocationGroupsMutation, DeleteLocationGroupsMutationVariables>(
    DeleteLocationGroupsDocument,
    options
  );
}
export type DeleteLocationGroupsMutationHookResult = ReturnType<typeof useDeleteLocationGroupsMutation>;
export type DeleteLocationGroupsMutationResult = Apollo.MutationResult<DeleteLocationGroupsMutation>;
export type DeleteLocationGroupsMutationOptions = Apollo.BaseMutationOptions<
  DeleteLocationGroupsMutation,
  DeleteLocationGroupsMutationVariables
>;
export const ExportLocationGroupDocument = gql`
  mutation ExportLocationGroup($type: ExportType!, $id: BigInt!) {
    locationGroupExport(type: $type, id: $id)
  }
`;
export type ExportLocationGroupMutationFn = Apollo.MutationFunction<
  ExportLocationGroupMutation,
  ExportLocationGroupMutationVariables
>;

/**
 * __useExportLocationGroupMutation__
 *
 * To run a mutation, you first call `useExportLocationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportLocationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportLocationGroupMutation, { data, loading, error }] = useExportLocationGroupMutation({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportLocationGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<ExportLocationGroupMutation, ExportLocationGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportLocationGroupMutation, ExportLocationGroupMutationVariables>(
    ExportLocationGroupDocument,
    options
  );
}
export type ExportLocationGroupMutationHookResult = ReturnType<typeof useExportLocationGroupMutation>;
export type ExportLocationGroupMutationResult = Apollo.MutationResult<ExportLocationGroupMutation>;
export type ExportLocationGroupMutationOptions = Apollo.BaseMutationOptions<
  ExportLocationGroupMutation,
  ExportLocationGroupMutationVariables
>;
export const UpdateLocatonGroupDocument = gql`
  mutation UpdateLocatonGroup($data: UpdateLocationGroupArgsDto!) {
    updateLocationGroup(data: $data)
  }
`;
export type UpdateLocatonGroupMutationFn = Apollo.MutationFunction<
  UpdateLocatonGroupMutation,
  UpdateLocatonGroupMutationVariables
>;

/**
 * __useUpdateLocatonGroupMutation__
 *
 * To run a mutation, you first call `useUpdateLocatonGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocatonGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocatonGroupMutation, { data, loading, error }] = useUpdateLocatonGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocatonGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateLocatonGroupMutation, UpdateLocatonGroupMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLocatonGroupMutation, UpdateLocatonGroupMutationVariables>(
    UpdateLocatonGroupDocument,
    options
  );
}
export type UpdateLocatonGroupMutationHookResult = ReturnType<typeof useUpdateLocatonGroupMutation>;
export type UpdateLocatonGroupMutationResult = Apollo.MutationResult<UpdateLocatonGroupMutation>;
export type UpdateLocatonGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocatonGroupMutation,
  UpdateLocatonGroupMutationVariables
>;
export const AssignCreativesToStrategyDocument = gql`
  mutation AssignCreativesToStrategy($strategyId: BigInt!, $creativeIDs: [BigInt!]!) {
    assignCreativesToStrategy(strategyId: $strategyId, creativeIds: $creativeIDs)
  }
`;
export type AssignCreativesToStrategyMutationFn = Apollo.MutationFunction<
  AssignCreativesToStrategyMutation,
  AssignCreativesToStrategyMutationVariables
>;

/**
 * __useAssignCreativesToStrategyMutation__
 *
 * To run a mutation, you first call `useAssignCreativesToStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCreativesToStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCreativesToStrategyMutation, { data, loading, error }] = useAssignCreativesToStrategyMutation({
 *   variables: {
 *      strategyId: // value for 'strategyId'
 *      creativeIDs: // value for 'creativeIDs'
 *   },
 * });
 */
export function useAssignCreativesToStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignCreativesToStrategyMutation,
    AssignCreativesToStrategyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignCreativesToStrategyMutation, AssignCreativesToStrategyMutationVariables>(
    AssignCreativesToStrategyDocument,
    options
  );
}
export type AssignCreativesToStrategyMutationHookResult = ReturnType<typeof useAssignCreativesToStrategyMutation>;
export type AssignCreativesToStrategyMutationResult = Apollo.MutationResult<AssignCreativesToStrategyMutation>;
export type AssignCreativesToStrategyMutationOptions = Apollo.BaseMutationOptions<
  AssignCreativesToStrategyMutation,
  AssignCreativesToStrategyMutationVariables
>;
export const BulkUpdateStrategiesDocument = gql`
  mutation BulkUpdateStrategies($data: [BulkUpdateStrategyArgsDto!]!) {
    bulkUpdateStrategies(data: $data)
  }
`;
export type BulkUpdateStrategiesMutationFn = Apollo.MutationFunction<
  BulkUpdateStrategiesMutation,
  BulkUpdateStrategiesMutationVariables
>;

/**
 * __useBulkUpdateStrategiesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateStrategiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateStrategiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateStrategiesMutation, { data, loading, error }] = useBulkUpdateStrategiesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateStrategiesMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkUpdateStrategiesMutation, BulkUpdateStrategiesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkUpdateStrategiesMutation, BulkUpdateStrategiesMutationVariables>(
    BulkUpdateStrategiesDocument,
    options
  );
}
export type BulkUpdateStrategiesMutationHookResult = ReturnType<typeof useBulkUpdateStrategiesMutation>;
export type BulkUpdateStrategiesMutationResult = Apollo.MutationResult<BulkUpdateStrategiesMutation>;
export type BulkUpdateStrategiesMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateStrategiesMutation,
  BulkUpdateStrategiesMutationVariables
>;
export const CloneStrategyDocument = gql`
  mutation CloneStrategy($id: BigInt!, $data: CloneStrategyArgsDto!) {
    cloneStrategy(id: $id, data: $data)
  }
`;
export type CloneStrategyMutationFn = Apollo.MutationFunction<CloneStrategyMutation, CloneStrategyMutationVariables>;

/**
 * __useCloneStrategyMutation__
 *
 * To run a mutation, you first call `useCloneStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneStrategyMutation, { data, loading, error }] = useCloneStrategyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<CloneStrategyMutation, CloneStrategyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneStrategyMutation, CloneStrategyMutationVariables>(CloneStrategyDocument, options);
}
export type CloneStrategyMutationHookResult = ReturnType<typeof useCloneStrategyMutation>;
export type CloneStrategyMutationResult = Apollo.MutationResult<CloneStrategyMutation>;
export type CloneStrategyMutationOptions = Apollo.BaseMutationOptions<
  CloneStrategyMutation,
  CloneStrategyMutationVariables
>;
export const CreateStrategyDocument = gql`
  mutation CreateStrategy($campaignId: BigInt!, $data: CreateStrategyArgsDto!) {
    createStrategy(campaignId: $campaignId, data: $data) {
      id
    }
  }
`;
export type CreateStrategyMutationFn = Apollo.MutationFunction<CreateStrategyMutation, CreateStrategyMutationVariables>;

/**
 * __useCreateStrategyMutation__
 *
 * To run a mutation, you first call `useCreateStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrategyMutation, { data, loading, error }] = useCreateStrategyMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateStrategyMutation, CreateStrategyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateStrategyMutation, CreateStrategyMutationVariables>(CreateStrategyDocument, options);
}
export type CreateStrategyMutationHookResult = ReturnType<typeof useCreateStrategyMutation>;
export type CreateStrategyMutationResult = Apollo.MutationResult<CreateStrategyMutation>;
export type CreateStrategyMutationOptions = Apollo.BaseMutationOptions<
  CreateStrategyMutation,
  CreateStrategyMutationVariables
>;
export const UpdateStrategyDocument = gql`
  mutation UpdateStrategy($id: BigInt!, $data: UpdateStrategyArgsDto!) {
    updateStrategy(id: $id, data: $data) {
      id
    }
  }
`;
export type UpdateStrategyMutationFn = Apollo.MutationFunction<UpdateStrategyMutation, UpdateStrategyMutationVariables>;

/**
 * __useUpdateStrategyMutation__
 *
 * To run a mutation, you first call `useUpdateStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrategyMutation, { data, loading, error }] = useUpdateStrategyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateStrategyMutation, UpdateStrategyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateStrategyMutation, UpdateStrategyMutationVariables>(UpdateStrategyDocument, options);
}
export type UpdateStrategyMutationHookResult = ReturnType<typeof useUpdateStrategyMutation>;
export type UpdateStrategyMutationResult = Apollo.MutationResult<UpdateStrategyMutation>;
export type UpdateStrategyMutationOptions = Apollo.BaseMutationOptions<
  UpdateStrategyMutation,
  UpdateStrategyMutationVariables
>;
export const BulkUpdateTargetingDocument = gql`
  mutation BulkUpdateTargeting($data: BulkUpdateTargetingArgsDto!) {
    bulkUpdateTargeting(data: $data)
  }
`;
export type BulkUpdateTargetingMutationFn = Apollo.MutationFunction<
  BulkUpdateTargetingMutation,
  BulkUpdateTargetingMutationVariables
>;

/**
 * __useBulkUpdateTargetingMutation__
 *
 * To run a mutation, you first call `useBulkUpdateTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateTargetingMutation, { data, loading, error }] = useBulkUpdateTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkUpdateTargetingMutation, BulkUpdateTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkUpdateTargetingMutation, BulkUpdateTargetingMutationVariables>(
    BulkUpdateTargetingDocument,
    options
  );
}
export type BulkUpdateTargetingMutationHookResult = ReturnType<typeof useBulkUpdateTargetingMutation>;
export type BulkUpdateTargetingMutationResult = Apollo.MutationResult<BulkUpdateTargetingMutation>;
export type BulkUpdateTargetingMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateTargetingMutation,
  BulkUpdateTargetingMutationVariables
>;
export const ReplaceTargetingAudiencesBatchDocument = gql`
  mutation ReplaceTargetingAudiencesBatch($id: Float!, $type: String!, $data: ReplaceTargetingAudiencesBatchDto!) {
    replaceTargetingAudiencesBatch(id: $id, type: $type, data: $data)
  }
`;
export type ReplaceTargetingAudiencesBatchMutationFn = Apollo.MutationFunction<
  ReplaceTargetingAudiencesBatchMutation,
  ReplaceTargetingAudiencesBatchMutationVariables
>;

/**
 * __useReplaceTargetingAudiencesBatchMutation__
 *
 * To run a mutation, you first call `useReplaceTargetingAudiencesBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceTargetingAudiencesBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceTargetingAudiencesBatchMutation, { data, loading, error }] = useReplaceTargetingAudiencesBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReplaceTargetingAudiencesBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReplaceTargetingAudiencesBatchMutation,
    ReplaceTargetingAudiencesBatchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplaceTargetingAudiencesBatchMutation, ReplaceTargetingAudiencesBatchMutationVariables>(
    ReplaceTargetingAudiencesBatchDocument,
    options
  );
}
export type ReplaceTargetingAudiencesBatchMutationHookResult = ReturnType<
  typeof useReplaceTargetingAudiencesBatchMutation
>;
export type ReplaceTargetingAudiencesBatchMutationResult =
  Apollo.MutationResult<ReplaceTargetingAudiencesBatchMutation>;
export type ReplaceTargetingAudiencesBatchMutationOptions = Apollo.BaseMutationOptions<
  ReplaceTargetingAudiencesBatchMutation,
  ReplaceTargetingAudiencesBatchMutationVariables
>;
export const ReplaceTargetingPoiBatchDocument = gql`
  mutation ReplaceTargetingPoiBatch(
    $referenceObjectID: BigInt!
    $referenceObjectType: EObjectType!
    $data: ReplaceBatchPoiInputDto!
  ) {
    replacePoiBatch(referenceObjectID: $referenceObjectID, referenceObjectType: $referenceObjectType, data: $data)
  }
`;
export type ReplaceTargetingPoiBatchMutationFn = Apollo.MutationFunction<
  ReplaceTargetingPoiBatchMutation,
  ReplaceTargetingPoiBatchMutationVariables
>;

/**
 * __useReplaceTargetingPoiBatchMutation__
 *
 * To run a mutation, you first call `useReplaceTargetingPoiBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceTargetingPoiBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceTargetingPoiBatchMutation, { data, loading, error }] = useReplaceTargetingPoiBatchMutation({
 *   variables: {
 *      referenceObjectID: // value for 'referenceObjectID'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReplaceTargetingPoiBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<ReplaceTargetingPoiBatchMutation, ReplaceTargetingPoiBatchMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplaceTargetingPoiBatchMutation, ReplaceTargetingPoiBatchMutationVariables>(
    ReplaceTargetingPoiBatchDocument,
    options
  );
}
export type ReplaceTargetingPoiBatchMutationHookResult = ReturnType<typeof useReplaceTargetingPoiBatchMutation>;
export type ReplaceTargetingPoiBatchMutationResult = Apollo.MutationResult<ReplaceTargetingPoiBatchMutation>;
export type ReplaceTargetingPoiBatchMutationOptions = Apollo.BaseMutationOptions<
  ReplaceTargetingPoiBatchMutation,
  ReplaceTargetingPoiBatchMutationVariables
>;
export const CreateAbsTargetingDocument = gql`
  mutation CreateAbsTargeting(
    $id: BigInt!
    $type: EObjectType!
    $data: [CreateDvAuthenticBrandSuitabilityTargetingDto!]!
  ) {
    batchCreateDvAuthenticBrandSuitabilityTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateAbsTargetingMutationFn = Apollo.MutationFunction<
  CreateAbsTargetingMutation,
  CreateAbsTargetingMutationVariables
>;

/**
 * __useCreateAbsTargetingMutation__
 *
 * To run a mutation, you first call `useCreateAbsTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbsTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbsTargetingMutation, { data, loading, error }] = useCreateAbsTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAbsTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAbsTargetingMutation, CreateAbsTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAbsTargetingMutation, CreateAbsTargetingMutationVariables>(
    CreateAbsTargetingDocument,
    options
  );
}
export type CreateAbsTargetingMutationHookResult = ReturnType<typeof useCreateAbsTargetingMutation>;
export type CreateAbsTargetingMutationResult = Apollo.MutationResult<CreateAbsTargetingMutation>;
export type CreateAbsTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateAbsTargetingMutation,
  CreateAbsTargetingMutationVariables
>;
export const DeleteAbsTargetingDocument = gql`
  mutation DeleteAbsTargeting($id: BigInt!) {
    deleteDvAuthenticBrandSuitabilityTargeting(id: $id)
  }
`;
export type DeleteAbsTargetingMutationFn = Apollo.MutationFunction<
  DeleteAbsTargetingMutation,
  DeleteAbsTargetingMutationVariables
>;

/**
 * __useDeleteAbsTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteAbsTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAbsTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAbsTargetingMutation, { data, loading, error }] = useDeleteAbsTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAbsTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAbsTargetingMutation, DeleteAbsTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAbsTargetingMutation, DeleteAbsTargetingMutationVariables>(
    DeleteAbsTargetingDocument,
    options
  );
}
export type DeleteAbsTargetingMutationHookResult = ReturnType<typeof useDeleteAbsTargetingMutation>;
export type DeleteAbsTargetingMutationResult = Apollo.MutationResult<DeleteAbsTargetingMutation>;
export type DeleteAbsTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteAbsTargetingMutation,
  DeleteAbsTargetingMutationVariables
>;
export const CreateAppCategoryTargetingDocument = gql`
  mutation CreateAppCategoryTargeting($data: [CreateAppCategoryTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateAppCategoryTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateAppCategoryTargetingMutationFn = Apollo.MutationFunction<
  CreateAppCategoryTargetingMutation,
  CreateAppCategoryTargetingMutationVariables
>;

/**
 * __useCreateAppCategoryTargetingMutation__
 *
 * To run a mutation, you first call `useCreateAppCategoryTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppCategoryTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppCategoryTargetingMutation, { data, loading, error }] = useCreateAppCategoryTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAppCategoryTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAppCategoryTargetingMutation,
    CreateAppCategoryTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAppCategoryTargetingMutation, CreateAppCategoryTargetingMutationVariables>(
    CreateAppCategoryTargetingDocument,
    options
  );
}
export type CreateAppCategoryTargetingMutationHookResult = ReturnType<typeof useCreateAppCategoryTargetingMutation>;
export type CreateAppCategoryTargetingMutationResult = Apollo.MutationResult<CreateAppCategoryTargetingMutation>;
export type CreateAppCategoryTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateAppCategoryTargetingMutation,
  CreateAppCategoryTargetingMutationVariables
>;
export const CreateAppTargetingDocument = gql`
  mutation CreateAppTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateAppTargetingDto!]!) {
    batchCreateAppTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateAppTargetingMutationFn = Apollo.MutationFunction<
  CreateAppTargetingMutation,
  CreateAppTargetingMutationVariables
>;

/**
 * __useCreateAppTargetingMutation__
 *
 * To run a mutation, you first call `useCreateAppTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppTargetingMutation, { data, loading, error }] = useCreateAppTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAppTargetingMutation, CreateAppTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAppTargetingMutation, CreateAppTargetingMutationVariables>(
    CreateAppTargetingDocument,
    options
  );
}
export type CreateAppTargetingMutationHookResult = ReturnType<typeof useCreateAppTargetingMutation>;
export type CreateAppTargetingMutationResult = Apollo.MutationResult<CreateAppTargetingMutation>;
export type CreateAppTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateAppTargetingMutation,
  CreateAppTargetingMutationVariables
>;
export const DeleteAppTargetingDocument = gql`
  mutation DeleteAppTargeting($ids: [BigInt!]!, $type: EObjectType, $refId: BigInt) {
    batchDeleteAppTargeting(ids: $ids, type: $type, refId: $refId)
  }
`;
export type DeleteAppTargetingMutationFn = Apollo.MutationFunction<
  DeleteAppTargetingMutation,
  DeleteAppTargetingMutationVariables
>;

/**
 * __useDeleteAppTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteAppTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppTargetingMutation, { data, loading, error }] = useDeleteAppTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useDeleteAppTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAppTargetingMutation, DeleteAppTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAppTargetingMutation, DeleteAppTargetingMutationVariables>(
    DeleteAppTargetingDocument,
    options
  );
}
export type DeleteAppTargetingMutationHookResult = ReturnType<typeof useDeleteAppTargetingMutation>;
export type DeleteAppTargetingMutationResult = Apollo.MutationResult<DeleteAppTargetingMutation>;
export type DeleteAppTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteAppTargetingMutation,
  DeleteAppTargetingMutationVariables
>;
export const UpdateAppTargetingDocument = gql`
  mutation UpdateAppTargeting($data: [AppTargetingBatchUpdateInput!]!) {
    batchUpdateAppTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateAppTargetingMutationFn = Apollo.MutationFunction<
  UpdateAppTargetingMutation,
  UpdateAppTargetingMutationVariables
>;

/**
 * __useUpdateAppTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateAppTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppTargetingMutation, { data, loading, error }] = useUpdateAppTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAppTargetingMutation, UpdateAppTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAppTargetingMutation, UpdateAppTargetingMutationVariables>(
    UpdateAppTargetingDocument,
    options
  );
}
export type UpdateAppTargetingMutationHookResult = ReturnType<typeof useUpdateAppTargetingMutation>;
export type UpdateAppTargetingMutationResult = Apollo.MutationResult<UpdateAppTargetingMutation>;
export type UpdateAppTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateAppTargetingMutation,
  UpdateAppTargetingMutationVariables
>;
export const CreateBrowserTargetingDocument = gql`
  mutation CreateBrowserTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateBrowserTargetingDto!]!) {
    batchCreateBrowserTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateBrowserTargetingMutationFn = Apollo.MutationFunction<
  CreateBrowserTargetingMutation,
  CreateBrowserTargetingMutationVariables
>;

/**
 * __useCreateBrowserTargetingMutation__
 *
 * To run a mutation, you first call `useCreateBrowserTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrowserTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrowserTargetingMutation, { data, loading, error }] = useCreateBrowserTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBrowserTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateBrowserTargetingMutation, CreateBrowserTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBrowserTargetingMutation, CreateBrowserTargetingMutationVariables>(
    CreateBrowserTargetingDocument,
    options
  );
}
export type CreateBrowserTargetingMutationHookResult = ReturnType<typeof useCreateBrowserTargetingMutation>;
export type CreateBrowserTargetingMutationResult = Apollo.MutationResult<CreateBrowserTargetingMutation>;
export type CreateBrowserTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateBrowserTargetingMutation,
  CreateBrowserTargetingMutationVariables
>;
export const DeleteBrowserTargetingDocument = gql`
  mutation DeleteBrowserTargeting($ids: [BigInt!]!) {
    batchDeleteBrowserTargeting(ids: $ids)
  }
`;
export type DeleteBrowserTargetingMutationFn = Apollo.MutationFunction<
  DeleteBrowserTargetingMutation,
  DeleteBrowserTargetingMutationVariables
>;

/**
 * __useDeleteBrowserTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteBrowserTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrowserTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrowserTargetingMutation, { data, loading, error }] = useDeleteBrowserTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteBrowserTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteBrowserTargetingMutation, DeleteBrowserTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBrowserTargetingMutation, DeleteBrowserTargetingMutationVariables>(
    DeleteBrowserTargetingDocument,
    options
  );
}
export type DeleteBrowserTargetingMutationHookResult = ReturnType<typeof useDeleteBrowserTargetingMutation>;
export type DeleteBrowserTargetingMutationResult = Apollo.MutationResult<DeleteBrowserTargetingMutation>;
export type DeleteBrowserTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteBrowserTargetingMutation,
  DeleteBrowserTargetingMutationVariables
>;
export const UpdateBrowserTargetingDocument = gql`
  mutation UpdateBrowserTargeting($data: [BrowserTargetingBatchUpdateInput!]!) {
    batchUpdateBrowserTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateBrowserTargetingMutationFn = Apollo.MutationFunction<
  UpdateBrowserTargetingMutation,
  UpdateBrowserTargetingMutationVariables
>;

/**
 * __useUpdateBrowserTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateBrowserTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrowserTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrowserTargetingMutation, { data, loading, error }] = useUpdateBrowserTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBrowserTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateBrowserTargetingMutation, UpdateBrowserTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBrowserTargetingMutation, UpdateBrowserTargetingMutationVariables>(
    UpdateBrowserTargetingDocument,
    options
  );
}
export type UpdateBrowserTargetingMutationHookResult = ReturnType<typeof useUpdateBrowserTargetingMutation>;
export type UpdateBrowserTargetingMutationResult = Apollo.MutationResult<UpdateBrowserTargetingMutation>;
export type UpdateBrowserTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateBrowserTargetingMutation,
  UpdateBrowserTargetingMutationVariables
>;
export const CreateBssTargetingDocument = gql`
  mutation CreateBssTargeting(
    $id: BigInt!
    $type: EObjectType!
    $data: [CreateDvBrandSafetySuitabilityTargetingDto!]!
  ) {
    batchCreateDvBrandSafetySuitabilityTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateBssTargetingMutationFn = Apollo.MutationFunction<
  CreateBssTargetingMutation,
  CreateBssTargetingMutationVariables
>;

/**
 * __useCreateBssTargetingMutation__
 *
 * To run a mutation, you first call `useCreateBssTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBssTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBssTargetingMutation, { data, loading, error }] = useCreateBssTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBssTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateBssTargetingMutation, CreateBssTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBssTargetingMutation, CreateBssTargetingMutationVariables>(
    CreateBssTargetingDocument,
    options
  );
}
export type CreateBssTargetingMutationHookResult = ReturnType<typeof useCreateBssTargetingMutation>;
export type CreateBssTargetingMutationResult = Apollo.MutationResult<CreateBssTargetingMutation>;
export type CreateBssTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateBssTargetingMutation,
  CreateBssTargetingMutationVariables
>;
export const DeleteBssTargetingDocument = gql`
  mutation DeleteBssTargeting($ids: [BigInt!]!, $type: EObjectType!, $refId: BigInt!) {
    batchDeleteDvBrandSafetySuitabilityTargeting(ids: $ids, type: $type, refId: $refId)
  }
`;
export type DeleteBssTargetingMutationFn = Apollo.MutationFunction<
  DeleteBssTargetingMutation,
  DeleteBssTargetingMutationVariables
>;

/**
 * __useDeleteBssTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteBssTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBssTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBssTargetingMutation, { data, loading, error }] = useDeleteBssTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useDeleteBssTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteBssTargetingMutation, DeleteBssTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBssTargetingMutation, DeleteBssTargetingMutationVariables>(
    DeleteBssTargetingDocument,
    options
  );
}
export type DeleteBssTargetingMutationHookResult = ReturnType<typeof useDeleteBssTargetingMutation>;
export type DeleteBssTargetingMutationResult = Apollo.MutationResult<DeleteBssTargetingMutation>;
export type DeleteBssTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteBssTargetingMutation,
  DeleteBssTargetingMutationVariables
>;
export const CreateCarrierTargetingDocument = gql`
  mutation CreateCarrierTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateCarrierTargetingDto!]!) {
    batchCreateCarrierTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateCarrierTargetingMutationFn = Apollo.MutationFunction<
  CreateCarrierTargetingMutation,
  CreateCarrierTargetingMutationVariables
>;

/**
 * __useCreateCarrierTargetingMutation__
 *
 * To run a mutation, you first call `useCreateCarrierTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierTargetingMutation, { data, loading, error }] = useCreateCarrierTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCarrierTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCarrierTargetingMutation, CreateCarrierTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCarrierTargetingMutation, CreateCarrierTargetingMutationVariables>(
    CreateCarrierTargetingDocument,
    options
  );
}
export type CreateCarrierTargetingMutationHookResult = ReturnType<typeof useCreateCarrierTargetingMutation>;
export type CreateCarrierTargetingMutationResult = Apollo.MutationResult<CreateCarrierTargetingMutation>;
export type CreateCarrierTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateCarrierTargetingMutation,
  CreateCarrierTargetingMutationVariables
>;
export const DeleteCarrierTargetingDocument = gql`
  mutation DeleteCarrierTargeting($ids: [BigInt!]!) {
    batchDeleteCarrierTargeting(ids: $ids)
  }
`;
export type DeleteCarrierTargetingMutationFn = Apollo.MutationFunction<
  DeleteCarrierTargetingMutation,
  DeleteCarrierTargetingMutationVariables
>;

/**
 * __useDeleteCarrierTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierTargetingMutation, { data, loading, error }] = useDeleteCarrierTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCarrierTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCarrierTargetingMutation, DeleteCarrierTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCarrierTargetingMutation, DeleteCarrierTargetingMutationVariables>(
    DeleteCarrierTargetingDocument,
    options
  );
}
export type DeleteCarrierTargetingMutationHookResult = ReturnType<typeof useDeleteCarrierTargetingMutation>;
export type DeleteCarrierTargetingMutationResult = Apollo.MutationResult<DeleteCarrierTargetingMutation>;
export type DeleteCarrierTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteCarrierTargetingMutation,
  DeleteCarrierTargetingMutationVariables
>;
export const UpdateCarrierTargetingDocument = gql`
  mutation UpdateCarrierTargeting($data: [CarrierTargetingBatchUpdateInput!]!) {
    batchUpdateCarrierTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateCarrierTargetingMutationFn = Apollo.MutationFunction<
  UpdateCarrierTargetingMutation,
  UpdateCarrierTargetingMutationVariables
>;

/**
 * __useUpdateCarrierTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierTargetingMutation, { data, loading, error }] = useUpdateCarrierTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarrierTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCarrierTargetingMutation, UpdateCarrierTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCarrierTargetingMutation, UpdateCarrierTargetingMutationVariables>(
    UpdateCarrierTargetingDocument,
    options
  );
}
export type UpdateCarrierTargetingMutationHookResult = ReturnType<typeof useUpdateCarrierTargetingMutation>;
export type UpdateCarrierTargetingMutationResult = Apollo.MutationResult<UpdateCarrierTargetingMutation>;
export type UpdateCarrierTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateCarrierTargetingMutation,
  UpdateCarrierTargetingMutationVariables
>;
export const CreateCreativeTypeTargetingDocument = gql`
  mutation CreateCreativeTypeTargeting($data: [CreateCreativeTypeTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateCreativeTypeTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateCreativeTypeTargetingMutationFn = Apollo.MutationFunction<
  CreateCreativeTypeTargetingMutation,
  CreateCreativeTypeTargetingMutationVariables
>;

/**
 * __useCreateCreativeTypeTargetingMutation__
 *
 * To run a mutation, you first call `useCreateCreativeTypeTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreativeTypeTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreativeTypeTargetingMutation, { data, loading, error }] = useCreateCreativeTypeTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCreativeTypeTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCreativeTypeTargetingMutation,
    CreateCreativeTypeTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCreativeTypeTargetingMutation, CreateCreativeTypeTargetingMutationVariables>(
    CreateCreativeTypeTargetingDocument,
    options
  );
}
export type CreateCreativeTypeTargetingMutationHookResult = ReturnType<typeof useCreateCreativeTypeTargetingMutation>;
export type CreateCreativeTypeTargetingMutationResult = Apollo.MutationResult<CreateCreativeTypeTargetingMutation>;
export type CreateCreativeTypeTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateCreativeTypeTargetingMutation,
  CreateCreativeTypeTargetingMutationVariables
>;
export const DeleteCreativeTypeTargetingDocument = gql`
  mutation DeleteCreativeTypeTargeting($ids: [BigInt!]!) {
    batchDeleteCreativeTypeTargeting(ids: $ids)
  }
`;
export type DeleteCreativeTypeTargetingMutationFn = Apollo.MutationFunction<
  DeleteCreativeTypeTargetingMutation,
  DeleteCreativeTypeTargetingMutationVariables
>;

/**
 * __useDeleteCreativeTypeTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteCreativeTypeTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreativeTypeTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreativeTypeTargetingMutation, { data, loading, error }] = useDeleteCreativeTypeTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCreativeTypeTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCreativeTypeTargetingMutation,
    DeleteCreativeTypeTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCreativeTypeTargetingMutation, DeleteCreativeTypeTargetingMutationVariables>(
    DeleteCreativeTypeTargetingDocument,
    options
  );
}
export type DeleteCreativeTypeTargetingMutationHookResult = ReturnType<typeof useDeleteCreativeTypeTargetingMutation>;
export type DeleteCreativeTypeTargetingMutationResult = Apollo.MutationResult<DeleteCreativeTypeTargetingMutation>;
export type DeleteCreativeTypeTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteCreativeTypeTargetingMutation,
  DeleteCreativeTypeTargetingMutationVariables
>;
export const UpdateCreativeTypeTargetingDocument = gql`
  mutation UpdateCreativeTypeTargeting($data: [CreativeTypeTargetingBatchUpdateInput!]!) {
    batchUpdateCreativeTypeTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateCreativeTypeTargetingMutationFn = Apollo.MutationFunction<
  UpdateCreativeTypeTargetingMutation,
  UpdateCreativeTypeTargetingMutationVariables
>;

/**
 * __useUpdateCreativeTypeTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeTypeTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeTypeTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeTypeTargetingMutation, { data, loading, error }] = useUpdateCreativeTypeTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCreativeTypeTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCreativeTypeTargetingMutation,
    UpdateCreativeTypeTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCreativeTypeTargetingMutation, UpdateCreativeTypeTargetingMutationVariables>(
    UpdateCreativeTypeTargetingDocument,
    options
  );
}
export type UpdateCreativeTypeTargetingMutationHookResult = ReturnType<typeof useUpdateCreativeTypeTargetingMutation>;
export type UpdateCreativeTypeTargetingMutationResult = Apollo.MutationResult<UpdateCreativeTypeTargetingMutation>;
export type UpdateCreativeTypeTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateCreativeTypeTargetingMutation,
  UpdateCreativeTypeTargetingMutationVariables
>;
export const CreateDealTargetingDocument = gql`
  mutation CreateDealTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateDealTargetingDto!]!) {
    batchCreateDealTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateDealTargetingMutationFn = Apollo.MutationFunction<
  CreateDealTargetingMutation,
  CreateDealTargetingMutationVariables
>;

/**
 * __useCreateDealTargetingMutation__
 *
 * To run a mutation, you first call `useCreateDealTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealTargetingMutation, { data, loading, error }] = useCreateDealTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDealTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDealTargetingMutation, CreateDealTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDealTargetingMutation, CreateDealTargetingMutationVariables>(
    CreateDealTargetingDocument,
    options
  );
}
export type CreateDealTargetingMutationHookResult = ReturnType<typeof useCreateDealTargetingMutation>;
export type CreateDealTargetingMutationResult = Apollo.MutationResult<CreateDealTargetingMutation>;
export type CreateDealTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateDealTargetingMutation,
  CreateDealTargetingMutationVariables
>;
export const DeleteDealTargetingDocument = gql`
  mutation DeleteDealTargeting($ids: [BigInt!]!, $type: EObjectType, $refId: BigInt) {
    batchDeleteDealTargeting(ids: $ids, type: $type, refId: $refId)
  }
`;
export type DeleteDealTargetingMutationFn = Apollo.MutationFunction<
  DeleteDealTargetingMutation,
  DeleteDealTargetingMutationVariables
>;

/**
 * __useDeleteDealTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteDealTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealTargetingMutation, { data, loading, error }] = useDeleteDealTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useDeleteDealTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDealTargetingMutation, DeleteDealTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDealTargetingMutation, DeleteDealTargetingMutationVariables>(
    DeleteDealTargetingDocument,
    options
  );
}
export type DeleteDealTargetingMutationHookResult = ReturnType<typeof useDeleteDealTargetingMutation>;
export type DeleteDealTargetingMutationResult = Apollo.MutationResult<DeleteDealTargetingMutation>;
export type DeleteDealTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteDealTargetingMutation,
  DeleteDealTargetingMutationVariables
>;
export const UpdateDealTargetingDocument = gql`
  mutation UpdateDealTargeting($data: [DealTargetingBatchUpdateInput!]!) {
    batchUpdateDealTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateDealTargetingMutationFn = Apollo.MutationFunction<
  UpdateDealTargetingMutation,
  UpdateDealTargetingMutationVariables
>;

/**
 * __useUpdateDealTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateDealTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealTargetingMutation, { data, loading, error }] = useUpdateDealTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDealTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDealTargetingMutation, UpdateDealTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDealTargetingMutation, UpdateDealTargetingMutationVariables>(
    UpdateDealTargetingDocument,
    options
  );
}
export type UpdateDealTargetingMutationHookResult = ReturnType<typeof useUpdateDealTargetingMutation>;
export type UpdateDealTargetingMutationResult = Apollo.MutationResult<UpdateDealTargetingMutation>;
export type UpdateDealTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateDealTargetingMutation,
  UpdateDealTargetingMutationVariables
>;
export const BatchDeleteDeviceTypesDocument = gql`
  mutation BatchDeleteDeviceTypes($ids: [BigInt!]!, $type: EObjectType, $refid: BigInt) {
    batchDeleteDeviceTypeTargeting(ids: $ids, type: $type, refId: $refid)
  }
`;
export type BatchDeleteDeviceTypesMutationFn = Apollo.MutationFunction<
  BatchDeleteDeviceTypesMutation,
  BatchDeleteDeviceTypesMutationVariables
>;

/**
 * __useBatchDeleteDeviceTypesMutation__
 *
 * To run a mutation, you first call `useBatchDeleteDeviceTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteDeviceTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteDeviceTypesMutation, { data, loading, error }] = useBatchDeleteDeviceTypesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *      refid: // value for 'refid'
 *   },
 * });
 */
export function useBatchDeleteDeviceTypesMutation(
  baseOptions?: Apollo.MutationHookOptions<BatchDeleteDeviceTypesMutation, BatchDeleteDeviceTypesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchDeleteDeviceTypesMutation, BatchDeleteDeviceTypesMutationVariables>(
    BatchDeleteDeviceTypesDocument,
    options
  );
}
export type BatchDeleteDeviceTypesMutationHookResult = ReturnType<typeof useBatchDeleteDeviceTypesMutation>;
export type BatchDeleteDeviceTypesMutationResult = Apollo.MutationResult<BatchDeleteDeviceTypesMutation>;
export type BatchDeleteDeviceTypesMutationOptions = Apollo.BaseMutationOptions<
  BatchDeleteDeviceTypesMutation,
  BatchDeleteDeviceTypesMutationVariables
>;
export const CreateDeviceTypeTargetingDocument = gql`
  mutation CreateDeviceTypeTargeting($data: [CreateDeviceTypeTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateDeviceTypeTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateDeviceTypeTargetingMutationFn = Apollo.MutationFunction<
  CreateDeviceTypeTargetingMutation,
  CreateDeviceTypeTargetingMutationVariables
>;

/**
 * __useCreateDeviceTypeTargetingMutation__
 *
 * To run a mutation, you first call `useCreateDeviceTypeTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceTypeTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceTypeTargetingMutation, { data, loading, error }] = useCreateDeviceTypeTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateDeviceTypeTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeviceTypeTargetingMutation,
    CreateDeviceTypeTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDeviceTypeTargetingMutation, CreateDeviceTypeTargetingMutationVariables>(
    CreateDeviceTypeTargetingDocument,
    options
  );
}
export type CreateDeviceTypeTargetingMutationHookResult = ReturnType<typeof useCreateDeviceTypeTargetingMutation>;
export type CreateDeviceTypeTargetingMutationResult = Apollo.MutationResult<CreateDeviceTypeTargetingMutation>;
export type CreateDeviceTypeTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateDeviceTypeTargetingMutation,
  CreateDeviceTypeTargetingMutationVariables
>;
export const UpdateDeviceTypeTargetingDocument = gql`
  mutation UpdateDeviceTypeTargeting($data: [DeviceTypeTargetingBatchUpdateInput!]!) {
    batchUpdateDeviceTypeTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateDeviceTypeTargetingMutationFn = Apollo.MutationFunction<
  UpdateDeviceTypeTargetingMutation,
  UpdateDeviceTypeTargetingMutationVariables
>;

/**
 * __useUpdateDeviceTypeTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceTypeTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceTypeTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceTypeTargetingMutation, { data, loading, error }] = useUpdateDeviceTypeTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDeviceTypeTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDeviceTypeTargetingMutation,
    UpdateDeviceTypeTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDeviceTypeTargetingMutation, UpdateDeviceTypeTargetingMutationVariables>(
    UpdateDeviceTypeTargetingDocument,
    options
  );
}
export type UpdateDeviceTypeTargetingMutationHookResult = ReturnType<typeof useUpdateDeviceTypeTargetingMutation>;
export type UpdateDeviceTypeTargetingMutationResult = Apollo.MutationResult<UpdateDeviceTypeTargetingMutation>;
export type UpdateDeviceTypeTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateDeviceTypeTargetingMutation,
  UpdateDeviceTypeTargetingMutationVariables
>;
export const CreateDvSegmentTargetingDocument = gql`
  mutation CreateDvSegmentTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateDvViewabilityTargetingDto!]!) {
    batchCreateDvViewabilityTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateDvSegmentTargetingMutationFn = Apollo.MutationFunction<
  CreateDvSegmentTargetingMutation,
  CreateDvSegmentTargetingMutationVariables
>;

/**
 * __useCreateDvSegmentTargetingMutation__
 *
 * To run a mutation, you first call `useCreateDvSegmentTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDvSegmentTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDvSegmentTargetingMutation, { data, loading, error }] = useCreateDvSegmentTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDvSegmentTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDvSegmentTargetingMutation, CreateDvSegmentTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDvSegmentTargetingMutation, CreateDvSegmentTargetingMutationVariables>(
    CreateDvSegmentTargetingDocument,
    options
  );
}
export type CreateDvSegmentTargetingMutationHookResult = ReturnType<typeof useCreateDvSegmentTargetingMutation>;
export type CreateDvSegmentTargetingMutationResult = Apollo.MutationResult<CreateDvSegmentTargetingMutation>;
export type CreateDvSegmentTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateDvSegmentTargetingMutation,
  CreateDvSegmentTargetingMutationVariables
>;
export const CreateFreqCapTargetingDocument = gql`
  mutation CreateFreqCapTargeting($data: [CreateFrequencyTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateFrequencyTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateFreqCapTargetingMutationFn = Apollo.MutationFunction<
  CreateFreqCapTargetingMutation,
  CreateFreqCapTargetingMutationVariables
>;

/**
 * __useCreateFreqCapTargetingMutation__
 *
 * To run a mutation, you first call `useCreateFreqCapTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFreqCapTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFreqCapTargetingMutation, { data, loading, error }] = useCreateFreqCapTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateFreqCapTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFreqCapTargetingMutation, CreateFreqCapTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFreqCapTargetingMutation, CreateFreqCapTargetingMutationVariables>(
    CreateFreqCapTargetingDocument,
    options
  );
}
export type CreateFreqCapTargetingMutationHookResult = ReturnType<typeof useCreateFreqCapTargetingMutation>;
export type CreateFreqCapTargetingMutationResult = Apollo.MutationResult<CreateFreqCapTargetingMutation>;
export type CreateFreqCapTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateFreqCapTargetingMutation,
  CreateFreqCapTargetingMutationVariables
>;
export const CreateGenreTargetingDocument = gql`
  mutation CreateGenreTargeting($data: [CreateGenreTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateGenreTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateGenreTargetingMutationFn = Apollo.MutationFunction<
  CreateGenreTargetingMutation,
  CreateGenreTargetingMutationVariables
>;

/**
 * __useCreateGenreTargetingMutation__
 *
 * To run a mutation, you first call `useCreateGenreTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenreTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenreTargetingMutation, { data, loading, error }] = useCreateGenreTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateGenreTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateGenreTargetingMutation, CreateGenreTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGenreTargetingMutation, CreateGenreTargetingMutationVariables>(
    CreateGenreTargetingDocument,
    options
  );
}
export type CreateGenreTargetingMutationHookResult = ReturnType<typeof useCreateGenreTargetingMutation>;
export type CreateGenreTargetingMutationResult = Apollo.MutationResult<CreateGenreTargetingMutation>;
export type CreateGenreTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateGenreTargetingMutation,
  CreateGenreTargetingMutationVariables
>;
export const CreateCountryTargetingDocument = gql`
  mutation CreateCountryTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateCountryTargetingDto!]!) {
    batchCreateCountryTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateCountryTargetingMutationFn = Apollo.MutationFunction<
  CreateCountryTargetingMutation,
  CreateCountryTargetingMutationVariables
>;

/**
 * __useCreateCountryTargetingMutation__
 *
 * To run a mutation, you first call `useCreateCountryTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCountryTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCountryTargetingMutation, { data, loading, error }] = useCreateCountryTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCountryTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCountryTargetingMutation, CreateCountryTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCountryTargetingMutation, CreateCountryTargetingMutationVariables>(
    CreateCountryTargetingDocument,
    options
  );
}
export type CreateCountryTargetingMutationHookResult = ReturnType<typeof useCreateCountryTargetingMutation>;
export type CreateCountryTargetingMutationResult = Apollo.MutationResult<CreateCountryTargetingMutation>;
export type CreateCountryTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateCountryTargetingMutation,
  CreateCountryTargetingMutationVariables
>;
export const CreateGeoTargetingDocument = gql`
  mutation CreateGeoTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateGeoTargetingDto!]!) {
    batchCreateGeoTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateGeoTargetingMutationFn = Apollo.MutationFunction<
  CreateGeoTargetingMutation,
  CreateGeoTargetingMutationVariables
>;

/**
 * __useCreateGeoTargetingMutation__
 *
 * To run a mutation, you first call `useCreateGeoTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeoTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeoTargetingMutation, { data, loading, error }] = useCreateGeoTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGeoTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateGeoTargetingMutation, CreateGeoTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGeoTargetingMutation, CreateGeoTargetingMutationVariables>(
    CreateGeoTargetingDocument,
    options
  );
}
export type CreateGeoTargetingMutationHookResult = ReturnType<typeof useCreateGeoTargetingMutation>;
export type CreateGeoTargetingMutationResult = Apollo.MutationResult<CreateGeoTargetingMutation>;
export type CreateGeoTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateGeoTargetingMutation,
  CreateGeoTargetingMutationVariables
>;
export const DeleteCountryTargetingDocument = gql`
  mutation DeleteCountryTargeting($ids: [BigInt!]!, $refId: BigInt!, $type: EObjectType!) {
    batchDeleteCountryTargeting(ids: $ids, refId: $refId, type: $type)
  }
`;
export type DeleteCountryTargetingMutationFn = Apollo.MutationFunction<
  DeleteCountryTargetingMutation,
  DeleteCountryTargetingMutationVariables
>;

/**
 * __useDeleteCountryTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteCountryTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCountryTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCountryTargetingMutation, { data, loading, error }] = useDeleteCountryTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      refId: // value for 'refId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteCountryTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCountryTargetingMutation, DeleteCountryTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCountryTargetingMutation, DeleteCountryTargetingMutationVariables>(
    DeleteCountryTargetingDocument,
    options
  );
}
export type DeleteCountryTargetingMutationHookResult = ReturnType<typeof useDeleteCountryTargetingMutation>;
export type DeleteCountryTargetingMutationResult = Apollo.MutationResult<DeleteCountryTargetingMutation>;
export type DeleteCountryTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteCountryTargetingMutation,
  DeleteCountryTargetingMutationVariables
>;
export const DeleteGeoTargetingDocument = gql`
  mutation DeleteGeoTargeting($ids: [BigInt!]!, $refId: BigInt!, $type: EObjectType!) {
    batchDeleteGeoTargeting(ids: $ids, refId: $refId, type: $type)
  }
`;
export type DeleteGeoTargetingMutationFn = Apollo.MutationFunction<
  DeleteGeoTargetingMutation,
  DeleteGeoTargetingMutationVariables
>;

/**
 * __useDeleteGeoTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteGeoTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGeoTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeoTargetingMutation, { data, loading, error }] = useDeleteGeoTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      refId: // value for 'refId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteGeoTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteGeoTargetingMutation, DeleteGeoTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteGeoTargetingMutation, DeleteGeoTargetingMutationVariables>(
    DeleteGeoTargetingDocument,
    options
  );
}
export type DeleteGeoTargetingMutationHookResult = ReturnType<typeof useDeleteGeoTargetingMutation>;
export type DeleteGeoTargetingMutationResult = Apollo.MutationResult<DeleteGeoTargetingMutation>;
export type DeleteGeoTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteGeoTargetingMutation,
  DeleteGeoTargetingMutationVariables
>;
export const UpdateCountryTargetingDocument = gql`
  mutation UpdateCountryTargeting($data: [CountryTargetingBatchUpdateInput!]!) {
    batchUpdateCountryTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateCountryTargetingMutationFn = Apollo.MutationFunction<
  UpdateCountryTargetingMutation,
  UpdateCountryTargetingMutationVariables
>;

/**
 * __useUpdateCountryTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateCountryTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryTargetingMutation, { data, loading, error }] = useUpdateCountryTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCountryTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCountryTargetingMutation, UpdateCountryTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCountryTargetingMutation, UpdateCountryTargetingMutationVariables>(
    UpdateCountryTargetingDocument,
    options
  );
}
export type UpdateCountryTargetingMutationHookResult = ReturnType<typeof useUpdateCountryTargetingMutation>;
export type UpdateCountryTargetingMutationResult = Apollo.MutationResult<UpdateCountryTargetingMutation>;
export type UpdateCountryTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateCountryTargetingMutation,
  UpdateCountryTargetingMutationVariables
>;
export const UpdateGeoTargetingDocument = gql`
  mutation UpdateGeoTargeting($data: [GeoTargetingBatchUpdateInput!]!) {
    batchUpdateGeoTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateGeoTargetingMutationFn = Apollo.MutationFunction<
  UpdateGeoTargetingMutation,
  UpdateGeoTargetingMutationVariables
>;

/**
 * __useUpdateGeoTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateGeoTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeoTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeoTargetingMutation, { data, loading, error }] = useUpdateGeoTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGeoTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateGeoTargetingMutation, UpdateGeoTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateGeoTargetingMutation, UpdateGeoTargetingMutationVariables>(
    UpdateGeoTargetingDocument,
    options
  );
}
export type UpdateGeoTargetingMutationHookResult = ReturnType<typeof useUpdateGeoTargetingMutation>;
export type UpdateGeoTargetingMutationResult = Apollo.MutationResult<UpdateGeoTargetingMutation>;
export type UpdateGeoTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateGeoTargetingMutation,
  UpdateGeoTargetingMutationVariables
>;
export const CreateIabCategoryTargetingDocument = gql`
  mutation CreateIabCategoryTargeting($data: [CreateCategoryTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateCategoryTargeting(data: $data, id: $id, type: $type) {
      id
      categoryId
      exclude
    }
  }
`;
export type CreateIabCategoryTargetingMutationFn = Apollo.MutationFunction<
  CreateIabCategoryTargetingMutation,
  CreateIabCategoryTargetingMutationVariables
>;

/**
 * __useCreateIabCategoryTargetingMutation__
 *
 * To run a mutation, you first call `useCreateIabCategoryTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIabCategoryTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIabCategoryTargetingMutation, { data, loading, error }] = useCreateIabCategoryTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateIabCategoryTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIabCategoryTargetingMutation,
    CreateIabCategoryTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateIabCategoryTargetingMutation, CreateIabCategoryTargetingMutationVariables>(
    CreateIabCategoryTargetingDocument,
    options
  );
}
export type CreateIabCategoryTargetingMutationHookResult = ReturnType<typeof useCreateIabCategoryTargetingMutation>;
export type CreateIabCategoryTargetingMutationResult = Apollo.MutationResult<CreateIabCategoryTargetingMutation>;
export type CreateIabCategoryTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateIabCategoryTargetingMutation,
  CreateIabCategoryTargetingMutationVariables
>;
export const CreateLanguageTargetingDocument = gql`
  mutation CreateLanguageTargeting($data: [CreateLanguageTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateLanguageTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateLanguageTargetingMutationFn = Apollo.MutationFunction<
  CreateLanguageTargetingMutation,
  CreateLanguageTargetingMutationVariables
>;

/**
 * __useCreateLanguageTargetingMutation__
 *
 * To run a mutation, you first call `useCreateLanguageTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLanguageTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLanguageTargetingMutation, { data, loading, error }] = useCreateLanguageTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateLanguageTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateLanguageTargetingMutation, CreateLanguageTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLanguageTargetingMutation, CreateLanguageTargetingMutationVariables>(
    CreateLanguageTargetingDocument,
    options
  );
}
export type CreateLanguageTargetingMutationHookResult = ReturnType<typeof useCreateLanguageTargetingMutation>;
export type CreateLanguageTargetingMutationResult = Apollo.MutationResult<CreateLanguageTargetingMutation>;
export type CreateLanguageTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateLanguageTargetingMutation,
  CreateLanguageTargetingMutationVariables
>;
export const CreateLiveTargetingDocument = gql`
  mutation CreateLiveTargeting($data: [CreateLiveTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateLiveTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateLiveTargetingMutationFn = Apollo.MutationFunction<
  CreateLiveTargetingMutation,
  CreateLiveTargetingMutationVariables
>;

/**
 * __useCreateLiveTargetingMutation__
 *
 * To run a mutation, you first call `useCreateLiveTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveTargetingMutation, { data, loading, error }] = useCreateLiveTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateLiveTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateLiveTargetingMutation, CreateLiveTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLiveTargetingMutation, CreateLiveTargetingMutationVariables>(
    CreateLiveTargetingDocument,
    options
  );
}
export type CreateLiveTargetingMutationHookResult = ReturnType<typeof useCreateLiveTargetingMutation>;
export type CreateLiveTargetingMutationResult = Apollo.MutationResult<CreateLiveTargetingMutation>;
export type CreateLiveTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateLiveTargetingMutation,
  CreateLiveTargetingMutationVariables
>;
export const CreateOsTargetingDocument = gql`
  mutation CreateOsTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateOsTargetingDto!]!) {
    batchCreateOsTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateOsTargetingMutationFn = Apollo.MutationFunction<
  CreateOsTargetingMutation,
  CreateOsTargetingMutationVariables
>;

/**
 * __useCreateOsTargetingMutation__
 *
 * To run a mutation, you first call `useCreateOsTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOsTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOsTargetingMutation, { data, loading, error }] = useCreateOsTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOsTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOsTargetingMutation, CreateOsTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOsTargetingMutation, CreateOsTargetingMutationVariables>(
    CreateOsTargetingDocument,
    options
  );
}
export type CreateOsTargetingMutationHookResult = ReturnType<typeof useCreateOsTargetingMutation>;
export type CreateOsTargetingMutationResult = Apollo.MutationResult<CreateOsTargetingMutation>;
export type CreateOsTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateOsTargetingMutation,
  CreateOsTargetingMutationVariables
>;
export const DeleteOsTargetingDocument = gql`
  mutation DeleteOsTargeting($ids: [BigInt!]!) {
    batchDeleteOsTargeting(ids: $ids)
  }
`;
export type DeleteOsTargetingMutationFn = Apollo.MutationFunction<
  DeleteOsTargetingMutation,
  DeleteOsTargetingMutationVariables
>;

/**
 * __useDeleteOsTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteOsTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOsTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOsTargetingMutation, { data, loading, error }] = useDeleteOsTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteOsTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteOsTargetingMutation, DeleteOsTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteOsTargetingMutation, DeleteOsTargetingMutationVariables>(
    DeleteOsTargetingDocument,
    options
  );
}
export type DeleteOsTargetingMutationHookResult = ReturnType<typeof useDeleteOsTargetingMutation>;
export type DeleteOsTargetingMutationResult = Apollo.MutationResult<DeleteOsTargetingMutation>;
export type DeleteOsTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteOsTargetingMutation,
  DeleteOsTargetingMutationVariables
>;
export const UpdateOsTargetingDocument = gql`
  mutation UpdateOsTargeting($data: [OsTargetingBatchUpdateInput!]!) {
    batchUpdateOsTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateOsTargetingMutationFn = Apollo.MutationFunction<
  UpdateOsTargetingMutation,
  UpdateOsTargetingMutationVariables
>;

/**
 * __useUpdateOsTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateOsTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOsTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOsTargetingMutation, { data, loading, error }] = useUpdateOsTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOsTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOsTargetingMutation, UpdateOsTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOsTargetingMutation, UpdateOsTargetingMutationVariables>(
    UpdateOsTargetingDocument,
    options
  );
}
export type UpdateOsTargetingMutationHookResult = ReturnType<typeof useUpdateOsTargetingMutation>;
export type UpdateOsTargetingMutationResult = Apollo.MutationResult<UpdateOsTargetingMutation>;
export type UpdateOsTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateOsTargetingMutation,
  UpdateOsTargetingMutationVariables
>;
export const BatchDeletePositionTargetingDocument = gql`
  mutation BatchDeletePositionTargeting($ids: [BigInt!]!) {
    batchDeletePositionTargeting(ids: $ids)
  }
`;
export type BatchDeletePositionTargetingMutationFn = Apollo.MutationFunction<
  BatchDeletePositionTargetingMutation,
  BatchDeletePositionTargetingMutationVariables
>;

/**
 * __useBatchDeletePositionTargetingMutation__
 *
 * To run a mutation, you first call `useBatchDeletePositionTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeletePositionTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeletePositionTargetingMutation, { data, loading, error }] = useBatchDeletePositionTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBatchDeletePositionTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchDeletePositionTargetingMutation,
    BatchDeletePositionTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchDeletePositionTargetingMutation, BatchDeletePositionTargetingMutationVariables>(
    BatchDeletePositionTargetingDocument,
    options
  );
}
export type BatchDeletePositionTargetingMutationHookResult = ReturnType<typeof useBatchDeletePositionTargetingMutation>;
export type BatchDeletePositionTargetingMutationResult = Apollo.MutationResult<BatchDeletePositionTargetingMutation>;
export type BatchDeletePositionTargetingMutationOptions = Apollo.BaseMutationOptions<
  BatchDeletePositionTargetingMutation,
  BatchDeletePositionTargetingMutationVariables
>;
export const CreatePlacementTargetingDocument = gql`
  mutation CreatePlacementTargeting($data: [CreatePositionTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreatePositionTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreatePlacementTargetingMutationFn = Apollo.MutationFunction<
  CreatePlacementTargetingMutation,
  CreatePlacementTargetingMutationVariables
>;

/**
 * __useCreatePlacementTargetingMutation__
 *
 * To run a mutation, you first call `useCreatePlacementTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlacementTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlacementTargetingMutation, { data, loading, error }] = useCreatePlacementTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreatePlacementTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePlacementTargetingMutation, CreatePlacementTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePlacementTargetingMutation, CreatePlacementTargetingMutationVariables>(
    CreatePlacementTargetingDocument,
    options
  );
}
export type CreatePlacementTargetingMutationHookResult = ReturnType<typeof useCreatePlacementTargetingMutation>;
export type CreatePlacementTargetingMutationResult = Apollo.MutationResult<CreatePlacementTargetingMutation>;
export type CreatePlacementTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreatePlacementTargetingMutation,
  CreatePlacementTargetingMutationVariables
>;
export const UpdatePlacementTargetingDocument = gql`
  mutation UpdatePlacementTargeting($data: [PositionTargetingBatchUpdateInput!]!) {
    batchUpdatePositionTargeting(data: $data) {
      id
    }
  }
`;
export type UpdatePlacementTargetingMutationFn = Apollo.MutationFunction<
  UpdatePlacementTargetingMutation,
  UpdatePlacementTargetingMutationVariables
>;

/**
 * __useUpdatePlacementTargetingMutation__
 *
 * To run a mutation, you first call `useUpdatePlacementTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlacementTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlacementTargetingMutation, { data, loading, error }] = useUpdatePlacementTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePlacementTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePlacementTargetingMutation, UpdatePlacementTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePlacementTargetingMutation, UpdatePlacementTargetingMutationVariables>(
    UpdatePlacementTargetingDocument,
    options
  );
}
export type UpdatePlacementTargetingMutationHookResult = ReturnType<typeof useUpdatePlacementTargetingMutation>;
export type UpdatePlacementTargetingMutationResult = Apollo.MutationResult<UpdatePlacementTargetingMutation>;
export type UpdatePlacementTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlacementTargetingMutation,
  UpdatePlacementTargetingMutationVariables
>;
export const CreateProductionTargetingDocument = gql`
  mutation CreateProductionTargeting($data: [CreateProductionTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateProductionTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateProductionTargetingMutationFn = Apollo.MutationFunction<
  CreateProductionTargetingMutation,
  CreateProductionTargetingMutationVariables
>;

/**
 * __useCreateProductionTargetingMutation__
 *
 * To run a mutation, you first call `useCreateProductionTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductionTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductionTargetingMutation, { data, loading, error }] = useCreateProductionTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateProductionTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProductionTargetingMutation,
    CreateProductionTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProductionTargetingMutation, CreateProductionTargetingMutationVariables>(
    CreateProductionTargetingDocument,
    options
  );
}
export type CreateProductionTargetingMutationHookResult = ReturnType<typeof useCreateProductionTargetingMutation>;
export type CreateProductionTargetingMutationResult = Apollo.MutationResult<CreateProductionTargetingMutation>;
export type CreateProductionTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateProductionTargetingMutation,
  CreateProductionTargetingMutationVariables
>;
export const CreateRatingTargetingDocument = gql`
  mutation CreateRatingTargeting($data: [CreateRatingTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateRatingTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateRatingTargetingMutationFn = Apollo.MutationFunction<
  CreateRatingTargetingMutation,
  CreateRatingTargetingMutationVariables
>;

/**
 * __useCreateRatingTargetingMutation__
 *
 * To run a mutation, you first call `useCreateRatingTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRatingTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRatingTargetingMutation, { data, loading, error }] = useCreateRatingTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateRatingTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateRatingTargetingMutation, CreateRatingTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRatingTargetingMutation, CreateRatingTargetingMutationVariables>(
    CreateRatingTargetingDocument,
    options
  );
}
export type CreateRatingTargetingMutationHookResult = ReturnType<typeof useCreateRatingTargetingMutation>;
export type CreateRatingTargetingMutationResult = Apollo.MutationResult<CreateRatingTargetingMutation>;
export type CreateRatingTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateRatingTargetingMutation,
  CreateRatingTargetingMutationVariables
>;
export const CreateSiteTargetingDocument = gql`
  mutation CreateSiteTargeting($id: BigInt!, $type: EObjectType!, $data: [CreateSiteTargetingDto!]!) {
    batchCreateSiteTargeting(id: $id, type: $type, data: $data) {
      id
    }
  }
`;
export type CreateSiteTargetingMutationFn = Apollo.MutationFunction<
  CreateSiteTargetingMutation,
  CreateSiteTargetingMutationVariables
>;

/**
 * __useCreateSiteTargetingMutation__
 *
 * To run a mutation, you first call `useCreateSiteTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteTargetingMutation, { data, loading, error }] = useCreateSiteTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSiteTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSiteTargetingMutation, CreateSiteTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSiteTargetingMutation, CreateSiteTargetingMutationVariables>(
    CreateSiteTargetingDocument,
    options
  );
}
export type CreateSiteTargetingMutationHookResult = ReturnType<typeof useCreateSiteTargetingMutation>;
export type CreateSiteTargetingMutationResult = Apollo.MutationResult<CreateSiteTargetingMutation>;
export type CreateSiteTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateSiteTargetingMutation,
  CreateSiteTargetingMutationVariables
>;
export const DeleteSiteTargetingDocument = gql`
  mutation DeleteSiteTargeting($ids: [BigInt!]!, $type: EObjectType, $refId: BigInt) {
    batchDeleteSiteTargeting(ids: $ids, type: $type, refId: $refId)
  }
`;
export type DeleteSiteTargetingMutationFn = Apollo.MutationFunction<
  DeleteSiteTargetingMutation,
  DeleteSiteTargetingMutationVariables
>;

/**
 * __useDeleteSiteTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteSiteTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteTargetingMutation, { data, loading, error }] = useDeleteSiteTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *      refId: // value for 'refId'
 *   },
 * });
 */
export function useDeleteSiteTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSiteTargetingMutation, DeleteSiteTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteSiteTargetingMutation, DeleteSiteTargetingMutationVariables>(
    DeleteSiteTargetingDocument,
    options
  );
}
export type DeleteSiteTargetingMutationHookResult = ReturnType<typeof useDeleteSiteTargetingMutation>;
export type DeleteSiteTargetingMutationResult = Apollo.MutationResult<DeleteSiteTargetingMutation>;
export type DeleteSiteTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteSiteTargetingMutation,
  DeleteSiteTargetingMutationVariables
>;
export const UpdateSiteTargetingDocument = gql`
  mutation UpdateSiteTargeting($data: [SiteTargetingBatchUpdateInput!]!) {
    batchUpdateSiteTargeting(data: $data) {
      id
    }
  }
`;
export type UpdateSiteTargetingMutationFn = Apollo.MutationFunction<
  UpdateSiteTargetingMutation,
  UpdateSiteTargetingMutationVariables
>;

/**
 * __useUpdateSiteTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateSiteTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteTargetingMutation, { data, loading, error }] = useUpdateSiteTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSiteTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSiteTargetingMutation, UpdateSiteTargetingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSiteTargetingMutation, UpdateSiteTargetingMutationVariables>(
    UpdateSiteTargetingDocument,
    options
  );
}
export type UpdateSiteTargetingMutationHookResult = ReturnType<typeof useUpdateSiteTargetingMutation>;
export type UpdateSiteTargetingMutationResult = Apollo.MutationResult<UpdateSiteTargetingMutation>;
export type UpdateSiteTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateSiteTargetingMutation,
  UpdateSiteTargetingMutationVariables
>;
export const SupplyBatchReplaceDocument = gql`
  mutation SupplyBatchReplace($objectType: TargetingObjectTypeEnum!, $objectId: BigInt!, $replace: BatchReplace!) {
    supplyBatchReplace(objectType: $objectType, objectId: $objectId, replace: $replace)
  }
`;
export type SupplyBatchReplaceMutationFn = Apollo.MutationFunction<
  SupplyBatchReplaceMutation,
  SupplyBatchReplaceMutationVariables
>;

/**
 * __useSupplyBatchReplaceMutation__
 *
 * To run a mutation, you first call `useSupplyBatchReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplyBatchReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplyBatchReplaceMutation, { data, loading, error }] = useSupplyBatchReplaceMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      replace: // value for 'replace'
 *   },
 * });
 */
export function useSupplyBatchReplaceMutation(
  baseOptions?: Apollo.MutationHookOptions<SupplyBatchReplaceMutation, SupplyBatchReplaceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SupplyBatchReplaceMutation, SupplyBatchReplaceMutationVariables>(
    SupplyBatchReplaceDocument,
    options
  );
}
export type SupplyBatchReplaceMutationHookResult = ReturnType<typeof useSupplyBatchReplaceMutation>;
export type SupplyBatchReplaceMutationResult = Apollo.MutationResult<SupplyBatchReplaceMutation>;
export type SupplyBatchReplaceMutationOptions = Apollo.BaseMutationOptions<
  SupplyBatchReplaceMutation,
  SupplyBatchReplaceMutationVariables
>;
export const CreateSupplySourceTargetingDocument = gql`
  mutation CreateSupplySourceTargeting($data: CreateSupplyTargetingDto!, $id: BigInt!, $type: EObjectType!) {
    createSupplyTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateSupplySourceTargetingMutationFn = Apollo.MutationFunction<
  CreateSupplySourceTargetingMutation,
  CreateSupplySourceTargetingMutationVariables
>;

/**
 * __useCreateSupplySourceTargetingMutation__
 *
 * To run a mutation, you first call `useCreateSupplySourceTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplySourceTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplySourceTargetingMutation, { data, loading, error }] = useCreateSupplySourceTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateSupplySourceTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSupplySourceTargetingMutation,
    CreateSupplySourceTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSupplySourceTargetingMutation, CreateSupplySourceTargetingMutationVariables>(
    CreateSupplySourceTargetingDocument,
    options
  );
}
export type CreateSupplySourceTargetingMutationHookResult = ReturnType<typeof useCreateSupplySourceTargetingMutation>;
export type CreateSupplySourceTargetingMutationResult = Apollo.MutationResult<CreateSupplySourceTargetingMutation>;
export type CreateSupplySourceTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateSupplySourceTargetingMutation,
  CreateSupplySourceTargetingMutationVariables
>;
export const DeleteSupplySourceTargetingDocument = gql`
  mutation DeleteSupplySourceTargeting($id: BigInt!) {
    deleteSupplyTargeting(id: $id)
  }
`;
export type DeleteSupplySourceTargetingMutationFn = Apollo.MutationFunction<
  DeleteSupplySourceTargetingMutation,
  DeleteSupplySourceTargetingMutationVariables
>;

/**
 * __useDeleteSupplySourceTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteSupplySourceTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplySourceTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplySourceTargetingMutation, { data, loading, error }] = useDeleteSupplySourceTargetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplySourceTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSupplySourceTargetingMutation,
    DeleteSupplySourceTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteSupplySourceTargetingMutation, DeleteSupplySourceTargetingMutationVariables>(
    DeleteSupplySourceTargetingDocument,
    options
  );
}
export type DeleteSupplySourceTargetingMutationHookResult = ReturnType<typeof useDeleteSupplySourceTargetingMutation>;
export type DeleteSupplySourceTargetingMutationResult = Apollo.MutationResult<DeleteSupplySourceTargetingMutation>;
export type DeleteSupplySourceTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteSupplySourceTargetingMutation,
  DeleteSupplySourceTargetingMutationVariables
>;
export const UpdateSupplySourceTargetingDocument = gql`
  mutation UpdateSupplySourceTargeting($data: UpdateSupplyTargetingDto!, $id: BigInt!) {
    updateSupplyTargeting(data: $data, id: $id) {
      id
    }
  }
`;
export type UpdateSupplySourceTargetingMutationFn = Apollo.MutationFunction<
  UpdateSupplySourceTargetingMutation,
  UpdateSupplySourceTargetingMutationVariables
>;

/**
 * __useUpdateSupplySourceTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateSupplySourceTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplySourceTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplySourceTargetingMutation, { data, loading, error }] = useUpdateSupplySourceTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSupplySourceTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSupplySourceTargetingMutation,
    UpdateSupplySourceTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSupplySourceTargetingMutation, UpdateSupplySourceTargetingMutationVariables>(
    UpdateSupplySourceTargetingDocument,
    options
  );
}
export type UpdateSupplySourceTargetingMutationHookResult = ReturnType<typeof useUpdateSupplySourceTargetingMutation>;
export type UpdateSupplySourceTargetingMutationResult = Apollo.MutationResult<UpdateSupplySourceTargetingMutation>;
export type UpdateSupplySourceTargetingMutationOptions = Apollo.BaseMutationOptions<
  UpdateSupplySourceTargetingMutation,
  UpdateSupplySourceTargetingMutationVariables
>;
export const CreateTimePartingTargetingDocument = gql`
  mutation CreateTimePartingTargeting($data: [CreateDayPartTargetingDto!]!, $id: BigInt!, $type: EObjectType!) {
    batchCreateDayPartTargeting(data: $data, id: $id, type: $type) {
      id
    }
  }
`;
export type CreateTimePartingTargetingMutationFn = Apollo.MutationFunction<
  CreateTimePartingTargetingMutation,
  CreateTimePartingTargetingMutationVariables
>;

/**
 * __useCreateTimePartingTargetingMutation__
 *
 * To run a mutation, you first call `useCreateTimePartingTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimePartingTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimePartingTargetingMutation, { data, loading, error }] = useCreateTimePartingTargetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateTimePartingTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTimePartingTargetingMutation,
    CreateTimePartingTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTimePartingTargetingMutation, CreateTimePartingTargetingMutationVariables>(
    CreateTimePartingTargetingDocument,
    options
  );
}
export type CreateTimePartingTargetingMutationHookResult = ReturnType<typeof useCreateTimePartingTargetingMutation>;
export type CreateTimePartingTargetingMutationResult = Apollo.MutationResult<CreateTimePartingTargetingMutation>;
export type CreateTimePartingTargetingMutationOptions = Apollo.BaseMutationOptions<
  CreateTimePartingTargetingMutation,
  CreateTimePartingTargetingMutationVariables
>;
export const DeleteTimePartingTargetingDocument = gql`
  mutation DeleteTimePartingTargeting($ids: [BigInt!]!, $objectID: BigInt!, $type: EObjectType!) {
    batchDeleteDayPartTargeting(ids: $ids, refId: $objectID, type: $type)
  }
`;
export type DeleteTimePartingTargetingMutationFn = Apollo.MutationFunction<
  DeleteTimePartingTargetingMutation,
  DeleteTimePartingTargetingMutationVariables
>;

/**
 * __useDeleteTimePartingTargetingMutation__
 *
 * To run a mutation, you first call `useDeleteTimePartingTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimePartingTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimePartingTargetingMutation, { data, loading, error }] = useDeleteTimePartingTargetingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      objectID: // value for 'objectID'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteTimePartingTargetingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTimePartingTargetingMutation,
    DeleteTimePartingTargetingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTimePartingTargetingMutation, DeleteTimePartingTargetingMutationVariables>(
    DeleteTimePartingTargetingDocument,
    options
  );
}
export type DeleteTimePartingTargetingMutationHookResult = ReturnType<typeof useDeleteTimePartingTargetingMutation>;
export type DeleteTimePartingTargetingMutationResult = Apollo.MutationResult<DeleteTimePartingTargetingMutation>;
export type DeleteTimePartingTargetingMutationOptions = Apollo.BaseMutationOptions<
  DeleteTimePartingTargetingMutation,
  DeleteTimePartingTargetingMutationVariables
>;
export const GetAccountDocument = gql`
  query GetAccount($id: BigInt!) {
    account(id: $id) {
      id
      name
      status
      salesforceId
      rateCard {
        audience {
          tierCpm {
            custom
            premium
            standard
            verified
          }
        }
      }
      currency
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
}
export function useGetAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
}
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountsDocument = gql`
  query GetAccounts {
    accounts {
      nodes {
        id
        name
        status
        salesforceId
        rateCard {
          audience {
            tierCpm {
              custom
              premium
              verified
              standard
            }
            processingMargin {
              thirdParty
            }
          }
        }
        currency
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
}
export function useGetAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
}
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetActorDocument = gql`
  query GetActor {
    actor {
      actorId
      customerId
      emailAddress
      availableCustomers {
        id
        name
        code
        selected
      }
    }
  }
`;

/**
 * __useGetActorQuery__
 *
 * To run a query within a React component, call `useGetActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActorQuery(baseOptions?: Apollo.QueryHookOptions<GetActorQuery, GetActorQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActorQuery, GetActorQueryVariables>(GetActorDocument, options);
}
export function useGetActorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActorQuery, GetActorQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActorQuery, GetActorQueryVariables>(GetActorDocument, options);
}
export type GetActorQueryHookResult = ReturnType<typeof useGetActorQuery>;
export type GetActorLazyQueryHookResult = ReturnType<typeof useGetActorLazyQuery>;
export type GetActorQueryResult = Apollo.QueryResult<GetActorQuery, GetActorQueryVariables>;
export const GetAdvertisersDocument = gql`
  query GetAdvertisers(
    $searchName: String
    $limit: Int
    $offset: Int
    $accountId: BigInt
    $id: BigInt
    $ids: [BigInt!]
    $status: String
    $userIds: [BigInt!]
  ) {
    advertisers(
      searchName: $searchName
      limit: $limit
      offset: $offset
      accountId: $accountId
      id: $id
      ids: $ids
      status: $status
      userIds: $userIds
    ) {
      nodes {
        id
        name
        code
        agencyId
        accountId
        lineItemCurrencies
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAdvertisersQuery__
 *
 * To run a query within a React component, call `useGetAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertisersQuery({
 *   variables: {
 *      searchName: // value for 'searchName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetAdvertisersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAdvertisersQuery, GetAdvertisersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdvertisersQuery, GetAdvertisersQueryVariables>(GetAdvertisersDocument, options);
}
export function useGetAdvertisersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertisersQuery, GetAdvertisersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdvertisersQuery, GetAdvertisersQueryVariables>(GetAdvertisersDocument, options);
}
export type GetAdvertisersQueryHookResult = ReturnType<typeof useGetAdvertisersQuery>;
export type GetAdvertisersLazyQueryHookResult = ReturnType<typeof useGetAdvertisersLazyQuery>;
export type GetAdvertisersQueryResult = Apollo.QueryResult<GetAdvertisersQuery, GetAdvertisersQueryVariables>;
export const GetAgenciesDocument = gql`
  query GetAgencies(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $accountId: BigInt
    $namePrefix: String
    $status: ResourceStatus
    $userIds: [BigInt!]
  ) {
    agencies(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      accountId: $accountId
      namePrefix: $namePrefix
      status: $status
      userIds: $userIds
    ) {
      nodes {
        id
        name
        accountId
        status
        createdAt
        updatedAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAgenciesQuery__
 *
 * To run a query within a React component, call `useGetAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgenciesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      accountId: // value for 'accountId'
 *      namePrefix: // value for 'namePrefix'
 *      status: // value for 'status'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetAgenciesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAgenciesQuery, GetAgenciesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgenciesQuery, GetAgenciesQueryVariables>(GetAgenciesDocument, options);
}
export function useGetAgenciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAgenciesQuery, GetAgenciesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgenciesQuery, GetAgenciesQueryVariables>(GetAgenciesDocument, options);
}
export type GetAgenciesQueryHookResult = ReturnType<typeof useGetAgenciesQuery>;
export type GetAgenciesLazyQueryHookResult = ReturnType<typeof useGetAgenciesLazyQuery>;
export type GetAgenciesQueryResult = Apollo.QueryResult<GetAgenciesQuery, GetAgenciesQueryVariables>;
export const GetAudienceCategoriesDocument = gql`
  query GetAudienceCategories(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $namePrefix: String
    $parentIds: [BigInt!]
    $rootOnly: Boolean
  ) {
    audienceCategories(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      namePrefix: $namePrefix
      parentIds: $parentIds
      rootOnly: $rootOnly
    ) {
      limit
      offset
      totalCount
      nodes {
        id
        name
        parentId
      }
    }
  }
`;

/**
 * __useGetAudienceCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAudienceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *      parentIds: // value for 'parentIds'
 *      rootOnly: // value for 'rootOnly'
 *   },
 * });
 */
export function useGetAudienceCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAudienceCategoriesQuery, GetAudienceCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudienceCategoriesQuery, GetAudienceCategoriesQueryVariables>(
    GetAudienceCategoriesDocument,
    options
  );
}
export function useGetAudienceCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceCategoriesQuery, GetAudienceCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudienceCategoriesQuery, GetAudienceCategoriesQueryVariables>(
    GetAudienceCategoriesDocument,
    options
  );
}
export type GetAudienceCategoriesQueryHookResult = ReturnType<typeof useGetAudienceCategoriesQuery>;
export type GetAudienceCategoriesLazyQueryHookResult = ReturnType<typeof useGetAudienceCategoriesLazyQuery>;
export type GetAudienceCategoriesQueryResult = Apollo.QueryResult<
  GetAudienceCategoriesQuery,
  GetAudienceCategoriesQueryVariables
>;
export const GetAudienceDataProvidersDocument = gql`
  query GetAudienceDataProviders($args: GetAudienceDataProvidersArgsDto!) {
    getAudienceDataProviders(args: $args) {
      nodes {
        dataProvider
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAudienceDataProvidersQuery__
 *
 * To run a query within a React component, call `useGetAudienceDataProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceDataProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceDataProvidersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetAudienceDataProvidersQuery(
  baseOptions: Apollo.QueryHookOptions<GetAudienceDataProvidersQuery, GetAudienceDataProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudienceDataProvidersQuery, GetAudienceDataProvidersQueryVariables>(
    GetAudienceDataProvidersDocument,
    options
  );
}
export function useGetAudienceDataProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceDataProvidersQuery, GetAudienceDataProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudienceDataProvidersQuery, GetAudienceDataProvidersQueryVariables>(
    GetAudienceDataProvidersDocument,
    options
  );
}
export type GetAudienceDataProvidersQueryHookResult = ReturnType<typeof useGetAudienceDataProvidersQuery>;
export type GetAudienceDataProvidersLazyQueryHookResult = ReturnType<typeof useGetAudienceDataProvidersLazyQuery>;
export type GetAudienceDataProvidersQueryResult = Apollo.QueryResult<
  GetAudienceDataProvidersQuery,
  GetAudienceDataProvidersQueryVariables
>;
export const GetAudienceTypesDocument = gql`
  query GetAudienceTypes($limit: Int, $offset: Int, $id: BigInt, $ids: [BigInt!], $namePrefix: String) {
    audienceTypes(limit: $limit, offset: $offset, id: $id, ids: $ids, namePrefix: $namePrefix) {
      limit
      offset
      nodes {
        name
        id
      }
      totalCount
    }
  }
`;

/**
 * __useGetAudienceTypesQuery__
 *
 * To run a query within a React component, call `useGetAudienceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetAudienceTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAudienceTypesQuery, GetAudienceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudienceTypesQuery, GetAudienceTypesQueryVariables>(GetAudienceTypesDocument, options);
}
export function useGetAudienceTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceTypesQuery, GetAudienceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudienceTypesQuery, GetAudienceTypesQueryVariables>(GetAudienceTypesDocument, options);
}
export type GetAudienceTypesQueryHookResult = ReturnType<typeof useGetAudienceTypesQuery>;
export type GetAudienceTypesLazyQueryHookResult = ReturnType<typeof useGetAudienceTypesLazyQuery>;
export type GetAudienceTypesQueryResult = Apollo.QueryResult<GetAudienceTypesQuery, GetAudienceTypesQueryVariables>;
export const GetAudiencesDocument = gql`
  query GetAudiences(
    $limit: Int
    $offset: Int
    $userId: BigInt
    $accountId: BigInt!
    $billing: EAudienceBilling
    $id: BigInt
    $ids: [BigInt!]
    $targetingMethod: [EAudienceType!]
    $namePrefix: String
    $searchString: String
    $withStrategies: Boolean
    $sort: [AudiencesSort!]
    $includePublic: Boolean = false
    $envs: [EAudienceEnvironment!]
    $excludeParentForId: Int
    $countryCodes: [String!]
    $typeIds: [BigInt!]
    $categoryIds: [BigInt!]
    $subCategoryIds: [BigInt!]
    $providers: [EAudienceProvider!]
    $dataProviders: [String!]
    $withChildren: Boolean
    $withEnvs: Boolean
  ) {
    audiences(
      limit: $limit
      offset: $offset
      userId: $userId
      accountId: $accountId
      billing: $billing
      id: $id
      ids: $ids
      targetingMethod: $targetingMethod
      namePrefix: $namePrefix
      searchString: $searchString
      withStrategies: $withStrategies
      sort: $sort
      includePublic: $includePublic
      envs: $envs
      excludeParentForId: $excludeParentForId
      countryCodes: $countryCodes
      typeIds: $typeIds
      categoryIds: $categoryIds
      subCategoryIds: $subCategoryIds
      providers: $providers
      dataProviders: $dataProviders
      withChildren: $withChildren
      withEnvs: $withEnvs
    ) {
      totalCount
      limit
      offset
      nodes {
        accountId
        approxSize
        billing
        categoryId
        subCategoryId
        children {
          id
          childrenClause
          exclude
          children {
            id
            childrenClause
            exclude
            children {
              id
              childrenClause
              exclude
            }
          }
        }
        rawChildren {
          accountId
          approxSize
          billing
          categoryId
          subCategoryId
          countryCode
          cpm
          provider
          dataProvider
          id
          description
          envs
          name
          strategiesCount
          strategyNames
          type
          targetingMethod
          createdAt
          updatedAt
        }
        childrenClause
        countryCode
        country {
          name
        }
        cpm
        provider
        dataProvider
        id
        description
        envs
        name
        strategiesCount
        strategyNames
        type
        targetingMethod
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetAudiencesQuery__
 *
 * To run a query within a React component, call `useGetAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudiencesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *      accountId: // value for 'accountId'
 *      billing: // value for 'billing'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      targetingMethod: // value for 'targetingMethod'
 *      namePrefix: // value for 'namePrefix'
 *      searchString: // value for 'searchString'
 *      withStrategies: // value for 'withStrategies'
 *      sort: // value for 'sort'
 *      includePublic: // value for 'includePublic'
 *      envs: // value for 'envs'
 *      excludeParentForId: // value for 'excludeParentForId'
 *      countryCodes: // value for 'countryCodes'
 *      typeIds: // value for 'typeIds'
 *      categoryIds: // value for 'categoryIds'
 *      subCategoryIds: // value for 'subCategoryIds'
 *      providers: // value for 'providers'
 *      dataProviders: // value for 'dataProviders'
 *      withChildren: // value for 'withChildren'
 *      withEnvs: // value for 'withEnvs'
 *   },
 * });
 */
export function useGetAudiencesQuery(
  baseOptions: Apollo.QueryHookOptions<GetAudiencesQuery, GetAudiencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudiencesQuery, GetAudiencesQueryVariables>(GetAudiencesDocument, options);
}
export function useGetAudiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudiencesQuery, GetAudiencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudiencesQuery, GetAudiencesQueryVariables>(GetAudiencesDocument, options);
}
export type GetAudiencesQueryHookResult = ReturnType<typeof useGetAudiencesQuery>;
export type GetAudiencesLazyQueryHookResult = ReturnType<typeof useGetAudiencesLazyQuery>;
export type GetAudiencesQueryResult = Apollo.QueryResult<GetAudiencesQuery, GetAudiencesQueryVariables>;
export const GetCampaignsDocument = gql`
  query GetCampaigns(
    $ids: [Int!]
    $limit: Int
    $offset: Int
    $searchName: String
    $searchId: Int
    $range: CampaignDateRangeFilter = {}
    $sortBy: CampaignsSortInputDto
    $advertiserIds: [Int!]
    $withCreativesCount: Boolean
  ) {
    campaigns(
      searchIds: $ids
      limit: $limit
      offset: $offset
      searchName: $searchName
      searchId: $searchId
      range: $range
      sortBy: $sortBy
      advertiserIds: $advertiserIds
    ) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        status
        flightPacing
        dailyPacing
        impressions
        clickThroughRate
        clicks
        bids
        wins
        mediaSpend
        cpm
        cpc
        ctr
        vcr
        spentYesterdayCurrency
        spentYesterdayImpression
        amountSpent
        amountToSpend
        budget
        budgetRemaining
        daysLeft
        advertiserId
        currency
        dailyCap
        pacing
        pacingOption
        acop
        kpiId
        kpiGoal
        rateAmount
        rateType
        pacingTracking
        pacingGoal
        type
        startDate
        endDate
        createdAt
        updatedAt
        margin
        managedService
        viewabilityProvider
        idealDailyPacing
        strategies(range: $range, withCreativesCount: $withCreativesCount) {
          ...StrategyFields
        }
      }
    }
  }
  ${StrategyFieldsFragmentDoc}
`;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchName: // value for 'searchName'
 *      searchId: // value for 'searchId'
 *      range: // value for 'range'
 *      sortBy: // value for 'sortBy'
 *      advertiserIds: // value for 'advertiserIds'
 *      withCreativesCount: // value for 'withCreativesCount'
 *   },
 * });
 */
export function useGetCampaignsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
}
export function useGetCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
}
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCampaignsForPerformanceReportsModalDocument = gql`
  query GetCampaignsForPerformanceReportsModal(
    $limit: Int
    $offset: Int
    $searchName: String
    $sortBy: CampaignsSortInputDto
    $searchAdvertiserName: String
    $accountId: Int
    $ids: [Int!]
  ) {
    campaigns(
      limit: $limit
      offset: $offset
      searchName: $searchName
      sortBy: $sortBy
      searchAdvertiserName: $searchAdvertiserName
      accountId: $accountId
      searchIds: $ids
    ) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        status
        currency
        advertiser {
          id
          name
          code
        }
      }
    }
  }
`;

/**
 * __useGetCampaignsForPerformanceReportsModalQuery__
 *
 * To run a query within a React component, call `useGetCampaignsForPerformanceReportsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsForPerformanceReportsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsForPerformanceReportsModalQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchName: // value for 'searchName'
 *      sortBy: // value for 'sortBy'
 *      searchAdvertiserName: // value for 'searchAdvertiserName'
 *      accountId: // value for 'accountId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCampaignsForPerformanceReportsModalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCampaignsForPerformanceReportsModalQuery,
    GetCampaignsForPerformanceReportsModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCampaignsForPerformanceReportsModalQuery,
    GetCampaignsForPerformanceReportsModalQueryVariables
  >(GetCampaignsForPerformanceReportsModalDocument, options);
}
export function useGetCampaignsForPerformanceReportsModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCampaignsForPerformanceReportsModalQuery,
    GetCampaignsForPerformanceReportsModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCampaignsForPerformanceReportsModalQuery,
    GetCampaignsForPerformanceReportsModalQueryVariables
  >(GetCampaignsForPerformanceReportsModalDocument, options);
}
export type GetCampaignsForPerformanceReportsModalQueryHookResult = ReturnType<
  typeof useGetCampaignsForPerformanceReportsModalQuery
>;
export type GetCampaignsForPerformanceReportsModalLazyQueryHookResult = ReturnType<
  typeof useGetCampaignsForPerformanceReportsModalLazyQuery
>;
export type GetCampaignsForPerformanceReportsModalQueryResult = Apollo.QueryResult<
  GetCampaignsForPerformanceReportsModalQuery,
  GetCampaignsForPerformanceReportsModalQueryVariables
>;
export const GetCustomReportFieldCategoriesDocument = gql`
  query GetCustomReportFieldCategories {
    customReportFields {
      label
      value
    }
  }
`;

/**
 * __useGetCustomReportFieldCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCustomReportFieldCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomReportFieldCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomReportFieldCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomReportFieldCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomReportFieldCategoriesQuery,
    GetCustomReportFieldCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomReportFieldCategoriesQuery, GetCustomReportFieldCategoriesQueryVariables>(
    GetCustomReportFieldCategoriesDocument,
    options
  );
}
export function useGetCustomReportFieldCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomReportFieldCategoriesQuery,
    GetCustomReportFieldCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomReportFieldCategoriesQuery, GetCustomReportFieldCategoriesQueryVariables>(
    GetCustomReportFieldCategoriesDocument,
    options
  );
}
export type GetCustomReportFieldCategoriesQueryHookResult = ReturnType<typeof useGetCustomReportFieldCategoriesQuery>;
export type GetCustomReportFieldCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetCustomReportFieldCategoriesLazyQuery
>;
export type GetCustomReportFieldCategoriesQueryResult = Apollo.QueryResult<
  GetCustomReportFieldCategoriesQuery,
  GetCustomReportFieldCategoriesQueryVariables
>;
export const GetDealForEditDocument = gql`
  query GetDealForEdit($search: SearchDealsArgsDto!) {
    deals(search: $search) {
      nodes {
        id
        margin
        endDate
        salesforceId
        bidFloor
        dspDealId
        startDate
        createdAt
        dspIds
        dspSeatId
        updatedAt
        status
        creator
        account {
          id
          name
        }
        auctionType
        status
        name
        bidRequests
        bidRate
        bids
        winRate
        impressions
        revenue
        cpm
        priority
        salesforceId
        supplyDealIds
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDealForEditQuery__
 *
 * To run a query within a React component, call `useGetDealForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealForEditQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDealForEditQuery(
  baseOptions: Apollo.QueryHookOptions<GetDealForEditQuery, GetDealForEditQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealForEditQuery, GetDealForEditQueryVariables>(GetDealForEditDocument, options);
}
export function useGetDealForEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDealForEditQuery, GetDealForEditQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealForEditQuery, GetDealForEditQueryVariables>(GetDealForEditDocument, options);
}
export type GetDealForEditQueryHookResult = ReturnType<typeof useGetDealForEditQuery>;
export type GetDealForEditLazyQueryHookResult = ReturnType<typeof useGetDealForEditLazyQuery>;
export type GetDealForEditQueryResult = Apollo.QueryResult<GetDealForEditQuery, GetDealForEditQueryVariables>;
export const GetDealsSummaryDocument = gql`
  query GetDealsSummary($search: SearchDealsArgsDto!) {
    deals(search: $search) {
      nodes {
        id
        margin
        endDate
        salesforceId
        bidFloor
        dspDealId
        startDate
        createdAt
        dspIds
        dspSeatId
        updatedAt
        status
        creator
        account {
          id
          name
        }
        auctionType
        status
        name
        bidRequests
        bidRate
        bids
        winRate
        impressions
        revenue
        cpm
        priority
        salesforceId
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDealsSummaryQuery__
 *
 * To run a query within a React component, call `useGetDealsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsSummaryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDealsSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<GetDealsSummaryQuery, GetDealsSummaryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealsSummaryQuery, GetDealsSummaryQueryVariables>(GetDealsSummaryDocument, options);
}
export function useGetDealsSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDealsSummaryQuery, GetDealsSummaryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealsSummaryQuery, GetDealsSummaryQueryVariables>(GetDealsSummaryDocument, options);
}
export type GetDealsSummaryQueryHookResult = ReturnType<typeof useGetDealsSummaryQuery>;
export type GetDealsSummaryLazyQueryHookResult = ReturnType<typeof useGetDealsSummaryLazyQuery>;
export type GetDealsSummaryQueryResult = Apollo.QueryResult<GetDealsSummaryQuery, GetDealsSummaryQueryVariables>;
export const GetDsPsDocument = gql`
  query GetDSPs($id: BigInt, $limit: Int = 10, $offset: Int = 0, $status: ResourceStatus, $namePrefix: String) {
    dsp(id: $id, status: $status, limit: $limit, offset: $offset, namePrefix: $namePrefix) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDsPsQuery__
 *
 * To run a query within a React component, call `useGetDsPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDsPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDsPsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetDsPsQuery(baseOptions?: Apollo.QueryHookOptions<GetDsPsQuery, GetDsPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDsPsQuery, GetDsPsQueryVariables>(GetDsPsDocument, options);
}
export function useGetDsPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDsPsQuery, GetDsPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDsPsQuery, GetDsPsQueryVariables>(GetDsPsDocument, options);
}
export type GetDsPsQueryHookResult = ReturnType<typeof useGetDsPsQuery>;
export type GetDsPsLazyQueryHookResult = ReturnType<typeof useGetDsPsLazyQuery>;
export type GetDsPsQueryResult = Apollo.QueryResult<GetDsPsQuery, GetDsPsQueryVariables>;
export const GetGeoAdvertisersDocument = gql`
  query GetGeoAdvertisers($searchName: String, $limit: Int, $offset: Int) {
    advertisersGeo(searchName: $searchName, limit: $limit, offset: $offset) {
      nodes {
        id
        name
        code
        lineItemCurrencies
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetGeoAdvertisersQuery__
 *
 * To run a query within a React component, call `useGetGeoAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeoAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeoAdvertisersQuery({
 *   variables: {
 *      searchName: // value for 'searchName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetGeoAdvertisersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGeoAdvertisersQuery, GetGeoAdvertisersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGeoAdvertisersQuery, GetGeoAdvertisersQueryVariables>(GetGeoAdvertisersDocument, options);
}
export function useGetGeoAdvertisersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGeoAdvertisersQuery, GetGeoAdvertisersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGeoAdvertisersQuery, GetGeoAdvertisersQueryVariables>(
    GetGeoAdvertisersDocument,
    options
  );
}
export type GetGeoAdvertisersQueryHookResult = ReturnType<typeof useGetGeoAdvertisersQuery>;
export type GetGeoAdvertisersLazyQueryHookResult = ReturnType<typeof useGetGeoAdvertisersLazyQuery>;
export type GetGeoAdvertisersQueryResult = Apollo.QueryResult<GetGeoAdvertisersQuery, GetGeoAdvertisersQueryVariables>;
export const GetGeoCampaignsDocument = gql`
  query GetGeoCampaigns($searchCampName: String, $searchAdvName: String, $limit: Int, $offset: Int) {
    campaignsGeo(searchCampName: $searchCampName, searchAdvName: $searchAdvName, limit: $limit, offset: $offset) {
      nodes {
        id
        name
        status
        currency
        advertiser {
          id
          name
          code
          lineItemCurrencies
        }
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetGeoCampaignsQuery__
 *
 * To run a query within a React component, call `useGetGeoCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeoCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeoCampaignsQuery({
 *   variables: {
 *      searchCampName: // value for 'searchCampName'
 *      searchAdvName: // value for 'searchAdvName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetGeoCampaignsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGeoCampaignsQuery, GetGeoCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGeoCampaignsQuery, GetGeoCampaignsQueryVariables>(GetGeoCampaignsDocument, options);
}
export function useGetGeoCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGeoCampaignsQuery, GetGeoCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGeoCampaignsQuery, GetGeoCampaignsQueryVariables>(GetGeoCampaignsDocument, options);
}
export type GetGeoCampaignsQueryHookResult = ReturnType<typeof useGetGeoCampaignsQuery>;
export type GetGeoCampaignsLazyQueryHookResult = ReturnType<typeof useGetGeoCampaignsLazyQuery>;
export type GetGeoCampaignsQueryResult = Apollo.QueryResult<GetGeoCampaignsQuery, GetGeoCampaignsQueryVariables>;
export const GetKpisDocument = gql`
  query GetKpis($limit: Int = 10, $offset: Int = 0, $id: BigInt, $namePrefix: String) {
    kpi(limit: $limit, offset: $offset, id: $id, namePrefix: $namePrefix) {
      nodes {
        id
        name
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetKpisQuery__
 *
 * To run a query within a React component, call `useGetKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpisQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetKpisQuery(baseOptions?: Apollo.QueryHookOptions<GetKpisQuery, GetKpisQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetKpisQuery, GetKpisQueryVariables>(GetKpisDocument, options);
}
export function useGetKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpisQuery, GetKpisQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetKpisQuery, GetKpisQueryVariables>(GetKpisDocument, options);
}
export type GetKpisQueryHookResult = ReturnType<typeof useGetKpisQuery>;
export type GetKpisLazyQueryHookResult = ReturnType<typeof useGetKpisLazyQuery>;
export type GetKpisQueryResult = Apollo.QueryResult<GetKpisQuery, GetKpisQueryVariables>;
export const GetLocationGroupsDocument = gql`
  query GetLocationGroups(
    $limit: Int
    $offset: Int
    $accountId: BigInt
    $id: BigInt
    $ids: [BigInt!]
    $namePrefix: String
    $sort: [LocationGroupsSort!]
    $withPoiCount: Boolean
    $withStrategies: Boolean
  ) {
    locationGroups(
      limit: $limit
      offset: $offset
      accountId: $accountId
      id: $id
      ids: $ids
      namePrefix: $namePrefix
      sort: $sort
      withPoiCount: $withPoiCount
      withStrategies: $withStrategies
    ) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        createdAt
        updatedAt
        poiCount
        strategyCount
        strategyNames
      }
    }
  }
`;

/**
 * __useGetLocationGroupsQuery__
 *
 * To run a query within a React component, call `useGetLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *      sort: // value for 'sort'
 *      withPoiCount: // value for 'withPoiCount'
 *      withStrategies: // value for 'withStrategies'
 *   },
 * });
 */
export function useGetLocationGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>(GetLocationGroupsDocument, options);
}
export function useGetLocationGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>(
    GetLocationGroupsDocument,
    options
  );
}
export type GetLocationGroupsQueryHookResult = ReturnType<typeof useGetLocationGroupsQuery>;
export type GetLocationGroupsLazyQueryHookResult = ReturnType<typeof useGetLocationGroupsLazyQuery>;
export type GetLocationGroupsQueryResult = Apollo.QueryResult<GetLocationGroupsQuery, GetLocationGroupsQueryVariables>;
export const GetPointsOfInterestDocument = gql`
  query GetPointsOfInterest(
    $limit: Int
    $offset: Int
    $brands: [String!]
    $categories: [String!]
    $cityPrefix: String
    $contextLocationGroupId: BigInt
    $countryCodes: [String!]
    $id: BigInt
    $ids: [BigInt!]
    $locationGroupId: BigInt
    $namePrefix: String
    $searchString: String
    $sort: [PointOfInterestSort!]
    $states: [String!]
    $subCategories: [String!]
    $tagPrefix: String
  ) {
    pointsOfInterest(
      limit: $limit
      offset: $offset
      brands: $brands
      categories: $categories
      cityPrefix: $cityPrefix
      contextLocationGroupId: $contextLocationGroupId
      countryCodes: $countryCodes
      id: $id
      ids: $ids
      locationGroupId: $locationGroupId
      namePrefix: $namePrefix
      searchString: $searchString
      sort: $sort
      states: $states
      subcategories: $subCategories
      tagPrefix: $tagPrefix
    ) {
      totalCount
      limit
      offset
      nodes {
        added
        address
        brands
        category
        city
        countryCode
        createdAt
        id
        lat
        long
        name
        state
        status
        subcategory
        tags
        updatedAt
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brands: // value for 'brands'
 *      categories: // value for 'categories'
 *      cityPrefix: // value for 'cityPrefix'
 *      contextLocationGroupId: // value for 'contextLocationGroupId'
 *      countryCodes: // value for 'countryCodes'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      locationGroupId: // value for 'locationGroupId'
 *      namePrefix: // value for 'namePrefix'
 *      searchString: // value for 'searchString'
 *      sort: // value for 'sort'
 *      states: // value for 'states'
 *      subCategories: // value for 'subCategories'
 *      tagPrefix: // value for 'tagPrefix'
 *   },
 * });
 */
export function useGetPointsOfInterestQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPointsOfInterestQuery, GetPointsOfInterestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestQuery, GetPointsOfInterestQueryVariables>(
    GetPointsOfInterestDocument,
    options
  );
}
export function useGetPointsOfInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPointsOfInterestQuery, GetPointsOfInterestQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestQuery, GetPointsOfInterestQueryVariables>(
    GetPointsOfInterestDocument,
    options
  );
}
export type GetPointsOfInterestQueryHookResult = ReturnType<typeof useGetPointsOfInterestQuery>;
export type GetPointsOfInterestLazyQueryHookResult = ReturnType<typeof useGetPointsOfInterestLazyQuery>;
export type GetPointsOfInterestQueryResult = Apollo.QueryResult<
  GetPointsOfInterestQuery,
  GetPointsOfInterestQueryVariables
>;
export const GetPointsOfInterestBrandsDocument = gql`
  query GetPointsOfInterestBrands($limit: Int, $offset: Int, $id: BigInt, $ids: [BigInt!], $namePrefix: String) {
    pointsOfInterestBrands(limit: $limit, offset: $offset, id: $id, ids: $ids, namePrefix: $namePrefix) {
      totalCount
      limit
      offset
      nodes {
        name
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestBrandsQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestBrandsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetPointsOfInterestBrandsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPointsOfInterestBrandsQuery, GetPointsOfInterestBrandsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestBrandsQuery, GetPointsOfInterestBrandsQueryVariables>(
    GetPointsOfInterestBrandsDocument,
    options
  );
}
export function useGetPointsOfInterestBrandsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPointsOfInterestBrandsQuery, GetPointsOfInterestBrandsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestBrandsQuery, GetPointsOfInterestBrandsQueryVariables>(
    GetPointsOfInterestBrandsDocument,
    options
  );
}
export type GetPointsOfInterestBrandsQueryHookResult = ReturnType<typeof useGetPointsOfInterestBrandsQuery>;
export type GetPointsOfInterestBrandsLazyQueryHookResult = ReturnType<typeof useGetPointsOfInterestBrandsLazyQuery>;
export type GetPointsOfInterestBrandsQueryResult = Apollo.QueryResult<
  GetPointsOfInterestBrandsQuery,
  GetPointsOfInterestBrandsQueryVariables
>;
export const GetPointsOfInterestCategoriesDocument = gql`
  query GetPointsOfInterestCategories(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $namePrefix: String
    $countryCodes: [String!]
    $states: [String!]
  ) {
    pointsOfInterestCategories(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      namePrefix: $namePrefix
      countryCodes: $countryCodes
      states: $states
    ) {
      totalCount
      limit
      offset
      nodes {
        name
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *      countryCodes: // value for 'countryCodes'
 *      states: // value for 'states'
 *   },
 * });
 */
export function useGetPointsOfInterestCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPointsOfInterestCategoriesQuery, GetPointsOfInterestCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestCategoriesQuery, GetPointsOfInterestCategoriesQueryVariables>(
    GetPointsOfInterestCategoriesDocument,
    options
  );
}
export function useGetPointsOfInterestCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPointsOfInterestCategoriesQuery,
    GetPointsOfInterestCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestCategoriesQuery, GetPointsOfInterestCategoriesQueryVariables>(
    GetPointsOfInterestCategoriesDocument,
    options
  );
}
export type GetPointsOfInterestCategoriesQueryHookResult = ReturnType<typeof useGetPointsOfInterestCategoriesQuery>;
export type GetPointsOfInterestCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestCategoriesLazyQuery
>;
export type GetPointsOfInterestCategoriesQueryResult = Apollo.QueryResult<
  GetPointsOfInterestCategoriesQuery,
  GetPointsOfInterestCategoriesQueryVariables
>;
export const GetPointsOfInterestCategoriesWithSubCategoriesDocument = gql`
  query GetPointsOfInterestCategoriesWithSubCategories(
    $limit: Int
    $offset: Int
    $countryCodes: [String!]
    $states: [String!]
  ) {
    pointsOfInterestCategoriesWithSubCategories(
      limit: $limit
      offset: $offset
      countryCodes: $countryCodes
      states: $states
    ) {
      totalCount
      limit
      offset
      nodes {
        categoryName
        subCategoryNames
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestCategoriesWithSubCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestCategoriesWithSubCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestCategoriesWithSubCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestCategoriesWithSubCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      countryCodes: // value for 'countryCodes'
 *      states: // value for 'states'
 *   },
 * });
 */
export function useGetPointsOfInterestCategoriesWithSubCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPointsOfInterestCategoriesWithSubCategoriesQuery,
    GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPointsOfInterestCategoriesWithSubCategoriesQuery,
    GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables
  >(GetPointsOfInterestCategoriesWithSubCategoriesDocument, options);
}
export function useGetPointsOfInterestCategoriesWithSubCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPointsOfInterestCategoriesWithSubCategoriesQuery,
    GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPointsOfInterestCategoriesWithSubCategoriesQuery,
    GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables
  >(GetPointsOfInterestCategoriesWithSubCategoriesDocument, options);
}
export type GetPointsOfInterestCategoriesWithSubCategoriesQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestCategoriesWithSubCategoriesQuery
>;
export type GetPointsOfInterestCategoriesWithSubCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestCategoriesWithSubCategoriesLazyQuery
>;
export type GetPointsOfInterestCategoriesWithSubCategoriesQueryResult = Apollo.QueryResult<
  GetPointsOfInterestCategoriesWithSubCategoriesQuery,
  GetPointsOfInterestCategoriesWithSubCategoriesQueryVariables
>;
export const GetPointsOfInterestNameAndLatLongDocument = gql`
  query GetPointsOfInterestNameAndLatLong(
    $limit: Int
    $offset: Int
    $brands: [String!]
    $categories: [String!]
    $cityPrefix: String
    $contextLocationGroupId: BigInt
    $countryCodes: [String!]
    $id: BigInt
    $ids: [BigInt!]
    $locationGroupId: BigInt
    $namePrefix: String
    $searchString: String
    $sort: [PointOfInterestSort!]
    $states: [String!]
    $subCategories: [String!]
    $tagPrefix: String
  ) {
    pointsOfInterest(
      limit: $limit
      offset: $offset
      brands: $brands
      categories: $categories
      cityPrefix: $cityPrefix
      contextLocationGroupId: $contextLocationGroupId
      countryCodes: $countryCodes
      id: $id
      ids: $ids
      locationGroupId: $locationGroupId
      namePrefix: $namePrefix
      searchString: $searchString
      sort: $sort
      states: $states
      subcategories: $subCategories
      tagPrefix: $tagPrefix
    ) {
      totalCount
      limit
      offset
      nodes {
        name
        lat
        long
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestNameAndLatLongQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestNameAndLatLongQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestNameAndLatLongQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestNameAndLatLongQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brands: // value for 'brands'
 *      categories: // value for 'categories'
 *      cityPrefix: // value for 'cityPrefix'
 *      contextLocationGroupId: // value for 'contextLocationGroupId'
 *      countryCodes: // value for 'countryCodes'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      locationGroupId: // value for 'locationGroupId'
 *      namePrefix: // value for 'namePrefix'
 *      searchString: // value for 'searchString'
 *      sort: // value for 'sort'
 *      states: // value for 'states'
 *      subCategories: // value for 'subCategories'
 *      tagPrefix: // value for 'tagPrefix'
 *   },
 * });
 */
export function useGetPointsOfInterestNameAndLatLongQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPointsOfInterestNameAndLatLongQuery,
    GetPointsOfInterestNameAndLatLongQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestNameAndLatLongQuery, GetPointsOfInterestNameAndLatLongQueryVariables>(
    GetPointsOfInterestNameAndLatLongDocument,
    options
  );
}
export function useGetPointsOfInterestNameAndLatLongLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPointsOfInterestNameAndLatLongQuery,
    GetPointsOfInterestNameAndLatLongQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestNameAndLatLongQuery, GetPointsOfInterestNameAndLatLongQueryVariables>(
    GetPointsOfInterestNameAndLatLongDocument,
    options
  );
}
export type GetPointsOfInterestNameAndLatLongQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestNameAndLatLongQuery
>;
export type GetPointsOfInterestNameAndLatLongLazyQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestNameAndLatLongLazyQuery
>;
export type GetPointsOfInterestNameAndLatLongQueryResult = Apollo.QueryResult<
  GetPointsOfInterestNameAndLatLongQuery,
  GetPointsOfInterestNameAndLatLongQueryVariables
>;
export const GetPointsOfInterestIDandNameDocument = gql`
  query GetPointsOfInterestIDandName(
    $limit: Int
    $offset: Int
    $brands: [String!]
    $categories: [String!]
    $cityPrefix: String
    $contextLocationGroupId: BigInt
    $countryCodes: [String!]
    $id: BigInt
    $ids: [BigInt!]
    $locationGroupId: BigInt
    $namePrefix: String
    $searchString: String
    $sort: [PointOfInterestSort!]
    $states: [String!]
    $subCategories: [String!]
    $tagPrefix: String
  ) {
    pointsOfInterest(
      limit: $limit
      offset: $offset
      brands: $brands
      categories: $categories
      cityPrefix: $cityPrefix
      contextLocationGroupId: $contextLocationGroupId
      countryCodes: $countryCodes
      id: $id
      ids: $ids
      locationGroupId: $locationGroupId
      namePrefix: $namePrefix
      searchString: $searchString
      sort: $sort
      states: $states
      subcategories: $subCategories
      tagPrefix: $tagPrefix
    ) {
      totalCount
      limit
      offset
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestIDandNameQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestIDandNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestIDandNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestIDandNameQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      brands: // value for 'brands'
 *      categories: // value for 'categories'
 *      cityPrefix: // value for 'cityPrefix'
 *      contextLocationGroupId: // value for 'contextLocationGroupId'
 *      countryCodes: // value for 'countryCodes'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      locationGroupId: // value for 'locationGroupId'
 *      namePrefix: // value for 'namePrefix'
 *      searchString: // value for 'searchString'
 *      sort: // value for 'sort'
 *      states: // value for 'states'
 *      subCategories: // value for 'subCategories'
 *      tagPrefix: // value for 'tagPrefix'
 *   },
 * });
 */
export function useGetPointsOfInterestIDandNameQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPointsOfInterestIDandNameQuery, GetPointsOfInterestIDandNameQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestIDandNameQuery, GetPointsOfInterestIDandNameQueryVariables>(
    GetPointsOfInterestIDandNameDocument,
    options
  );
}
export function useGetPointsOfInterestIDandNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPointsOfInterestIDandNameQuery,
    GetPointsOfInterestIDandNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestIDandNameQuery, GetPointsOfInterestIDandNameQueryVariables>(
    GetPointsOfInterestIDandNameDocument,
    options
  );
}
export type GetPointsOfInterestIDandNameQueryHookResult = ReturnType<typeof useGetPointsOfInterestIDandNameQuery>;
export type GetPointsOfInterestIDandNameLazyQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestIDandNameLazyQuery
>;
export type GetPointsOfInterestIDandNameQueryResult = Apollo.QueryResult<
  GetPointsOfInterestIDandNameQuery,
  GetPointsOfInterestIDandNameQueryVariables
>;
export const GetPointsOfInterestStatesDocument = gql`
  query GetPointsOfInterestStates(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $namePrefix: String
    $countryCodes: [String!]
  ) {
    pointsOfInterestStates(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      namePrefix: $namePrefix
      countryCodes: $countryCodes
    ) {
      totalCount
      limit
      offset
      nodes {
        name
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestStatesQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestStatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *      countryCodes: // value for 'countryCodes'
 *   },
 * });
 */
export function useGetPointsOfInterestStatesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPointsOfInterestStatesQuery, GetPointsOfInterestStatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestStatesQuery, GetPointsOfInterestStatesQueryVariables>(
    GetPointsOfInterestStatesDocument,
    options
  );
}
export function useGetPointsOfInterestStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPointsOfInterestStatesQuery, GetPointsOfInterestStatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestStatesQuery, GetPointsOfInterestStatesQueryVariables>(
    GetPointsOfInterestStatesDocument,
    options
  );
}
export type GetPointsOfInterestStatesQueryHookResult = ReturnType<typeof useGetPointsOfInterestStatesQuery>;
export type GetPointsOfInterestStatesLazyQueryHookResult = ReturnType<typeof useGetPointsOfInterestStatesLazyQuery>;
export type GetPointsOfInterestStatesQueryResult = Apollo.QueryResult<
  GetPointsOfInterestStatesQuery,
  GetPointsOfInterestStatesQueryVariables
>;
export const GetPointsOfInterestSubCategoriesDocument = gql`
  query GetPointsOfInterestSubCategories(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $categories: [String!]
    $namePrefix: String
  ) {
    pointsOfInterestSubCategories(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      categories: $categories
      namePrefix: $namePrefix
    ) {
      totalCount
      limit
      offset
      nodes {
        name
      }
    }
  }
`;

/**
 * __useGetPointsOfInterestSubCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPointsOfInterestSubCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsOfInterestSubCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsOfInterestSubCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      categories: // value for 'categories'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetPointsOfInterestSubCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPointsOfInterestSubCategoriesQuery,
    GetPointsOfInterestSubCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsOfInterestSubCategoriesQuery, GetPointsOfInterestSubCategoriesQueryVariables>(
    GetPointsOfInterestSubCategoriesDocument,
    options
  );
}
export function useGetPointsOfInterestSubCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPointsOfInterestSubCategoriesQuery,
    GetPointsOfInterestSubCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsOfInterestSubCategoriesQuery, GetPointsOfInterestSubCategoriesQueryVariables>(
    GetPointsOfInterestSubCategoriesDocument,
    options
  );
}
export type GetPointsOfInterestSubCategoriesQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestSubCategoriesQuery
>;
export type GetPointsOfInterestSubCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetPointsOfInterestSubCategoriesLazyQuery
>;
export type GetPointsOfInterestSubCategoriesQueryResult = Apollo.QueryResult<
  GetPointsOfInterestSubCategoriesQuery,
  GetPointsOfInterestSubCategoriesQueryVariables
>;
export const GetPixelMappingsDocument = gql`
  query GetPixelMappings(
    $limit: Int
    $offset: Int
    $accountId: BigInt
    $id: BigInt
    $ids: [BigInt!]
    $pixelIds: [BigInt!]
  ) {
    pixelMappings(limit: $limit, offset: $offset, accountId: $accountId, pixelIds: $pixelIds, id: $id, ids: $ids) {
      totalCount
      limit
      offset
      nodes {
        id
        accountId
        pixelId
        pageUrl
        description
        createdAt
        updatedAt
        events
        lastFire
        pixel {
          id
          name
          advertiserId
          status
          createdAt
        }
      }
    }
  }
`;

/**
 * __useGetPixelMappingsQuery__
 *
 * To run a query within a React component, call `useGetPixelMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPixelMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPixelMappingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      pixelIds: // value for 'pixelIds'
 *   },
 * });
 */
export function useGetPixelMappingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPixelMappingsQuery, GetPixelMappingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPixelMappingsQuery, GetPixelMappingsQueryVariables>(GetPixelMappingsDocument, options);
}
export function useGetPixelMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPixelMappingsQuery, GetPixelMappingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPixelMappingsQuery, GetPixelMappingsQueryVariables>(GetPixelMappingsDocument, options);
}
export type GetPixelMappingsQueryHookResult = ReturnType<typeof useGetPixelMappingsQuery>;
export type GetPixelMappingsLazyQueryHookResult = ReturnType<typeof useGetPixelMappingsLazyQuery>;
export type GetPixelMappingsQueryResult = Apollo.QueryResult<GetPixelMappingsQuery, GetPixelMappingsQueryVariables>;
export const GetPixelsDocument = gql`
  query GetPixels(
    $limit: Int
    $offset: Int
    $accountId: BigInt
    $id: BigInt
    $ids: [BigInt!]
    $namePrefix: String
    $sort: [PixelSort!]
    $mappedSort: [PixelMappedSort!]
    $status: EPixelsStatus
  ) {
    pixels(
      limit: $limit
      offset: $offset
      accountId: $accountId
      id: $id
      ids: $ids
      namePrefix: $namePrefix
      sort: $sort
      mappedSort: $mappedSort
      status: $status
    ) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        advertiserId
        status
        createdAt
        mappedNames
        mappedUrls
        mappedIds
      }
    }
  }
`;

/**
 * __useGetPixelsQuery__
 *
 * To run a query within a React component, call `useGetPixelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPixelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPixelsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      namePrefix: // value for 'namePrefix'
 *      sort: // value for 'sort'
 *      mappedSort: // value for 'mappedSort'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetPixelsQuery(baseOptions?: Apollo.QueryHookOptions<GetPixelsQuery, GetPixelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPixelsQuery, GetPixelsQueryVariables>(GetPixelsDocument, options);
}
export function useGetPixelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPixelsQuery, GetPixelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPixelsQuery, GetPixelsQueryVariables>(GetPixelsDocument, options);
}
export type GetPixelsQueryHookResult = ReturnType<typeof useGetPixelsQuery>;
export type GetPixelsLazyQueryHookResult = ReturnType<typeof useGetPixelsLazyQuery>;
export type GetPixelsQueryResult = Apollo.QueryResult<GetPixelsQuery, GetPixelsQueryVariables>;
export const GetPublisherDocument = gql`
  query GetPublisher($id: Float!) {
    publisher(id: $id) {
      id
      name
      platform
      metadata
    }
  }
`;

/**
 * __useGetPublisherQuery__
 *
 * To run a query within a React component, call `useGetPublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublisherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublisherQuery(
  baseOptions: Apollo.QueryHookOptions<GetPublisherQuery, GetPublisherQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublisherQuery, GetPublisherQueryVariables>(GetPublisherDocument, options);
}
export function useGetPublisherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPublisherQuery, GetPublisherQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublisherQuery, GetPublisherQueryVariables>(GetPublisherDocument, options);
}
export type GetPublisherQueryHookResult = ReturnType<typeof useGetPublisherQuery>;
export type GetPublisherLazyQueryHookResult = ReturnType<typeof useGetPublisherLazyQuery>;
export type GetPublisherQueryResult = Apollo.QueryResult<GetPublisherQuery, GetPublisherQueryVariables>;
export const GetPublishersDocument = gql`
  query GetPublishers($type: PlatformType) {
    publishers(type: $type) {
      id
      name
      platform
      metadata
    }
  }
`;

/**
 * __useGetPublishersQuery__
 *
 * To run a query within a React component, call `useGetPublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishersQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPublishersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPublishersQuery, GetPublishersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublishersQuery, GetPublishersQueryVariables>(GetPublishersDocument, options);
}
export function useGetPublishersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPublishersQuery, GetPublishersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublishersQuery, GetPublishersQueryVariables>(GetPublishersDocument, options);
}
export type GetPublishersQueryHookResult = ReturnType<typeof useGetPublishersQuery>;
export type GetPublishersLazyQueryHookResult = ReturnType<typeof useGetPublishersLazyQuery>;
export type GetPublishersQueryResult = Apollo.QueryResult<GetPublishersQuery, GetPublishersQueryVariables>;
export const GetReportFileDownloadUrlDocument = gql`
  query GetReportFileDownloadUrl($id: Float!) {
    downloadReportFile(id: $id) {
      fileUrl
    }
  }
`;

/**
 * __useGetReportFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportFileDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportFileDownloadUrlQuery, GetReportFileDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportFileDownloadUrlQuery, GetReportFileDownloadUrlQueryVariables>(
    GetReportFileDownloadUrlDocument,
    options
  );
}
export function useGetReportFileDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportFileDownloadUrlQuery, GetReportFileDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportFileDownloadUrlQuery, GetReportFileDownloadUrlQueryVariables>(
    GetReportFileDownloadUrlDocument,
    options
  );
}
export type GetReportFileDownloadUrlQueryHookResult = ReturnType<typeof useGetReportFileDownloadUrlQuery>;
export type GetReportFileDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetReportFileDownloadUrlLazyQuery>;
export type GetReportFileDownloadUrlQueryResult = Apollo.QueryResult<
  GetReportFileDownloadUrlQuery,
  GetReportFileDownloadUrlQueryVariables
>;
export const GetReportFieldsDocument = gql`
  query GetReportFields {
    reportFields {
      label
      value
    }
  }
`;

/**
 * __useGetReportFieldsQuery__
 *
 * To run a query within a React component, call `useGetReportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetReportFieldsQuery, GetReportFieldsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportFieldsQuery, GetReportFieldsQueryVariables>(GetReportFieldsDocument, options);
}
export function useGetReportFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportFieldsQuery, GetReportFieldsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportFieldsQuery, GetReportFieldsQueryVariables>(GetReportFieldsDocument, options);
}
export type GetReportFieldsQueryHookResult = ReturnType<typeof useGetReportFieldsQuery>;
export type GetReportFieldsLazyQueryHookResult = ReturnType<typeof useGetReportFieldsLazyQuery>;
export type GetReportFieldsQueryResult = Apollo.QueryResult<GetReportFieldsQuery, GetReportFieldsQueryVariables>;
export const GetReportsDocument = gql`
  query GetReports(
    $searchName: String
    $startDate: DateTime
    $endDate: DateTime
    $timezone: String
    $accountId: Float
    $limit: Int
    $offset: Int
    $sortBy: ReportColumnsSortingInputDto
    $creator: Float
    $searchId: Int
  ) {
    reports(
      searchName: $searchName
      startDate: $startDate
      endDate: $endDate
      timezone: $timezone
      accountId: $accountId
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      creator: $creator
      searchId: $searchId
    ) {
      nodes {
        id
        reportName
        startDate
        endDate
        timezone
        reportLastUpdated
        reportStatus
        accountId
        advertiserIds
        fields
        lineItemIds
        frequency
        isSendingEmail
        emails
        creator
        metrics
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      searchName: // value for 'searchName'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timezone: // value for 'timezone'
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      creator: // value for 'creator'
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
}
export function useGetReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
}
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const GetStrategiesDocument = gql`
  query GetStrategies(
    $limit: Int
    $offset: Int
    $ids: [BigInt!]
    $campaignIds: [BigInt!]
    $accountId: Int
    $id: BigInt
    $namePrefix: String
    $salesforceId: String
    $status: ERecordEntityStatus
    $sortBy: StrategySortInputDto
    $withCreativesCount: Boolean
  ) {
    strategies(
      limit: $limit
      offset: $offset
      ids: $ids
      campaignIds: $campaignIds
      accountId: $accountId
      id: $id
      namePrefix: $namePrefix
      salesforceId: $salesforceId
      status: $status
      sortBy: $sortBy
      withCreativesCount: $withCreativesCount
    ) {
      nodes {
        ...StrategyFields
      }
      totalCount
      offset
      limit
    }
  }
  ${StrategyFieldsFragmentDoc}
`;

/**
 * __useGetStrategiesQuery__
 *
 * To run a query within a React component, call `useGetStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrategiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ids: // value for 'ids'
 *      campaignIds: // value for 'campaignIds'
 *      accountId: // value for 'accountId'
 *      id: // value for 'id'
 *      namePrefix: // value for 'namePrefix'
 *      salesforceId: // value for 'salesforceId'
 *      status: // value for 'status'
 *      sortBy: // value for 'sortBy'
 *      withCreativesCount: // value for 'withCreativesCount'
 *   },
 * });
 */
export function useGetStrategiesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetStrategiesQuery, GetStrategiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStrategiesQuery, GetStrategiesQueryVariables>(GetStrategiesDocument, options);
}
export function useGetStrategiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStrategiesQuery, GetStrategiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStrategiesQuery, GetStrategiesQueryVariables>(GetStrategiesDocument, options);
}
export type GetStrategiesQueryHookResult = ReturnType<typeof useGetStrategiesQuery>;
export type GetStrategiesLazyQueryHookResult = ReturnType<typeof useGetStrategiesLazyQuery>;
export type GetStrategiesQueryResult = Apollo.QueryResult<GetStrategiesQuery, GetStrategiesQueryVariables>;
export const GetUserDocument = gql`
  query GetUser($id: Float!) {
    user(id: $id) {
      id
      accountId
      email
      firstName
      lastName
      roleId
      status
      lastLogin
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetAdaptCtvTemplatesDocument = gql`
  query GetAdaptCtvTemplates($search: SearchAdaptCtvTemplatesDto!) {
    adaptCtvTemplates(search: $search) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        props {
          ctaCategoryId
          cta
          template
        }
      }
    }
  }
`;

/**
 * __useGetAdaptCtvTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAdaptCtvTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdaptCtvTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdaptCtvTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAdaptCtvTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdaptCtvTemplatesQuery, GetAdaptCtvTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdaptCtvTemplatesQuery, GetAdaptCtvTemplatesQueryVariables>(
    GetAdaptCtvTemplatesDocument,
    options
  );
}
export function useGetAdaptCtvTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdaptCtvTemplatesQuery, GetAdaptCtvTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdaptCtvTemplatesQuery, GetAdaptCtvTemplatesQueryVariables>(
    GetAdaptCtvTemplatesDocument,
    options
  );
}
export type GetAdaptCtvTemplatesQueryHookResult = ReturnType<typeof useGetAdaptCtvTemplatesQuery>;
export type GetAdaptCtvTemplatesLazyQueryHookResult = ReturnType<typeof useGetAdaptCtvTemplatesLazyQuery>;
export type GetAdaptCtvTemplatesQueryResult = Apollo.QueryResult<
  GetAdaptCtvTemplatesQuery,
  GetAdaptCtvTemplatesQueryVariables
>;
export const GetAudiencesChildrenDocument = gql`
  query GetAudiencesChildren($accountId: BigInt!, $ids: [BigInt!], $withChildren: Boolean, $includePublic: Boolean) {
    audiences(accountId: $accountId, ids: $ids, withChildren: $withChildren, includePublic: $includePublic) {
      nodes {
        id
        name
        children {
          exclude
          id
        }
      }
    }
  }
`;

/**
 * __useGetAudiencesChildrenQuery__
 *
 * To run a query within a React component, call `useGetAudiencesChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencesChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudiencesChildrenQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      ids: // value for 'ids'
 *      withChildren: // value for 'withChildren'
 *      includePublic: // value for 'includePublic'
 *   },
 * });
 */
export function useGetAudiencesChildrenQuery(
  baseOptions: Apollo.QueryHookOptions<GetAudiencesChildrenQuery, GetAudiencesChildrenQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudiencesChildrenQuery, GetAudiencesChildrenQueryVariables>(
    GetAudiencesChildrenDocument,
    options
  );
}
export function useGetAudiencesChildrenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudiencesChildrenQuery, GetAudiencesChildrenQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudiencesChildrenQuery, GetAudiencesChildrenQueryVariables>(
    GetAudiencesChildrenDocument,
    options
  );
}
export type GetAudiencesChildrenQueryHookResult = ReturnType<typeof useGetAudiencesChildrenQuery>;
export type GetAudiencesChildrenLazyQueryHookResult = ReturnType<typeof useGetAudiencesChildrenLazyQuery>;
export type GetAudiencesChildrenQueryResult = Apollo.QueryResult<
  GetAudiencesChildrenQuery,
  GetAudiencesChildrenQueryVariables
>;
export const GetAudiencesChildrenDataDocument = gql`
  query GetAudiencesChildrenData($accountId: BigInt!, $ids: [BigInt!], $includePublic: Boolean) {
    audiences(accountId: $accountId, ids: $ids, includePublic: $includePublic) {
      nodes {
        name
        provider
        dataProvider
        id
      }
    }
  }
`;

/**
 * __useGetAudiencesChildrenDataQuery__
 *
 * To run a query within a React component, call `useGetAudiencesChildrenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencesChildrenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudiencesChildrenDataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      ids: // value for 'ids'
 *      includePublic: // value for 'includePublic'
 *   },
 * });
 */
export function useGetAudiencesChildrenDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetAudiencesChildrenDataQuery, GetAudiencesChildrenDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAudiencesChildrenDataQuery, GetAudiencesChildrenDataQueryVariables>(
    GetAudiencesChildrenDataDocument,
    options
  );
}
export function useGetAudiencesChildrenDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAudiencesChildrenDataQuery, GetAudiencesChildrenDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAudiencesChildrenDataQuery, GetAudiencesChildrenDataQueryVariables>(
    GetAudiencesChildrenDataDocument,
    options
  );
}
export type GetAudiencesChildrenDataQueryHookResult = ReturnType<typeof useGetAudiencesChildrenDataQuery>;
export type GetAudiencesChildrenDataLazyQueryHookResult = ReturnType<typeof useGetAudiencesChildrenDataLazyQuery>;
export type GetAudiencesChildrenDataQueryResult = Apollo.QueryResult<
  GetAudiencesChildrenDataQuery,
  GetAudiencesChildrenDataQueryVariables
>;
export const GetCreativeFormatsDocument = gql`
  query GetCreativeFormats($search: SearchCreativeFormatsDto!) {
    creativeFormats(search: $search) {
      limit
      offset
      totalCount
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useGetCreativeFormatsQuery__
 *
 * To run a query within a React component, call `useGetCreativeFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeFormatsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCreativeFormatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreativeFormatsQuery, GetCreativeFormatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreativeFormatsQuery, GetCreativeFormatsQueryVariables>(
    GetCreativeFormatsDocument,
    options
  );
}
export function useGetCreativeFormatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeFormatsQuery, GetCreativeFormatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreativeFormatsQuery, GetCreativeFormatsQueryVariables>(
    GetCreativeFormatsDocument,
    options
  );
}
export type GetCreativeFormatsQueryHookResult = ReturnType<typeof useGetCreativeFormatsQuery>;
export type GetCreativeFormatsLazyQueryHookResult = ReturnType<typeof useGetCreativeFormatsLazyQuery>;
export type GetCreativeFormatsQueryResult = Apollo.QueryResult<
  GetCreativeFormatsQuery,
  GetCreativeFormatsQueryVariables
>;
export const GetCreativesDocument = gql`
  query GetCreatives($search: SearchCreativeDto!) {
    creatives(search: $search) {
      nodes {
        __typename
        ... on NativeCreativeSchema {
          id
          name
          advertiserID
          status
          mimeType
          typeID
          previewURL
          thirdPartyPlacementID
          thirdPartyPlacementName
          createdAt
          updatedAt
          formatId
          account {
            id
            name
          }
          advertiser {
            id
            name
          }
          attributes {
            platform
            main {
              url
              width
              height
            }
            mains {
              url
              width
              height
            }
            logo {
              url
              width
              height
            }
            slides {
              main {
                url
                width
                height
              }
              headline
              caption
              clickThroughLink
              ctaText
            }
            brandName
            headline
            headlines
            caption
            clickThroughLink
            ctaText
            disclosure
            effectCtaName
            effectLogoName
            effectMediaName
            publisherId
            animationName
            animation {
              intro
              load
              attention
            }
            height
            width
            thirdPartyPixelTracking
            thirdPartyTagTracking
            event_trackers {
              event
              method
              url
            }
            video {
              clickThroughLink
              thirdPartyTag
              thirdPartyTagUrl
              thirdPartyPixelTracking
              thirdPartyTagTracking
              media {
                url
                height
                width
                mimeType
              }
              title
              bitRate
              maxBitRate
              minBitRate
              codec
              maintainAspectRatio
              scalable
              durationInSeconds
            }
          }
        }
        ... on BannerCreativeSchema {
          bannerAttributes: attributes {
            media {
              width
              height
              url
            }
            clickThroughLink
            thirdPartyTag
            thirdPartyPixelTracking
            thirdPartyTagTracking
          }
          formatId
          account {
            id
            name
          }
          advertiser {
            id
            name
          }
          id
          name
          advertiserID
          status
          mimeType
          typeID
          previewURL
          thirdPartyPlacementID
          thirdPartyPlacementName
          createdAt
          updatedAt
        }
        ... on AudioCreativeSchema {
          audioAttributes: attributes {
            bitRate
            clickThroughLink
            codec
            durationInSeconds
            maxBitRate
            media {
              url
              mimeType
            }
            minBitRate
            thirdPartyTag
            thirdPartyTagUrl
            thirdPartyPixelTracking
            thirdPartyTagTracking
            title
          }
          formatId
          account {
            id
            name
          }
          advertiser {
            id
            name
          }
          id
          name
          advertiserID
          status
          mimeType
          typeID
          previewURL
          thirdPartyPlacementID
          thirdPartyPlacementName
          createdAt
          updatedAt
        }
        ... on VideoCreativeSchema {
          videoAttributes: attributes {
            bitRate
            clickThroughLink
            codec
            durationInSeconds
            maintainAspectRatio
            maxBitRate
            media {
              url
              width
              height
              mimeType
            }
            minBitRate
            scalable
            thirdPartyTag
            thirdPartyTagUrl
            thirdPartyPixelTracking
            thirdPartyTagTracking
            title
            format
            variantThirdPartyImpTracking
            tagUrlForThirdPartyDSP
          }
          formatId
          account {
            id
            name
          }
          advertiser {
            id
            name
          }
          id
          name
          advertiserID
          status
          mimeType
          typeID
          previewURL
          thirdPartyPlacementID
          thirdPartyPlacementName
          createdAt
          updatedAt
        }
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetCreativesQuery__
 *
 * To run a query within a React component, call `useGetCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCreativesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreativesQuery, GetCreativesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreativesQuery, GetCreativesQueryVariables>(GetCreativesDocument, options);
}
export function useGetCreativesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreativesQuery, GetCreativesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreativesQuery, GetCreativesQueryVariables>(GetCreativesDocument, options);
}
export type GetCreativesQueryHookResult = ReturnType<typeof useGetCreativesQuery>;
export type GetCreativesLazyQueryHookResult = ReturnType<typeof useGetCreativesLazyQuery>;
export type GetCreativesQueryResult = Apollo.QueryResult<GetCreativesQuery, GetCreativesQueryVariables>;
export const GetCtvVideoTemplatesDocument = gql`
  query GetCtvVideoTemplates($search: SearchVideoTemplatesDto!) {
    ctvVideoTemplates(search: $search) {
      totalCount
      limit
      offset
      nodes {
        id
        name
        createdAt
      }
    }
  }
`;

/**
 * __useGetCtvVideoTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCtvVideoTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCtvVideoTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCtvVideoTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCtvVideoTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCtvVideoTemplatesQuery, GetCtvVideoTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCtvVideoTemplatesQuery, GetCtvVideoTemplatesQueryVariables>(
    GetCtvVideoTemplatesDocument,
    options
  );
}
export function useGetCtvVideoTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCtvVideoTemplatesQuery, GetCtvVideoTemplatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCtvVideoTemplatesQuery, GetCtvVideoTemplatesQueryVariables>(
    GetCtvVideoTemplatesDocument,
    options
  );
}
export type GetCtvVideoTemplatesQueryHookResult = ReturnType<typeof useGetCtvVideoTemplatesQuery>;
export type GetCtvVideoTemplatesLazyQueryHookResult = ReturnType<typeof useGetCtvVideoTemplatesLazyQuery>;
export type GetCtvVideoTemplatesQueryResult = Apollo.QueryResult<
  GetCtvVideoTemplatesQuery,
  GetCtvVideoTemplatesQueryVariables
>;
export const GetCtvVideoVariantsDocument = gql`
  query GetCtvVideoVariants($search: SearchCtvVideoVariantsDto!) {
    creativeVideoVariants(search: $search) {
      totalCount
      limit
      offset
      nodes {
        id
        creativeId
        props
        templateId
        status
      }
    }
  }
`;

/**
 * __useGetCtvVideoVariantsQuery__
 *
 * To run a query within a React component, call `useGetCtvVideoVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCtvVideoVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCtvVideoVariantsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCtvVideoVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCtvVideoVariantsQuery, GetCtvVideoVariantsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCtvVideoVariantsQuery, GetCtvVideoVariantsQueryVariables>(
    GetCtvVideoVariantsDocument,
    options
  );
}
export function useGetCtvVideoVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCtvVideoVariantsQuery, GetCtvVideoVariantsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCtvVideoVariantsQuery, GetCtvVideoVariantsQueryVariables>(
    GetCtvVideoVariantsDocument,
    options
  );
}
export type GetCtvVideoVariantsQueryHookResult = ReturnType<typeof useGetCtvVideoVariantsQuery>;
export type GetCtvVideoVariantsLazyQueryHookResult = ReturnType<typeof useGetCtvVideoVariantsLazyQuery>;
export type GetCtvVideoVariantsQueryResult = Apollo.QueryResult<
  GetCtvVideoVariantsQuery,
  GetCtvVideoVariantsQueryVariables
>;
export const GetDcoCreativesDocument = gql`
  query GetDCOCreatives($search: SearchCreativeDto!) {
    creatives(search: $search) {
      nodes {
        __typename
        ... on VideoCreativeSchema {
          videoAttributes: attributes {
            bitRate
            clickThroughLink
            codec
            durationInSeconds
            maintainAspectRatio
            maxBitRate
            media {
              url
              width
              height
              mimeType
            }
            minBitRate
            scalable
            thirdPartyTag
            thirdPartyTagUrl
            thirdPartyPixelTracking
            thirdPartyTagTracking
            title
            format
            variantThirdPartyImpTracking
            tagUrlForThirdPartyDSP
          }
          formatId
          account {
            id
            name
          }
          advertiser {
            id
            name
          }
          id
          name
          advertiserID
          status
          mimeType
          typeID
          previewURL
          thirdPartyPlacementID
          thirdPartyPlacementName
          createdAt
          updatedAt
        }
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetDcoCreativesQuery__
 *
 * To run a query within a React component, call `useGetDcoCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDcoCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDcoCreativesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDcoCreativesQuery(
  baseOptions: Apollo.QueryHookOptions<GetDcoCreativesQuery, GetDcoCreativesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDcoCreativesQuery, GetDcoCreativesQueryVariables>(GetDcoCreativesDocument, options);
}
export function useGetDcoCreativesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDcoCreativesQuery, GetDcoCreativesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDcoCreativesQuery, GetDcoCreativesQueryVariables>(GetDcoCreativesDocument, options);
}
export type GetDcoCreativesQueryHookResult = ReturnType<typeof useGetDcoCreativesQuery>;
export type GetDcoCreativesLazyQueryHookResult = ReturnType<typeof useGetDcoCreativesLazyQuery>;
export type GetDcoCreativesQueryResult = Apollo.QueryResult<GetDcoCreativesQuery, GetDcoCreativesQueryVariables>;
export const GetFreqCapTargetingDocument = gql`
  query GetFreqCapTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
  ) {
    frequencyTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
    ) {
      nodes {
        id
        createdAt
        freqCapPeriod
        freqCapCount
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetFreqCapTargetingQuery__
 *
 * To run a query within a React component, call `useGetFreqCapTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreqCapTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreqCapTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *   },
 * });
 */
export function useGetFreqCapTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFreqCapTargetingQuery, GetFreqCapTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFreqCapTargetingQuery, GetFreqCapTargetingQueryVariables>(
    GetFreqCapTargetingDocument,
    options
  );
}
export function useGetFreqCapTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFreqCapTargetingQuery, GetFreqCapTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFreqCapTargetingQuery, GetFreqCapTargetingQueryVariables>(
    GetFreqCapTargetingDocument,
    options
  );
}
export type GetFreqCapTargetingQueryHookResult = ReturnType<typeof useGetFreqCapTargetingQuery>;
export type GetFreqCapTargetingLazyQueryHookResult = ReturnType<typeof useGetFreqCapTargetingLazyQuery>;
export type GetFreqCapTargetingQueryResult = Apollo.QueryResult<
  GetFreqCapTargetingQuery,
  GetFreqCapTargetingQueryVariables
>;
export const GetSupplySourceTargetingDocument = gql`
  query GetSupplySourceTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
  ) {
    supplyTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
    ) {
      nodes {
        verifiedSupplyOnly
        supplySource
        supplyId
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetSupplySourceTargetingQuery__
 *
 * To run a query within a React component, call `useGetSupplySourceTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplySourceTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplySourceTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *   },
 * });
 */
export function useGetSupplySourceTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupplySourceTargetingQuery, GetSupplySourceTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupplySourceTargetingQuery, GetSupplySourceTargetingQueryVariables>(
    GetSupplySourceTargetingDocument,
    options
  );
}
export function useGetSupplySourceTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupplySourceTargetingQuery, GetSupplySourceTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupplySourceTargetingQuery, GetSupplySourceTargetingQueryVariables>(
    GetSupplySourceTargetingDocument,
    options
  );
}
export type GetSupplySourceTargetingQueryHookResult = ReturnType<typeof useGetSupplySourceTargetingQuery>;
export type GetSupplySourceTargetingLazyQueryHookResult = ReturnType<typeof useGetSupplySourceTargetingLazyQuery>;
export type GetSupplySourceTargetingQueryResult = Apollo.QueryResult<
  GetSupplySourceTargetingQuery,
  GetSupplySourceTargetingQueryVariables
>;
export const GetTargetingAudiencesDocument = gql`
  query GetTargetingAudiences($id: BigInt!, $type: String!, $limit: Int, $offset: Int, $accountId: BigInt!) {
    targetingAudiences(id: $id, type: $type, limit: $limit, offset: $offset, accountId: $accountId) {
      limit
      offset
      nodes {
        id
        audienceId
        exclude
        referenceObjectId
        audience {
          id
          name
        }
      }
      totalCount
    }
  }
`;

/**
 * __useGetTargetingAudiencesQuery__
 *
 * To run a query within a React component, call `useGetTargetingAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetingAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetingAudiencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetTargetingAudiencesQuery(
  baseOptions: Apollo.QueryHookOptions<GetTargetingAudiencesQuery, GetTargetingAudiencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTargetingAudiencesQuery, GetTargetingAudiencesQueryVariables>(
    GetTargetingAudiencesDocument,
    options
  );
}
export function useGetTargetingAudiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTargetingAudiencesQuery, GetTargetingAudiencesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTargetingAudiencesQuery, GetTargetingAudiencesQueryVariables>(
    GetTargetingAudiencesDocument,
    options
  );
}
export type GetTargetingAudiencesQueryHookResult = ReturnType<typeof useGetTargetingAudiencesQuery>;
export type GetTargetingAudiencesLazyQueryHookResult = ReturnType<typeof useGetTargetingAudiencesLazyQuery>;
export type GetTargetingAudiencesQueryResult = Apollo.QueryResult<
  GetTargetingAudiencesQuery,
  GetTargetingAudiencesQueryVariables
>;
export const GetTargetingPoiDocument = gql`
  query GetTargetingPoi(
    $referenceObjectID: BigInt!
    $referenceObjectType: EObjectType!
    $limit: Int
    $offset: Int
    $type: EPoiType!
  ) {
    poi(
      referenceObjectID: $referenceObjectID
      referenceObjectType: $referenceObjectType
      limit: $limit
      offset: $offset
      type: $type
    ) {
      limit
      offset
      totalCount
      nodes {
        id
        referenceObjectId
        referenceObjectType
        customLat
        customLong
        minRadius
        maxRadius
        locationGroupId
      }
    }
  }
`;

/**
 * __useGetTargetingPoiQuery__
 *
 * To run a query within a React component, call `useGetTargetingPoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetingPoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetingPoiQuery({
 *   variables: {
 *      referenceObjectID: // value for 'referenceObjectID'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTargetingPoiQuery(
  baseOptions: Apollo.QueryHookOptions<GetTargetingPoiQuery, GetTargetingPoiQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTargetingPoiQuery, GetTargetingPoiQueryVariables>(GetTargetingPoiDocument, options);
}
export function useGetTargetingPoiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTargetingPoiQuery, GetTargetingPoiQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTargetingPoiQuery, GetTargetingPoiQueryVariables>(GetTargetingPoiDocument, options);
}
export type GetTargetingPoiQueryHookResult = ReturnType<typeof useGetTargetingPoiQuery>;
export type GetTargetingPoiLazyQueryHookResult = ReturnType<typeof useGetTargetingPoiLazyQuery>;
export type GetTargetingPoiQueryResult = Apollo.QueryResult<GetTargetingPoiQuery, GetTargetingPoiQueryVariables>;
export const GetAbsTargetingDocument = gql`
  query GetAbsTargeting(
    $limit: Int
    $offset: Int
    $id: BigInt
    $exclude: Boolean
    $ids: [BigInt!]
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $switcherRecord: Boolean
  ) {
    dvAuthenticBrandSuitabilityTargeting(
      limit: $limit
      offset: $offset
      id: $id
      exclude: $exclude
      ids: $ids
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      switcherRecord: $switcherRecord
    ) {
      nodes {
        id
        dvSegmentCode
        exclude
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAbsTargetingQuery__
 *
 * To run a query within a React component, call `useGetAbsTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbsTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbsTargetingQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      exclude: // value for 'exclude'
 *      ids: // value for 'ids'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      switcherRecord: // value for 'switcherRecord'
 *   },
 * });
 */
export function useGetAbsTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAbsTargetingQuery, GetAbsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAbsTargetingQuery, GetAbsTargetingQueryVariables>(GetAbsTargetingDocument, options);
}
export function useGetAbsTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAbsTargetingQuery, GetAbsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAbsTargetingQuery, GetAbsTargetingQueryVariables>(GetAbsTargetingDocument, options);
}
export type GetAbsTargetingQueryHookResult = ReturnType<typeof useGetAbsTargetingQuery>;
export type GetAbsTargetingLazyQueryHookResult = ReturnType<typeof useGetAbsTargetingLazyQuery>;
export type GetAbsTargetingQueryResult = Apollo.QueryResult<GetAbsTargetingQuery, GetAbsTargetingQueryVariables>;
export const GetAppCategoriesDocument = gql`
  query GetAppCategories($limit: Int, $offset: Int, $namePrefix: String) {
    appCategory(limit: $limit, offset: $offset, categoryNamePrefix: $namePrefix) {
      nodes {
        id
        categoryName
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetAppCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAppCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetAppCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAppCategoriesQuery, GetAppCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppCategoriesQuery, GetAppCategoriesQueryVariables>(GetAppCategoriesDocument, options);
}
export function useGetAppCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppCategoriesQuery, GetAppCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppCategoriesQuery, GetAppCategoriesQueryVariables>(GetAppCategoriesDocument, options);
}
export type GetAppCategoriesQueryHookResult = ReturnType<typeof useGetAppCategoriesQuery>;
export type GetAppCategoriesLazyQueryHookResult = ReturnType<typeof useGetAppCategoriesLazyQuery>;
export type GetAppCategoriesQueryResult = Apollo.QueryResult<GetAppCategoriesQuery, GetAppCategoriesQueryVariables>;
export const GetAppCategoriesTargetingDocument = gql`
  query GetAppCategoriesTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    appCategoryTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        categoryId
        exclude
        id
        appCategory {
          categoryName
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetAppCategoriesTargetingQuery__
 *
 * To run a query within a React component, call `useGetAppCategoriesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppCategoriesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppCategoriesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetAppCategoriesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAppCategoriesTargetingQuery, GetAppCategoriesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppCategoriesTargetingQuery, GetAppCategoriesTargetingQueryVariables>(
    GetAppCategoriesTargetingDocument,
    options
  );
}
export function useGetAppCategoriesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppCategoriesTargetingQuery, GetAppCategoriesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppCategoriesTargetingQuery, GetAppCategoriesTargetingQueryVariables>(
    GetAppCategoriesTargetingDocument,
    options
  );
}
export type GetAppCategoriesTargetingQueryHookResult = ReturnType<typeof useGetAppCategoriesTargetingQuery>;
export type GetAppCategoriesTargetingLazyQueryHookResult = ReturnType<typeof useGetAppCategoriesTargetingLazyQuery>;
export type GetAppCategoriesTargetingQueryResult = Apollo.QueryResult<
  GetAppCategoriesTargetingQuery,
  GetAppCategoriesTargetingQueryVariables
>;
export const GetAppsDocument = gql`
  query GetApps(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $status: ResourceStatus
    $bundleIdPrefix: String
    $bundle_ids: [String!]
    $domainPrefix: String
  ) {
    app(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      status: $status
      bundleIdPrefix: $bundleIdPrefix
      bundle_ids: $bundle_ids
      domainPrefix: $domainPrefix
    ) {
      nodes {
        id
        status
        bundleId
        domain
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAppsQuery__
 *
 * To run a query within a React component, call `useGetAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      bundleIdPrefix: // value for 'bundleIdPrefix'
 *      bundle_ids: // value for 'bundle_ids'
 *      domainPrefix: // value for 'domainPrefix'
 *   },
 * });
 */
export function useGetAppsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppsQuery, GetAppsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument, options);
}
export function useGetAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppsQuery, GetAppsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument, options);
}
export type GetAppsQueryHookResult = ReturnType<typeof useGetAppsQuery>;
export type GetAppsLazyQueryHookResult = ReturnType<typeof useGetAppsLazyQuery>;
export type GetAppsQueryResult = Apollo.QueryResult<GetAppsQuery, GetAppsQueryVariables>;
export const GetAppTargetingDocument = gql`
  query GetAppTargeting(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $exclude: Boolean
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $switcherRecord: Boolean
  ) {
    appTargeting(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      exclude: $exclude
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      switcherRecord: $switcherRecord
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        bundleId
        exclude
        switcherRecord
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetAppTargetingQuery__
 *
 * To run a query within a React component, call `useGetAppTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppTargetingQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      exclude: // value for 'exclude'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      switcherRecord: // value for 'switcherRecord'
 *   },
 * });
 */
export function useGetAppTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAppTargetingQuery, GetAppTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppTargetingQuery, GetAppTargetingQueryVariables>(GetAppTargetingDocument, options);
}
export function useGetAppTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppTargetingQuery, GetAppTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppTargetingQuery, GetAppTargetingQueryVariables>(GetAppTargetingDocument, options);
}
export type GetAppTargetingQueryHookResult = ReturnType<typeof useGetAppTargetingQuery>;
export type GetAppTargetingLazyQueryHookResult = ReturnType<typeof useGetAppTargetingLazyQuery>;
export type GetAppTargetingQueryResult = Apollo.QueryResult<GetAppTargetingQuery, GetAppTargetingQueryVariables>;
export const GetBrowserTargetingDocument = gql`
  query GetBrowserTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    browserTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        browserId
        exclude
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetBrowserTargetingQuery__
 *
 * To run a query within a React component, call `useGetBrowserTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrowserTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrowserTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetBrowserTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBrowserTargetingQuery, GetBrowserTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBrowserTargetingQuery, GetBrowserTargetingQueryVariables>(
    GetBrowserTargetingDocument,
    options
  );
}
export function useGetBrowserTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBrowserTargetingQuery, GetBrowserTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBrowserTargetingQuery, GetBrowserTargetingQueryVariables>(
    GetBrowserTargetingDocument,
    options
  );
}
export type GetBrowserTargetingQueryHookResult = ReturnType<typeof useGetBrowserTargetingQuery>;
export type GetBrowserTargetingLazyQueryHookResult = ReturnType<typeof useGetBrowserTargetingLazyQuery>;
export type GetBrowserTargetingQueryResult = Apollo.QueryResult<
  GetBrowserTargetingQuery,
  GetBrowserTargetingQueryVariables
>;
export const GetBrowsersDocument = gql`
  query GetBrowsers($limit: Int, $offset: Int, $id: BigInt, $namePrefix: String, $status: ResourceStatus) {
    browser(limit: $limit, offset: $offset, id: $id, namePrefix: $namePrefix, status: $status) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetBrowsersQuery__
 *
 * To run a query within a React component, call `useGetBrowsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrowsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrowsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      namePrefix: // value for 'namePrefix'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBrowsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBrowsersQuery, GetBrowsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBrowsersQuery, GetBrowsersQueryVariables>(GetBrowsersDocument, options);
}
export function useGetBrowsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBrowsersQuery, GetBrowsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBrowsersQuery, GetBrowsersQueryVariables>(GetBrowsersDocument, options);
}
export type GetBrowsersQueryHookResult = ReturnType<typeof useGetBrowsersQuery>;
export type GetBrowsersLazyQueryHookResult = ReturnType<typeof useGetBrowsersLazyQuery>;
export type GetBrowsersQueryResult = Apollo.QueryResult<GetBrowsersQuery, GetBrowsersQueryVariables>;
export const GetBssTargetingDocument = gql`
  query GetBssTargeting(
    $limit: Int
    $offset: Int
    $id: BigInt
    $exclude: Boolean
    $ids: [BigInt!]
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $switcherRecord: Boolean
  ) {
    dvBrandSafetySuitabilityTargeting(
      limit: $limit
      offset: $offset
      id: $id
      exclude: $exclude
      ids: $ids
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      switcherRecord: $switcherRecord
    ) {
      nodes {
        createdAt
        id
        exclude
        dvSegmentId
        dvSegment {
          id
          name
          product
        }
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetBssTargetingQuery__
 *
 * To run a query within a React component, call `useGetBssTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBssTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBssTargetingQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      exclude: // value for 'exclude'
 *      ids: // value for 'ids'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      switcherRecord: // value for 'switcherRecord'
 *   },
 * });
 */
export function useGetBssTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBssTargetingQuery, GetBssTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBssTargetingQuery, GetBssTargetingQueryVariables>(GetBssTargetingDocument, options);
}
export function useGetBssTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBssTargetingQuery, GetBssTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBssTargetingQuery, GetBssTargetingQueryVariables>(GetBssTargetingDocument, options);
}
export type GetBssTargetingQueryHookResult = ReturnType<typeof useGetBssTargetingQuery>;
export type GetBssTargetingLazyQueryHookResult = ReturnType<typeof useGetBssTargetingLazyQuery>;
export type GetBssTargetingQueryResult = Apollo.QueryResult<GetBssTargetingQuery, GetBssTargetingQueryVariables>;
export const DealBulkTargetingDocument = gql`
  query DealBulkTargeting($data: DealsTargetingBulkDto!) {
    dealBulkTargeting(data: $data) {
      app {
        id
        referenceObjectId
        exclude
        bundleId
        switcherRecord
        createdAt
      }
      audience {
        id
        exclude
        referenceObjectId
        audience {
          id
          name
        }
        audienceId
      }
      browser {
        id
        referenceObjectId
        exclude
        browserId
      }
      carrier {
        id
        exclude
        referenceObjectId
        carrier
        createdAt
      }
      category {
        id
        categoryId
        exclude
        referenceObjectId
        createdAt
      }
      country {
        id
        referenceObjectId
        exclude
        country {
          name
          status
          code
          createdAt
        }
        countryCode
      }
      dayPart {
        id
        exclude
        referenceObjectId
        startHour
        endHour
        createdAt
      }
      deal {
        id
        referenceObjectId
        exclude
        inventoryDealId
        createdAt
      }
      deviceModel {
        id
        deviceModelId
        referenceObjectId
        exclude
        createdAt
      }
      deviceType {
        id
        referenceObjectId
        exclude
        deviceTypeId
        createdAt
      }
      creativeType {
        referenceObjectId
        creativeAttribute
        creativeAttributeValue
        creativeTypeId
        createdAt
        exclude
        id
      }
      dvAuthenticBrand {
        id
        dvSegmentCode
        referenceObjectId
        exclude
        createdAt
      }
      dvBrandSafety {
        id
        dvSegmentId
        dvSegment {
          id
          name
        }
        referenceObjectId
        exclude
        createdAt
      }
      dvViewability {
        id
        dvSegmentId
        dvSegment {
          id
          name
        }
        exclude
        referenceObjectId
        createdAt
      }
      frequency {
        id
        freqCapCount
        freqCapPeriod
        referenceObjectId
        createdAt
      }
      genre {
        id
        genreId
        genere {
          id
          name
          status
        }
        exclude
        referenceObjectId
        createdAt
      }
      geo {
        id
        referenceObjectId
        geoId
        state {
          name
          countryCode
          stateCode
        }
        city {
          name
          stateCode
          countryCode
        }
        metro {
          name
          countryCode
          code
        }
        postalCode {
          code
        }
        type
        exclude
        createdAt
      }
      language {
        id
        referenceObjectId
        exclude
        languageId
        language {
          name
        }
      }
      live {
        id
        referenceObjectId
        exclude
        live
      }
      os {
        id
        referenceObjectId
        exclude
        osId
      }
      poi {
        id
        referenceObjectId
        customLat
        customLong
        minRadius
        maxRadius
        locationGroupId
      }
      position {
        id
        referenceObjectId
        exclude
        position
      }
      production {
        id
        referenceObjectId
        exclude
        production
      }
      rating {
        id
        referenceObjectId
        exclude
        ratingId
        rating {
          name
        }
      }
      segment {
        id
        referenceObjectId
        exclude
        segmentId
        type
      }
      site {
        id
        referenceObjectId
        exclude
        domain
        switcherRecord
      }
      supply {
        id
        referenceObjectId
        supplyId
        exclude
        verifiedSupplyOnly
        supplySource
      }
    }
  }
`;

/**
 * __useDealBulkTargetingQuery__
 *
 * To run a query within a React component, call `useDealBulkTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealBulkTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealBulkTargetingQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDealBulkTargetingQuery(
  baseOptions: Apollo.QueryHookOptions<DealBulkTargetingQuery, DealBulkTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DealBulkTargetingQuery, DealBulkTargetingQueryVariables>(DealBulkTargetingDocument, options);
}
export function useDealBulkTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DealBulkTargetingQuery, DealBulkTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DealBulkTargetingQuery, DealBulkTargetingQueryVariables>(
    DealBulkTargetingDocument,
    options
  );
}
export type DealBulkTargetingQueryHookResult = ReturnType<typeof useDealBulkTargetingQuery>;
export type DealBulkTargetingLazyQueryHookResult = ReturnType<typeof useDealBulkTargetingLazyQuery>;
export type DealBulkTargetingQueryResult = Apollo.QueryResult<DealBulkTargetingQuery, DealBulkTargetingQueryVariables>;
export const GetCarriesDocument = gql`
  query GetCarries($id: BigInt, $namePrefix: String, $status: ResourceStatus, $limit: Int, $offset: Int) {
    carrier(id: $id, namePrefix: $namePrefix, status: $status, limit: $limit, offset: $offset) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetCarriesQuery__
 *
 * To run a query within a React component, call `useGetCarriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      namePrefix: // value for 'namePrefix'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCarriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCarriesQuery, GetCarriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarriesQuery, GetCarriesQueryVariables>(GetCarriesDocument, options);
}
export function useGetCarriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCarriesQuery, GetCarriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarriesQuery, GetCarriesQueryVariables>(GetCarriesDocument, options);
}
export type GetCarriesQueryHookResult = ReturnType<typeof useGetCarriesQuery>;
export type GetCarriesLazyQueryHookResult = ReturnType<typeof useGetCarriesLazyQuery>;
export type GetCarriesQueryResult = Apollo.QueryResult<GetCarriesQuery, GetCarriesQueryVariables>;
export const GetCarriersTargetingDocument = gql`
  query GetCarriersTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    carrierTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        carrier
        exclude
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetCarriersTargetingQuery__
 *
 * To run a query within a React component, call `useGetCarriersTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriersTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriersTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetCarriersTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCarriersTargetingQuery, GetCarriersTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarriersTargetingQuery, GetCarriersTargetingQueryVariables>(
    GetCarriersTargetingDocument,
    options
  );
}
export function useGetCarriersTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCarriersTargetingQuery, GetCarriersTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarriersTargetingQuery, GetCarriersTargetingQueryVariables>(
    GetCarriersTargetingDocument,
    options
  );
}
export type GetCarriersTargetingQueryHookResult = ReturnType<typeof useGetCarriersTargetingQuery>;
export type GetCarriersTargetingLazyQueryHookResult = ReturnType<typeof useGetCarriersTargetingLazyQuery>;
export type GetCarriersTargetingQueryResult = Apollo.QueryResult<
  GetCarriersTargetingQuery,
  GetCarriersTargetingQueryVariables
>;
export const GetCreativeTypesDocument = gql`
  query GetCreativeTypes($limit: Int, $offset: Int) {
    creativeType(limit: $limit, offset: $offset) {
      nodes {
        id
        name
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetCreativeTypesQuery__
 *
 * To run a query within a React component, call `useGetCreativeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCreativeTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCreativeTypesQuery, GetCreativeTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreativeTypesQuery, GetCreativeTypesQueryVariables>(GetCreativeTypesDocument, options);
}
export function useGetCreativeTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeTypesQuery, GetCreativeTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreativeTypesQuery, GetCreativeTypesQueryVariables>(GetCreativeTypesDocument, options);
}
export type GetCreativeTypesQueryHookResult = ReturnType<typeof useGetCreativeTypesQuery>;
export type GetCreativeTypesLazyQueryHookResult = ReturnType<typeof useGetCreativeTypesLazyQuery>;
export type GetCreativeTypesQueryResult = Apollo.QueryResult<GetCreativeTypesQuery, GetCreativeTypesQueryVariables>;
export const GetCreativeTypesTargetingDocument = gql`
  query GetCreativeTypesTargeting(
    $id: BigInt
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $limit: Int
    $offset: Int
    $exclude: Boolean
  ) {
    creativeTypeTargeting(
      id: $id
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      limit: $limit
      offset: $offset
      exclude: $exclude
    ) {
      nodes {
        creativeAttribute
        creativeAttributeValue
        creativeTypeId
        createdAt
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetCreativeTypesTargetingQuery__
 *
 * To run a query within a React component, call `useGetCreativeTypesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeTypesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeTypesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetCreativeTypesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCreativeTypesTargetingQuery, GetCreativeTypesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreativeTypesTargetingQuery, GetCreativeTypesTargetingQueryVariables>(
    GetCreativeTypesTargetingDocument,
    options
  );
}
export function useGetCreativeTypesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeTypesTargetingQuery, GetCreativeTypesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCreativeTypesTargetingQuery, GetCreativeTypesTargetingQueryVariables>(
    GetCreativeTypesTargetingDocument,
    options
  );
}
export type GetCreativeTypesTargetingQueryHookResult = ReturnType<typeof useGetCreativeTypesTargetingQuery>;
export type GetCreativeTypesTargetingLazyQueryHookResult = ReturnType<typeof useGetCreativeTypesTargetingLazyQuery>;
export type GetCreativeTypesTargetingQueryResult = Apollo.QueryResult<
  GetCreativeTypesTargetingQuery,
  GetCreativeTypesTargetingQueryVariables
>;
export const GetDealsTargetingDocument = gql`
  query GetDealsTargeting(
    $exclude: Boolean
    $id: BigInt
    $ids: [BigInt!]
    $inventoryDealIds: [BigInt!]
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
  ) {
    dealTargeting(
      exclude: $exclude
      id: $id
      ids: $ids
      inventoryDealIds: $inventoryDealIds
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
    ) {
      nodes {
        id
        inventoryDealId
        referenceObjectId
        referenceObjectType
      }
      limit
      offset
      totalCount
    }
  }
`;

/**
 * __useGetDealsTargetingQuery__
 *
 * To run a query within a React component, call `useGetDealsTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsTargetingQuery({
 *   variables: {
 *      exclude: // value for 'exclude'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      inventoryDealIds: // value for 'inventoryDealIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *   },
 * });
 */
export function useGetDealsTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDealsTargetingQuery, GetDealsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealsTargetingQuery, GetDealsTargetingQueryVariables>(GetDealsTargetingDocument, options);
}
export function useGetDealsTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDealsTargetingQuery, GetDealsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealsTargetingQuery, GetDealsTargetingQueryVariables>(
    GetDealsTargetingDocument,
    options
  );
}
export type GetDealsTargetingQueryHookResult = ReturnType<typeof useGetDealsTargetingQuery>;
export type GetDealsTargetingLazyQueryHookResult = ReturnType<typeof useGetDealsTargetingLazyQuery>;
export type GetDealsTargetingQueryResult = Apollo.QueryResult<GetDealsTargetingQuery, GetDealsTargetingQueryVariables>;
export const GetInventoryDealsDocument = gql`
  query GetInventoryDeals($search: SearchDealsArgsDto!) {
    deals(search: $search) {
      nodes {
        id
        name
        dspDealId
        auctionType
        bidFloor
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetInventoryDealsQuery__
 *
 * To run a query within a React component, call `useGetInventoryDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryDealsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInventoryDealsQuery(
  baseOptions: Apollo.QueryHookOptions<GetInventoryDealsQuery, GetInventoryDealsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInventoryDealsQuery, GetInventoryDealsQueryVariables>(GetInventoryDealsDocument, options);
}
export function useGetInventoryDealsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryDealsQuery, GetInventoryDealsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInventoryDealsQuery, GetInventoryDealsQueryVariables>(
    GetInventoryDealsDocument,
    options
  );
}
export type GetInventoryDealsQueryHookResult = ReturnType<typeof useGetInventoryDealsQuery>;
export type GetInventoryDealsLazyQueryHookResult = ReturnType<typeof useGetInventoryDealsLazyQuery>;
export type GetInventoryDealsQueryResult = Apollo.QueryResult<GetInventoryDealsQuery, GetInventoryDealsQueryVariables>;
export const GetDeviceTypesDocument = gql`
  query GetDeviceTypes($limit: Int, $offset: Int, $status: ResourceStatus) {
    device(limit: $limit, offset: $offset, status: $status) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDeviceTypesQuery__
 *
 * To run a query within a React component, call `useGetDeviceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDeviceTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(GetDeviceTypesDocument, options);
}
export function useGetDeviceTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(GetDeviceTypesDocument, options);
}
export type GetDeviceTypesQueryHookResult = ReturnType<typeof useGetDeviceTypesQuery>;
export type GetDeviceTypesLazyQueryHookResult = ReturnType<typeof useGetDeviceTypesLazyQuery>;
export type GetDeviceTypesQueryResult = Apollo.QueryResult<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>;
export const GetDeviceTypesTargetingDocument = gql`
  query GetDeviceTypesTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    deviceTypeTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        deviceTypeId
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDeviceTypesTargetingQuery__
 *
 * To run a query within a React component, call `useGetDeviceTypesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTypesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTypesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetDeviceTypesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDeviceTypesTargetingQuery, GetDeviceTypesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceTypesTargetingQuery, GetDeviceTypesTargetingQueryVariables>(
    GetDeviceTypesTargetingDocument,
    options
  );
}
export function useGetDeviceTypesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceTypesTargetingQuery, GetDeviceTypesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceTypesTargetingQuery, GetDeviceTypesTargetingQueryVariables>(
    GetDeviceTypesTargetingDocument,
    options
  );
}
export type GetDeviceTypesTargetingQueryHookResult = ReturnType<typeof useGetDeviceTypesTargetingQuery>;
export type GetDeviceTypesTargetingLazyQueryHookResult = ReturnType<typeof useGetDeviceTypesTargetingLazyQuery>;
export type GetDeviceTypesTargetingQueryResult = Apollo.QueryResult<
  GetDeviceTypesTargetingQuery,
  GetDeviceTypesTargetingQueryVariables
>;
export const GetDvViewabilityTargetingDocument = gql`
  query GetDvViewabilityTargeting(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $exclude: Boolean
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
  ) {
    dvViewabilityTargeting(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      exclude: $exclude
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
    ) {
      nodes {
        id
        referenceObjectId
        dvSegmentId
        exclude
        dvSegmentId
        dvSegment {
          name
          creativeType
        }
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetDvViewabilityTargetingQuery__
 *
 * To run a query within a React component, call `useGetDvViewabilityTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDvViewabilityTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDvViewabilityTargetingQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      exclude: // value for 'exclude'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *   },
 * });
 */
export function useGetDvViewabilityTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDvViewabilityTargetingQuery, GetDvViewabilityTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDvViewabilityTargetingQuery, GetDvViewabilityTargetingQueryVariables>(
    GetDvViewabilityTargetingDocument,
    options
  );
}
export function useGetDvViewabilityTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDvViewabilityTargetingQuery, GetDvViewabilityTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDvViewabilityTargetingQuery, GetDvViewabilityTargetingQueryVariables>(
    GetDvViewabilityTargetingDocument,
    options
  );
}
export type GetDvViewabilityTargetingQueryHookResult = ReturnType<typeof useGetDvViewabilityTargetingQuery>;
export type GetDvViewabilityTargetingLazyQueryHookResult = ReturnType<typeof useGetDvViewabilityTargetingLazyQuery>;
export type GetDvViewabilityTargetingQueryResult = Apollo.QueryResult<
  GetDvViewabilityTargetingQuery,
  GetDvViewabilityTargetingQueryVariables
>;
export const GetDvSegmentsDocument = gql`
  query GetDVSegments(
    $id: BigInt
    $limit: Int = 10
    $offset: Int = 0
    $name: String
    $creativeType: ECreativeType
    $product: EProduct
  ) {
    dvSegment(id: $id, limit: $limit, offset: $offset, name: $name, creativeType: $creativeType, product: $product) {
      nodes {
        id
        name
        dvSegmentCode
        product
        creativeType
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetDvSegmentsQuery__
 *
 * To run a query within a React component, call `useGetDvSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDvSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDvSegmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      creativeType: // value for 'creativeType'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetDvSegmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDvSegmentsQuery, GetDvSegmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDvSegmentsQuery, GetDvSegmentsQueryVariables>(GetDvSegmentsDocument, options);
}
export function useGetDvSegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDvSegmentsQuery, GetDvSegmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDvSegmentsQuery, GetDvSegmentsQueryVariables>(GetDvSegmentsDocument, options);
}
export type GetDvSegmentsQueryHookResult = ReturnType<typeof useGetDvSegmentsQuery>;
export type GetDvSegmentsLazyQueryHookResult = ReturnType<typeof useGetDvSegmentsLazyQuery>;
export type GetDvSegmentsQueryResult = Apollo.QueryResult<GetDvSegmentsQuery, GetDvSegmentsQueryVariables>;
export const GetGenresTargetingDocument = gql`
  query GetGenresTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    genreTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        genreId
        exclude
        id
        genre {
          name
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetGenresTargetingQuery__
 *
 * To run a query within a React component, call `useGetGenresTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenresTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenresTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetGenresTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGenresTargetingQuery, GetGenresTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGenresTargetingQuery, GetGenresTargetingQueryVariables>(
    GetGenresTargetingDocument,
    options
  );
}
export function useGetGenresTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGenresTargetingQuery, GetGenresTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGenresTargetingQuery, GetGenresTargetingQueryVariables>(
    GetGenresTargetingDocument,
    options
  );
}
export type GetGenresTargetingQueryHookResult = ReturnType<typeof useGetGenresTargetingQuery>;
export type GetGenresTargetingLazyQueryHookResult = ReturnType<typeof useGetGenresTargetingLazyQuery>;
export type GetGenresTargetingQueryResult = Apollo.QueryResult<
  GetGenresTargetingQuery,
  GetGenresTargetingQueryVariables
>;
export const GetGenresDocument = gql`
  query GetGenres($limit: Int, $offset: Int, $status: ResourceStatus, $namePrefix: String) {
    genre(limit: $limit, offset: $offset, status: $status, namePrefix: $namePrefix) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetGenresQuery__
 *
 * To run a query within a React component, call `useGetGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenresQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetGenresQuery(baseOptions?: Apollo.QueryHookOptions<GetGenresQuery, GetGenresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGenresQuery, GetGenresQueryVariables>(GetGenresDocument, options);
}
export function useGetGenresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGenresQuery, GetGenresQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGenresQuery, GetGenresQueryVariables>(GetGenresDocument, options);
}
export type GetGenresQueryHookResult = ReturnType<typeof useGetGenresQuery>;
export type GetGenresLazyQueryHookResult = ReturnType<typeof useGetGenresLazyQuery>;
export type GetGenresQueryResult = Apollo.QueryResult<GetGenresQuery, GetGenresQueryVariables>;
export const GetCityDocument = gql`
  query GetCity($limit: Int, $offset: Int, $namePrefix: String, $ids: [BigInt!]) {
    cities(limit: $limit, offset: $offset, namePrefix: $namePrefix, ids: $ids) {
      nodes {
        name
        countryCode
        stateCode
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetCityQuery__
 *
 * To run a query within a React component, call `useGetCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCityQuery(baseOptions?: Apollo.QueryHookOptions<GetCityQuery, GetCityQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCityQuery, GetCityQueryVariables>(GetCityDocument, options);
}
export function useGetCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityQuery, GetCityQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCityQuery, GetCityQueryVariables>(GetCityDocument, options);
}
export type GetCityQueryHookResult = ReturnType<typeof useGetCityQuery>;
export type GetCityLazyQueryHookResult = ReturnType<typeof useGetCityLazyQuery>;
export type GetCityQueryResult = Apollo.QueryResult<GetCityQuery, GetCityQueryVariables>;
export const GetCountriesDocument = gql`
  query GetCountries(
    $limit: Int
    $offset: Int
    $namePrefix: String
    $status: ResourceStatus
    $code: String
    $codes: [String!]
  ) {
    country(limit: $limit, offset: $offset, namePrefix: $namePrefix, status: $status, code: $code, codes: $codes) {
      nodes {
        name
        code
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *      status: // value for 'status'
 *      code: // value for 'code'
 *      codes: // value for 'codes'
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetCountryTargetingDocument = gql`
  query GetCountryTargeting(
    $id: BigInt
    $ids: [BigInt!]
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
    $namePrefix: String
  ) {
    countryTargeting(
      id: $id
      ids: $ids
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
      namePrefix: $namePrefix
    ) {
      nodes {
        id
        country {
          name
        }
        referenceObjectId
        referenceObjectType
        countryCode
        exclude
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetCountryTargetingQuery__
 *
 * To run a query within a React component, call `useGetCountryTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetCountryTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountryTargetingQuery, GetCountryTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountryTargetingQuery, GetCountryTargetingQueryVariables>(
    GetCountryTargetingDocument,
    options
  );
}
export function useGetCountryTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountryTargetingQuery, GetCountryTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountryTargetingQuery, GetCountryTargetingQueryVariables>(
    GetCountryTargetingDocument,
    options
  );
}
export type GetCountryTargetingQueryHookResult = ReturnType<typeof useGetCountryTargetingQuery>;
export type GetCountryTargetingLazyQueryHookResult = ReturnType<typeof useGetCountryTargetingLazyQuery>;
export type GetCountryTargetingQueryResult = Apollo.QueryResult<
  GetCountryTargetingQuery,
  GetCountryTargetingQueryVariables
>;
export const GetGeoTargetingDocument = gql`
  query GetGeoTargeting(
    $id: BigInt
    $ids: [BigInt!]
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
    $type: EGeoType
    $namePrefix: String
  ) {
    geoTargeting(
      id: $id
      ids: $ids
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
      type: $type
      namePrefix: $namePrefix
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        geoId
        state {
          name
          countryCode
          stateCode
        }
        city {
          name
          stateCode
          countryCode
        }
        metro {
          name
          countryCode
          code
        }
        postalCode {
          code
        }
        type
        exclude
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetGeoTargetingQuery__
 *
 * To run a query within a React component, call `useGetGeoTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeoTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeoTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *      type: // value for 'type'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetGeoTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGeoTargetingQuery, GetGeoTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGeoTargetingQuery, GetGeoTargetingQueryVariables>(GetGeoTargetingDocument, options);
}
export function useGetGeoTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGeoTargetingQuery, GetGeoTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGeoTargetingQuery, GetGeoTargetingQueryVariables>(GetGeoTargetingDocument, options);
}
export type GetGeoTargetingQueryHookResult = ReturnType<typeof useGetGeoTargetingQuery>;
export type GetGeoTargetingLazyQueryHookResult = ReturnType<typeof useGetGeoTargetingLazyQuery>;
export type GetGeoTargetingQueryResult = Apollo.QueryResult<GetGeoTargetingQuery, GetGeoTargetingQueryVariables>;
export const GetMetroDocument = gql`
  query GetMetro($limit: Int, $offset: Int, $namePrefix: String, $ids: [BigInt!]) {
    metros(limit: $limit, offset: $offset, namePrefix: $namePrefix, ids: $ids) {
      nodes {
        name
        code
        countryCode
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetMetroQuery__
 *
 * To run a query within a React component, call `useGetMetroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetroQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMetroQuery(baseOptions?: Apollo.QueryHookOptions<GetMetroQuery, GetMetroQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetroQuery, GetMetroQueryVariables>(GetMetroDocument, options);
}
export function useGetMetroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetroQuery, GetMetroQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetroQuery, GetMetroQueryVariables>(GetMetroDocument, options);
}
export type GetMetroQueryHookResult = ReturnType<typeof useGetMetroQuery>;
export type GetMetroLazyQueryHookResult = ReturnType<typeof useGetMetroLazyQuery>;
export type GetMetroQueryResult = Apollo.QueryResult<GetMetroQuery, GetMetroQueryVariables>;
export const GetPostalCodesDocument = gql`
  query GetPostalCodes($limit: Int, $offset: Int, $countryCode: String, $codes: [String!]) {
    postalCodes(limit: $limit, offset: $offset, countryCode: $countryCode, codes: $codes) {
      nodes {
        id
        code
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetPostalCodesQuery__
 *
 * To run a query within a React component, call `useGetPostalCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostalCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostalCodesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      countryCode: // value for 'countryCode'
 *      codes: // value for 'codes'
 *   },
 * });
 */
export function useGetPostalCodesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostalCodesQuery, GetPostalCodesQueryVariables>(GetPostalCodesDocument, options);
}
export function useGetPostalCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostalCodesQuery, GetPostalCodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostalCodesQuery, GetPostalCodesQueryVariables>(GetPostalCodesDocument, options);
}
export type GetPostalCodesQueryHookResult = ReturnType<typeof useGetPostalCodesQuery>;
export type GetPostalCodesLazyQueryHookResult = ReturnType<typeof useGetPostalCodesLazyQuery>;
export type GetPostalCodesQueryResult = Apollo.QueryResult<GetPostalCodesQuery, GetPostalCodesQueryVariables>;
export const GetStateDocument = gql`
  query GetState($limit: Int, $offset: Int, $namePrefix: String, $ids: [BigInt!]) {
    states(limit: $limit, offset: $offset, namePrefix: $namePrefix, ids: $ids) {
      nodes {
        name
        countryCode
        stateCode
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetStateQuery__
 *
 * To run a query within a React component, call `useGetStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStateQuery(baseOptions?: Apollo.QueryHookOptions<GetStateQuery, GetStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStateQuery, GetStateQueryVariables>(GetStateDocument, options);
}
export function useGetStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateQuery, GetStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStateQuery, GetStateQueryVariables>(GetStateDocument, options);
}
export type GetStateQueryHookResult = ReturnType<typeof useGetStateQuery>;
export type GetStateLazyQueryHookResult = ReturnType<typeof useGetStateLazyQuery>;
export type GetStateQueryResult = Apollo.QueryResult<GetStateQuery, GetStateQueryVariables>;
export const GetIabCategoriesDocument = gql`
  query GetIabCategories($limit: Int, $offset: Int, $status: ResourceStatus, $namePrefix: String) {
    category(limit: $limit, offset: $offset, status: $status, namePrefix: $namePrefix) {
      nodes {
        id
        name
        status
        createdAt
        iabCategory
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetIabCategoriesQuery__
 *
 * To run a query within a React component, call `useGetIabCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIabCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIabCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetIabCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIabCategoriesQuery, GetIabCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIabCategoriesQuery, GetIabCategoriesQueryVariables>(GetIabCategoriesDocument, options);
}
export function useGetIabCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIabCategoriesQuery, GetIabCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIabCategoriesQuery, GetIabCategoriesQueryVariables>(GetIabCategoriesDocument, options);
}
export type GetIabCategoriesQueryHookResult = ReturnType<typeof useGetIabCategoriesQuery>;
export type GetIabCategoriesLazyQueryHookResult = ReturnType<typeof useGetIabCategoriesLazyQuery>;
export type GetIabCategoriesQueryResult = Apollo.QueryResult<GetIabCategoriesQuery, GetIabCategoriesQueryVariables>;
export const GetIabCategoriesTargetingDocument = gql`
  query GetIabCategoriesTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    categoryTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        id
        exclude
        categoryId
        category {
          id
          name
          iabCategory
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetIabCategoriesTargetingQuery__
 *
 * To run a query within a React component, call `useGetIabCategoriesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIabCategoriesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIabCategoriesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetIabCategoriesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIabCategoriesTargetingQuery, GetIabCategoriesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIabCategoriesTargetingQuery, GetIabCategoriesTargetingQueryVariables>(
    GetIabCategoriesTargetingDocument,
    options
  );
}
export function useGetIabCategoriesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIabCategoriesTargetingQuery, GetIabCategoriesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIabCategoriesTargetingQuery, GetIabCategoriesTargetingQueryVariables>(
    GetIabCategoriesTargetingDocument,
    options
  );
}
export type GetIabCategoriesTargetingQueryHookResult = ReturnType<typeof useGetIabCategoriesTargetingQuery>;
export type GetIabCategoriesTargetingLazyQueryHookResult = ReturnType<typeof useGetIabCategoriesTargetingLazyQuery>;
export type GetIabCategoriesTargetingQueryResult = Apollo.QueryResult<
  GetIabCategoriesTargetingQuery,
  GetIabCategoriesTargetingQueryVariables
>;
export const GetLanguagesTargetingDocument = gql`
  query GetLanguagesTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    LanguageTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        languageId
        exclude
        id
        language {
          name
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetLanguagesTargetingQuery__
 *
 * To run a query within a React component, call `useGetLanguagesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetLanguagesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLanguagesTargetingQuery, GetLanguagesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguagesTargetingQuery, GetLanguagesTargetingQueryVariables>(
    GetLanguagesTargetingDocument,
    options
  );
}
export function useGetLanguagesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesTargetingQuery, GetLanguagesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguagesTargetingQuery, GetLanguagesTargetingQueryVariables>(
    GetLanguagesTargetingDocument,
    options
  );
}
export type GetLanguagesTargetingQueryHookResult = ReturnType<typeof useGetLanguagesTargetingQuery>;
export type GetLanguagesTargetingLazyQueryHookResult = ReturnType<typeof useGetLanguagesTargetingLazyQuery>;
export type GetLanguagesTargetingQueryResult = Apollo.QueryResult<
  GetLanguagesTargetingQuery,
  GetLanguagesTargetingQueryVariables
>;
export const GetLanguagesDocument = gql`
  query GetLanguages($limit: Int, $offset: Int, $status: ResourceStatus, $namePrefix: String) {
    language(limit: $limit, offset: $offset, status: $status, namePrefix: $namePrefix) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetLanguagesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
}
export function useGetLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
}
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetLivesTargetingDocument = gql`
  query GetLivesTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    LiveTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        live
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetLivesTargetingQuery__
 *
 * To run a query within a React component, call `useGetLivesTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLivesTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLivesTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetLivesTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLivesTargetingQuery, GetLivesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLivesTargetingQuery, GetLivesTargetingQueryVariables>(GetLivesTargetingDocument, options);
}
export function useGetLivesTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLivesTargetingQuery, GetLivesTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLivesTargetingQuery, GetLivesTargetingQueryVariables>(
    GetLivesTargetingDocument,
    options
  );
}
export type GetLivesTargetingQueryHookResult = ReturnType<typeof useGetLivesTargetingQuery>;
export type GetLivesTargetingLazyQueryHookResult = ReturnType<typeof useGetLivesTargetingLazyQuery>;
export type GetLivesTargetingQueryResult = Apollo.QueryResult<GetLivesTargetingQuery, GetLivesTargetingQueryVariables>;
export const GetOsDocument = gql`
  query GetOs($id: BigInt, $limit: Int, $offset: Int, $namePrefix: String, $status: ResourceStatus) {
    os(id: $id, limit: $limit, offset: $offset, namePrefix: $namePrefix, status: $status) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetOsQuery__
 *
 * To run a query within a React component, call `useGetOsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      namePrefix: // value for 'namePrefix'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOsQuery(baseOptions?: Apollo.QueryHookOptions<GetOsQuery, GetOsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOsQuery, GetOsQueryVariables>(GetOsDocument, options);
}
export function useGetOsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOsQuery, GetOsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOsQuery, GetOsQueryVariables>(GetOsDocument, options);
}
export type GetOsQueryHookResult = ReturnType<typeof useGetOsQuery>;
export type GetOsLazyQueryHookResult = ReturnType<typeof useGetOsLazyQuery>;
export type GetOsQueryResult = Apollo.QueryResult<GetOsQuery, GetOsQueryVariables>;
export const GetOsTargetingDocument = gql`
  query GetOsTargeting(
    $id: BigInt
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $limit: Int
    $offset: Int
    $exclude: Boolean
  ) {
    osTargeting(
      id: $id
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      limit: $limit
      offset: $offset
      exclude: $exclude
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        exclude
        osId
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetOsTargetingQuery__
 *
 * To run a query within a React component, call `useGetOsTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOsTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOsTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetOsTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOsTargetingQuery, GetOsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOsTargetingQuery, GetOsTargetingQueryVariables>(GetOsTargetingDocument, options);
}
export function useGetOsTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOsTargetingQuery, GetOsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOsTargetingQuery, GetOsTargetingQueryVariables>(GetOsTargetingDocument, options);
}
export type GetOsTargetingQueryHookResult = ReturnType<typeof useGetOsTargetingQuery>;
export type GetOsTargetingLazyQueryHookResult = ReturnType<typeof useGetOsTargetingLazyQuery>;
export type GetOsTargetingQueryResult = Apollo.QueryResult<GetOsTargetingQuery, GetOsTargetingQueryVariables>;
export const GetPlacementTargetingDocument = gql`
  query GetPlacementTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    positionTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        position
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetPlacementTargetingQuery__
 *
 * To run a query within a React component, call `useGetPlacementTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacementTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacementTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetPlacementTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPlacementTargetingQuery, GetPlacementTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlacementTargetingQuery, GetPlacementTargetingQueryVariables>(
    GetPlacementTargetingDocument,
    options
  );
}
export function useGetPlacementTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlacementTargetingQuery, GetPlacementTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlacementTargetingQuery, GetPlacementTargetingQueryVariables>(
    GetPlacementTargetingDocument,
    options
  );
}
export type GetPlacementTargetingQueryHookResult = ReturnType<typeof useGetPlacementTargetingQuery>;
export type GetPlacementTargetingLazyQueryHookResult = ReturnType<typeof useGetPlacementTargetingLazyQuery>;
export type GetPlacementTargetingQueryResult = Apollo.QueryResult<
  GetPlacementTargetingQuery,
  GetPlacementTargetingQueryVariables
>;
export const GetProductionsTargetingDocument = gql`
  query GetProductionsTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    ProductionTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        production
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetProductionsTargetingQuery__
 *
 * To run a query within a React component, call `useGetProductionsTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionsTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionsTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetProductionsTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProductionsTargetingQuery, GetProductionsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductionsTargetingQuery, GetProductionsTargetingQueryVariables>(
    GetProductionsTargetingDocument,
    options
  );
}
export function useGetProductionsTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductionsTargetingQuery, GetProductionsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductionsTargetingQuery, GetProductionsTargetingQueryVariables>(
    GetProductionsTargetingDocument,
    options
  );
}
export type GetProductionsTargetingQueryHookResult = ReturnType<typeof useGetProductionsTargetingQuery>;
export type GetProductionsTargetingLazyQueryHookResult = ReturnType<typeof useGetProductionsTargetingLazyQuery>;
export type GetProductionsTargetingQueryResult = Apollo.QueryResult<
  GetProductionsTargetingQuery,
  GetProductionsTargetingQueryVariables
>;
export const GetRatingsDocument = gql`
  query GetRatings($limit: Int, $offset: Int, $status: ResourceStatus, $namePrefix: String) {
    rating(limit: $limit, offset: $offset, status: $status, namePrefix: $namePrefix) {
      nodes {
        id
        name
        status
        createdAt
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetRatingsQuery__
 *
 * To run a query within a React component, call `useGetRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useGetRatingsQuery(baseOptions?: Apollo.QueryHookOptions<GetRatingsQuery, GetRatingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRatingsQuery, GetRatingsQueryVariables>(GetRatingsDocument, options);
}
export function useGetRatingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRatingsQuery, GetRatingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRatingsQuery, GetRatingsQueryVariables>(GetRatingsDocument, options);
}
export type GetRatingsQueryHookResult = ReturnType<typeof useGetRatingsQuery>;
export type GetRatingsLazyQueryHookResult = ReturnType<typeof useGetRatingsLazyQuery>;
export type GetRatingsQueryResult = Apollo.QueryResult<GetRatingsQuery, GetRatingsQueryVariables>;
export const GetRatingsTargetingDocument = gql`
  query GetRatingsTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    RatingTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        ratingId
        exclude
        id
        rating {
          name
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetRatingsTargetingQuery__
 *
 * To run a query within a React component, call `useGetRatingsTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingsTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingsTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetRatingsTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRatingsTargetingQuery, GetRatingsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRatingsTargetingQuery, GetRatingsTargetingQueryVariables>(
    GetRatingsTargetingDocument,
    options
  );
}
export function useGetRatingsTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRatingsTargetingQuery, GetRatingsTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRatingsTargetingQuery, GetRatingsTargetingQueryVariables>(
    GetRatingsTargetingDocument,
    options
  );
}
export type GetRatingsTargetingQueryHookResult = ReturnType<typeof useGetRatingsTargetingQuery>;
export type GetRatingsTargetingLazyQueryHookResult = ReturnType<typeof useGetRatingsTargetingLazyQuery>;
export type GetRatingsTargetingQueryResult = Apollo.QueryResult<
  GetRatingsTargetingQuery,
  GetRatingsTargetingQueryVariables
>;
export const GetSitesDocument = gql`
  query GetSites(
    $limit: Int
    $offset: Int
    $id: BigInt
    $status: ResourceStatus
    $domainPrefix: String
    $domains: [String!]
    $ids: [BigInt!]
  ) {
    site(
      limit: $limit
      offset: $offset
      id: $id
      status: $status
      domainPrefix: $domainPrefix
      domains: $domains
      ids: $ids
    ) {
      nodes {
        id
        status
        domain
        createdAt
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      domainPrefix: // value for 'domainPrefix'
 *      domains: // value for 'domains'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
}
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
}
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export const GetSiteTargetingDocument = gql`
  query GetSiteTargeting(
    $limit: Int
    $offset: Int
    $id: BigInt
    $ids: [BigInt!]
    $exclude: Boolean
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $switcherRecord: Boolean
  ) {
    siteTargeting(
      limit: $limit
      offset: $offset
      id: $id
      ids: $ids
      exclude: $exclude
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      switcherRecord: $switcherRecord
    ) {
      nodes {
        id
        referenceObjectId
        referenceObjectType
        domain
        exclude
        switcherRecord
      }
      totalCount
      limit
      offset
    }
  }
`;

/**
 * __useGetSiteTargetingQuery__
 *
 * To run a query within a React component, call `useGetSiteTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteTargetingQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      exclude: // value for 'exclude'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      switcherRecord: // value for 'switcherRecord'
 *   },
 * });
 */
export function useGetSiteTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSiteTargetingQuery, GetSiteTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSiteTargetingQuery, GetSiteTargetingQueryVariables>(GetSiteTargetingDocument, options);
}
export function useGetSiteTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSiteTargetingQuery, GetSiteTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSiteTargetingQuery, GetSiteTargetingQueryVariables>(GetSiteTargetingDocument, options);
}
export type GetSiteTargetingQueryHookResult = ReturnType<typeof useGetSiteTargetingQuery>;
export type GetSiteTargetingLazyQueryHookResult = ReturnType<typeof useGetSiteTargetingLazyQuery>;
export type GetSiteTargetingQueryResult = Apollo.QueryResult<GetSiteTargetingQuery, GetSiteTargetingQueryVariables>;
export const GetESupplyDocument = gql`
  query GetESupply($search: SearchESupplyArgsDto!) {
    getESupply(search: $search) {
      id
      name
      supplySource
      externalSupplyId
      createdAt
    }
  }
`;

/**
 * __useGetESupplyQuery__
 *
 * To run a query within a React component, call `useGetESupplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetESupplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetESupplyQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetESupplyQuery(baseOptions: Apollo.QueryHookOptions<GetESupplyQuery, GetESupplyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetESupplyQuery, GetESupplyQueryVariables>(GetESupplyDocument, options);
}
export function useGetESupplyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetESupplyQuery, GetESupplyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetESupplyQuery, GetESupplyQueryVariables>(GetESupplyDocument, options);
}
export type GetESupplyQueryHookResult = ReturnType<typeof useGetESupplyQuery>;
export type GetESupplyLazyQueryHookResult = ReturnType<typeof useGetESupplyLazyQuery>;
export type GetESupplyQueryResult = Apollo.QueryResult<GetESupplyQuery, GetESupplyQueryVariables>;
export const GetTimePartingTargetingDocument = gql`
  query GetTimePartingTargeting(
    $id: BigInt
    $limit: Int
    $offset: Int
    $referenceObjectId: BigInt
    $referenceObjectType: EObjectType
    $exclude: Boolean
  ) {
    dayPartTargeting(
      id: $id
      limit: $limit
      offset: $offset
      referenceObjectId: $referenceObjectId
      referenceObjectType: $referenceObjectType
      exclude: $exclude
    ) {
      nodes {
        startHour
        endHour
        weekday
        exclude
        id
      }
      totalCount
      offset
      limit
    }
  }
`;

/**
 * __useGetTimePartingTargetingQuery__
 *
 * To run a query within a React component, call `useGetTimePartingTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimePartingTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimePartingTargetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      referenceObjectId: // value for 'referenceObjectId'
 *      referenceObjectType: // value for 'referenceObjectType'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useGetTimePartingTargetingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTimePartingTargetingQuery, GetTimePartingTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimePartingTargetingQuery, GetTimePartingTargetingQueryVariables>(
    GetTimePartingTargetingDocument,
    options
  );
}
export function useGetTimePartingTargetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimePartingTargetingQuery, GetTimePartingTargetingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimePartingTargetingQuery, GetTimePartingTargetingQueryVariables>(
    GetTimePartingTargetingDocument,
    options
  );
}
export type GetTimePartingTargetingQueryHookResult = ReturnType<typeof useGetTimePartingTargetingQuery>;
export type GetTimePartingTargetingLazyQueryHookResult = ReturnType<typeof useGetTimePartingTargetingLazyQuery>;
export type GetTimePartingTargetingQueryResult = Apollo.QueryResult<
  GetTimePartingTargetingQuery,
  GetTimePartingTargetingQueryVariables
>;
export const namedOperations = {
  Query: {
    GetAccount: 'GetAccount',
    GetAccounts: 'GetAccounts',
    GetActor: 'GetActor',
    GetAdvertisers: 'GetAdvertisers',
    GetAgencies: 'GetAgencies',
    GetAudienceCategories: 'GetAudienceCategories',
    GetAudienceDataProviders: 'GetAudienceDataProviders',
    GetAudienceTypes: 'GetAudienceTypes',
    GetAudiences: 'GetAudiences',
    GetCampaigns: 'GetCampaigns',
    GetCampaignsForPerformanceReportsModal: 'GetCampaignsForPerformanceReportsModal',
    GetCustomReportFieldCategories: 'GetCustomReportFieldCategories',
    GetDealForEdit: 'GetDealForEdit',
    GetDealsSummary: 'GetDealsSummary',
    GetDSPs: 'GetDSPs',
    GetGeoAdvertisers: 'GetGeoAdvertisers',
    GetGeoCampaigns: 'GetGeoCampaigns',
    GetKpis: 'GetKpis',
    GetLocationGroups: 'GetLocationGroups',
    GetPointsOfInterest: 'GetPointsOfInterest',
    GetPointsOfInterestBrands: 'GetPointsOfInterestBrands',
    GetPointsOfInterestCategories: 'GetPointsOfInterestCategories',
    GetPointsOfInterestCategoriesWithSubCategories: 'GetPointsOfInterestCategoriesWithSubCategories',
    GetPointsOfInterestNameAndLatLong: 'GetPointsOfInterestNameAndLatLong',
    GetPointsOfInterestIDandName: 'GetPointsOfInterestIDandName',
    GetPointsOfInterestStates: 'GetPointsOfInterestStates',
    GetPointsOfInterestSubCategories: 'GetPointsOfInterestSubCategories',
    GetPixelMappings: 'GetPixelMappings',
    GetPixels: 'GetPixels',
    GetPublisher: 'GetPublisher',
    GetPublishers: 'GetPublishers',
    GetReportFileDownloadUrl: 'GetReportFileDownloadUrl',
    GetReportFields: 'GetReportFields',
    GetReports: 'GetReports',
    GetStrategies: 'GetStrategies',
    GetUser: 'GetUser',
    GetAdaptCtvTemplates: 'GetAdaptCtvTemplates',
    GetAudiencesChildren: 'GetAudiencesChildren',
    GetAudiencesChildrenData: 'GetAudiencesChildrenData',
    GetCreativeFormats: 'GetCreativeFormats',
    GetCreatives: 'GetCreatives',
    GetCtvVideoTemplates: 'GetCtvVideoTemplates',
    GetCtvVideoVariants: 'GetCtvVideoVariants',
    GetDCOCreatives: 'GetDCOCreatives',
    GetFreqCapTargeting: 'GetFreqCapTargeting',
    GetSupplySourceTargeting: 'GetSupplySourceTargeting',
    GetTargetingAudiences: 'GetTargetingAudiences',
    GetTargetingPoi: 'GetTargetingPoi',
    GetAbsTargeting: 'GetAbsTargeting',
    GetAppCategories: 'GetAppCategories',
    GetAppCategoriesTargeting: 'GetAppCategoriesTargeting',
    GetApps: 'GetApps',
    GetAppTargeting: 'GetAppTargeting',
    GetBrowserTargeting: 'GetBrowserTargeting',
    GetBrowsers: 'GetBrowsers',
    GetBssTargeting: 'GetBssTargeting',
    DealBulkTargeting: 'DealBulkTargeting',
    GetCarries: 'GetCarries',
    GetCarriersTargeting: 'GetCarriersTargeting',
    GetCreativeTypes: 'GetCreativeTypes',
    GetCreativeTypesTargeting: 'GetCreativeTypesTargeting',
    GetDealsTargeting: 'GetDealsTargeting',
    GetInventoryDeals: 'GetInventoryDeals',
    GetDeviceTypes: 'GetDeviceTypes',
    GetDeviceTypesTargeting: 'GetDeviceTypesTargeting',
    GetDvViewabilityTargeting: 'GetDvViewabilityTargeting',
    GetDVSegments: 'GetDVSegments',
    GetGenresTargeting: 'GetGenresTargeting',
    GetGenres: 'GetGenres',
    GetCity: 'GetCity',
    GetCountries: 'GetCountries',
    GetCountryTargeting: 'GetCountryTargeting',
    GetGeoTargeting: 'GetGeoTargeting',
    GetMetro: 'GetMetro',
    GetPostalCodes: 'GetPostalCodes',
    GetState: 'GetState',
    GetIabCategories: 'GetIabCategories',
    GetIabCategoriesTargeting: 'GetIabCategoriesTargeting',
    GetLanguagesTargeting: 'GetLanguagesTargeting',
    GetLanguages: 'GetLanguages',
    GetLivesTargeting: 'GetLivesTargeting',
    GetOs: 'GetOs',
    GetOsTargeting: 'GetOsTargeting',
    GetPlacementTargeting: 'GetPlacementTargeting',
    GetProductionsTargeting: 'GetProductionsTargeting',
    GetRatings: 'GetRatings',
    GetRatingsTargeting: 'GetRatingsTargeting',
    GetSites: 'GetSites',
    GetSiteTargeting: 'GetSiteTargeting',
    GetESupply: 'GetESupply',
    GetTimePartingTargeting: 'GetTimePartingTargeting',
  },
  Mutation: {
    CloneDeal: 'CloneDeal',
    CreatePixel: 'CreatePixel',
    BatchReplacePixelMappings: 'BatchReplacePixelMappings',
    CreateReport: 'CreateReport',
    DeleteReports: 'DeleteReports',
    UpdatePixel: 'UpdatePixel',
    ExportPixels: 'ExportPixels',
    UpdateReport: 'UpdateReport',
    UploadImage: 'UploadImage',
    UploadVideo: 'UploadVideo',
    CreateAdaptCtvTemplate: 'CreateAdaptCtvTemplate',
    UpdateAdaptCtvTemplateById: 'UpdateAdaptCtvTemplateById',
    CreateCombinedAudience: 'CreateCombinedAudience',
    ExportAudiences: 'ExportAudiences',
    UpdateCombinedAudience: 'UpdateCombinedAudience',
    BulkUpdateCampaign: 'BulkUpdateCampaign',
    CloneCampaign: 'CloneCampaign',
    CreateCampaign: 'CreateCampaign',
    UpdateCampaign: 'UpdateCampaign',
    AddAudio: 'AddAudio',
    AddBanner: 'AddBanner',
    AddOrReplaceCtvVideoVariants: 'AddOrReplaceCtvVideoVariants',
    AddNative: 'AddNative',
    AddVideo: 'AddVideo',
    UpdateAudio: 'UpdateAudio',
    UpdateBanner: 'UpdateBanner',
    UpdateNative: 'UpdateNative',
    UpdateVideo: 'UpdateVideo',
    AssignCreativesToDeal: 'AssignCreativesToDeal',
    BulkUpdateDeal: 'BulkUpdateDeal',
    CreateDeal: 'CreateDeal',
    UnassignCreativesFromDeal: 'UnassignCreativesFromDeal',
    UpdateDeal: 'UpdateDeal',
    CreateLocatonGroup: 'CreateLocatonGroup',
    DeleteLocationGroups: 'DeleteLocationGroups',
    ExportLocationGroup: 'ExportLocationGroup',
    UpdateLocatonGroup: 'UpdateLocatonGroup',
    AssignCreativesToStrategy: 'AssignCreativesToStrategy',
    BulkUpdateStrategies: 'BulkUpdateStrategies',
    CloneStrategy: 'CloneStrategy',
    CreateStrategy: 'CreateStrategy',
    UpdateStrategy: 'UpdateStrategy',
    BulkUpdateTargeting: 'BulkUpdateTargeting',
    ReplaceTargetingAudiencesBatch: 'ReplaceTargetingAudiencesBatch',
    ReplaceTargetingPoiBatch: 'ReplaceTargetingPoiBatch',
    CreateAbsTargeting: 'CreateAbsTargeting',
    DeleteAbsTargeting: 'DeleteAbsTargeting',
    CreateAppCategoryTargeting: 'CreateAppCategoryTargeting',
    CreateAppTargeting: 'CreateAppTargeting',
    DeleteAppTargeting: 'DeleteAppTargeting',
    UpdateAppTargeting: 'UpdateAppTargeting',
    CreateBrowserTargeting: 'CreateBrowserTargeting',
    DeleteBrowserTargeting: 'DeleteBrowserTargeting',
    UpdateBrowserTargeting: 'UpdateBrowserTargeting',
    CreateBssTargeting: 'CreateBssTargeting',
    DeleteBssTargeting: 'DeleteBssTargeting',
    CreateCarrierTargeting: 'CreateCarrierTargeting',
    DeleteCarrierTargeting: 'DeleteCarrierTargeting',
    UpdateCarrierTargeting: 'UpdateCarrierTargeting',
    CreateCreativeTypeTargeting: 'CreateCreativeTypeTargeting',
    DeleteCreativeTypeTargeting: 'DeleteCreativeTypeTargeting',
    UpdateCreativeTypeTargeting: 'UpdateCreativeTypeTargeting',
    CreateDealTargeting: 'CreateDealTargeting',
    DeleteDealTargeting: 'DeleteDealTargeting',
    UpdateDealTargeting: 'UpdateDealTargeting',
    BatchDeleteDeviceTypes: 'BatchDeleteDeviceTypes',
    CreateDeviceTypeTargeting: 'CreateDeviceTypeTargeting',
    UpdateDeviceTypeTargeting: 'UpdateDeviceTypeTargeting',
    CreateDvSegmentTargeting: 'CreateDvSegmentTargeting',
    CreateFreqCapTargeting: 'CreateFreqCapTargeting',
    CreateGenreTargeting: 'CreateGenreTargeting',
    CreateCountryTargeting: 'CreateCountryTargeting',
    CreateGeoTargeting: 'CreateGeoTargeting',
    DeleteCountryTargeting: 'DeleteCountryTargeting',
    DeleteGeoTargeting: 'DeleteGeoTargeting',
    UpdateCountryTargeting: 'UpdateCountryTargeting',
    UpdateGeoTargeting: 'UpdateGeoTargeting',
    CreateIabCategoryTargeting: 'CreateIabCategoryTargeting',
    CreateLanguageTargeting: 'CreateLanguageTargeting',
    CreateLiveTargeting: 'CreateLiveTargeting',
    CreateOsTargeting: 'CreateOsTargeting',
    DeleteOsTargeting: 'DeleteOsTargeting',
    UpdateOsTargeting: 'UpdateOsTargeting',
    BatchDeletePositionTargeting: 'BatchDeletePositionTargeting',
    CreatePlacementTargeting: 'CreatePlacementTargeting',
    UpdatePlacementTargeting: 'UpdatePlacementTargeting',
    CreateProductionTargeting: 'CreateProductionTargeting',
    CreateRatingTargeting: 'CreateRatingTargeting',
    CreateSiteTargeting: 'CreateSiteTargeting',
    DeleteSiteTargeting: 'DeleteSiteTargeting',
    UpdateSiteTargeting: 'UpdateSiteTargeting',
    SupplyBatchReplace: 'SupplyBatchReplace',
    CreateSupplySourceTargeting: 'CreateSupplySourceTargeting',
    DeleteSupplySourceTargeting: 'DeleteSupplySourceTargeting',
    UpdateSupplySourceTargeting: 'UpdateSupplySourceTargeting',
    CreateTimePartingTargeting: 'CreateTimePartingTargeting',
    DeleteTimePartingTargeting: 'DeleteTimePartingTargeting',
  },
  Fragment: {
    StrategyFields: 'StrategyFields',
  },
};
